import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  bpchar: any;
  bytea: any;
  citext: any;
  float8: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "areas" */
export type Areas = {
  area_type: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_area?: Maybe<Areas>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "areas" */
export type Areas_Aggregate = {
  aggregate?: Maybe<Areas_Aggregate_Fields>;
  nodes: Array<Areas>;
};

/** aggregate fields of "areas" */
export type Areas_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Areas_Max_Fields>;
  min?: Maybe<Areas_Min_Fields>;
};


/** aggregate fields of "areas" */
export type Areas_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Areas_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "areas". All fields are combined with a logical 'AND'. */
export type Areas_Bool_Exp = {
  _and?: Maybe<Array<Areas_Bool_Exp>>;
  _not?: Maybe<Areas_Bool_Exp>;
  _or?: Maybe<Array<Areas_Bool_Exp>>;
  area_type?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parent_area?: Maybe<Areas_Bool_Exp>;
  parent_area_type?: Maybe<String_Comparison_Exp>;
  parent_id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "areas" */
export enum Areas_Constraint {
  /** unique or primary key constraint on columns "id", "area_type" */
  AreasPkey = 'areas_pkey'
}

/** input type for inserting data into table "areas" */
export type Areas_Insert_Input = {
  area_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_area?: Maybe<Areas_Obj_Rel_Insert_Input>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Areas_Max_Fields = {
  area_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Areas_Min_Fields = {
  area_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "areas" */
export type Areas_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Areas>;
};

/** input type for inserting object relation for remote table "areas" */
export type Areas_Obj_Rel_Insert_Input = {
  data: Areas_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Areas_On_Conflict>;
};

/** on_conflict condition type for table "areas" */
export type Areas_On_Conflict = {
  constraint: Areas_Constraint;
  update_columns?: Array<Areas_Update_Column>;
  where?: Maybe<Areas_Bool_Exp>;
};

/** Ordering options when selecting data from "areas". */
export type Areas_Order_By = {
  area_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_area?: Maybe<Areas_Order_By>;
  parent_area_type?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
};

/** primary key columns input for table: areas */
export type Areas_Pk_Columns_Input = {
  area_type: Scalars['String'];
  id: Scalars['String'];
};

/** select columns of table "areas" */
export enum Areas_Select_Column {
  /** column name */
  AreaType = 'area_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentAreaType = 'parent_area_type',
  /** column name */
  ParentId = 'parent_id'
}

/** input type for updating data in table "areas" */
export type Areas_Set_Input = {
  area_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "areas" */
export type Areas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Areas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Areas_Stream_Cursor_Value_Input = {
  area_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_area_type?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
};

/** update columns of table "areas" */
export enum Areas_Update_Column {
  /** column name */
  AreaType = 'area_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentAreaType = 'parent_area_type',
  /** column name */
  ParentId = 'parent_id'
}

export type Areas_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Areas_Set_Input>;
  where: Areas_Bool_Exp;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests = {
  id: Scalars['uuid'];
  options?: Maybe<Scalars['jsonb']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate = {
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields>;
  nodes: Array<AuthProviderRequests>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthProviderRequests_Max_Fields>;
  min?: Maybe<AuthProviderRequests_Min_Fields>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthProviderRequests_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input = {
  options?: Maybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp = {
  _and?: Maybe<Array<AuthProviderRequests_Bool_Exp>>;
  _not?: Maybe<AuthProviderRequests_Bool_Exp>;
  _or?: Maybe<Array<AuthProviderRequests_Bool_Exp>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  options?: Maybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input = {
  options?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input = {
  options?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input = {
  options?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  options?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields = {
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields = {
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict = {
  constraint: AuthProviderRequests_Constraint;
  update_columns?: Array<AuthProviderRequests_Update_Column>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By = {
  id?: Maybe<Order_By>;
  options?: Maybe<Order_By>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input = {
  options?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  options?: Maybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  options?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Options = 'options'
}

export type AuthProviderRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<AuthProviderRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<AuthProviderRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<AuthProviderRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<AuthProviderRequests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<AuthProviderRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders = {
  id: Scalars['String'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate = {
  aggregate?: Maybe<AuthProviders_Aggregate_Fields>;
  nodes: Array<AuthProviders>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthProviders_Max_Fields>;
  min?: Maybe<AuthProviders_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthProviders_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp = {
  _and?: Maybe<Array<AuthProviders_Bool_Exp>>;
  _not?: Maybe<AuthProviders_Bool_Exp>;
  _or?: Maybe<Array<AuthProviders_Bool_Exp>>;
  id?: Maybe<String_Comparison_Exp>;
  userProviders?: Maybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: Maybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  userProviders?: Maybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields = {
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields = {
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input = {
  data: AuthProviders_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<AuthProviders_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict = {
  constraint: AuthProviders_Constraint;
  update_columns?: Array<AuthProviders_Update_Column>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By = {
  id?: Maybe<Order_By>;
  userProviders_aggregate?: Maybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input = {
  id?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['String']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column {
  /** column name */
  Id = 'id'
}

export type AuthProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens = {
  createdAt: Scalars['timestamptz'];
  expiresAt: Scalars['timestamptz'];
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars['uuid'];
  refreshTokenHash?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate = {
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields>;
  nodes: Array<AuthRefreshTokens>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp = {
  count?: Maybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AuthRefreshTokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthRefreshTokens_Max_Fields>;
  min?: Maybe<AuthRefreshTokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<AuthRefreshTokens_Max_Order_By>;
  min?: Maybe<AuthRefreshTokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input = {
  data: Array<AuthRefreshTokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<AuthRefreshTokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp = {
  _and?: Maybe<Array<AuthRefreshTokens_Bool_Exp>>;
  _not?: Maybe<AuthRefreshTokens_Bool_Exp>;
  _or?: Maybe<Array<AuthRefreshTokens_Bool_Exp>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  expiresAt?: Maybe<Timestamptz_Comparison_Exp>;
  refreshToken?: Maybe<Uuid_Comparison_Exp>;
  refreshTokenHash?: Maybe<String_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userId?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint {
  /** unique or primary key constraint on columns "refresh_token" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Scalars['uuid']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Scalars['uuid']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  expiresAt?: Maybe<Order_By>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Order_By>;
  refreshTokenHash?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Scalars['uuid']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  expiresAt?: Maybe<Order_By>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Order_By>;
  refreshTokenHash?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict = {
  constraint: AuthRefreshTokens_Constraint;
  update_columns?: Array<AuthRefreshTokens_Update_Column>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By = {
  createdAt?: Maybe<Order_By>;
  expiresAt?: Maybe<Order_By>;
  refreshToken?: Maybe<Order_By>;
  refreshTokenHash?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userId?: Maybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input = {
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken: Scalars['uuid'];
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  RefreshTokenHash = 'refreshTokenHash',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiresAt?: Maybe<Scalars['timestamptz']>;
  /** DEPRECATED: auto-generated refresh token id. Will be replaced by a genereric id column that will be used as a primary key, not the refresh token itself. Use refresh_token_hash instead. */
  refreshToken?: Maybe<Scalars['uuid']>;
  refreshTokenHash?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UserId = 'userId'
}

export type AuthRefreshTokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles = {
  role: Scalars['String'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  usersByDefaultRole: Array<Users>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate = {
  aggregate?: Maybe<AuthRoles_Aggregate_Fields>;
  nodes: Array<AuthRoles>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthRoles_Max_Fields>;
  min?: Maybe<AuthRoles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthRoles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp = {
  _and?: Maybe<Array<AuthRoles_Bool_Exp>>;
  _not?: Maybe<AuthRoles_Bool_Exp>;
  _or?: Maybe<Array<AuthRoles_Bool_Exp>>;
  role?: Maybe<String_Comparison_Exp>;
  userRoles?: Maybe<AuthUserRoles_Bool_Exp>;
  userRoles_aggregate?: Maybe<AuthUserRoles_Aggregate_Bool_Exp>;
  usersByDefaultRole?: Maybe<Users_Bool_Exp>;
  usersByDefaultRole_aggregate?: Maybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input = {
  role?: Maybe<Scalars['String']>;
  userRoles?: Maybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  usersByDefaultRole?: Maybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields = {
  role?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields = {
  role?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input = {
  data: AuthRoles_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<AuthRoles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict = {
  constraint: AuthRoles_Constraint;
  update_columns?: Array<AuthRoles_Update_Column>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By = {
  role?: Maybe<Order_By>;
  userRoles_aggregate?: Maybe<AuthUserRoles_Aggregate_Order_By>;
  usersByDefaultRole_aggregate?: Maybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input = {
  role: Scalars['String'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input = {
  role?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input = {
  role?: Maybe<Scalars['String']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column {
  /** column name */
  Role = 'role'
}

export type AuthRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders = {
  accessToken: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  provider: AuthProviders;
  providerId: Scalars['String'];
  providerUserId: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate = {
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields>;
  nodes: Array<AuthUserProviders>;
};

export type AuthUserProviders_Aggregate_Bool_Exp = {
  count?: Maybe<AuthUserProviders_Aggregate_Bool_Exp_Count>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AuthUserProviders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthUserProviders_Max_Fields>;
  min?: Maybe<AuthUserProviders_Min_Fields>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthUserProviders_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<AuthUserProviders_Max_Order_By>;
  min?: Maybe<AuthUserProviders_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input = {
  data: Array<AuthUserProviders_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<AuthUserProviders_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp = {
  _and?: Maybe<Array<AuthUserProviders_Bool_Exp>>;
  _not?: Maybe<AuthUserProviders_Bool_Exp>;
  _or?: Maybe<Array<AuthUserProviders_Bool_Exp>>;
  accessToken?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  provider?: Maybe<AuthProviders_Bool_Exp>;
  providerId?: Maybe<String_Comparison_Exp>;
  providerUserId?: Maybe<String_Comparison_Exp>;
  refreshToken?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userId?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_id", "provider_user_id" */
  UserProvidersProviderIdProviderUserIdKey = 'user_providers_provider_id_provider_user_id_key',
  /** unique or primary key constraint on columns "provider_id", "user_id" */
  UserProvidersUserIdProviderIdKey = 'user_providers_user_id_provider_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input = {
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<AuthProviders_Obj_Rel_Insert_Input>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields = {
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By = {
  accessToken?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  providerId?: Maybe<Order_By>;
  providerUserId?: Maybe<Order_By>;
  refreshToken?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields = {
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By = {
  accessToken?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  providerId?: Maybe<Order_By>;
  providerUserId?: Maybe<Order_By>;
  refreshToken?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict = {
  constraint: AuthUserProviders_Constraint;
  update_columns?: Array<AuthUserProviders_Update_Column>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By = {
  accessToken?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  provider?: Maybe<AuthProviders_Order_By>;
  providerId?: Maybe<Order_By>;
  providerUserId?: Maybe<Order_By>;
  refreshToken?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userId?: Maybe<Order_By>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input = {
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input = {
  accessToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  providerId?: Maybe<Scalars['String']>;
  providerUserId?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column {
  /** column name */
  AccessToken = 'accessToken',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  ProviderUserId = 'providerUserId',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type AuthUserProviders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles = {
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  role: Scalars['String'];
  /** An object relationship */
  roleByRole: AuthRoles;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate = {
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields>;
  nodes: Array<AuthUserRoles>;
};

export type AuthUserRoles_Aggregate_Bool_Exp = {
  count?: Maybe<AuthUserRoles_Aggregate_Bool_Exp_Count>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AuthUserRoles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<AuthUserRoles_Max_Fields>;
  min?: Maybe<AuthUserRoles_Min_Fields>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthUserRoles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<AuthUserRoles_Max_Order_By>;
  min?: Maybe<AuthUserRoles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input = {
  data: Array<AuthUserRoles_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<AuthUserRoles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp = {
  _and?: Maybe<Array<AuthUserRoles_Bool_Exp>>;
  _not?: Maybe<AuthUserRoles_Bool_Exp>;
  _or?: Maybe<Array<AuthUserRoles_Bool_Exp>>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  roleByRole?: Maybe<AuthRoles_Bool_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userId?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<AuthRoles_Obj_Rel_Insert_Input>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict = {
  constraint: AuthUserRoles_Constraint;
  update_columns?: Array<AuthUserRoles_Update_Column>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By = {
  createdAt?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  roleByRole?: Maybe<AuthRoles_Order_By>;
  user?: Maybe<Users_Order_By>;
  userId?: Maybe<Order_By>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input = {
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'userId'
}

export type AuthUserRoles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys = {
  counter: Scalars['bigint'];
  credentialId: Scalars['String'];
  credentialPublicKey?: Maybe<Scalars['bytea']>;
  id: Scalars['uuid'];
  nickname?: Maybe<Scalars['String']>;
  transports: Scalars['String'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate = {
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields>;
  nodes: Array<AuthUserSecurityKeys>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp = {
  count?: Maybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields = {
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By = {
  avg?: Maybe<AuthUserSecurityKeys_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<AuthUserSecurityKeys_Max_Order_By>;
  min?: Maybe<AuthUserSecurityKeys_Min_Order_By>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Order_By>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Order_By>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Order_By>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Order_By>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Order_By>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input = {
  data: Array<AuthUserSecurityKeys_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<AuthUserSecurityKeys_On_Conflict>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By = {
  counter?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp = {
  _and?: Maybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  _not?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
  _or?: Maybe<Array<AuthUserSecurityKeys_Bool_Exp>>;
  counter?: Maybe<Bigint_Comparison_Exp>;
  credentialId?: Maybe<String_Comparison_Exp>;
  credentialPublicKey?: Maybe<Bytea_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  nickname?: Maybe<String_Comparison_Exp>;
  transports?: Maybe<String_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userId?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input = {
  counter?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input = {
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  credentialPublicKey?: Maybe<Scalars['bytea']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields = {
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By = {
  counter?: Maybe<Order_By>;
  credentialId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  transports?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields = {
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By = {
  counter?: Maybe<Order_By>;
  credentialId?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  transports?: Maybe<Order_By>;
  userId?: Maybe<Order_By>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict = {
  constraint: AuthUserSecurityKeys_Constraint;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By = {
  counter?: Maybe<Order_By>;
  credentialId?: Maybe<Order_By>;
  credentialPublicKey?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  nickname?: Maybe<Order_By>;
  transports?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userId?: Maybe<Order_By>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input = {
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  credentialPublicKey?: Maybe<Scalars['bytea']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By = {
  counter?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By = {
  counter?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By = {
  counter?: Maybe<Order_By>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input = {
  counter?: Maybe<Scalars['bigint']>;
  credentialId?: Maybe<Scalars['String']>;
  credentialPublicKey?: Maybe<Scalars['bytea']>;
  id?: Maybe<Scalars['uuid']>;
  nickname?: Maybe<Scalars['String']>;
  transports?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields = {
  counter?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By = {
  counter?: Maybe<Order_By>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column {
  /** column name */
  Counter = 'counter',
  /** column name */
  CredentialId = 'credentialId',
  /** column name */
  CredentialPublicKey = 'credentialPublicKey',
  /** column name */
  Id = 'id',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  Transports = 'transports',
  /** column name */
  UserId = 'userId'
}

export type AuthUserSecurityKeys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<AuthUserSecurityKeys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By = {
  counter?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By = {
  counter?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields = {
  counter?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By = {
  counter?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};


/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: Maybe<Scalars['bpchar']>;
  _gt?: Maybe<Scalars['bpchar']>;
  _gte?: Maybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['bpchar']>;
  _in?: Maybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['bpchar']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['bpchar']>;
  _lt?: Maybe<Scalars['bpchar']>;
  _lte?: Maybe<Scalars['bpchar']>;
  _neq?: Maybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['bpchar']>;
  _nin?: Maybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['bpchar']>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  downloadExpiration: Scalars['Int'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  id: Scalars['String'];
  maxUploadFileSize: Scalars['Int'];
  minUploadFileSize: Scalars['Int'];
  presignedUrlsEnabled: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate = {
  aggregate?: Maybe<Buckets_Aggregate_Fields>;
  nodes: Array<Buckets>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields = {
  avg?: Maybe<Buckets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Buckets_Max_Fields>;
  min?: Maybe<Buckets_Min_Fields>;
  stddev?: Maybe<Buckets_Stddev_Fields>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields>;
  sum?: Maybe<Buckets_Sum_Fields>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields>;
  variance?: Maybe<Buckets_Variance_Fields>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Buckets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp = {
  _and?: Maybe<Array<Buckets_Bool_Exp>>;
  _not?: Maybe<Buckets_Bool_Exp>;
  _or?: Maybe<Array<Buckets_Bool_Exp>>;
  cacheControl?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  downloadExpiration?: Maybe<Int_Comparison_Exp>;
  files?: Maybe<Files_Bool_Exp>;
  files_aggregate?: Maybe<Files_Aggregate_Bool_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  maxUploadFileSize?: Maybe<Int_Comparison_Exp>;
  minUploadFileSize?: Maybe<Int_Comparison_Exp>;
  presignedUrlsEnabled?: Maybe<Boolean_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input = {
  downloadExpiration?: Maybe<Scalars['Int']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  files?: Maybe<Files_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  presignedUrlsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input = {
  data: Buckets_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Buckets_On_Conflict>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict = {
  constraint: Buckets_Constraint;
  update_columns?: Array<Buckets_Update_Column>;
  where?: Maybe<Buckets_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By = {
  cacheControl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  downloadExpiration?: Maybe<Order_By>;
  files_aggregate?: Maybe<Files_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  maxUploadFileSize?: Maybe<Order_By>;
  minUploadFileSize?: Maybe<Order_By>;
  presignedUrlsEnabled?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  presignedUrlsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input = {
  cacheControl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  downloadExpiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
  presignedUrlsEnabled?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields = {
  downloadExpiration?: Maybe<Scalars['Int']>;
  maxUploadFileSize?: Maybe<Scalars['Int']>;
  minUploadFileSize?: Maybe<Scalars['Int']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column {
  /** column name */
  CacheControl = 'cacheControl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DownloadExpiration = 'downloadExpiration',
  /** column name */
  Id = 'id',
  /** column name */
  MaxUploadFileSize = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Buckets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Buckets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields = {
  downloadExpiration?: Maybe<Scalars['Float']>;
  maxUploadFileSize?: Maybe<Scalars['Float']>;
  minUploadFileSize?: Maybe<Scalars['Float']>;
};


/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: Maybe<Scalars['bytea']>;
  _gt?: Maybe<Scalars['bytea']>;
  _gte?: Maybe<Scalars['bytea']>;
  _in?: Maybe<Array<Scalars['bytea']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bytea']>;
  _lte?: Maybe<Scalars['bytea']>;
  _neq?: Maybe<Scalars['bytea']>;
  _nin?: Maybe<Array<Scalars['bytea']>>;
};

/** columns and relationships of "careers" */
export type Careers = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  careers_area?: Maybe<Areas>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "careers" */
export type Careers_Aggregate = {
  aggregate?: Maybe<Careers_Aggregate_Fields>;
  nodes: Array<Careers>;
};

/** aggregate fields of "careers" */
export type Careers_Aggregate_Fields = {
  avg?: Maybe<Careers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Careers_Max_Fields>;
  min?: Maybe<Careers_Min_Fields>;
  stddev?: Maybe<Careers_Stddev_Fields>;
  stddev_pop?: Maybe<Careers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Careers_Stddev_Samp_Fields>;
  sum?: Maybe<Careers_Sum_Fields>;
  var_pop?: Maybe<Careers_Var_Pop_Fields>;
  var_samp?: Maybe<Careers_Var_Samp_Fields>;
  variance?: Maybe<Careers_Variance_Fields>;
};


/** aggregate fields of "careers" */
export type Careers_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Careers_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Careers_Avg_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "careers". All fields are combined with a logical 'AND'. */
export type Careers_Bool_Exp = {
  _and?: Maybe<Array<Careers_Bool_Exp>>;
  _not?: Maybe<Careers_Bool_Exp>;
  _or?: Maybe<Array<Careers_Bool_Exp>>;
  amount?: Maybe<Float8_Comparison_Exp>;
  area_id?: Maybe<String_Comparison_Exp>;
  area_type?: Maybe<String_Comparison_Exp>;
  careers_area?: Maybe<Areas_Bool_Exp>;
  category?: Maybe<String_Comparison_Exp>;
  label?: Maybe<String_Comparison_Exp>;
  measure?: Maybe<String_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  year?: Maybe<Float8_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "careers" */
export type Careers_Inc_Input = {
  amount?: Maybe<Scalars['float8']>;
  year?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "careers" */
export type Careers_Insert_Input = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  careers_area?: Maybe<Areas_Obj_Rel_Insert_Input>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Careers_Max_Fields = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Careers_Min_Fields = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "careers" */
export type Careers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Careers>;
};

/** Ordering options when selecting data from "careers". */
export type Careers_Order_By = {
  amount?: Maybe<Order_By>;
  area_id?: Maybe<Order_By>;
  area_type?: Maybe<Order_By>;
  careers_area?: Maybe<Areas_Order_By>;
  category?: Maybe<Order_By>;
  label?: Maybe<Order_By>;
  measure?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** select columns of table "careers" */
export enum Careers_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AreaId = 'area_id',
  /** column name */
  AreaType = 'area_type',
  /** column name */
  Category = 'category',
  /** column name */
  Label = 'label',
  /** column name */
  Measure = 'measure',
  /** column name */
  Source = 'source',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "careers" */
export type Careers_Set_Input = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Careers_Stddev_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Careers_Stddev_Pop_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Careers_Stddev_Samp_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "careers" */
export type Careers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Careers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Careers_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['float8']>;
  area_id?: Maybe<Scalars['String']>;
  area_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Careers_Sum_Fields = {
  amount?: Maybe<Scalars['float8']>;
  year?: Maybe<Scalars['float8']>;
};

export type Careers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Careers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Careers_Set_Input>;
  where: Careers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Careers_Var_Pop_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Careers_Var_Samp_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Careers_Variance_Fields = {
  amount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
};

/** columns and relationships of "counties" */
export type Counties = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "counties" */
export type Counties_Aggregate = {
  aggregate?: Maybe<Counties_Aggregate_Fields>;
  nodes: Array<Counties>;
};

/** aggregate fields of "counties" */
export type Counties_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Counties_Max_Fields>;
  min?: Maybe<Counties_Min_Fields>;
};


/** aggregate fields of "counties" */
export type Counties_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Counties_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "counties". All fields are combined with a logical 'AND'. */
export type Counties_Bool_Exp = {
  _and?: Maybe<Array<Counties_Bool_Exp>>;
  _not?: Maybe<Counties_Bool_Exp>;
  _or?: Maybe<Array<Counties_Bool_Exp>>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "counties" */
export type Counties_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Counties_Max_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Counties_Min_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "counties" */
export type Counties_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Counties>;
};

/** Ordering options when selecting data from "counties". */
export type Counties_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** select columns of table "counties" */
export enum Counties_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "counties" */
export type Counties_Set_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "counties" */
export type Counties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Counties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Counties_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Counties_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Counties_Set_Input>;
  where: Counties_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "employer_stats" */
export type Employer_Stats = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "employer_stats" */
export type Employer_Stats_Aggregate = {
  aggregate?: Maybe<Employer_Stats_Aggregate_Fields>;
  nodes: Array<Employer_Stats>;
};

/** aggregate fields of "employer_stats" */
export type Employer_Stats_Aggregate_Fields = {
  avg?: Maybe<Employer_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Employer_Stats_Max_Fields>;
  min?: Maybe<Employer_Stats_Min_Fields>;
  stddev?: Maybe<Employer_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Employer_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Employer_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Employer_Stats_Sum_Fields>;
  var_pop?: Maybe<Employer_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Employer_Stats_Var_Samp_Fields>;
  variance?: Maybe<Employer_Stats_Variance_Fields>;
};


/** aggregate fields of "employer_stats" */
export type Employer_Stats_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Employer_Stats_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Employer_Stats_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "employer_stats". All fields are combined with a logical 'AND'. */
export type Employer_Stats_Bool_Exp = {
  Count?: Maybe<Bigint_Comparison_Exp>;
  _and?: Maybe<Array<Employer_Stats_Bool_Exp>>;
  _not?: Maybe<Employer_Stats_Bool_Exp>;
  _or?: Maybe<Array<Employer_Stats_Bool_Exp>>;
  category?: Maybe<String_Comparison_Exp>;
  employer?: Maybe<String_Comparison_Exp>;
  label?: Maybe<String_Comparison_Exp>;
  latitude?: Maybe<Float8_Comparison_Exp>;
  longitude?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "employer_stats" */
export type Employer_Stats_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "employer_stats" */
export type Employer_Stats_Insert_Input = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Employer_Stats_Max_Fields = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Employer_Stats_Min_Fields = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "employer_stats" */
export type Employer_Stats_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Employer_Stats>;
};

/** Ordering options when selecting data from "employer_stats". */
export type Employer_Stats_Order_By = {
  Count?: Maybe<Order_By>;
  category?: Maybe<Order_By>;
  employer?: Maybe<Order_By>;
  label?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
};

/** select columns of table "employer_stats" */
export enum Employer_Stats_Select_Column {
  /** column name */
  Count = 'Count',
  /** column name */
  Category = 'category',
  /** column name */
  Employer = 'employer',
  /** column name */
  Label = 'label',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "employer_stats" */
export type Employer_Stats_Set_Input = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Employer_Stats_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Employer_Stats_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Employer_Stats_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "employer_stats" */
export type Employer_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Employer_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Employer_Stats_Stream_Cursor_Value_Input = {
  Count?: Maybe<Scalars['bigint']>;
  category?: Maybe<Scalars['String']>;
  employer?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Employer_Stats_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
};

export type Employer_Stats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Employer_Stats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Employer_Stats_Set_Input>;
  where: Employer_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Employer_Stats_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Employer_Stats_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Employer_Stats_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "storage.files" */
export type Files = {
  /** An object relationship */
  bucket: Buckets;
  bucketId: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  etag?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isUploaded?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['timestamptz'];
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate = {
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Files_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields = {
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Files_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By = {
  avg?: Maybe<Files_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Files_Max_Order_By>;
  min?: Maybe<Files_Min_Order_By>;
  stddev?: Maybe<Files_Stddev_Order_By>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Order_By>;
  sum?: Maybe<Files_Sum_Order_By>;
  var_pop?: Maybe<Files_Var_Pop_Order_By>;
  var_samp?: Maybe<Files_Var_Samp_Order_By>;
  variance?: Maybe<Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By = {
  size?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: Maybe<Array<Files_Bool_Exp>>;
  _not?: Maybe<Files_Bool_Exp>;
  _or?: Maybe<Array<Files_Bool_Exp>>;
  bucket?: Maybe<Buckets_Bool_Exp>;
  bucketId?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  etag?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isUploaded?: Maybe<Boolean_Comparison_Exp>;
  mimeType?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  size?: Maybe<Int_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  uploadedByUserId?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input = {
  size?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input = {
  bucket?: Maybe<Buckets_Obj_Rel_Insert_Input>;
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isUploaded?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By = {
  bucketId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  etag?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mimeType?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  uploadedByUserId?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By = {
  bucketId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  etag?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mimeType?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  uploadedByUserId?: Maybe<Order_By>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: Maybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By = {
  bucket?: Maybe<Buckets_Order_By>;
  bucketId?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  etag?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isUploaded?: Maybe<Order_By>;
  mimeType?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  uploadedByUserId?: Maybe<Order_By>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "storage.files" */
export enum Files_Select_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUploaded = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input = {
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isUploaded?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By = {
  size?: Maybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  bucketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  isUploaded?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  uploadedByUserId?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  size?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By = {
  size?: Maybe<Order_By>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column {
  /** column name */
  BucketId = 'bucketId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Etag = 'etag',
  /** column name */
  Id = 'id',
  /** column name */
  IsUploaded = 'isUploaded',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadedByUserId = 'uploadedByUserId'
}

export type Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By = {
  size?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  size?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By = {
  size?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "geotree" */
export type Geotree = {
  CountyAreaCode: Scalars['bpchar'];
  LadAreaCode: Scalars['bpchar'];
  NationAreaCode: Scalars['bpchar'];
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** aggregated selection of "geotree" */
export type Geotree_Aggregate = {
  aggregate?: Maybe<Geotree_Aggregate_Fields>;
  nodes: Array<Geotree>;
};

/** aggregate fields of "geotree" */
export type Geotree_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Geotree_Max_Fields>;
  min?: Maybe<Geotree_Min_Fields>;
};


/** aggregate fields of "geotree" */
export type Geotree_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Geotree_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "geotree". All fields are combined with a logical 'AND'. */
export type Geotree_Bool_Exp = {
  CountyAreaCode?: Maybe<Bpchar_Comparison_Exp>;
  LadAreaCode?: Maybe<Bpchar_Comparison_Exp>;
  NationAreaCode?: Maybe<Bpchar_Comparison_Exp>;
  RegionAreaCode?: Maybe<Bpchar_Comparison_Exp>;
  _and?: Maybe<Array<Geotree_Bool_Exp>>;
  _not?: Maybe<Geotree_Bool_Exp>;
  _or?: Maybe<Array<Geotree_Bool_Exp>>;
};

/** unique or primary key constraints on table "geotree" */
export enum Geotree_Constraint {
  /** unique or primary key constraint on columns "LadAreaCode" */
  GeotreePkey = 'geotree_pkey'
}

/** input type for inserting data into table "geotree" */
export type Geotree_Insert_Input = {
  CountyAreaCode?: Maybe<Scalars['bpchar']>;
  LadAreaCode?: Maybe<Scalars['bpchar']>;
  NationAreaCode?: Maybe<Scalars['bpchar']>;
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** aggregate max on columns */
export type Geotree_Max_Fields = {
  CountyAreaCode?: Maybe<Scalars['bpchar']>;
  LadAreaCode?: Maybe<Scalars['bpchar']>;
  NationAreaCode?: Maybe<Scalars['bpchar']>;
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** aggregate min on columns */
export type Geotree_Min_Fields = {
  CountyAreaCode?: Maybe<Scalars['bpchar']>;
  LadAreaCode?: Maybe<Scalars['bpchar']>;
  NationAreaCode?: Maybe<Scalars['bpchar']>;
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** response of any mutation on the table "geotree" */
export type Geotree_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Geotree>;
};

/** on_conflict condition type for table "geotree" */
export type Geotree_On_Conflict = {
  constraint: Geotree_Constraint;
  update_columns?: Array<Geotree_Update_Column>;
  where?: Maybe<Geotree_Bool_Exp>;
};

/** Ordering options when selecting data from "geotree". */
export type Geotree_Order_By = {
  CountyAreaCode?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
};

/** primary key columns input for table: geotree */
export type Geotree_Pk_Columns_Input = {
  LadAreaCode: Scalars['bpchar'];
};

/** select columns of table "geotree" */
export enum Geotree_Select_Column {
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode'
}

/** input type for updating data in table "geotree" */
export type Geotree_Set_Input = {
  CountyAreaCode?: Maybe<Scalars['bpchar']>;
  LadAreaCode?: Maybe<Scalars['bpchar']>;
  NationAreaCode?: Maybe<Scalars['bpchar']>;
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** Streaming cursor of the table "geotree" */
export type Geotree_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geotree_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geotree_Stream_Cursor_Value_Input = {
  CountyAreaCode?: Maybe<Scalars['bpchar']>;
  LadAreaCode?: Maybe<Scalars['bpchar']>;
  NationAreaCode?: Maybe<Scalars['bpchar']>;
  RegionAreaCode?: Maybe<Scalars['bpchar']>;
};

/** update columns of table "geotree" */
export enum Geotree_Update_Column {
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode'
}

export type Geotree_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Geotree_Set_Input>;
  where: Geotree_Bool_Exp;
};

/** columns and relationships of "global_emerging_jobs" */
export type Global_Emerging_Jobs = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "global_emerging_jobs" */
export type Global_Emerging_Jobs_Aggregate = {
  aggregate?: Maybe<Global_Emerging_Jobs_Aggregate_Fields>;
  nodes: Array<Global_Emerging_Jobs>;
};

/** aggregate fields of "global_emerging_jobs" */
export type Global_Emerging_Jobs_Aggregate_Fields = {
  avg?: Maybe<Global_Emerging_Jobs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Global_Emerging_Jobs_Max_Fields>;
  min?: Maybe<Global_Emerging_Jobs_Min_Fields>;
  stddev?: Maybe<Global_Emerging_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Global_Emerging_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Global_Emerging_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Global_Emerging_Jobs_Sum_Fields>;
  var_pop?: Maybe<Global_Emerging_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Global_Emerging_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Global_Emerging_Jobs_Variance_Fields>;
};


/** aggregate fields of "global_emerging_jobs" */
export type Global_Emerging_Jobs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Global_Emerging_Jobs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Global_Emerging_Jobs_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "global_emerging_jobs". All fields are combined with a logical 'AND'. */
export type Global_Emerging_Jobs_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Global_Emerging_Jobs_Bool_Exp>>;
  _not?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
  _or?: Maybe<Array<Global_Emerging_Jobs_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "global_emerging_jobs" */
export type Global_Emerging_Jobs_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "global_emerging_jobs" */
export type Global_Emerging_Jobs_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Global_Emerging_Jobs_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Global_Emerging_Jobs_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "global_emerging_jobs" */
export type Global_Emerging_Jobs_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Emerging_Jobs>;
};

/** Ordering options when selecting data from "global_emerging_jobs". */
export type Global_Emerging_Jobs_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "global_emerging_jobs" */
export enum Global_Emerging_Jobs_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "global_emerging_jobs" */
export type Global_Emerging_Jobs_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Global_Emerging_Jobs_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Global_Emerging_Jobs_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Global_Emerging_Jobs_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "global_emerging_jobs" */
export type Global_Emerging_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Emerging_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Emerging_Jobs_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Global_Emerging_Jobs_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Global_Emerging_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Global_Emerging_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Global_Emerging_Jobs_Set_Input>;
  where: Global_Emerging_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Emerging_Jobs_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Global_Emerging_Jobs_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Global_Emerging_Jobs_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "global_emerging_skills" */
export type Global_Emerging_Skills = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "global_emerging_skills" */
export type Global_Emerging_Skills_Aggregate = {
  aggregate?: Maybe<Global_Emerging_Skills_Aggregate_Fields>;
  nodes: Array<Global_Emerging_Skills>;
};

/** aggregate fields of "global_emerging_skills" */
export type Global_Emerging_Skills_Aggregate_Fields = {
  avg?: Maybe<Global_Emerging_Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Global_Emerging_Skills_Max_Fields>;
  min?: Maybe<Global_Emerging_Skills_Min_Fields>;
  stddev?: Maybe<Global_Emerging_Skills_Stddev_Fields>;
  stddev_pop?: Maybe<Global_Emerging_Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Global_Emerging_Skills_Stddev_Samp_Fields>;
  sum?: Maybe<Global_Emerging_Skills_Sum_Fields>;
  var_pop?: Maybe<Global_Emerging_Skills_Var_Pop_Fields>;
  var_samp?: Maybe<Global_Emerging_Skills_Var_Samp_Fields>;
  variance?: Maybe<Global_Emerging_Skills_Variance_Fields>;
};


/** aggregate fields of "global_emerging_skills" */
export type Global_Emerging_Skills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Global_Emerging_Skills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Global_Emerging_Skills_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "global_emerging_skills". All fields are combined with a logical 'AND'. */
export type Global_Emerging_Skills_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Global_Emerging_Skills_Bool_Exp>>;
  _not?: Maybe<Global_Emerging_Skills_Bool_Exp>;
  _or?: Maybe<Array<Global_Emerging_Skills_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "global_emerging_skills" */
export type Global_Emerging_Skills_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "global_emerging_skills" */
export type Global_Emerging_Skills_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Global_Emerging_Skills_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Global_Emerging_Skills_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "global_emerging_skills" */
export type Global_Emerging_Skills_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Emerging_Skills>;
};

/** Ordering options when selecting data from "global_emerging_skills". */
export type Global_Emerging_Skills_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "global_emerging_skills" */
export enum Global_Emerging_Skills_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "global_emerging_skills" */
export type Global_Emerging_Skills_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Global_Emerging_Skills_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Global_Emerging_Skills_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Global_Emerging_Skills_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "global_emerging_skills" */
export type Global_Emerging_Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Emerging_Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Emerging_Skills_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Global_Emerging_Skills_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Global_Emerging_Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Global_Emerging_Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Global_Emerging_Skills_Set_Input>;
  where: Global_Emerging_Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Emerging_Skills_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Global_Emerging_Skills_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Global_Emerging_Skills_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters = {
  ChildSkill: Scalars['bpchar'];
  ParentSkill: Scalars['bpchar'];
  Similarity: Scalars['numeric'];
  id: Scalars['Int'];
};

/** aggregated selection of "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Aggregate = {
  aggregate?: Maybe<Global_Top_10_Skill_Clusters_Aggregate_Fields>;
  nodes: Array<Global_Top_10_Skill_Clusters>;
};

/** aggregate fields of "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Aggregate_Fields = {
  avg?: Maybe<Global_Top_10_Skill_Clusters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Global_Top_10_Skill_Clusters_Max_Fields>;
  min?: Maybe<Global_Top_10_Skill_Clusters_Min_Fields>;
  stddev?: Maybe<Global_Top_10_Skill_Clusters_Stddev_Fields>;
  stddev_pop?: Maybe<Global_Top_10_Skill_Clusters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Global_Top_10_Skill_Clusters_Stddev_Samp_Fields>;
  sum?: Maybe<Global_Top_10_Skill_Clusters_Sum_Fields>;
  var_pop?: Maybe<Global_Top_10_Skill_Clusters_Var_Pop_Fields>;
  var_samp?: Maybe<Global_Top_10_Skill_Clusters_Var_Samp_Fields>;
  variance?: Maybe<Global_Top_10_Skill_Clusters_Variance_Fields>;
};


/** aggregate fields of "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Global_Top_10_Skill_Clusters_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Global_Top_10_Skill_Clusters_Avg_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "global_top_10_skill_clusters". All fields are combined with a logical 'AND'. */
export type Global_Top_10_Skill_Clusters_Bool_Exp = {
  ChildSkill?: Maybe<Bpchar_Comparison_Exp>;
  ParentSkill?: Maybe<Bpchar_Comparison_Exp>;
  Similarity?: Maybe<Numeric_Comparison_Exp>;
  _and?: Maybe<Array<Global_Top_10_Skill_Clusters_Bool_Exp>>;
  _not?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
  _or?: Maybe<Array<Global_Top_10_Skill_Clusters_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_top_10_skill_clusters" */
export enum Global_Top_10_Skill_Clusters_Constraint {
  /** unique or primary key constraint on columns "ChildSkill", "ParentSkill" */
  GlobalTop_10SkillClustersParentSkillChildSkillKey = 'global_top_10_skill_clusters_ParentSkill_ChildSkill_key',
  /** unique or primary key constraint on columns "id" */
  GlobalTop_10SkillClustersPkey = 'global_top_10_skill_clusters_pkey'
}

/** input type for incrementing numeric columns in table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Inc_Input = {
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Insert_Input = {
  ChildSkill?: Maybe<Scalars['bpchar']>;
  ParentSkill?: Maybe<Scalars['bpchar']>;
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Global_Top_10_Skill_Clusters_Max_Fields = {
  ChildSkill?: Maybe<Scalars['bpchar']>;
  ParentSkill?: Maybe<Scalars['bpchar']>;
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Global_Top_10_Skill_Clusters_Min_Fields = {
  ChildSkill?: Maybe<Scalars['bpchar']>;
  ParentSkill?: Maybe<Scalars['bpchar']>;
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Top_10_Skill_Clusters>;
};

/** on_conflict condition type for table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_On_Conflict = {
  constraint: Global_Top_10_Skill_Clusters_Constraint;
  update_columns?: Array<Global_Top_10_Skill_Clusters_Update_Column>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};

/** Ordering options when selecting data from "global_top_10_skill_clusters". */
export type Global_Top_10_Skill_Clusters_Order_By = {
  ChildSkill?: Maybe<Order_By>;
  ParentSkill?: Maybe<Order_By>;
  Similarity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: global_top_10_skill_clusters */
export type Global_Top_10_Skill_Clusters_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "global_top_10_skill_clusters" */
export enum Global_Top_10_Skill_Clusters_Select_Column {
  /** column name */
  ChildSkill = 'ChildSkill',
  /** column name */
  ParentSkill = 'ParentSkill',
  /** column name */
  Similarity = 'Similarity',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Set_Input = {
  ChildSkill?: Maybe<Scalars['bpchar']>;
  ParentSkill?: Maybe<Scalars['bpchar']>;
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Global_Top_10_Skill_Clusters_Stddev_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Global_Top_10_Skill_Clusters_Stddev_Pop_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Global_Top_10_Skill_Clusters_Stddev_Samp_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "global_top_10_skill_clusters" */
export type Global_Top_10_Skill_Clusters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Top_10_Skill_Clusters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Top_10_Skill_Clusters_Stream_Cursor_Value_Input = {
  ChildSkill?: Maybe<Scalars['bpchar']>;
  ParentSkill?: Maybe<Scalars['bpchar']>;
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Global_Top_10_Skill_Clusters_Sum_Fields = {
  Similarity?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "global_top_10_skill_clusters" */
export enum Global_Top_10_Skill_Clusters_Update_Column {
  /** column name */
  ChildSkill = 'ChildSkill',
  /** column name */
  ParentSkill = 'ParentSkill',
  /** column name */
  Similarity = 'Similarity',
  /** column name */
  Id = 'id'
}

export type Global_Top_10_Skill_Clusters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Global_Top_10_Skill_Clusters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Global_Top_10_Skill_Clusters_Set_Input>;
  where: Global_Top_10_Skill_Clusters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Top_10_Skill_Clusters_Var_Pop_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Global_Top_10_Skill_Clusters_Var_Samp_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Global_Top_10_Skill_Clusters_Variance_Fields = {
  Similarity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "global_top_10_skills" */
export type Global_Top_10_Skills = {
  ParentSkill: Scalars['bpchar'];
  id: Scalars['Int'];
};

/** aggregated selection of "global_top_10_skills" */
export type Global_Top_10_Skills_Aggregate = {
  aggregate?: Maybe<Global_Top_10_Skills_Aggregate_Fields>;
  nodes: Array<Global_Top_10_Skills>;
};

/** aggregate fields of "global_top_10_skills" */
export type Global_Top_10_Skills_Aggregate_Fields = {
  avg?: Maybe<Global_Top_10_Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Global_Top_10_Skills_Max_Fields>;
  min?: Maybe<Global_Top_10_Skills_Min_Fields>;
  stddev?: Maybe<Global_Top_10_Skills_Stddev_Fields>;
  stddev_pop?: Maybe<Global_Top_10_Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Global_Top_10_Skills_Stddev_Samp_Fields>;
  sum?: Maybe<Global_Top_10_Skills_Sum_Fields>;
  var_pop?: Maybe<Global_Top_10_Skills_Var_Pop_Fields>;
  var_samp?: Maybe<Global_Top_10_Skills_Var_Samp_Fields>;
  variance?: Maybe<Global_Top_10_Skills_Variance_Fields>;
};


/** aggregate fields of "global_top_10_skills" */
export type Global_Top_10_Skills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Global_Top_10_Skills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Global_Top_10_Skills_Avg_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "global_top_10_skills". All fields are combined with a logical 'AND'. */
export type Global_Top_10_Skills_Bool_Exp = {
  ParentSkill?: Maybe<Bpchar_Comparison_Exp>;
  _and?: Maybe<Array<Global_Top_10_Skills_Bool_Exp>>;
  _not?: Maybe<Global_Top_10_Skills_Bool_Exp>;
  _or?: Maybe<Array<Global_Top_10_Skills_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_top_10_skills" */
export enum Global_Top_10_Skills_Constraint {
  /** unique or primary key constraint on columns "id" */
  GlobalTop_10SkillsIdKey = 'global_top_10_skills_id_key',
  /** unique or primary key constraint on columns "ParentSkill" */
  GlobalTop_10SkillsPkey = 'global_top_10_skills_pkey'
}

/** input type for incrementing numeric columns in table "global_top_10_skills" */
export type Global_Top_10_Skills_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "global_top_10_skills" */
export type Global_Top_10_Skills_Insert_Input = {
  ParentSkill?: Maybe<Scalars['bpchar']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Global_Top_10_Skills_Max_Fields = {
  ParentSkill?: Maybe<Scalars['bpchar']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Global_Top_10_Skills_Min_Fields = {
  ParentSkill?: Maybe<Scalars['bpchar']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "global_top_10_skills" */
export type Global_Top_10_Skills_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Top_10_Skills>;
};

/** on_conflict condition type for table "global_top_10_skills" */
export type Global_Top_10_Skills_On_Conflict = {
  constraint: Global_Top_10_Skills_Constraint;
  update_columns?: Array<Global_Top_10_Skills_Update_Column>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};

/** Ordering options when selecting data from "global_top_10_skills". */
export type Global_Top_10_Skills_Order_By = {
  ParentSkill?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: global_top_10_skills */
export type Global_Top_10_Skills_Pk_Columns_Input = {
  ParentSkill: Scalars['bpchar'];
};

/** select columns of table "global_top_10_skills" */
export enum Global_Top_10_Skills_Select_Column {
  /** column name */
  ParentSkill = 'ParentSkill',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "global_top_10_skills" */
export type Global_Top_10_Skills_Set_Input = {
  ParentSkill?: Maybe<Scalars['bpchar']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Global_Top_10_Skills_Stddev_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Global_Top_10_Skills_Stddev_Pop_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Global_Top_10_Skills_Stddev_Samp_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "global_top_10_skills" */
export type Global_Top_10_Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Top_10_Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Top_10_Skills_Stream_Cursor_Value_Input = {
  ParentSkill?: Maybe<Scalars['bpchar']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Global_Top_10_Skills_Sum_Fields = {
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "global_top_10_skills" */
export enum Global_Top_10_Skills_Update_Column {
  /** column name */
  ParentSkill = 'ParentSkill',
  /** column name */
  Id = 'id'
}

export type Global_Top_10_Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Global_Top_10_Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Global_Top_10_Skills_Set_Input>;
  where: Global_Top_10_Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Global_Top_10_Skills_Var_Pop_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Global_Top_10_Skills_Var_Samp_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Global_Top_10_Skills_Variance_Fields = {
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Month_By_Canoncounty>;
};

/** aggregate fields of "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_month_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Month_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Month_By_Canoncounty>;
};

/** Ordering options when selecting data from "job_counts_per_month_by_canoncounty". */
export type Job_Counts_Per_Month_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_month_by_canoncounty" */
export enum Job_Counts_Per_Month_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_month_by_canoncounty" */
export type Job_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Month_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Set_Input>;
  where: Job_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Month_By_Canoncounty_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Month_By_Global_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Month_By_Global>;
};

/** aggregate fields of "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Month_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Month_By_Global_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Month_By_Global_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Month_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Month_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Month_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Month_By_Global_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Month_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Month_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Month_By_Global_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Month_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Month_By_Global_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_month_by_global". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Month_By_Global_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Month_By_Global_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Month_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Month_By_Global_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Month_By_Global_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Month_By_Global>;
};

/** Ordering options when selecting data from "job_counts_per_month_by_global". */
export type Job_Counts_Per_Month_By_Global_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_month_by_global" */
export enum Job_Counts_Per_Month_By_Global_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Month_By_Global_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Month_By_Global_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Month_By_Global_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_month_by_global" */
export type Job_Counts_Per_Month_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Month_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Month_By_Global_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Month_By_Global_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Month_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Month_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Month_By_Global_Set_Input>;
  where: Job_Counts_Per_Month_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Month_By_Global_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Month_By_Global_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Month_By_Global_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Month_By_Lad_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Month_By_Lad>;
};

/** aggregate fields of "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Month_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Month_By_Lad_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Month_By_Lad_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Month_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Month_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Month_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Month_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Month_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Month_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Month_By_Lad_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Month_By_Lad_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_month_by_lad". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Month_By_Lad_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Month_By_Lad_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Month_By_Lad_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Month_By_Lad>;
};

/** Ordering options when selecting data from "job_counts_per_month_by_lad". */
export type Job_Counts_Per_Month_By_Lad_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_month_by_lad" */
export enum Job_Counts_Per_Month_By_Lad_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Month_By_Lad_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Month_By_Lad_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Month_By_Lad_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_month_by_lad" */
export type Job_Counts_Per_Month_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Month_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Month_By_Lad_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Month_By_Lad_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Month_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Month_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Month_By_Lad_Set_Input>;
  where: Job_Counts_Per_Month_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Month_By_Lad_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Month_By_Lad_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Month_By_Lad_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Month_By_Nation_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Month_By_Nation>;
};

/** aggregate fields of "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Month_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Month_By_Nation_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Month_By_Nation_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Month_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Month_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Month_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Month_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Month_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Month_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Month_By_Nation_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Month_By_Nation_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_month_by_nation". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Month_By_Nation_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Month_By_Nation_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Month_By_Nation_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Month_By_Nation>;
};

/** Ordering options when selecting data from "job_counts_per_month_by_nation". */
export type Job_Counts_Per_Month_By_Nation_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_month_by_nation" */
export enum Job_Counts_Per_Month_By_Nation_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Month_By_Nation_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Month_By_Nation_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Month_By_Nation_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_month_by_nation" */
export type Job_Counts_Per_Month_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Month_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Month_By_Nation_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Month_By_Nation_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Month_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Month_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Month_By_Nation_Set_Input>;
  where: Job_Counts_Per_Month_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Month_By_Nation_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Month_By_Nation_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Month_By_Nation_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Month_By_Region_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Month_By_Region>;
};

/** aggregate fields of "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Month_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Month_By_Region_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Month_By_Region_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Month_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Month_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Month_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Month_By_Region_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Month_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Month_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Month_By_Region_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Month_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Month_By_Region_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_month_by_region". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Month_By_Region_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Month_By_Region_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Month_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Month_By_Region_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Month_By_Region_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Month_By_Region>;
};

/** Ordering options when selecting data from "job_counts_per_month_by_region". */
export type Job_Counts_Per_Month_By_Region_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_month_by_region" */
export enum Job_Counts_Per_Month_By_Region_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Month_By_Region_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Month_By_Region_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Month_By_Region_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_month_by_region" */
export type Job_Counts_Per_Month_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Month_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Month_By_Region_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Month_By_Region_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Month_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Month_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Month_By_Region_Set_Input>;
  where: Job_Counts_Per_Month_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Month_By_Region_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Month_By_Region_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Month_By_Region_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Year_By_Canoncounty>;
};

/** aggregate fields of "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_year_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Year_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Year_By_Canoncounty>;
};

/** Ordering options when selecting data from "job_counts_per_year_by_canoncounty". */
export type Job_Counts_Per_Year_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_year_by_canoncounty" */
export enum Job_Counts_Per_Year_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_year_by_canoncounty" */
export type Job_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Year_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Set_Input>;
  where: Job_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Year_By_Canoncounty_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Year_By_Global_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Year_By_Global>;
};

/** aggregate fields of "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Year_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Year_By_Global_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Year_By_Global_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Year_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Year_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Year_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Year_By_Global_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Year_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Year_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Year_By_Global_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Year_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Year_By_Global_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_year_by_global". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Year_By_Global_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Year_By_Global_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Year_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Year_By_Global_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Year_By_Global_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Year_By_Global>;
};

/** Ordering options when selecting data from "job_counts_per_year_by_global". */
export type Job_Counts_Per_Year_By_Global_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_year_by_global" */
export enum Job_Counts_Per_Year_By_Global_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Year_By_Global_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Year_By_Global_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Year_By_Global_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_year_by_global" */
export type Job_Counts_Per_Year_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Year_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Year_By_Global_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Year_By_Global_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Year_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Year_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Year_By_Global_Set_Input>;
  where: Job_Counts_Per_Year_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Year_By_Global_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Year_By_Global_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Year_By_Global_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Year_By_Lad_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Year_By_Lad>;
};

/** aggregate fields of "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Year_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Year_By_Lad_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Year_By_Lad_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Year_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Year_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Year_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Year_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Year_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Year_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Year_By_Lad_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Year_By_Lad_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_year_by_lad". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Year_By_Lad_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Year_By_Lad_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Year_By_Lad_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Year_By_Lad>;
};

/** Ordering options when selecting data from "job_counts_per_year_by_lad". */
export type Job_Counts_Per_Year_By_Lad_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_year_by_lad" */
export enum Job_Counts_Per_Year_By_Lad_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Year_By_Lad_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Year_By_Lad_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Year_By_Lad_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_year_by_lad" */
export type Job_Counts_Per_Year_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Year_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Year_By_Lad_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Year_By_Lad_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Year_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Year_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Year_By_Lad_Set_Input>;
  where: Job_Counts_Per_Year_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Year_By_Lad_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Year_By_Lad_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Year_By_Lad_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Year_By_Nation_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Year_By_Nation>;
};

/** aggregate fields of "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Year_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Year_By_Nation_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Year_By_Nation_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Year_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Year_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Year_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Year_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Year_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Year_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Year_By_Nation_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Year_By_Nation_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_year_by_nation". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Year_By_Nation_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Year_By_Nation_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Year_By_Nation_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Year_By_Nation>;
};

/** Ordering options when selecting data from "job_counts_per_year_by_nation". */
export type Job_Counts_Per_Year_By_Nation_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_year_by_nation" */
export enum Job_Counts_Per_Year_By_Nation_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Year_By_Nation_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Year_By_Nation_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Year_By_Nation_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_year_by_nation" */
export type Job_Counts_Per_Year_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Year_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Year_By_Nation_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Year_By_Nation_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Year_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Year_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Year_By_Nation_Set_Input>;
  where: Job_Counts_Per_Year_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Year_By_Nation_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Year_By_Nation_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Year_By_Nation_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Aggregate = {
  aggregate?: Maybe<Job_Counts_Per_Year_By_Region_Aggregate_Fields>;
  nodes: Array<Job_Counts_Per_Year_By_Region>;
};

/** aggregate fields of "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Aggregate_Fields = {
  avg?: Maybe<Job_Counts_Per_Year_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Counts_Per_Year_By_Region_Max_Fields>;
  min?: Maybe<Job_Counts_Per_Year_By_Region_Min_Fields>;
  stddev?: Maybe<Job_Counts_Per_Year_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Counts_Per_Year_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Counts_Per_Year_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Counts_Per_Year_By_Region_Sum_Fields>;
  var_pop?: Maybe<Job_Counts_Per_Year_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Counts_Per_Year_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Job_Counts_Per_Year_By_Region_Variance_Fields>;
};


/** aggregate fields of "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Counts_Per_Year_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Counts_Per_Year_By_Region_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_counts_per_year_by_region". All fields are combined with a logical 'AND'. */
export type Job_Counts_Per_Year_By_Region_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Counts_Per_Year_By_Region_Bool_Exp>>;
  _not?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Job_Counts_Per_Year_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Counts_Per_Year_By_Region_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Counts_Per_Year_By_Region_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Counts_Per_Year_By_Region>;
};

/** Ordering options when selecting data from "job_counts_per_year_by_region". */
export type Job_Counts_Per_Year_By_Region_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_counts_per_year_by_region" */
export enum Job_Counts_Per_Year_By_Region_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Counts_Per_Year_By_Region_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Counts_Per_Year_By_Region_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Counts_Per_Year_By_Region_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_counts_per_year_by_region" */
export type Job_Counts_Per_Year_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Counts_Per_Year_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Counts_Per_Year_By_Region_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Counts_Per_Year_By_Region_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Job_Counts_Per_Year_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Counts_Per_Year_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Counts_Per_Year_By_Region_Set_Input>;
  where: Job_Counts_Per_Year_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Counts_Per_Year_By_Region_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Counts_Per_Year_By_Region_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Counts_Per_Year_By_Region_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Month_By_Canoncounty>;
};

/** aggregate fields of "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_month_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Month_By_Canoncounty>;
};

/** Ordering options when selecting data from "job_proportions_per_month_by_canoncounty". */
export type Job_Proportions_Per_Month_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_month_by_canoncounty" */
export enum Job_Proportions_Per_Month_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_month_by_canoncounty" */
export type Job_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Month_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Set_Input>;
  where: Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Month_By_Canoncounty_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Month_By_Global_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Month_By_Global>;
};

/** aggregate fields of "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Month_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Month_By_Global_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Month_By_Global_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Month_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Month_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Month_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Month_By_Global_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Month_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Month_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Month_By_Global_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Month_By_Global_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_month_by_global". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Month_By_Global_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Month_By_Global_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Month_By_Global_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Month_By_Global>;
};

/** Ordering options when selecting data from "job_proportions_per_month_by_global". */
export type Job_Proportions_Per_Month_By_Global_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_month_by_global" */
export enum Job_Proportions_Per_Month_By_Global_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Month_By_Global_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Month_By_Global_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Month_By_Global_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_month_by_global" */
export type Job_Proportions_Per_Month_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Month_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Month_By_Global_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Month_By_Global_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Month_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Month_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Month_By_Global_Set_Input>;
  where: Job_Proportions_Per_Month_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Month_By_Global_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Month_By_Global_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Month_By_Global_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Month_By_Lad_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Month_By_Lad>;
};

/** aggregate fields of "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Month_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Month_By_Lad_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Month_By_Lad_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Month_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Month_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Month_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Month_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Month_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Month_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Month_By_Lad_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Month_By_Lad_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_month_by_lad". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Month_By_Lad_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Month_By_Lad_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Month_By_Lad_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Month_By_Lad>;
};

/** Ordering options when selecting data from "job_proportions_per_month_by_lad". */
export type Job_Proportions_Per_Month_By_Lad_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_month_by_lad" */
export enum Job_Proportions_Per_Month_By_Lad_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Month_By_Lad_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Month_By_Lad_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Month_By_Lad_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_month_by_lad" */
export type Job_Proportions_Per_Month_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Month_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Month_By_Lad_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Month_By_Lad_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Month_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Month_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Month_By_Lad_Set_Input>;
  where: Job_Proportions_Per_Month_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Month_By_Lad_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Month_By_Lad_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Month_By_Lad_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Month_By_Nation_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Month_By_Nation>;
};

/** aggregate fields of "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Month_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Month_By_Nation_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Month_By_Nation_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Month_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Month_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Month_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Month_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Month_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Month_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Month_By_Nation_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Month_By_Nation_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_month_by_nation". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Month_By_Nation_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Month_By_Nation_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Month_By_Nation_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Month_By_Nation>;
};

/** Ordering options when selecting data from "job_proportions_per_month_by_nation". */
export type Job_Proportions_Per_Month_By_Nation_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_month_by_nation" */
export enum Job_Proportions_Per_Month_By_Nation_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Month_By_Nation_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Month_By_Nation_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Month_By_Nation_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_month_by_nation" */
export type Job_Proportions_Per_Month_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Month_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Month_By_Nation_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Month_By_Nation_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Month_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Month_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Month_By_Nation_Set_Input>;
  where: Job_Proportions_Per_Month_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Month_By_Nation_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Month_By_Nation_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Month_By_Nation_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Month_By_Region_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Month_By_Region>;
};

/** aggregate fields of "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Month_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Month_By_Region_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Month_By_Region_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Month_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Month_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Month_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Month_By_Region_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Month_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Month_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Month_By_Region_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Month_By_Region_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_month_by_region". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Month_By_Region_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Month_By_Region_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Month_By_Region_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Month_By_Region>;
};

/** Ordering options when selecting data from "job_proportions_per_month_by_region". */
export type Job_Proportions_Per_Month_By_Region_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_month_by_region" */
export enum Job_Proportions_Per_Month_By_Region_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Month_By_Region_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Month_By_Region_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Month_By_Region_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_month_by_region" */
export type Job_Proportions_Per_Month_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Month_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Month_By_Region_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Month_By_Region_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Month_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Month_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Month_By_Region_Set_Input>;
  where: Job_Proportions_Per_Month_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Month_By_Region_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Month_By_Region_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Month_By_Region_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Year_By_Canoncounty>;
};

/** aggregate fields of "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_year_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Year_By_Canoncounty>;
};

/** Ordering options when selecting data from "job_proportions_per_year_by_canoncounty". */
export type Job_Proportions_Per_Year_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_year_by_canoncounty" */
export enum Job_Proportions_Per_Year_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_year_by_canoncounty" */
export type Job_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Year_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Set_Input>;
  where: Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Year_By_Canoncounty_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Year_By_Global_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Year_By_Global>;
};

/** aggregate fields of "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Year_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Year_By_Global_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Year_By_Global_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Year_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Year_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Year_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Year_By_Global_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Year_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Year_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Year_By_Global_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Year_By_Global_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_year_by_global". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Year_By_Global_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Year_By_Global_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Year_By_Global_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Year_By_Global>;
};

/** Ordering options when selecting data from "job_proportions_per_year_by_global". */
export type Job_Proportions_Per_Year_By_Global_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_year_by_global" */
export enum Job_Proportions_Per_Year_By_Global_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Year_By_Global_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Year_By_Global_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Year_By_Global_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_year_by_global" */
export type Job_Proportions_Per_Year_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Year_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Year_By_Global_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Year_By_Global_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Year_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Year_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Year_By_Global_Set_Input>;
  where: Job_Proportions_Per_Year_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Year_By_Global_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Year_By_Global_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Year_By_Global_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Year_By_Lad_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Year_By_Lad>;
};

/** aggregate fields of "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Year_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Year_By_Lad_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Year_By_Lad_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Year_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Year_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Year_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Year_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Year_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Year_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Year_By_Lad_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Year_By_Lad_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_year_by_lad". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Year_By_Lad_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Year_By_Lad_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Year_By_Lad_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Year_By_Lad>;
};

/** Ordering options when selecting data from "job_proportions_per_year_by_lad". */
export type Job_Proportions_Per_Year_By_Lad_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_year_by_lad" */
export enum Job_Proportions_Per_Year_By_Lad_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Year_By_Lad_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Year_By_Lad_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Year_By_Lad_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_year_by_lad" */
export type Job_Proportions_Per_Year_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Year_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Year_By_Lad_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Year_By_Lad_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Year_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Year_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Year_By_Lad_Set_Input>;
  where: Job_Proportions_Per_Year_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Year_By_Lad_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Year_By_Lad_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Year_By_Lad_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Year_By_Nation_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Year_By_Nation>;
};

/** aggregate fields of "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Year_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Year_By_Nation_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Year_By_Nation_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Year_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Year_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Year_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Year_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Year_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Year_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Year_By_Nation_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Year_By_Nation_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_year_by_nation". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Year_By_Nation_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Year_By_Nation_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Year_By_Nation_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Year_By_Nation>;
};

/** Ordering options when selecting data from "job_proportions_per_year_by_nation". */
export type Job_Proportions_Per_Year_By_Nation_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_year_by_nation" */
export enum Job_Proportions_Per_Year_By_Nation_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Year_By_Nation_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Year_By_Nation_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Year_By_Nation_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_year_by_nation" */
export type Job_Proportions_Per_Year_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Year_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Year_By_Nation_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Year_By_Nation_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Year_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Year_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Year_By_Nation_Set_Input>;
  where: Job_Proportions_Per_Year_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Year_By_Nation_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Year_By_Nation_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Year_By_Nation_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Aggregate = {
  aggregate?: Maybe<Job_Proportions_Per_Year_By_Region_Aggregate_Fields>;
  nodes: Array<Job_Proportions_Per_Year_By_Region>;
};

/** aggregate fields of "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Aggregate_Fields = {
  avg?: Maybe<Job_Proportions_Per_Year_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Proportions_Per_Year_By_Region_Max_Fields>;
  min?: Maybe<Job_Proportions_Per_Year_By_Region_Min_Fields>;
  stddev?: Maybe<Job_Proportions_Per_Year_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Proportions_Per_Year_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Proportions_Per_Year_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Proportions_Per_Year_By_Region_Sum_Fields>;
  var_pop?: Maybe<Job_Proportions_Per_Year_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Proportions_Per_Year_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Job_Proportions_Per_Year_By_Region_Variance_Fields>;
};


/** aggregate fields of "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Job_Proportions_Per_Year_By_Region_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_proportions_per_year_by_region". All fields are combined with a logical 'AND'. */
export type Job_Proportions_Per_Year_By_Region_Bool_Exp = {
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Bool_Exp>>;
  _not?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Insert_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Proportions_Per_Year_By_Region_Max_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Proportions_Per_Year_By_Region_Min_Fields = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Proportions_Per_Year_By_Region>;
};

/** Ordering options when selecting data from "job_proportions_per_year_by_region". */
export type Job_Proportions_Per_Year_By_Region_Order_By = {
  CleanJobTitle?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "job_proportions_per_year_by_region" */
export enum Job_Proportions_Per_Year_By_Region_Select_Column {
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Set_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Proportions_Per_Year_By_Region_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Job_Proportions_Per_Year_By_Region_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Job_Proportions_Per_Year_By_Region_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "job_proportions_per_year_by_region" */
export type Job_Proportions_Per_Year_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Proportions_Per_Year_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Proportions_Per_Year_By_Region_Stream_Cursor_Value_Input = {
  CleanJobTitle?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Proportions_Per_Year_By_Region_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Job_Proportions_Per_Year_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Job_Proportions_Per_Year_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Job_Proportions_Per_Year_By_Region_Set_Input>;
  where: Job_Proportions_Per_Year_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Proportions_Per_Year_By_Region_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Job_Proportions_Per_Year_By_Region_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Job_Proportions_Per_Year_By_Region_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "lads" */
export type Lads = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "lads" */
export type Lads_Aggregate = {
  aggregate?: Maybe<Lads_Aggregate_Fields>;
  nodes: Array<Lads>;
};

/** aggregate fields of "lads" */
export type Lads_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Lads_Max_Fields>;
  min?: Maybe<Lads_Min_Fields>;
};


/** aggregate fields of "lads" */
export type Lads_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Lads_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lads". All fields are combined with a logical 'AND'. */
export type Lads_Bool_Exp = {
  _and?: Maybe<Array<Lads_Bool_Exp>>;
  _not?: Maybe<Lads_Bool_Exp>;
  _or?: Maybe<Array<Lads_Bool_Exp>>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "lads" */
export type Lads_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Lads_Max_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Lads_Min_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lads" */
export type Lads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Lads>;
};

/** Ordering options when selecting data from "lads". */
export type Lads_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** select columns of table "lads" */
export enum Lads_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "lads" */
export type Lads_Set_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "lads" */
export type Lads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lads_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Lads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Lads_Set_Input>;
  where: Lads_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response>;
  /** delete data from the table: "areas" */
  delete_areas?: Maybe<Areas_Mutation_Response>;
  /** delete single row from the table: "areas" */
  delete_areas_by_pk?: Maybe<Areas>;
  /** delete data from the table: "careers" */
  delete_careers?: Maybe<Careers_Mutation_Response>;
  /** delete data from the table: "counties" */
  delete_counties?: Maybe<Counties_Mutation_Response>;
  /** delete data from the table: "employer_stats" */
  delete_employer_stats?: Maybe<Employer_Stats_Mutation_Response>;
  /** delete data from the table: "geotree" */
  delete_geotree?: Maybe<Geotree_Mutation_Response>;
  /** delete single row from the table: "geotree" */
  delete_geotree_by_pk?: Maybe<Geotree>;
  /** delete data from the table: "global_emerging_jobs" */
  delete_global_emerging_jobs?: Maybe<Global_Emerging_Jobs_Mutation_Response>;
  /** delete data from the table: "global_emerging_skills" */
  delete_global_emerging_skills?: Maybe<Global_Emerging_Skills_Mutation_Response>;
  /** delete data from the table: "global_top_10_skill_clusters" */
  delete_global_top_10_skill_clusters?: Maybe<Global_Top_10_Skill_Clusters_Mutation_Response>;
  /** delete single row from the table: "global_top_10_skill_clusters" */
  delete_global_top_10_skill_clusters_by_pk?: Maybe<Global_Top_10_Skill_Clusters>;
  /** delete data from the table: "global_top_10_skills" */
  delete_global_top_10_skills?: Maybe<Global_Top_10_Skills_Mutation_Response>;
  /** delete single row from the table: "global_top_10_skills" */
  delete_global_top_10_skills_by_pk?: Maybe<Global_Top_10_Skills>;
  /** delete data from the table: "job_counts_per_month_by_canoncounty" */
  delete_job_counts_per_month_by_canoncounty?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "job_counts_per_month_by_global" */
  delete_job_counts_per_month_by_global?: Maybe<Job_Counts_Per_Month_By_Global_Mutation_Response>;
  /** delete data from the table: "job_counts_per_month_by_lad" */
  delete_job_counts_per_month_by_lad?: Maybe<Job_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** delete data from the table: "job_counts_per_month_by_nation" */
  delete_job_counts_per_month_by_nation?: Maybe<Job_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** delete data from the table: "job_counts_per_month_by_region" */
  delete_job_counts_per_month_by_region?: Maybe<Job_Counts_Per_Month_By_Region_Mutation_Response>;
  /** delete data from the table: "job_counts_per_year_by_canoncounty" */
  delete_job_counts_per_year_by_canoncounty?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "job_counts_per_year_by_global" */
  delete_job_counts_per_year_by_global?: Maybe<Job_Counts_Per_Year_By_Global_Mutation_Response>;
  /** delete data from the table: "job_counts_per_year_by_lad" */
  delete_job_counts_per_year_by_lad?: Maybe<Job_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** delete data from the table: "job_counts_per_year_by_nation" */
  delete_job_counts_per_year_by_nation?: Maybe<Job_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** delete data from the table: "job_counts_per_year_by_region" */
  delete_job_counts_per_year_by_region?: Maybe<Job_Counts_Per_Year_By_Region_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_month_by_canoncounty" */
  delete_job_proportions_per_month_by_canoncounty?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_month_by_global" */
  delete_job_proportions_per_month_by_global?: Maybe<Job_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_month_by_lad" */
  delete_job_proportions_per_month_by_lad?: Maybe<Job_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_month_by_nation" */
  delete_job_proportions_per_month_by_nation?: Maybe<Job_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_month_by_region" */
  delete_job_proportions_per_month_by_region?: Maybe<Job_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_year_by_canoncounty" */
  delete_job_proportions_per_year_by_canoncounty?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_year_by_global" */
  delete_job_proportions_per_year_by_global?: Maybe<Job_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_year_by_lad" */
  delete_job_proportions_per_year_by_lad?: Maybe<Job_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_year_by_nation" */
  delete_job_proportions_per_year_by_nation?: Maybe<Job_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** delete data from the table: "job_proportions_per_year_by_region" */
  delete_job_proportions_per_year_by_region?: Maybe<Job_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** delete data from the table: "lads" */
  delete_lads?: Maybe<Lads_Mutation_Response>;
  /** delete data from the table: "nations" */
  delete_nations?: Maybe<Nations_Mutation_Response>;
  /** delete data from the table: "profile_by_jobs" */
  delete_profile_by_jobs?: Maybe<Profile_By_Jobs_Mutation_Response>;
  /** delete data from the table: "profile_by_skills" */
  delete_profile_by_skills?: Maybe<Profile_By_Skills_Mutation_Response>;
  /** delete data from the table: "regions" */
  delete_regions?: Maybe<Regions_Mutation_Response>;
  /** delete data from the table: "salary_by_canoncounty" */
  delete_salary_by_canoncounty?: Maybe<Salary_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "salary_by_global" */
  delete_salary_by_global?: Maybe<Salary_By_Global_Mutation_Response>;
  /** delete data from the table: "salary_by_lad" */
  delete_salary_by_lad?: Maybe<Salary_By_Lad_Mutation_Response>;
  /** delete data from the table: "salary_by_nation" */
  delete_salary_by_nation?: Maybe<Salary_By_Nation_Mutation_Response>;
  /** delete data from the table: "salary_by_region" */
  delete_salary_by_region?: Maybe<Salary_By_Region_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_month_by_canoncounty" */
  delete_skill_counts_per_month_by_canoncounty?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_month_by_global" */
  delete_skill_counts_per_month_by_global?: Maybe<Skill_Counts_Per_Month_By_Global_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_month_by_lad" */
  delete_skill_counts_per_month_by_lad?: Maybe<Skill_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_month_by_nation" */
  delete_skill_counts_per_month_by_nation?: Maybe<Skill_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_month_by_region" */
  delete_skill_counts_per_month_by_region?: Maybe<Skill_Counts_Per_Month_By_Region_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_year_by_canoncounty" */
  delete_skill_counts_per_year_by_canoncounty?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_year_by_global" */
  delete_skill_counts_per_year_by_global?: Maybe<Skill_Counts_Per_Year_By_Global_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_year_by_lad" */
  delete_skill_counts_per_year_by_lad?: Maybe<Skill_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_year_by_nation" */
  delete_skill_counts_per_year_by_nation?: Maybe<Skill_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** delete data from the table: "skill_counts_per_year_by_region" */
  delete_skill_counts_per_year_by_region?: Maybe<Skill_Counts_Per_Year_By_Region_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_month_by_canoncounty" */
  delete_skill_proportions_per_month_by_canoncounty?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_month_by_global" */
  delete_skill_proportions_per_month_by_global?: Maybe<Skill_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_month_by_lad" */
  delete_skill_proportions_per_month_by_lad?: Maybe<Skill_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_month_by_nation" */
  delete_skill_proportions_per_month_by_nation?: Maybe<Skill_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_month_by_region" */
  delete_skill_proportions_per_month_by_region?: Maybe<Skill_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_year_by_canoncounty" */
  delete_skill_proportions_per_year_by_canoncounty?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_year_by_global" */
  delete_skill_proportions_per_year_by_global?: Maybe<Skill_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_year_by_lad" */
  delete_skill_proportions_per_year_by_lad?: Maybe<Skill_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_year_by_nation" */
  delete_skill_proportions_per_year_by_nation?: Maybe<Skill_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** delete data from the table: "skill_proportions_per_year_by_region" */
  delete_skill_proportions_per_year_by_region?: Maybe<Skill_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** delete data from the table: "terms" */
  delete_terms?: Maybe<Terms_Mutation_Response>;
  /** delete single row from the table: "terms" */
  delete_terms_by_pk?: Maybe<Terms>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "areas" */
  insert_areas?: Maybe<Areas_Mutation_Response>;
  /** insert a single row into the table: "areas" */
  insert_areas_one?: Maybe<Areas>;
  /** insert data into the table: "careers" */
  insert_careers?: Maybe<Careers_Mutation_Response>;
  /** insert a single row into the table: "careers" */
  insert_careers_one?: Maybe<Careers>;
  /** insert data into the table: "counties" */
  insert_counties?: Maybe<Counties_Mutation_Response>;
  /** insert a single row into the table: "counties" */
  insert_counties_one?: Maybe<Counties>;
  /** insert data into the table: "employer_stats" */
  insert_employer_stats?: Maybe<Employer_Stats_Mutation_Response>;
  /** insert a single row into the table: "employer_stats" */
  insert_employer_stats_one?: Maybe<Employer_Stats>;
  /** insert data into the table: "geotree" */
  insert_geotree?: Maybe<Geotree_Mutation_Response>;
  /** insert a single row into the table: "geotree" */
  insert_geotree_one?: Maybe<Geotree>;
  /** insert data into the table: "global_emerging_jobs" */
  insert_global_emerging_jobs?: Maybe<Global_Emerging_Jobs_Mutation_Response>;
  /** insert a single row into the table: "global_emerging_jobs" */
  insert_global_emerging_jobs_one?: Maybe<Global_Emerging_Jobs>;
  /** insert data into the table: "global_emerging_skills" */
  insert_global_emerging_skills?: Maybe<Global_Emerging_Skills_Mutation_Response>;
  /** insert a single row into the table: "global_emerging_skills" */
  insert_global_emerging_skills_one?: Maybe<Global_Emerging_Skills>;
  /** insert data into the table: "global_top_10_skill_clusters" */
  insert_global_top_10_skill_clusters?: Maybe<Global_Top_10_Skill_Clusters_Mutation_Response>;
  /** insert a single row into the table: "global_top_10_skill_clusters" */
  insert_global_top_10_skill_clusters_one?: Maybe<Global_Top_10_Skill_Clusters>;
  /** insert data into the table: "global_top_10_skills" */
  insert_global_top_10_skills?: Maybe<Global_Top_10_Skills_Mutation_Response>;
  /** insert a single row into the table: "global_top_10_skills" */
  insert_global_top_10_skills_one?: Maybe<Global_Top_10_Skills>;
  /** insert data into the table: "job_counts_per_month_by_canoncounty" */
  insert_job_counts_per_month_by_canoncounty?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_month_by_canoncounty" */
  insert_job_counts_per_month_by_canoncounty_one?: Maybe<Job_Counts_Per_Month_By_Canoncounty>;
  /** insert data into the table: "job_counts_per_month_by_global" */
  insert_job_counts_per_month_by_global?: Maybe<Job_Counts_Per_Month_By_Global_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_month_by_global" */
  insert_job_counts_per_month_by_global_one?: Maybe<Job_Counts_Per_Month_By_Global>;
  /** insert data into the table: "job_counts_per_month_by_lad" */
  insert_job_counts_per_month_by_lad?: Maybe<Job_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_month_by_lad" */
  insert_job_counts_per_month_by_lad_one?: Maybe<Job_Counts_Per_Month_By_Lad>;
  /** insert data into the table: "job_counts_per_month_by_nation" */
  insert_job_counts_per_month_by_nation?: Maybe<Job_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_month_by_nation" */
  insert_job_counts_per_month_by_nation_one?: Maybe<Job_Counts_Per_Month_By_Nation>;
  /** insert data into the table: "job_counts_per_month_by_region" */
  insert_job_counts_per_month_by_region?: Maybe<Job_Counts_Per_Month_By_Region_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_month_by_region" */
  insert_job_counts_per_month_by_region_one?: Maybe<Job_Counts_Per_Month_By_Region>;
  /** insert data into the table: "job_counts_per_year_by_canoncounty" */
  insert_job_counts_per_year_by_canoncounty?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_year_by_canoncounty" */
  insert_job_counts_per_year_by_canoncounty_one?: Maybe<Job_Counts_Per_Year_By_Canoncounty>;
  /** insert data into the table: "job_counts_per_year_by_global" */
  insert_job_counts_per_year_by_global?: Maybe<Job_Counts_Per_Year_By_Global_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_year_by_global" */
  insert_job_counts_per_year_by_global_one?: Maybe<Job_Counts_Per_Year_By_Global>;
  /** insert data into the table: "job_counts_per_year_by_lad" */
  insert_job_counts_per_year_by_lad?: Maybe<Job_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_year_by_lad" */
  insert_job_counts_per_year_by_lad_one?: Maybe<Job_Counts_Per_Year_By_Lad>;
  /** insert data into the table: "job_counts_per_year_by_nation" */
  insert_job_counts_per_year_by_nation?: Maybe<Job_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_year_by_nation" */
  insert_job_counts_per_year_by_nation_one?: Maybe<Job_Counts_Per_Year_By_Nation>;
  /** insert data into the table: "job_counts_per_year_by_region" */
  insert_job_counts_per_year_by_region?: Maybe<Job_Counts_Per_Year_By_Region_Mutation_Response>;
  /** insert a single row into the table: "job_counts_per_year_by_region" */
  insert_job_counts_per_year_by_region_one?: Maybe<Job_Counts_Per_Year_By_Region>;
  /** insert data into the table: "job_proportions_per_month_by_canoncounty" */
  insert_job_proportions_per_month_by_canoncounty?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_month_by_canoncounty" */
  insert_job_proportions_per_month_by_canoncounty_one?: Maybe<Job_Proportions_Per_Month_By_Canoncounty>;
  /** insert data into the table: "job_proportions_per_month_by_global" */
  insert_job_proportions_per_month_by_global?: Maybe<Job_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_month_by_global" */
  insert_job_proportions_per_month_by_global_one?: Maybe<Job_Proportions_Per_Month_By_Global>;
  /** insert data into the table: "job_proportions_per_month_by_lad" */
  insert_job_proportions_per_month_by_lad?: Maybe<Job_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_month_by_lad" */
  insert_job_proportions_per_month_by_lad_one?: Maybe<Job_Proportions_Per_Month_By_Lad>;
  /** insert data into the table: "job_proportions_per_month_by_nation" */
  insert_job_proportions_per_month_by_nation?: Maybe<Job_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_month_by_nation" */
  insert_job_proportions_per_month_by_nation_one?: Maybe<Job_Proportions_Per_Month_By_Nation>;
  /** insert data into the table: "job_proportions_per_month_by_region" */
  insert_job_proportions_per_month_by_region?: Maybe<Job_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_month_by_region" */
  insert_job_proportions_per_month_by_region_one?: Maybe<Job_Proportions_Per_Month_By_Region>;
  /** insert data into the table: "job_proportions_per_year_by_canoncounty" */
  insert_job_proportions_per_year_by_canoncounty?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_year_by_canoncounty" */
  insert_job_proportions_per_year_by_canoncounty_one?: Maybe<Job_Proportions_Per_Year_By_Canoncounty>;
  /** insert data into the table: "job_proportions_per_year_by_global" */
  insert_job_proportions_per_year_by_global?: Maybe<Job_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_year_by_global" */
  insert_job_proportions_per_year_by_global_one?: Maybe<Job_Proportions_Per_Year_By_Global>;
  /** insert data into the table: "job_proportions_per_year_by_lad" */
  insert_job_proportions_per_year_by_lad?: Maybe<Job_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_year_by_lad" */
  insert_job_proportions_per_year_by_lad_one?: Maybe<Job_Proportions_Per_Year_By_Lad>;
  /** insert data into the table: "job_proportions_per_year_by_nation" */
  insert_job_proportions_per_year_by_nation?: Maybe<Job_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_year_by_nation" */
  insert_job_proportions_per_year_by_nation_one?: Maybe<Job_Proportions_Per_Year_By_Nation>;
  /** insert data into the table: "job_proportions_per_year_by_region" */
  insert_job_proportions_per_year_by_region?: Maybe<Job_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** insert a single row into the table: "job_proportions_per_year_by_region" */
  insert_job_proportions_per_year_by_region_one?: Maybe<Job_Proportions_Per_Year_By_Region>;
  /** insert data into the table: "lads" */
  insert_lads?: Maybe<Lads_Mutation_Response>;
  /** insert a single row into the table: "lads" */
  insert_lads_one?: Maybe<Lads>;
  /** insert data into the table: "nations" */
  insert_nations?: Maybe<Nations_Mutation_Response>;
  /** insert a single row into the table: "nations" */
  insert_nations_one?: Maybe<Nations>;
  /** insert data into the table: "profile_by_jobs" */
  insert_profile_by_jobs?: Maybe<Profile_By_Jobs_Mutation_Response>;
  /** insert a single row into the table: "profile_by_jobs" */
  insert_profile_by_jobs_one?: Maybe<Profile_By_Jobs>;
  /** insert data into the table: "profile_by_skills" */
  insert_profile_by_skills?: Maybe<Profile_By_Skills_Mutation_Response>;
  /** insert a single row into the table: "profile_by_skills" */
  insert_profile_by_skills_one?: Maybe<Profile_By_Skills>;
  /** insert data into the table: "regions" */
  insert_regions?: Maybe<Regions_Mutation_Response>;
  /** insert a single row into the table: "regions" */
  insert_regions_one?: Maybe<Regions>;
  /** insert data into the table: "salary_by_canoncounty" */
  insert_salary_by_canoncounty?: Maybe<Salary_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "salary_by_canoncounty" */
  insert_salary_by_canoncounty_one?: Maybe<Salary_By_Canoncounty>;
  /** insert data into the table: "salary_by_global" */
  insert_salary_by_global?: Maybe<Salary_By_Global_Mutation_Response>;
  /** insert a single row into the table: "salary_by_global" */
  insert_salary_by_global_one?: Maybe<Salary_By_Global>;
  /** insert data into the table: "salary_by_lad" */
  insert_salary_by_lad?: Maybe<Salary_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "salary_by_lad" */
  insert_salary_by_lad_one?: Maybe<Salary_By_Lad>;
  /** insert data into the table: "salary_by_nation" */
  insert_salary_by_nation?: Maybe<Salary_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "salary_by_nation" */
  insert_salary_by_nation_one?: Maybe<Salary_By_Nation>;
  /** insert data into the table: "salary_by_region" */
  insert_salary_by_region?: Maybe<Salary_By_Region_Mutation_Response>;
  /** insert a single row into the table: "salary_by_region" */
  insert_salary_by_region_one?: Maybe<Salary_By_Region>;
  /** insert data into the table: "skill_counts_per_month_by_canoncounty" */
  insert_skill_counts_per_month_by_canoncounty?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_month_by_canoncounty" */
  insert_skill_counts_per_month_by_canoncounty_one?: Maybe<Skill_Counts_Per_Month_By_Canoncounty>;
  /** insert data into the table: "skill_counts_per_month_by_global" */
  insert_skill_counts_per_month_by_global?: Maybe<Skill_Counts_Per_Month_By_Global_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_month_by_global" */
  insert_skill_counts_per_month_by_global_one?: Maybe<Skill_Counts_Per_Month_By_Global>;
  /** insert data into the table: "skill_counts_per_month_by_lad" */
  insert_skill_counts_per_month_by_lad?: Maybe<Skill_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_month_by_lad" */
  insert_skill_counts_per_month_by_lad_one?: Maybe<Skill_Counts_Per_Month_By_Lad>;
  /** insert data into the table: "skill_counts_per_month_by_nation" */
  insert_skill_counts_per_month_by_nation?: Maybe<Skill_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_month_by_nation" */
  insert_skill_counts_per_month_by_nation_one?: Maybe<Skill_Counts_Per_Month_By_Nation>;
  /** insert data into the table: "skill_counts_per_month_by_region" */
  insert_skill_counts_per_month_by_region?: Maybe<Skill_Counts_Per_Month_By_Region_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_month_by_region" */
  insert_skill_counts_per_month_by_region_one?: Maybe<Skill_Counts_Per_Month_By_Region>;
  /** insert data into the table: "skill_counts_per_year_by_canoncounty" */
  insert_skill_counts_per_year_by_canoncounty?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_year_by_canoncounty" */
  insert_skill_counts_per_year_by_canoncounty_one?: Maybe<Skill_Counts_Per_Year_By_Canoncounty>;
  /** insert data into the table: "skill_counts_per_year_by_global" */
  insert_skill_counts_per_year_by_global?: Maybe<Skill_Counts_Per_Year_By_Global_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_year_by_global" */
  insert_skill_counts_per_year_by_global_one?: Maybe<Skill_Counts_Per_Year_By_Global>;
  /** insert data into the table: "skill_counts_per_year_by_lad" */
  insert_skill_counts_per_year_by_lad?: Maybe<Skill_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_year_by_lad" */
  insert_skill_counts_per_year_by_lad_one?: Maybe<Skill_Counts_Per_Year_By_Lad>;
  /** insert data into the table: "skill_counts_per_year_by_nation" */
  insert_skill_counts_per_year_by_nation?: Maybe<Skill_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_year_by_nation" */
  insert_skill_counts_per_year_by_nation_one?: Maybe<Skill_Counts_Per_Year_By_Nation>;
  /** insert data into the table: "skill_counts_per_year_by_region" */
  insert_skill_counts_per_year_by_region?: Maybe<Skill_Counts_Per_Year_By_Region_Mutation_Response>;
  /** insert a single row into the table: "skill_counts_per_year_by_region" */
  insert_skill_counts_per_year_by_region_one?: Maybe<Skill_Counts_Per_Year_By_Region>;
  /** insert data into the table: "skill_proportions_per_month_by_canoncounty" */
  insert_skill_proportions_per_month_by_canoncounty?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_month_by_canoncounty" */
  insert_skill_proportions_per_month_by_canoncounty_one?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty>;
  /** insert data into the table: "skill_proportions_per_month_by_global" */
  insert_skill_proportions_per_month_by_global?: Maybe<Skill_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_month_by_global" */
  insert_skill_proportions_per_month_by_global_one?: Maybe<Skill_Proportions_Per_Month_By_Global>;
  /** insert data into the table: "skill_proportions_per_month_by_lad" */
  insert_skill_proportions_per_month_by_lad?: Maybe<Skill_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_month_by_lad" */
  insert_skill_proportions_per_month_by_lad_one?: Maybe<Skill_Proportions_Per_Month_By_Lad>;
  /** insert data into the table: "skill_proportions_per_month_by_nation" */
  insert_skill_proportions_per_month_by_nation?: Maybe<Skill_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_month_by_nation" */
  insert_skill_proportions_per_month_by_nation_one?: Maybe<Skill_Proportions_Per_Month_By_Nation>;
  /** insert data into the table: "skill_proportions_per_month_by_region" */
  insert_skill_proportions_per_month_by_region?: Maybe<Skill_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_month_by_region" */
  insert_skill_proportions_per_month_by_region_one?: Maybe<Skill_Proportions_Per_Month_By_Region>;
  /** insert data into the table: "skill_proportions_per_year_by_canoncounty" */
  insert_skill_proportions_per_year_by_canoncounty?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_year_by_canoncounty" */
  insert_skill_proportions_per_year_by_canoncounty_one?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty>;
  /** insert data into the table: "skill_proportions_per_year_by_global" */
  insert_skill_proportions_per_year_by_global?: Maybe<Skill_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_year_by_global" */
  insert_skill_proportions_per_year_by_global_one?: Maybe<Skill_Proportions_Per_Year_By_Global>;
  /** insert data into the table: "skill_proportions_per_year_by_lad" */
  insert_skill_proportions_per_year_by_lad?: Maybe<Skill_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_year_by_lad" */
  insert_skill_proportions_per_year_by_lad_one?: Maybe<Skill_Proportions_Per_Year_By_Lad>;
  /** insert data into the table: "skill_proportions_per_year_by_nation" */
  insert_skill_proportions_per_year_by_nation?: Maybe<Skill_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_year_by_nation" */
  insert_skill_proportions_per_year_by_nation_one?: Maybe<Skill_Proportions_Per_Year_By_Nation>;
  /** insert data into the table: "skill_proportions_per_year_by_region" */
  insert_skill_proportions_per_year_by_region?: Maybe<Skill_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** insert a single row into the table: "skill_proportions_per_year_by_region" */
  insert_skill_proportions_per_year_by_region_one?: Maybe<Skill_Proportions_Per_Year_By_Region>;
  /** insert data into the table: "terms" */
  insert_terms?: Maybe<Terms_Mutation_Response>;
  /** insert a single row into the table: "terms" */
  insert_terms_one?: Maybe<Terms>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response>;
  /** update data of the table: "areas" */
  update_areas?: Maybe<Areas_Mutation_Response>;
  /** update single row of the table: "areas" */
  update_areas_by_pk?: Maybe<Areas>;
  /** update multiples rows of table: "areas" */
  update_areas_many?: Maybe<Array<Maybe<Areas_Mutation_Response>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response>>>;
  /** update data of the table: "careers" */
  update_careers?: Maybe<Careers_Mutation_Response>;
  /** update multiples rows of table: "careers" */
  update_careers_many?: Maybe<Array<Maybe<Careers_Mutation_Response>>>;
  /** update data of the table: "counties" */
  update_counties?: Maybe<Counties_Mutation_Response>;
  /** update multiples rows of table: "counties" */
  update_counties_many?: Maybe<Array<Maybe<Counties_Mutation_Response>>>;
  /** update data of the table: "employer_stats" */
  update_employer_stats?: Maybe<Employer_Stats_Mutation_Response>;
  /** update multiples rows of table: "employer_stats" */
  update_employer_stats_many?: Maybe<Array<Maybe<Employer_Stats_Mutation_Response>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "geotree" */
  update_geotree?: Maybe<Geotree_Mutation_Response>;
  /** update single row of the table: "geotree" */
  update_geotree_by_pk?: Maybe<Geotree>;
  /** update multiples rows of table: "geotree" */
  update_geotree_many?: Maybe<Array<Maybe<Geotree_Mutation_Response>>>;
  /** update data of the table: "global_emerging_jobs" */
  update_global_emerging_jobs?: Maybe<Global_Emerging_Jobs_Mutation_Response>;
  /** update multiples rows of table: "global_emerging_jobs" */
  update_global_emerging_jobs_many?: Maybe<Array<Maybe<Global_Emerging_Jobs_Mutation_Response>>>;
  /** update data of the table: "global_emerging_skills" */
  update_global_emerging_skills?: Maybe<Global_Emerging_Skills_Mutation_Response>;
  /** update multiples rows of table: "global_emerging_skills" */
  update_global_emerging_skills_many?: Maybe<Array<Maybe<Global_Emerging_Skills_Mutation_Response>>>;
  /** update data of the table: "global_top_10_skill_clusters" */
  update_global_top_10_skill_clusters?: Maybe<Global_Top_10_Skill_Clusters_Mutation_Response>;
  /** update single row of the table: "global_top_10_skill_clusters" */
  update_global_top_10_skill_clusters_by_pk?: Maybe<Global_Top_10_Skill_Clusters>;
  /** update multiples rows of table: "global_top_10_skill_clusters" */
  update_global_top_10_skill_clusters_many?: Maybe<Array<Maybe<Global_Top_10_Skill_Clusters_Mutation_Response>>>;
  /** update data of the table: "global_top_10_skills" */
  update_global_top_10_skills?: Maybe<Global_Top_10_Skills_Mutation_Response>;
  /** update single row of the table: "global_top_10_skills" */
  update_global_top_10_skills_by_pk?: Maybe<Global_Top_10_Skills>;
  /** update multiples rows of table: "global_top_10_skills" */
  update_global_top_10_skills_many?: Maybe<Array<Maybe<Global_Top_10_Skills_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_month_by_canoncounty" */
  update_job_counts_per_month_by_canoncounty?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_month_by_canoncounty" */
  update_job_counts_per_month_by_canoncounty_many?: Maybe<Array<Maybe<Job_Counts_Per_Month_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_month_by_global" */
  update_job_counts_per_month_by_global?: Maybe<Job_Counts_Per_Month_By_Global_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_month_by_global" */
  update_job_counts_per_month_by_global_many?: Maybe<Array<Maybe<Job_Counts_Per_Month_By_Global_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_month_by_lad" */
  update_job_counts_per_month_by_lad?: Maybe<Job_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_month_by_lad" */
  update_job_counts_per_month_by_lad_many?: Maybe<Array<Maybe<Job_Counts_Per_Month_By_Lad_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_month_by_nation" */
  update_job_counts_per_month_by_nation?: Maybe<Job_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_month_by_nation" */
  update_job_counts_per_month_by_nation_many?: Maybe<Array<Maybe<Job_Counts_Per_Month_By_Nation_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_month_by_region" */
  update_job_counts_per_month_by_region?: Maybe<Job_Counts_Per_Month_By_Region_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_month_by_region" */
  update_job_counts_per_month_by_region_many?: Maybe<Array<Maybe<Job_Counts_Per_Month_By_Region_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_year_by_canoncounty" */
  update_job_counts_per_year_by_canoncounty?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_year_by_canoncounty" */
  update_job_counts_per_year_by_canoncounty_many?: Maybe<Array<Maybe<Job_Counts_Per_Year_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_year_by_global" */
  update_job_counts_per_year_by_global?: Maybe<Job_Counts_Per_Year_By_Global_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_year_by_global" */
  update_job_counts_per_year_by_global_many?: Maybe<Array<Maybe<Job_Counts_Per_Year_By_Global_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_year_by_lad" */
  update_job_counts_per_year_by_lad?: Maybe<Job_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_year_by_lad" */
  update_job_counts_per_year_by_lad_many?: Maybe<Array<Maybe<Job_Counts_Per_Year_By_Lad_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_year_by_nation" */
  update_job_counts_per_year_by_nation?: Maybe<Job_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_year_by_nation" */
  update_job_counts_per_year_by_nation_many?: Maybe<Array<Maybe<Job_Counts_Per_Year_By_Nation_Mutation_Response>>>;
  /** update data of the table: "job_counts_per_year_by_region" */
  update_job_counts_per_year_by_region?: Maybe<Job_Counts_Per_Year_By_Region_Mutation_Response>;
  /** update multiples rows of table: "job_counts_per_year_by_region" */
  update_job_counts_per_year_by_region_many?: Maybe<Array<Maybe<Job_Counts_Per_Year_By_Region_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_month_by_canoncounty" */
  update_job_proportions_per_month_by_canoncounty?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_month_by_canoncounty" */
  update_job_proportions_per_month_by_canoncounty_many?: Maybe<Array<Maybe<Job_Proportions_Per_Month_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_month_by_global" */
  update_job_proportions_per_month_by_global?: Maybe<Job_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_month_by_global" */
  update_job_proportions_per_month_by_global_many?: Maybe<Array<Maybe<Job_Proportions_Per_Month_By_Global_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_month_by_lad" */
  update_job_proportions_per_month_by_lad?: Maybe<Job_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_month_by_lad" */
  update_job_proportions_per_month_by_lad_many?: Maybe<Array<Maybe<Job_Proportions_Per_Month_By_Lad_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_month_by_nation" */
  update_job_proportions_per_month_by_nation?: Maybe<Job_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_month_by_nation" */
  update_job_proportions_per_month_by_nation_many?: Maybe<Array<Maybe<Job_Proportions_Per_Month_By_Nation_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_month_by_region" */
  update_job_proportions_per_month_by_region?: Maybe<Job_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_month_by_region" */
  update_job_proportions_per_month_by_region_many?: Maybe<Array<Maybe<Job_Proportions_Per_Month_By_Region_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_year_by_canoncounty" */
  update_job_proportions_per_year_by_canoncounty?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_year_by_canoncounty" */
  update_job_proportions_per_year_by_canoncounty_many?: Maybe<Array<Maybe<Job_Proportions_Per_Year_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_year_by_global" */
  update_job_proportions_per_year_by_global?: Maybe<Job_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_year_by_global" */
  update_job_proportions_per_year_by_global_many?: Maybe<Array<Maybe<Job_Proportions_Per_Year_By_Global_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_year_by_lad" */
  update_job_proportions_per_year_by_lad?: Maybe<Job_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_year_by_lad" */
  update_job_proportions_per_year_by_lad_many?: Maybe<Array<Maybe<Job_Proportions_Per_Year_By_Lad_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_year_by_nation" */
  update_job_proportions_per_year_by_nation?: Maybe<Job_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_year_by_nation" */
  update_job_proportions_per_year_by_nation_many?: Maybe<Array<Maybe<Job_Proportions_Per_Year_By_Nation_Mutation_Response>>>;
  /** update data of the table: "job_proportions_per_year_by_region" */
  update_job_proportions_per_year_by_region?: Maybe<Job_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** update multiples rows of table: "job_proportions_per_year_by_region" */
  update_job_proportions_per_year_by_region_many?: Maybe<Array<Maybe<Job_Proportions_Per_Year_By_Region_Mutation_Response>>>;
  /** update data of the table: "lads" */
  update_lads?: Maybe<Lads_Mutation_Response>;
  /** update multiples rows of table: "lads" */
  update_lads_many?: Maybe<Array<Maybe<Lads_Mutation_Response>>>;
  /** update data of the table: "nations" */
  update_nations?: Maybe<Nations_Mutation_Response>;
  /** update multiples rows of table: "nations" */
  update_nations_many?: Maybe<Array<Maybe<Nations_Mutation_Response>>>;
  /** update data of the table: "profile_by_jobs" */
  update_profile_by_jobs?: Maybe<Profile_By_Jobs_Mutation_Response>;
  /** update multiples rows of table: "profile_by_jobs" */
  update_profile_by_jobs_many?: Maybe<Array<Maybe<Profile_By_Jobs_Mutation_Response>>>;
  /** update data of the table: "profile_by_skills" */
  update_profile_by_skills?: Maybe<Profile_By_Skills_Mutation_Response>;
  /** update multiples rows of table: "profile_by_skills" */
  update_profile_by_skills_many?: Maybe<Array<Maybe<Profile_By_Skills_Mutation_Response>>>;
  /** update data of the table: "regions" */
  update_regions?: Maybe<Regions_Mutation_Response>;
  /** update multiples rows of table: "regions" */
  update_regions_many?: Maybe<Array<Maybe<Regions_Mutation_Response>>>;
  /** update data of the table: "salary_by_canoncounty" */
  update_salary_by_canoncounty?: Maybe<Salary_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "salary_by_canoncounty" */
  update_salary_by_canoncounty_many?: Maybe<Array<Maybe<Salary_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "salary_by_global" */
  update_salary_by_global?: Maybe<Salary_By_Global_Mutation_Response>;
  /** update multiples rows of table: "salary_by_global" */
  update_salary_by_global_many?: Maybe<Array<Maybe<Salary_By_Global_Mutation_Response>>>;
  /** update data of the table: "salary_by_lad" */
  update_salary_by_lad?: Maybe<Salary_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "salary_by_lad" */
  update_salary_by_lad_many?: Maybe<Array<Maybe<Salary_By_Lad_Mutation_Response>>>;
  /** update data of the table: "salary_by_nation" */
  update_salary_by_nation?: Maybe<Salary_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "salary_by_nation" */
  update_salary_by_nation_many?: Maybe<Array<Maybe<Salary_By_Nation_Mutation_Response>>>;
  /** update data of the table: "salary_by_region" */
  update_salary_by_region?: Maybe<Salary_By_Region_Mutation_Response>;
  /** update multiples rows of table: "salary_by_region" */
  update_salary_by_region_many?: Maybe<Array<Maybe<Salary_By_Region_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_month_by_canoncounty" */
  update_skill_counts_per_month_by_canoncounty?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_month_by_canoncounty" */
  update_skill_counts_per_month_by_canoncounty_many?: Maybe<Array<Maybe<Skill_Counts_Per_Month_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_month_by_global" */
  update_skill_counts_per_month_by_global?: Maybe<Skill_Counts_Per_Month_By_Global_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_month_by_global" */
  update_skill_counts_per_month_by_global_many?: Maybe<Array<Maybe<Skill_Counts_Per_Month_By_Global_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_month_by_lad" */
  update_skill_counts_per_month_by_lad?: Maybe<Skill_Counts_Per_Month_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_month_by_lad" */
  update_skill_counts_per_month_by_lad_many?: Maybe<Array<Maybe<Skill_Counts_Per_Month_By_Lad_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_month_by_nation" */
  update_skill_counts_per_month_by_nation?: Maybe<Skill_Counts_Per_Month_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_month_by_nation" */
  update_skill_counts_per_month_by_nation_many?: Maybe<Array<Maybe<Skill_Counts_Per_Month_By_Nation_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_month_by_region" */
  update_skill_counts_per_month_by_region?: Maybe<Skill_Counts_Per_Month_By_Region_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_month_by_region" */
  update_skill_counts_per_month_by_region_many?: Maybe<Array<Maybe<Skill_Counts_Per_Month_By_Region_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_year_by_canoncounty" */
  update_skill_counts_per_year_by_canoncounty?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_year_by_canoncounty" */
  update_skill_counts_per_year_by_canoncounty_many?: Maybe<Array<Maybe<Skill_Counts_Per_Year_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_year_by_global" */
  update_skill_counts_per_year_by_global?: Maybe<Skill_Counts_Per_Year_By_Global_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_year_by_global" */
  update_skill_counts_per_year_by_global_many?: Maybe<Array<Maybe<Skill_Counts_Per_Year_By_Global_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_year_by_lad" */
  update_skill_counts_per_year_by_lad?: Maybe<Skill_Counts_Per_Year_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_year_by_lad" */
  update_skill_counts_per_year_by_lad_many?: Maybe<Array<Maybe<Skill_Counts_Per_Year_By_Lad_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_year_by_nation" */
  update_skill_counts_per_year_by_nation?: Maybe<Skill_Counts_Per_Year_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_year_by_nation" */
  update_skill_counts_per_year_by_nation_many?: Maybe<Array<Maybe<Skill_Counts_Per_Year_By_Nation_Mutation_Response>>>;
  /** update data of the table: "skill_counts_per_year_by_region" */
  update_skill_counts_per_year_by_region?: Maybe<Skill_Counts_Per_Year_By_Region_Mutation_Response>;
  /** update multiples rows of table: "skill_counts_per_year_by_region" */
  update_skill_counts_per_year_by_region_many?: Maybe<Array<Maybe<Skill_Counts_Per_Year_By_Region_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_month_by_canoncounty" */
  update_skill_proportions_per_month_by_canoncounty?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_month_by_canoncounty" */
  update_skill_proportions_per_month_by_canoncounty_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_month_by_global" */
  update_skill_proportions_per_month_by_global?: Maybe<Skill_Proportions_Per_Month_By_Global_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_month_by_global" */
  update_skill_proportions_per_month_by_global_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Month_By_Global_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_month_by_lad" */
  update_skill_proportions_per_month_by_lad?: Maybe<Skill_Proportions_Per_Month_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_month_by_lad" */
  update_skill_proportions_per_month_by_lad_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Month_By_Lad_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_month_by_nation" */
  update_skill_proportions_per_month_by_nation?: Maybe<Skill_Proportions_Per_Month_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_month_by_nation" */
  update_skill_proportions_per_month_by_nation_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Month_By_Nation_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_month_by_region" */
  update_skill_proportions_per_month_by_region?: Maybe<Skill_Proportions_Per_Month_By_Region_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_month_by_region" */
  update_skill_proportions_per_month_by_region_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Month_By_Region_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_year_by_canoncounty" */
  update_skill_proportions_per_year_by_canoncounty?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_year_by_canoncounty" */
  update_skill_proportions_per_year_by_canoncounty_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_year_by_global" */
  update_skill_proportions_per_year_by_global?: Maybe<Skill_Proportions_Per_Year_By_Global_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_year_by_global" */
  update_skill_proportions_per_year_by_global_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Year_By_Global_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_year_by_lad" */
  update_skill_proportions_per_year_by_lad?: Maybe<Skill_Proportions_Per_Year_By_Lad_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_year_by_lad" */
  update_skill_proportions_per_year_by_lad_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Year_By_Lad_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_year_by_nation" */
  update_skill_proportions_per_year_by_nation?: Maybe<Skill_Proportions_Per_Year_By_Nation_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_year_by_nation" */
  update_skill_proportions_per_year_by_nation_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Year_By_Nation_Mutation_Response>>>;
  /** update data of the table: "skill_proportions_per_year_by_region" */
  update_skill_proportions_per_year_by_region?: Maybe<Skill_Proportions_Per_Year_By_Region_Mutation_Response>;
  /** update multiples rows of table: "skill_proportions_per_year_by_region" */
  update_skill_proportions_per_year_by_region_many?: Maybe<Array<Maybe<Skill_Proportions_Per_Year_By_Region_Mutation_Response>>>;
  /** update data of the table: "terms" */
  update_terms?: Maybe<Terms_Mutation_Response>;
  /** update single row of the table: "terms" */
  update_terms_by_pk?: Maybe<Terms>;
  /** update multiples rows of table: "terms" */
  update_terms_many?: Maybe<Array<Maybe<Terms_Mutation_Response>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs = {
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs = {
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs = {
  refreshToken: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs = {
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs = {
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs = {
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs = {
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs = {
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AreasArgs = {
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Areas_By_PkArgs = {
  area_type: Scalars['String'];
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CareersArgs = {
  where: Careers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CountiesArgs = {
  where: Counties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Employer_StatsArgs = {
  where: Employer_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GeotreeArgs = {
  where: Geotree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Geotree_By_PkArgs = {
  LadAreaCode: Scalars['bpchar'];
};


/** mutation root */
export type Mutation_RootDelete_Global_Emerging_JobsArgs = {
  where: Global_Emerging_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Emerging_SkillsArgs = {
  where: Global_Emerging_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Top_10_Skill_ClustersArgs = {
  where: Global_Top_10_Skill_Clusters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Top_10_Skill_Clusters_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Global_Top_10_SkillsArgs = {
  where: Global_Top_10_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Top_10_Skills_By_PkArgs = {
  ParentSkill: Scalars['bpchar'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Month_By_CanoncountyArgs = {
  where: Job_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Month_By_GlobalArgs = {
  where: Job_Counts_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Month_By_LadArgs = {
  where: Job_Counts_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Month_By_NationArgs = {
  where: Job_Counts_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Month_By_RegionArgs = {
  where: Job_Counts_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Year_By_CanoncountyArgs = {
  where: Job_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Year_By_GlobalArgs = {
  where: Job_Counts_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Year_By_LadArgs = {
  where: Job_Counts_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Year_By_NationArgs = {
  where: Job_Counts_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Counts_Per_Year_By_RegionArgs = {
  where: Job_Counts_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Month_By_CanoncountyArgs = {
  where: Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Month_By_GlobalArgs = {
  where: Job_Proportions_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Month_By_LadArgs = {
  where: Job_Proportions_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Month_By_NationArgs = {
  where: Job_Proportions_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Month_By_RegionArgs = {
  where: Job_Proportions_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Year_By_CanoncountyArgs = {
  where: Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Year_By_GlobalArgs = {
  where: Job_Proportions_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Year_By_LadArgs = {
  where: Job_Proportions_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Year_By_NationArgs = {
  where: Job_Proportions_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Proportions_Per_Year_By_RegionArgs = {
  where: Job_Proportions_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_LadsArgs = {
  where: Lads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NationsArgs = {
  where: Nations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_By_JobsArgs = {
  where: Profile_By_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_By_SkillsArgs = {
  where: Profile_By_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RegionsArgs = {
  where: Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_By_CanoncountyArgs = {
  where: Salary_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_By_GlobalArgs = {
  where: Salary_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_By_LadArgs = {
  where: Salary_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_By_NationArgs = {
  where: Salary_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_By_RegionArgs = {
  where: Salary_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Month_By_CanoncountyArgs = {
  where: Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Month_By_GlobalArgs = {
  where: Skill_Counts_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Month_By_LadArgs = {
  where: Skill_Counts_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Month_By_NationArgs = {
  where: Skill_Counts_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Month_By_RegionArgs = {
  where: Skill_Counts_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Year_By_CanoncountyArgs = {
  where: Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Year_By_GlobalArgs = {
  where: Skill_Counts_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Year_By_LadArgs = {
  where: Skill_Counts_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Year_By_NationArgs = {
  where: Skill_Counts_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Counts_Per_Year_By_RegionArgs = {
  where: Skill_Counts_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Month_By_CanoncountyArgs = {
  where: Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Month_By_GlobalArgs = {
  where: Skill_Proportions_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Month_By_LadArgs = {
  where: Skill_Proportions_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Month_By_NationArgs = {
  where: Skill_Proportions_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Month_By_RegionArgs = {
  where: Skill_Proportions_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Year_By_CanoncountyArgs = {
  where: Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Year_By_GlobalArgs = {
  where: Skill_Proportions_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Year_By_LadArgs = {
  where: Skill_Proportions_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Year_By_NationArgs = {
  where: Skill_Proportions_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_Proportions_Per_Year_By_RegionArgs = {
  where: Skill_Proportions_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TermsArgs = {
  where: Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Terms_By_PkArgs = {
  term: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs = {
  object: AuthProviders_Insert_Input;
  on_conflict?: Maybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs = {
  object: AuthProviderRequests_Insert_Input;
  on_conflict?: Maybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs = {
  objects: Array<AuthProviderRequests_Insert_Input>;
  on_conflict?: Maybe<AuthProviderRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs = {
  objects: Array<AuthProviders_Insert_Input>;
  on_conflict?: Maybe<AuthProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs = {
  object: AuthRefreshTokens_Insert_Input;
  on_conflict?: Maybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokens_Insert_Input>;
  on_conflict?: Maybe<AuthRefreshTokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs = {
  object: AuthRoles_Insert_Input;
  on_conflict?: Maybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs = {
  objects: Array<AuthRoles_Insert_Input>;
  on_conflict?: Maybe<AuthRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs = {
  object: AuthUserProviders_Insert_Input;
  on_conflict?: Maybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs = {
  objects: Array<AuthUserProviders_Insert_Input>;
  on_conflict?: Maybe<AuthUserProviders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs = {
  object: AuthUserRoles_Insert_Input;
  on_conflict?: Maybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs = {
  objects: Array<AuthUserRoles_Insert_Input>;
  on_conflict?: Maybe<AuthUserRoles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs = {
  object: AuthUserSecurityKeys_Insert_Input;
  on_conflict?: Maybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs = {
  objects: Array<AuthUserSecurityKeys_Insert_Input>;
  on_conflict?: Maybe<AuthUserSecurityKeys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs = {
  object: Buckets_Insert_Input;
  on_conflict?: Maybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs = {
  objects: Array<Buckets_Insert_Input>;
  on_conflict?: Maybe<Buckets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs = {
  object: Files_Insert_Input;
  on_conflict?: Maybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: Maybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AreasArgs = {
  objects: Array<Areas_Insert_Input>;
  on_conflict?: Maybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Areas_OneArgs = {
  object: Areas_Insert_Input;
  on_conflict?: Maybe<Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CareersArgs = {
  objects: Array<Careers_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Careers_OneArgs = {
  object: Careers_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_CountiesArgs = {
  objects: Array<Counties_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Counties_OneArgs = {
  object: Counties_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Employer_StatsArgs = {
  objects: Array<Employer_Stats_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Employer_Stats_OneArgs = {
  object: Employer_Stats_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_GeotreeArgs = {
  objects: Array<Geotree_Insert_Input>;
  on_conflict?: Maybe<Geotree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Geotree_OneArgs = {
  object: Geotree_Insert_Input;
  on_conflict?: Maybe<Geotree_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Emerging_JobsArgs = {
  objects: Array<Global_Emerging_Jobs_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Emerging_Jobs_OneArgs = {
  object: Global_Emerging_Jobs_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Global_Emerging_SkillsArgs = {
  objects: Array<Global_Emerging_Skills_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Emerging_Skills_OneArgs = {
  object: Global_Emerging_Skills_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Global_Top_10_Skill_ClustersArgs = {
  objects: Array<Global_Top_10_Skill_Clusters_Insert_Input>;
  on_conflict?: Maybe<Global_Top_10_Skill_Clusters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Top_10_Skill_Clusters_OneArgs = {
  object: Global_Top_10_Skill_Clusters_Insert_Input;
  on_conflict?: Maybe<Global_Top_10_Skill_Clusters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Top_10_SkillsArgs = {
  objects: Array<Global_Top_10_Skills_Insert_Input>;
  on_conflict?: Maybe<Global_Top_10_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Top_10_Skills_OneArgs = {
  object: Global_Top_10_Skills_Insert_Input;
  on_conflict?: Maybe<Global_Top_10_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_CanoncountyArgs = {
  objects: Array<Job_Counts_Per_Month_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_Canoncounty_OneArgs = {
  object: Job_Counts_Per_Month_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_GlobalArgs = {
  objects: Array<Job_Counts_Per_Month_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_Global_OneArgs = {
  object: Job_Counts_Per_Month_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_LadArgs = {
  objects: Array<Job_Counts_Per_Month_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_Lad_OneArgs = {
  object: Job_Counts_Per_Month_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_NationArgs = {
  objects: Array<Job_Counts_Per_Month_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_Nation_OneArgs = {
  object: Job_Counts_Per_Month_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_RegionArgs = {
  objects: Array<Job_Counts_Per_Month_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Month_By_Region_OneArgs = {
  object: Job_Counts_Per_Month_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_CanoncountyArgs = {
  objects: Array<Job_Counts_Per_Year_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_Canoncounty_OneArgs = {
  object: Job_Counts_Per_Year_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_GlobalArgs = {
  objects: Array<Job_Counts_Per_Year_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_Global_OneArgs = {
  object: Job_Counts_Per_Year_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_LadArgs = {
  objects: Array<Job_Counts_Per_Year_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_Lad_OneArgs = {
  object: Job_Counts_Per_Year_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_NationArgs = {
  objects: Array<Job_Counts_Per_Year_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_Nation_OneArgs = {
  object: Job_Counts_Per_Year_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_RegionArgs = {
  objects: Array<Job_Counts_Per_Year_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Counts_Per_Year_By_Region_OneArgs = {
  object: Job_Counts_Per_Year_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_CanoncountyArgs = {
  objects: Array<Job_Proportions_Per_Month_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_Canoncounty_OneArgs = {
  object: Job_Proportions_Per_Month_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_GlobalArgs = {
  objects: Array<Job_Proportions_Per_Month_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_Global_OneArgs = {
  object: Job_Proportions_Per_Month_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_LadArgs = {
  objects: Array<Job_Proportions_Per_Month_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_Lad_OneArgs = {
  object: Job_Proportions_Per_Month_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_NationArgs = {
  objects: Array<Job_Proportions_Per_Month_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_Nation_OneArgs = {
  object: Job_Proportions_Per_Month_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_RegionArgs = {
  objects: Array<Job_Proportions_Per_Month_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Month_By_Region_OneArgs = {
  object: Job_Proportions_Per_Month_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_CanoncountyArgs = {
  objects: Array<Job_Proportions_Per_Year_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_Canoncounty_OneArgs = {
  object: Job_Proportions_Per_Year_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_GlobalArgs = {
  objects: Array<Job_Proportions_Per_Year_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_Global_OneArgs = {
  object: Job_Proportions_Per_Year_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_LadArgs = {
  objects: Array<Job_Proportions_Per_Year_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_Lad_OneArgs = {
  object: Job_Proportions_Per_Year_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_NationArgs = {
  objects: Array<Job_Proportions_Per_Year_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_Nation_OneArgs = {
  object: Job_Proportions_Per_Year_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_RegionArgs = {
  objects: Array<Job_Proportions_Per_Year_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Proportions_Per_Year_By_Region_OneArgs = {
  object: Job_Proportions_Per_Year_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_LadsArgs = {
  objects: Array<Lads_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Lads_OneArgs = {
  object: Lads_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_NationsArgs = {
  objects: Array<Nations_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nations_OneArgs = {
  object: Nations_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Profile_By_JobsArgs = {
  objects: Array<Profile_By_Jobs_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_By_Jobs_OneArgs = {
  object: Profile_By_Jobs_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Profile_By_SkillsArgs = {
  objects: Array<Profile_By_Skills_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_By_Skills_OneArgs = {
  object: Profile_By_Skills_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_RegionsArgs = {
  objects: Array<Regions_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Regions_OneArgs = {
  object: Regions_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_CanoncountyArgs = {
  objects: Array<Salary_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_Canoncounty_OneArgs = {
  object: Salary_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_GlobalArgs = {
  objects: Array<Salary_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_Global_OneArgs = {
  object: Salary_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_LadArgs = {
  objects: Array<Salary_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_Lad_OneArgs = {
  object: Salary_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_NationArgs = {
  objects: Array<Salary_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_Nation_OneArgs = {
  object: Salary_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_RegionArgs = {
  objects: Array<Salary_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_By_Region_OneArgs = {
  object: Salary_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_CanoncountyArgs = {
  objects: Array<Skill_Counts_Per_Month_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_Canoncounty_OneArgs = {
  object: Skill_Counts_Per_Month_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_GlobalArgs = {
  objects: Array<Skill_Counts_Per_Month_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_Global_OneArgs = {
  object: Skill_Counts_Per_Month_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_LadArgs = {
  objects: Array<Skill_Counts_Per_Month_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_Lad_OneArgs = {
  object: Skill_Counts_Per_Month_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_NationArgs = {
  objects: Array<Skill_Counts_Per_Month_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_Nation_OneArgs = {
  object: Skill_Counts_Per_Month_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_RegionArgs = {
  objects: Array<Skill_Counts_Per_Month_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Month_By_Region_OneArgs = {
  object: Skill_Counts_Per_Month_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_CanoncountyArgs = {
  objects: Array<Skill_Counts_Per_Year_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_Canoncounty_OneArgs = {
  object: Skill_Counts_Per_Year_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_GlobalArgs = {
  objects: Array<Skill_Counts_Per_Year_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_Global_OneArgs = {
  object: Skill_Counts_Per_Year_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_LadArgs = {
  objects: Array<Skill_Counts_Per_Year_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_Lad_OneArgs = {
  object: Skill_Counts_Per_Year_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_NationArgs = {
  objects: Array<Skill_Counts_Per_Year_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_Nation_OneArgs = {
  object: Skill_Counts_Per_Year_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_RegionArgs = {
  objects: Array<Skill_Counts_Per_Year_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Counts_Per_Year_By_Region_OneArgs = {
  object: Skill_Counts_Per_Year_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_CanoncountyArgs = {
  objects: Array<Skill_Proportions_Per_Month_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_Canoncounty_OneArgs = {
  object: Skill_Proportions_Per_Month_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_GlobalArgs = {
  objects: Array<Skill_Proportions_Per_Month_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_Global_OneArgs = {
  object: Skill_Proportions_Per_Month_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_LadArgs = {
  objects: Array<Skill_Proportions_Per_Month_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_Lad_OneArgs = {
  object: Skill_Proportions_Per_Month_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_NationArgs = {
  objects: Array<Skill_Proportions_Per_Month_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_Nation_OneArgs = {
  object: Skill_Proportions_Per_Month_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_RegionArgs = {
  objects: Array<Skill_Proportions_Per_Month_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Month_By_Region_OneArgs = {
  object: Skill_Proportions_Per_Month_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_CanoncountyArgs = {
  objects: Array<Skill_Proportions_Per_Year_By_Canoncounty_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_Canoncounty_OneArgs = {
  object: Skill_Proportions_Per_Year_By_Canoncounty_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_GlobalArgs = {
  objects: Array<Skill_Proportions_Per_Year_By_Global_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_Global_OneArgs = {
  object: Skill_Proportions_Per_Year_By_Global_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_LadArgs = {
  objects: Array<Skill_Proportions_Per_Year_By_Lad_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_Lad_OneArgs = {
  object: Skill_Proportions_Per_Year_By_Lad_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_NationArgs = {
  objects: Array<Skill_Proportions_Per_Year_By_Nation_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_Nation_OneArgs = {
  object: Skill_Proportions_Per_Year_By_Nation_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_RegionArgs = {
  objects: Array<Skill_Proportions_Per_Year_By_Region_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_Proportions_Per_Year_By_Region_OneArgs = {
  object: Skill_Proportions_Per_Year_By_Region_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_TermsArgs = {
  objects: Array<Terms_Insert_Input>;
  on_conflict?: Maybe<Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Terms_OneArgs = {
  object: Terms_Insert_Input;
  on_conflict?: Maybe<Terms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs = {
  _set?: Maybe<AuthProviders_Set_Input>;
  pk_columns: AuthProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs = {
  _append?: Maybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: Maybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: Maybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: Maybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: Maybe<AuthProviderRequests_Prepend_Input>;
  _set?: Maybe<AuthProviderRequests_Set_Input>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs = {
  _append?: Maybe<AuthProviderRequests_Append_Input>;
  _delete_at_path?: Maybe<AuthProviderRequests_Delete_At_Path_Input>;
  _delete_elem?: Maybe<AuthProviderRequests_Delete_Elem_Input>;
  _delete_key?: Maybe<AuthProviderRequests_Delete_Key_Input>;
  _prepend?: Maybe<AuthProviderRequests_Prepend_Input>;
  _set?: Maybe<AuthProviderRequests_Set_Input>;
  where: AuthProviderRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs = {
  _set?: Maybe<AuthProviders_Set_Input>;
  where: AuthProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs = {
  _set?: Maybe<AuthRefreshTokens_Set_Input>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs = {
  _set?: Maybe<AuthRefreshTokens_Set_Input>;
  where: AuthRefreshTokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs = {
  _set?: Maybe<AuthRoles_Set_Input>;
  pk_columns: AuthRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs = {
  _set?: Maybe<AuthRoles_Set_Input>;
  where: AuthRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs = {
  _set?: Maybe<AuthUserProviders_Set_Input>;
  pk_columns: AuthUserProviders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs = {
  _set?: Maybe<AuthUserProviders_Set_Input>;
  where: AuthUserProviders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs = {
  _set?: Maybe<AuthUserRoles_Set_Input>;
  pk_columns: AuthUserRoles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs = {
  _set?: Maybe<AuthUserRoles_Set_Input>;
  where: AuthUserRoles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs = {
  _inc?: Maybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: Maybe<AuthUserSecurityKeys_Set_Input>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs = {
  _inc?: Maybe<AuthUserSecurityKeys_Inc_Input>;
  _set?: Maybe<AuthUserSecurityKeys_Set_Input>;
  where: AuthUserSecurityKeys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs = {
  _inc?: Maybe<Buckets_Inc_Input>;
  _set?: Maybe<Buckets_Set_Input>;
  pk_columns: Buckets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs = {
  _inc?: Maybe<Buckets_Inc_Input>;
  _set?: Maybe<Buckets_Set_Input>;
  where: Buckets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs = {
  _inc?: Maybe<Files_Inc_Input>;
  _set?: Maybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs = {
  _inc?: Maybe<Files_Inc_Input>;
  _set?: Maybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  _append?: Maybe<Users_Append_Input>;
  _delete_at_path?: Maybe<Users_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Users_Delete_Elem_Input>;
  _delete_key?: Maybe<Users_Delete_Key_Input>;
  _prepend?: Maybe<Users_Prepend_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _append?: Maybe<Users_Append_Input>;
  _delete_at_path?: Maybe<Users_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Users_Delete_Elem_Input>;
  _delete_key?: Maybe<Users_Delete_Key_Input>;
  _prepend?: Maybe<Users_Prepend_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AreasArgs = {
  _set?: Maybe<Areas_Set_Input>;
  where: Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_By_PkArgs = {
  _set?: Maybe<Areas_Set_Input>;
  pk_columns: Areas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Areas_ManyArgs = {
  updates: Array<Areas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs = {
  updates: Array<AuthProviderRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs = {
  updates: Array<AuthProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs = {
  updates: Array<AuthRefreshTokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs = {
  updates: Array<AuthRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs = {
  updates: Array<AuthUserProviders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs = {
  updates: Array<AuthUserRoles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs = {
  updates: Array<AuthUserSecurityKeys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs = {
  updates: Array<Buckets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CareersArgs = {
  _inc?: Maybe<Careers_Inc_Input>;
  _set?: Maybe<Careers_Set_Input>;
  where: Careers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Careers_ManyArgs = {
  updates: Array<Careers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountiesArgs = {
  _set?: Maybe<Counties_Set_Input>;
  where: Counties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Counties_ManyArgs = {
  updates: Array<Counties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Employer_StatsArgs = {
  _inc?: Maybe<Employer_Stats_Inc_Input>;
  _set?: Maybe<Employer_Stats_Set_Input>;
  where: Employer_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Employer_Stats_ManyArgs = {
  updates: Array<Employer_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GeotreeArgs = {
  _set?: Maybe<Geotree_Set_Input>;
  where: Geotree_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Geotree_By_PkArgs = {
  _set?: Maybe<Geotree_Set_Input>;
  pk_columns: Geotree_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Geotree_ManyArgs = {
  updates: Array<Geotree_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Emerging_JobsArgs = {
  _inc?: Maybe<Global_Emerging_Jobs_Inc_Input>;
  _set?: Maybe<Global_Emerging_Jobs_Set_Input>;
  where: Global_Emerging_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Emerging_Jobs_ManyArgs = {
  updates: Array<Global_Emerging_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Emerging_SkillsArgs = {
  _inc?: Maybe<Global_Emerging_Skills_Inc_Input>;
  _set?: Maybe<Global_Emerging_Skills_Set_Input>;
  where: Global_Emerging_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Emerging_Skills_ManyArgs = {
  updates: Array<Global_Emerging_Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_Skill_ClustersArgs = {
  _inc?: Maybe<Global_Top_10_Skill_Clusters_Inc_Input>;
  _set?: Maybe<Global_Top_10_Skill_Clusters_Set_Input>;
  where: Global_Top_10_Skill_Clusters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_Skill_Clusters_By_PkArgs = {
  _inc?: Maybe<Global_Top_10_Skill_Clusters_Inc_Input>;
  _set?: Maybe<Global_Top_10_Skill_Clusters_Set_Input>;
  pk_columns: Global_Top_10_Skill_Clusters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_Skill_Clusters_ManyArgs = {
  updates: Array<Global_Top_10_Skill_Clusters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_SkillsArgs = {
  _inc?: Maybe<Global_Top_10_Skills_Inc_Input>;
  _set?: Maybe<Global_Top_10_Skills_Set_Input>;
  where: Global_Top_10_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_Skills_By_PkArgs = {
  _inc?: Maybe<Global_Top_10_Skills_Inc_Input>;
  _set?: Maybe<Global_Top_10_Skills_Set_Input>;
  pk_columns: Global_Top_10_Skills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Top_10_Skills_ManyArgs = {
  updates: Array<Global_Top_10_Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_CanoncountyArgs = {
  _inc?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Set_Input>;
  where: Job_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_Canoncounty_ManyArgs = {
  updates: Array<Job_Counts_Per_Month_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_GlobalArgs = {
  _inc?: Maybe<Job_Counts_Per_Month_By_Global_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Month_By_Global_Set_Input>;
  where: Job_Counts_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_Global_ManyArgs = {
  updates: Array<Job_Counts_Per_Month_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_LadArgs = {
  _inc?: Maybe<Job_Counts_Per_Month_By_Lad_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Month_By_Lad_Set_Input>;
  where: Job_Counts_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_Lad_ManyArgs = {
  updates: Array<Job_Counts_Per_Month_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_NationArgs = {
  _inc?: Maybe<Job_Counts_Per_Month_By_Nation_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Month_By_Nation_Set_Input>;
  where: Job_Counts_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_Nation_ManyArgs = {
  updates: Array<Job_Counts_Per_Month_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_RegionArgs = {
  _inc?: Maybe<Job_Counts_Per_Month_By_Region_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Month_By_Region_Set_Input>;
  where: Job_Counts_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Month_By_Region_ManyArgs = {
  updates: Array<Job_Counts_Per_Month_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_CanoncountyArgs = {
  _inc?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Set_Input>;
  where: Job_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_Canoncounty_ManyArgs = {
  updates: Array<Job_Counts_Per_Year_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_GlobalArgs = {
  _inc?: Maybe<Job_Counts_Per_Year_By_Global_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Year_By_Global_Set_Input>;
  where: Job_Counts_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_Global_ManyArgs = {
  updates: Array<Job_Counts_Per_Year_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_LadArgs = {
  _inc?: Maybe<Job_Counts_Per_Year_By_Lad_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Year_By_Lad_Set_Input>;
  where: Job_Counts_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_Lad_ManyArgs = {
  updates: Array<Job_Counts_Per_Year_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_NationArgs = {
  _inc?: Maybe<Job_Counts_Per_Year_By_Nation_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Year_By_Nation_Set_Input>;
  where: Job_Counts_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_Nation_ManyArgs = {
  updates: Array<Job_Counts_Per_Year_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_RegionArgs = {
  _inc?: Maybe<Job_Counts_Per_Year_By_Region_Inc_Input>;
  _set?: Maybe<Job_Counts_Per_Year_By_Region_Set_Input>;
  where: Job_Counts_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Counts_Per_Year_By_Region_ManyArgs = {
  updates: Array<Job_Counts_Per_Year_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_CanoncountyArgs = {
  _inc?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Set_Input>;
  where: Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_Canoncounty_ManyArgs = {
  updates: Array<Job_Proportions_Per_Month_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_GlobalArgs = {
  _inc?: Maybe<Job_Proportions_Per_Month_By_Global_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Month_By_Global_Set_Input>;
  where: Job_Proportions_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_Global_ManyArgs = {
  updates: Array<Job_Proportions_Per_Month_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_LadArgs = {
  _inc?: Maybe<Job_Proportions_Per_Month_By_Lad_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Month_By_Lad_Set_Input>;
  where: Job_Proportions_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_Lad_ManyArgs = {
  updates: Array<Job_Proportions_Per_Month_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_NationArgs = {
  _inc?: Maybe<Job_Proportions_Per_Month_By_Nation_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Month_By_Nation_Set_Input>;
  where: Job_Proportions_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_Nation_ManyArgs = {
  updates: Array<Job_Proportions_Per_Month_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_RegionArgs = {
  _inc?: Maybe<Job_Proportions_Per_Month_By_Region_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Month_By_Region_Set_Input>;
  where: Job_Proportions_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Month_By_Region_ManyArgs = {
  updates: Array<Job_Proportions_Per_Month_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_CanoncountyArgs = {
  _inc?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Set_Input>;
  where: Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_Canoncounty_ManyArgs = {
  updates: Array<Job_Proportions_Per_Year_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_GlobalArgs = {
  _inc?: Maybe<Job_Proportions_Per_Year_By_Global_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Year_By_Global_Set_Input>;
  where: Job_Proportions_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_Global_ManyArgs = {
  updates: Array<Job_Proportions_Per_Year_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_LadArgs = {
  _inc?: Maybe<Job_Proportions_Per_Year_By_Lad_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Year_By_Lad_Set_Input>;
  where: Job_Proportions_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_Lad_ManyArgs = {
  updates: Array<Job_Proportions_Per_Year_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_NationArgs = {
  _inc?: Maybe<Job_Proportions_Per_Year_By_Nation_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Year_By_Nation_Set_Input>;
  where: Job_Proportions_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_Nation_ManyArgs = {
  updates: Array<Job_Proportions_Per_Year_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_RegionArgs = {
  _inc?: Maybe<Job_Proportions_Per_Year_By_Region_Inc_Input>;
  _set?: Maybe<Job_Proportions_Per_Year_By_Region_Set_Input>;
  where: Job_Proportions_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Proportions_Per_Year_By_Region_ManyArgs = {
  updates: Array<Job_Proportions_Per_Year_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LadsArgs = {
  _set?: Maybe<Lads_Set_Input>;
  where: Lads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lads_ManyArgs = {
  updates: Array<Lads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NationsArgs = {
  _set?: Maybe<Nations_Set_Input>;
  where: Nations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nations_ManyArgs = {
  updates: Array<Nations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_JobsArgs = {
  _inc?: Maybe<Profile_By_Jobs_Inc_Input>;
  _set?: Maybe<Profile_By_Jobs_Set_Input>;
  where: Profile_By_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_Jobs_ManyArgs = {
  updates: Array<Profile_By_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_SkillsArgs = {
  _inc?: Maybe<Profile_By_Skills_Inc_Input>;
  _set?: Maybe<Profile_By_Skills_Set_Input>;
  where: Profile_By_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_Skills_ManyArgs = {
  updates: Array<Profile_By_Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RegionsArgs = {
  _set?: Maybe<Regions_Set_Input>;
  where: Regions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Regions_ManyArgs = {
  updates: Array<Regions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_CanoncountyArgs = {
  _inc?: Maybe<Salary_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Salary_By_Canoncounty_Set_Input>;
  where: Salary_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_Canoncounty_ManyArgs = {
  updates: Array<Salary_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_GlobalArgs = {
  _inc?: Maybe<Salary_By_Global_Inc_Input>;
  _set?: Maybe<Salary_By_Global_Set_Input>;
  where: Salary_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_Global_ManyArgs = {
  updates: Array<Salary_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_LadArgs = {
  _inc?: Maybe<Salary_By_Lad_Inc_Input>;
  _set?: Maybe<Salary_By_Lad_Set_Input>;
  where: Salary_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_Lad_ManyArgs = {
  updates: Array<Salary_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_NationArgs = {
  _inc?: Maybe<Salary_By_Nation_Inc_Input>;
  _set?: Maybe<Salary_By_Nation_Set_Input>;
  where: Salary_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_Nation_ManyArgs = {
  updates: Array<Salary_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_RegionArgs = {
  _inc?: Maybe<Salary_By_Region_Inc_Input>;
  _set?: Maybe<Salary_By_Region_Set_Input>;
  where: Salary_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_By_Region_ManyArgs = {
  updates: Array<Salary_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_CanoncountyArgs = {
  _inc?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Set_Input>;
  where: Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_Canoncounty_ManyArgs = {
  updates: Array<Skill_Counts_Per_Month_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_GlobalArgs = {
  _inc?: Maybe<Skill_Counts_Per_Month_By_Global_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Month_By_Global_Set_Input>;
  where: Skill_Counts_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_Global_ManyArgs = {
  updates: Array<Skill_Counts_Per_Month_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_LadArgs = {
  _inc?: Maybe<Skill_Counts_Per_Month_By_Lad_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Month_By_Lad_Set_Input>;
  where: Skill_Counts_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_Lad_ManyArgs = {
  updates: Array<Skill_Counts_Per_Month_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_NationArgs = {
  _inc?: Maybe<Skill_Counts_Per_Month_By_Nation_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Month_By_Nation_Set_Input>;
  where: Skill_Counts_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_Nation_ManyArgs = {
  updates: Array<Skill_Counts_Per_Month_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_RegionArgs = {
  _inc?: Maybe<Skill_Counts_Per_Month_By_Region_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Month_By_Region_Set_Input>;
  where: Skill_Counts_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Month_By_Region_ManyArgs = {
  updates: Array<Skill_Counts_Per_Month_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_CanoncountyArgs = {
  _inc?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Set_Input>;
  where: Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_Canoncounty_ManyArgs = {
  updates: Array<Skill_Counts_Per_Year_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_GlobalArgs = {
  _inc?: Maybe<Skill_Counts_Per_Year_By_Global_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Year_By_Global_Set_Input>;
  where: Skill_Counts_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_Global_ManyArgs = {
  updates: Array<Skill_Counts_Per_Year_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_LadArgs = {
  _inc?: Maybe<Skill_Counts_Per_Year_By_Lad_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Year_By_Lad_Set_Input>;
  where: Skill_Counts_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_Lad_ManyArgs = {
  updates: Array<Skill_Counts_Per_Year_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_NationArgs = {
  _inc?: Maybe<Skill_Counts_Per_Year_By_Nation_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Year_By_Nation_Set_Input>;
  where: Skill_Counts_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_Nation_ManyArgs = {
  updates: Array<Skill_Counts_Per_Year_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_RegionArgs = {
  _inc?: Maybe<Skill_Counts_Per_Year_By_Region_Inc_Input>;
  _set?: Maybe<Skill_Counts_Per_Year_By_Region_Set_Input>;
  where: Skill_Counts_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Counts_Per_Year_By_Region_ManyArgs = {
  updates: Array<Skill_Counts_Per_Year_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_CanoncountyArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_Canoncounty_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Month_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_GlobalArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Global_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Month_By_Global_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_Global_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Month_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_LadArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Lad_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Month_By_Lad_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_Lad_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Month_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_NationArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Nation_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Month_By_Nation_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_Nation_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Month_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_RegionArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Region_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Month_By_Region_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Month_By_Region_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Month_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_CanoncountyArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_Canoncounty_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Year_By_Canoncounty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_GlobalArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Global_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Year_By_Global_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Global_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_Global_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Year_By_Global_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_LadArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Lad_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Year_By_Lad_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Lad_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_Lad_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Year_By_Lad_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_NationArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Nation_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Year_By_Nation_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Nation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_Nation_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Year_By_Nation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_RegionArgs = {
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Region_Inc_Input>;
  _set?: Maybe<Skill_Proportions_Per_Year_By_Region_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_Proportions_Per_Year_By_Region_ManyArgs = {
  updates: Array<Skill_Proportions_Per_Year_By_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TermsArgs = {
  _set?: Maybe<Terms_Set_Input>;
  where: Terms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Terms_By_PkArgs = {
  _set?: Maybe<Terms_Set_Input>;
  pk_columns: Terms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Terms_ManyArgs = {
  updates: Array<Terms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** columns and relationships of "nations" */
export type Nations = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "nations" */
export type Nations_Aggregate = {
  aggregate?: Maybe<Nations_Aggregate_Fields>;
  nodes: Array<Nations>;
};

/** aggregate fields of "nations" */
export type Nations_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Nations_Max_Fields>;
  min?: Maybe<Nations_Min_Fields>;
};


/** aggregate fields of "nations" */
export type Nations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Nations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nations". All fields are combined with a logical 'AND'. */
export type Nations_Bool_Exp = {
  _and?: Maybe<Array<Nations_Bool_Exp>>;
  _not?: Maybe<Nations_Bool_Exp>;
  _or?: Maybe<Array<Nations_Bool_Exp>>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "nations" */
export type Nations_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Nations_Max_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Nations_Min_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "nations" */
export type Nations_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nations>;
};

/** Ordering options when selecting data from "nations". */
export type Nations_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** select columns of table "nations" */
export enum Nations_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "nations" */
export type Nations_Set_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "nations" */
export type Nations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nations_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Nations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Nations_Set_Input>;
  where: Nations_Bool_Exp;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "profile_by_jobs" */
export type Profile_By_Jobs = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "profile_by_jobs" */
export type Profile_By_Jobs_Aggregate = {
  aggregate?: Maybe<Profile_By_Jobs_Aggregate_Fields>;
  nodes: Array<Profile_By_Jobs>;
};

/** aggregate fields of "profile_by_jobs" */
export type Profile_By_Jobs_Aggregate_Fields = {
  avg?: Maybe<Profile_By_Jobs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Profile_By_Jobs_Max_Fields>;
  min?: Maybe<Profile_By_Jobs_Min_Fields>;
  stddev?: Maybe<Profile_By_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Profile_By_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profile_By_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Profile_By_Jobs_Sum_Fields>;
  var_pop?: Maybe<Profile_By_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Profile_By_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Profile_By_Jobs_Variance_Fields>;
};


/** aggregate fields of "profile_by_jobs" */
export type Profile_By_Jobs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Profile_By_Jobs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Profile_By_Jobs_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profile_by_jobs". All fields are combined with a logical 'AND'. */
export type Profile_By_Jobs_Bool_Exp = {
  CanonEmployer?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  Latitude?: Maybe<Float8_Comparison_Exp>;
  Longitude?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Profile_By_Jobs_Bool_Exp>>;
  _not?: Maybe<Profile_By_Jobs_Bool_Exp>;
  _or?: Maybe<Array<Profile_By_Jobs_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "profile_by_jobs" */
export type Profile_By_Jobs_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "profile_by_jobs" */
export type Profile_By_Jobs_Insert_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profile_By_Jobs_Max_Fields = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Profile_By_Jobs_Min_Fields = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "profile_by_jobs" */
export type Profile_By_Jobs_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_By_Jobs>;
};

/** Ordering options when selecting data from "profile_by_jobs". */
export type Profile_By_Jobs_Order_By = {
  CanonEmployer?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  Latitude?: Maybe<Order_By>;
  Longitude?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "profile_by_jobs" */
export enum Profile_By_Jobs_Select_Column {
  /** column name */
  CanonEmployer = 'CanonEmployer',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Count = 'Count',
  /** column name */
  Latitude = 'Latitude',
  /** column name */
  Longitude = 'Longitude',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "profile_by_jobs" */
export type Profile_By_Jobs_Set_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Profile_By_Jobs_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Profile_By_Jobs_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Profile_By_Jobs_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "profile_by_jobs" */
export type Profile_By_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_By_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_By_Jobs_Stream_Cursor_Value_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Profile_By_Jobs_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
};

export type Profile_By_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Profile_By_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Profile_By_Jobs_Set_Input>;
  where: Profile_By_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profile_By_Jobs_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Profile_By_Jobs_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Profile_By_Jobs_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "profile_by_skills" */
export type Profile_By_Skills = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "profile_by_skills" */
export type Profile_By_Skills_Aggregate = {
  aggregate?: Maybe<Profile_By_Skills_Aggregate_Fields>;
  nodes: Array<Profile_By_Skills>;
};

/** aggregate fields of "profile_by_skills" */
export type Profile_By_Skills_Aggregate_Fields = {
  avg?: Maybe<Profile_By_Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Profile_By_Skills_Max_Fields>;
  min?: Maybe<Profile_By_Skills_Min_Fields>;
  stddev?: Maybe<Profile_By_Skills_Stddev_Fields>;
  stddev_pop?: Maybe<Profile_By_Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profile_By_Skills_Stddev_Samp_Fields>;
  sum?: Maybe<Profile_By_Skills_Sum_Fields>;
  var_pop?: Maybe<Profile_By_Skills_Var_Pop_Fields>;
  var_samp?: Maybe<Profile_By_Skills_Var_Samp_Fields>;
  variance?: Maybe<Profile_By_Skills_Variance_Fields>;
};


/** aggregate fields of "profile_by_skills" */
export type Profile_By_Skills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Profile_By_Skills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Profile_By_Skills_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profile_by_skills". All fields are combined with a logical 'AND'. */
export type Profile_By_Skills_Bool_Exp = {
  CanonEmployer?: Maybe<String_Comparison_Exp>;
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  Latitude?: Maybe<Float8_Comparison_Exp>;
  Longitude?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Profile_By_Skills_Bool_Exp>>;
  _not?: Maybe<Profile_By_Skills_Bool_Exp>;
  _or?: Maybe<Array<Profile_By_Skills_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "profile_by_skills" */
export type Profile_By_Skills_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "profile_by_skills" */
export type Profile_By_Skills_Insert_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profile_By_Skills_Max_Fields = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Profile_By_Skills_Min_Fields = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "profile_by_skills" */
export type Profile_By_Skills_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_By_Skills>;
};

/** Ordering options when selecting data from "profile_by_skills". */
export type Profile_By_Skills_Order_By = {
  CanonEmployer?: Maybe<Order_By>;
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  Latitude?: Maybe<Order_By>;
  Longitude?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "profile_by_skills" */
export enum Profile_By_Skills_Select_Column {
  /** column name */
  CanonEmployer = 'CanonEmployer',
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  Latitude = 'Latitude',
  /** column name */
  Longitude = 'Longitude',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "profile_by_skills" */
export type Profile_By_Skills_Set_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Profile_By_Skills_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Profile_By_Skills_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Profile_By_Skills_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "profile_by_skills" */
export type Profile_By_Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_By_Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_By_Skills_Stream_Cursor_Value_Input = {
  CanonEmployer?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Profile_By_Skills_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
  Latitude?: Maybe<Scalars['float8']>;
  Longitude?: Maybe<Scalars['float8']>;
};

export type Profile_By_Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Profile_By_Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Profile_By_Skills_Set_Input>;
  where: Profile_By_Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profile_By_Skills_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Profile_By_Skills_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Profile_By_Skills_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  /** fetch data from the table: "areas" */
  areas: Array<Areas>;
  /** fetch aggregated fields from the table: "areas" */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table: "careers" */
  careers: Array<Careers>;
  /** fetch aggregated fields from the table: "careers" */
  careers_aggregate: Careers_Aggregate;
  /** fetch data from the table: "counties" */
  counties: Array<Counties>;
  /** fetch aggregated fields from the table: "counties" */
  counties_aggregate: Counties_Aggregate;
  /** fetch data from the table: "employer_stats" */
  employer_stats: Array<Employer_Stats>;
  /** fetch aggregated fields from the table: "employer_stats" */
  employer_stats_aggregate: Employer_Stats_Aggregate;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table: "geotree" */
  geotree: Array<Geotree>;
  /** fetch aggregated fields from the table: "geotree" */
  geotree_aggregate: Geotree_Aggregate;
  /** fetch data from the table: "geotree" using primary key columns */
  geotree_by_pk?: Maybe<Geotree>;
  /** fetch data from the table: "global_emerging_jobs" */
  global_emerging_jobs: Array<Global_Emerging_Jobs>;
  /** fetch aggregated fields from the table: "global_emerging_jobs" */
  global_emerging_jobs_aggregate: Global_Emerging_Jobs_Aggregate;
  /** fetch data from the table: "global_emerging_skills" */
  global_emerging_skills: Array<Global_Emerging_Skills>;
  /** fetch aggregated fields from the table: "global_emerging_skills" */
  global_emerging_skills_aggregate: Global_Emerging_Skills_Aggregate;
  /** fetch data from the table: "global_top_10_skill_clusters" */
  global_top_10_skill_clusters: Array<Global_Top_10_Skill_Clusters>;
  /** fetch aggregated fields from the table: "global_top_10_skill_clusters" */
  global_top_10_skill_clusters_aggregate: Global_Top_10_Skill_Clusters_Aggregate;
  /** fetch data from the table: "global_top_10_skill_clusters" using primary key columns */
  global_top_10_skill_clusters_by_pk?: Maybe<Global_Top_10_Skill_Clusters>;
  /** fetch data from the table: "global_top_10_skills" */
  global_top_10_skills: Array<Global_Top_10_Skills>;
  /** fetch aggregated fields from the table: "global_top_10_skills" */
  global_top_10_skills_aggregate: Global_Top_10_Skills_Aggregate;
  /** fetch data from the table: "global_top_10_skills" using primary key columns */
  global_top_10_skills_by_pk?: Maybe<Global_Top_10_Skills>;
  /** fetch data from the table: "job_counts_per_month_by_canoncounty" */
  job_counts_per_month_by_canoncounty: Array<Job_Counts_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_canoncounty" */
  job_counts_per_month_by_canoncounty_aggregate: Job_Counts_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table: "job_counts_per_month_by_global" */
  job_counts_per_month_by_global: Array<Job_Counts_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_global" */
  job_counts_per_month_by_global_aggregate: Job_Counts_Per_Month_By_Global_Aggregate;
  /** fetch data from the table: "job_counts_per_month_by_lad" */
  job_counts_per_month_by_lad: Array<Job_Counts_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_lad" */
  job_counts_per_month_by_lad_aggregate: Job_Counts_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table: "job_counts_per_month_by_nation" */
  job_counts_per_month_by_nation: Array<Job_Counts_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_nation" */
  job_counts_per_month_by_nation_aggregate: Job_Counts_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table: "job_counts_per_month_by_region" */
  job_counts_per_month_by_region: Array<Job_Counts_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_region" */
  job_counts_per_month_by_region_aggregate: Job_Counts_Per_Month_By_Region_Aggregate;
  /** fetch data from the table: "job_counts_per_year_by_canoncounty" */
  job_counts_per_year_by_canoncounty: Array<Job_Counts_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_canoncounty" */
  job_counts_per_year_by_canoncounty_aggregate: Job_Counts_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table: "job_counts_per_year_by_global" */
  job_counts_per_year_by_global: Array<Job_Counts_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_global" */
  job_counts_per_year_by_global_aggregate: Job_Counts_Per_Year_By_Global_Aggregate;
  /** fetch data from the table: "job_counts_per_year_by_lad" */
  job_counts_per_year_by_lad: Array<Job_Counts_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_lad" */
  job_counts_per_year_by_lad_aggregate: Job_Counts_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table: "job_counts_per_year_by_nation" */
  job_counts_per_year_by_nation: Array<Job_Counts_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_nation" */
  job_counts_per_year_by_nation_aggregate: Job_Counts_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table: "job_counts_per_year_by_region" */
  job_counts_per_year_by_region: Array<Job_Counts_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_region" */
  job_counts_per_year_by_region_aggregate: Job_Counts_Per_Year_By_Region_Aggregate;
  /** fetch data from the table: "job_proportions_per_month_by_canoncounty" */
  job_proportions_per_month_by_canoncounty: Array<Job_Proportions_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_canoncounty" */
  job_proportions_per_month_by_canoncounty_aggregate: Job_Proportions_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table: "job_proportions_per_month_by_global" */
  job_proportions_per_month_by_global: Array<Job_Proportions_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_global" */
  job_proportions_per_month_by_global_aggregate: Job_Proportions_Per_Month_By_Global_Aggregate;
  /** fetch data from the table: "job_proportions_per_month_by_lad" */
  job_proportions_per_month_by_lad: Array<Job_Proportions_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_lad" */
  job_proportions_per_month_by_lad_aggregate: Job_Proportions_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table: "job_proportions_per_month_by_nation" */
  job_proportions_per_month_by_nation: Array<Job_Proportions_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_nation" */
  job_proportions_per_month_by_nation_aggregate: Job_Proportions_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table: "job_proportions_per_month_by_region" */
  job_proportions_per_month_by_region: Array<Job_Proportions_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_region" */
  job_proportions_per_month_by_region_aggregate: Job_Proportions_Per_Month_By_Region_Aggregate;
  /** fetch data from the table: "job_proportions_per_year_by_canoncounty" */
  job_proportions_per_year_by_canoncounty: Array<Job_Proportions_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_canoncounty" */
  job_proportions_per_year_by_canoncounty_aggregate: Job_Proportions_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table: "job_proportions_per_year_by_global" */
  job_proportions_per_year_by_global: Array<Job_Proportions_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_global" */
  job_proportions_per_year_by_global_aggregate: Job_Proportions_Per_Year_By_Global_Aggregate;
  /** fetch data from the table: "job_proportions_per_year_by_lad" */
  job_proportions_per_year_by_lad: Array<Job_Proportions_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_lad" */
  job_proportions_per_year_by_lad_aggregate: Job_Proportions_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table: "job_proportions_per_year_by_nation" */
  job_proportions_per_year_by_nation: Array<Job_Proportions_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_nation" */
  job_proportions_per_year_by_nation_aggregate: Job_Proportions_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table: "job_proportions_per_year_by_region" */
  job_proportions_per_year_by_region: Array<Job_Proportions_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_region" */
  job_proportions_per_year_by_region_aggregate: Job_Proportions_Per_Year_By_Region_Aggregate;
  /** fetch data from the table: "lads" */
  lads: Array<Lads>;
  /** fetch aggregated fields from the table: "lads" */
  lads_aggregate: Lads_Aggregate;
  /** fetch data from the table: "nations" */
  nations: Array<Nations>;
  /** fetch aggregated fields from the table: "nations" */
  nations_aggregate: Nations_Aggregate;
  /** fetch data from the table: "profile_by_jobs" */
  profile_by_jobs: Array<Profile_By_Jobs>;
  /** fetch aggregated fields from the table: "profile_by_jobs" */
  profile_by_jobs_aggregate: Profile_By_Jobs_Aggregate;
  /** fetch data from the table: "profile_by_skills" */
  profile_by_skills: Array<Profile_By_Skills>;
  /** fetch aggregated fields from the table: "profile_by_skills" */
  profile_by_skills_aggregate: Profile_By_Skills_Aggregate;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table: "salary_by_canoncounty" */
  salary_by_canoncounty: Array<Salary_By_Canoncounty>;
  /** fetch aggregated fields from the table: "salary_by_canoncounty" */
  salary_by_canoncounty_aggregate: Salary_By_Canoncounty_Aggregate;
  /** fetch data from the table: "salary_by_global" */
  salary_by_global: Array<Salary_By_Global>;
  /** fetch aggregated fields from the table: "salary_by_global" */
  salary_by_global_aggregate: Salary_By_Global_Aggregate;
  /** fetch data from the table: "salary_by_lad" */
  salary_by_lad: Array<Salary_By_Lad>;
  /** fetch aggregated fields from the table: "salary_by_lad" */
  salary_by_lad_aggregate: Salary_By_Lad_Aggregate;
  /** fetch data from the table: "salary_by_nation" */
  salary_by_nation: Array<Salary_By_Nation>;
  /** fetch aggregated fields from the table: "salary_by_nation" */
  salary_by_nation_aggregate: Salary_By_Nation_Aggregate;
  /** fetch data from the table: "salary_by_region" */
  salary_by_region: Array<Salary_By_Region>;
  /** fetch aggregated fields from the table: "salary_by_region" */
  salary_by_region_aggregate: Salary_By_Region_Aggregate;
  /** fetch data from the table: "skill_counts_per_month_by_canoncounty" */
  skill_counts_per_month_by_canoncounty: Array<Skill_Counts_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_canoncounty" */
  skill_counts_per_month_by_canoncounty_aggregate: Skill_Counts_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table: "skill_counts_per_month_by_global" */
  skill_counts_per_month_by_global: Array<Skill_Counts_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_global" */
  skill_counts_per_month_by_global_aggregate: Skill_Counts_Per_Month_By_Global_Aggregate;
  /** fetch data from the table: "skill_counts_per_month_by_lad" */
  skill_counts_per_month_by_lad: Array<Skill_Counts_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_lad" */
  skill_counts_per_month_by_lad_aggregate: Skill_Counts_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table: "skill_counts_per_month_by_nation" */
  skill_counts_per_month_by_nation: Array<Skill_Counts_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_nation" */
  skill_counts_per_month_by_nation_aggregate: Skill_Counts_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table: "skill_counts_per_month_by_region" */
  skill_counts_per_month_by_region: Array<Skill_Counts_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_region" */
  skill_counts_per_month_by_region_aggregate: Skill_Counts_Per_Month_By_Region_Aggregate;
  /** fetch data from the table: "skill_counts_per_year_by_canoncounty" */
  skill_counts_per_year_by_canoncounty: Array<Skill_Counts_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_canoncounty" */
  skill_counts_per_year_by_canoncounty_aggregate: Skill_Counts_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table: "skill_counts_per_year_by_global" */
  skill_counts_per_year_by_global: Array<Skill_Counts_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_global" */
  skill_counts_per_year_by_global_aggregate: Skill_Counts_Per_Year_By_Global_Aggregate;
  /** fetch data from the table: "skill_counts_per_year_by_lad" */
  skill_counts_per_year_by_lad: Array<Skill_Counts_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_lad" */
  skill_counts_per_year_by_lad_aggregate: Skill_Counts_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table: "skill_counts_per_year_by_nation" */
  skill_counts_per_year_by_nation: Array<Skill_Counts_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_nation" */
  skill_counts_per_year_by_nation_aggregate: Skill_Counts_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table: "skill_counts_per_year_by_region" */
  skill_counts_per_year_by_region: Array<Skill_Counts_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_region" */
  skill_counts_per_year_by_region_aggregate: Skill_Counts_Per_Year_By_Region_Aggregate;
  /** fetch data from the table: "skill_proportions_per_month_by_canoncounty" */
  skill_proportions_per_month_by_canoncounty: Array<Skill_Proportions_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_canoncounty" */
  skill_proportions_per_month_by_canoncounty_aggregate: Skill_Proportions_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table: "skill_proportions_per_month_by_global" */
  skill_proportions_per_month_by_global: Array<Skill_Proportions_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_global" */
  skill_proportions_per_month_by_global_aggregate: Skill_Proportions_Per_Month_By_Global_Aggregate;
  /** fetch data from the table: "skill_proportions_per_month_by_lad" */
  skill_proportions_per_month_by_lad: Array<Skill_Proportions_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_lad" */
  skill_proportions_per_month_by_lad_aggregate: Skill_Proportions_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table: "skill_proportions_per_month_by_nation" */
  skill_proportions_per_month_by_nation: Array<Skill_Proportions_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_nation" */
  skill_proportions_per_month_by_nation_aggregate: Skill_Proportions_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table: "skill_proportions_per_month_by_region" */
  skill_proportions_per_month_by_region: Array<Skill_Proportions_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_region" */
  skill_proportions_per_month_by_region_aggregate: Skill_Proportions_Per_Month_By_Region_Aggregate;
  /** fetch data from the table: "skill_proportions_per_year_by_canoncounty" */
  skill_proportions_per_year_by_canoncounty: Array<Skill_Proportions_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_canoncounty" */
  skill_proportions_per_year_by_canoncounty_aggregate: Skill_Proportions_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table: "skill_proportions_per_year_by_global" */
  skill_proportions_per_year_by_global: Array<Skill_Proportions_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_global" */
  skill_proportions_per_year_by_global_aggregate: Skill_Proportions_Per_Year_By_Global_Aggregate;
  /** fetch data from the table: "skill_proportions_per_year_by_lad" */
  skill_proportions_per_year_by_lad: Array<Skill_Proportions_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_lad" */
  skill_proportions_per_year_by_lad_aggregate: Skill_Proportions_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table: "skill_proportions_per_year_by_nation" */
  skill_proportions_per_year_by_nation: Array<Skill_Proportions_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_nation" */
  skill_proportions_per_year_by_nation_aggregate: Skill_Proportions_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table: "skill_proportions_per_year_by_region" */
  skill_proportions_per_year_by_region: Array<Skill_Proportions_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_region" */
  skill_proportions_per_year_by_region_aggregate: Skill_Proportions_Per_Year_By_Region_Aggregate;
  /** fetch data from the table: "terms" */
  terms: Array<Terms>;
  /** fetch aggregated fields from the table: "terms" */
  terms_aggregate: Terms_Aggregate;
  /** fetch data from the table: "terms" using primary key columns */
  terms_by_pk?: Maybe<Terms>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
};


export type Query_RootAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Query_RootAreas_By_PkArgs = {
  area_type: Scalars['String'];
  id: Scalars['String'];
};


export type Query_RootAuthProviderArgs = {
  id: Scalars['String'];
};


export type Query_RootAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthProviderRequestsArgs = {
  distinct_on?: Maybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviderRequests_Order_By>>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviderRequests_Order_By>>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};


export type Query_RootAuthProvidersArgs = {
  distinct_on?: Maybe<Array<AuthProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviders_Order_By>>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthProvidersAggregateArgs = {
  distinct_on?: Maybe<Array<AuthProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviders_Order_By>>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};


export type Query_RootAuthRefreshTokenArgs = {
  refreshToken: Scalars['uuid'];
};


export type Query_RootAuthRefreshTokensArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


export type Query_RootAuthRoleArgs = {
  role: Scalars['String'];
};


export type Query_RootAuthRolesArgs = {
  distinct_on?: Maybe<Array<AuthRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRoles_Order_By>>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthRolesAggregateArgs = {
  distinct_on?: Maybe<Array<AuthRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRoles_Order_By>>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};


export type Query_RootAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserProvidersArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


export type Query_RootAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserRolesArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAuthUserSecurityKeysArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Query_RootBucketArgs = {
  id: Scalars['String'];
};


export type Query_RootBucketsArgs = {
  distinct_on?: Maybe<Array<Buckets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Buckets_Order_By>>;
  where?: Maybe<Buckets_Bool_Exp>;
};


export type Query_RootBucketsAggregateArgs = {
  distinct_on?: Maybe<Array<Buckets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Buckets_Order_By>>;
  where?: Maybe<Buckets_Bool_Exp>;
};


export type Query_RootCareersArgs = {
  distinct_on?: Maybe<Array<Careers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Careers_Order_By>>;
  where?: Maybe<Careers_Bool_Exp>;
};


export type Query_RootCareers_AggregateArgs = {
  distinct_on?: Maybe<Array<Careers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Careers_Order_By>>;
  where?: Maybe<Careers_Bool_Exp>;
};


export type Query_RootCountiesArgs = {
  distinct_on?: Maybe<Array<Counties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Counties_Order_By>>;
  where?: Maybe<Counties_Bool_Exp>;
};


export type Query_RootCounties_AggregateArgs = {
  distinct_on?: Maybe<Array<Counties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Counties_Order_By>>;
  where?: Maybe<Counties_Bool_Exp>;
};


export type Query_RootEmployer_StatsArgs = {
  distinct_on?: Maybe<Array<Employer_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employer_Stats_Order_By>>;
  where?: Maybe<Employer_Stats_Bool_Exp>;
};


export type Query_RootEmployer_Stats_AggregateArgs = {
  distinct_on?: Maybe<Array<Employer_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employer_Stats_Order_By>>;
  where?: Maybe<Employer_Stats_Bool_Exp>;
};


export type Query_RootFileArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFilesArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};


export type Query_RootFilesAggregateArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};


export type Query_RootGeotreeArgs = {
  distinct_on?: Maybe<Array<Geotree_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geotree_Order_By>>;
  where?: Maybe<Geotree_Bool_Exp>;
};


export type Query_RootGeotree_AggregateArgs = {
  distinct_on?: Maybe<Array<Geotree_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geotree_Order_By>>;
  where?: Maybe<Geotree_Bool_Exp>;
};


export type Query_RootGeotree_By_PkArgs = {
  LadAreaCode: Scalars['bpchar'];
};


export type Query_RootGlobal_Emerging_JobsArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Jobs_Order_By>>;
  where?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
};


export type Query_RootGlobal_Emerging_Jobs_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Jobs_Order_By>>;
  where?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
};


export type Query_RootGlobal_Emerging_SkillsArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Skills_Order_By>>;
  where?: Maybe<Global_Emerging_Skills_Bool_Exp>;
};


export type Query_RootGlobal_Emerging_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Skills_Order_By>>;
  where?: Maybe<Global_Emerging_Skills_Bool_Exp>;
};


export type Query_RootGlobal_Top_10_Skill_ClustersArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skill_Clusters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skill_Clusters_Order_By>>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};


export type Query_RootGlobal_Top_10_Skill_Clusters_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skill_Clusters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skill_Clusters_Order_By>>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};


export type Query_RootGlobal_Top_10_Skill_Clusters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGlobal_Top_10_SkillsArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skills_Order_By>>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};


export type Query_RootGlobal_Top_10_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skills_Order_By>>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};


export type Query_RootGlobal_Top_10_Skills_By_PkArgs = {
  ParentSkill: Scalars['bpchar'];
};


export type Query_RootJob_Counts_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootJob_Counts_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootJob_Proportions_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootLadsArgs = {
  distinct_on?: Maybe<Array<Lads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lads_Order_By>>;
  where?: Maybe<Lads_Bool_Exp>;
};


export type Query_RootLads_AggregateArgs = {
  distinct_on?: Maybe<Array<Lads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lads_Order_By>>;
  where?: Maybe<Lads_Bool_Exp>;
};


export type Query_RootNationsArgs = {
  distinct_on?: Maybe<Array<Nations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nations_Order_By>>;
  where?: Maybe<Nations_Bool_Exp>;
};


export type Query_RootNations_AggregateArgs = {
  distinct_on?: Maybe<Array<Nations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nations_Order_By>>;
  where?: Maybe<Nations_Bool_Exp>;
};


export type Query_RootProfile_By_JobsArgs = {
  distinct_on?: Maybe<Array<Profile_By_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Jobs_Order_By>>;
  where?: Maybe<Profile_By_Jobs_Bool_Exp>;
};


export type Query_RootProfile_By_Jobs_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_By_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Jobs_Order_By>>;
  where?: Maybe<Profile_By_Jobs_Bool_Exp>;
};


export type Query_RootProfile_By_SkillsArgs = {
  distinct_on?: Maybe<Array<Profile_By_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Skills_Order_By>>;
  where?: Maybe<Profile_By_Skills_Bool_Exp>;
};


export type Query_RootProfile_By_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_By_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Skills_Order_By>>;
  where?: Maybe<Profile_By_Skills_Bool_Exp>;
};


export type Query_RootRegionsArgs = {
  distinct_on?: Maybe<Array<Regions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regions_Order_By>>;
  where?: Maybe<Regions_Bool_Exp>;
};


export type Query_RootRegions_AggregateArgs = {
  distinct_on?: Maybe<Array<Regions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regions_Order_By>>;
  where?: Maybe<Regions_Bool_Exp>;
};


export type Query_RootSalary_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Salary_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Canoncounty_Order_By>>;
  where?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSalary_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Canoncounty_Order_By>>;
  where?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSalary_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Salary_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Global_Order_By>>;
  where?: Maybe<Salary_By_Global_Bool_Exp>;
};


export type Query_RootSalary_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Global_Order_By>>;
  where?: Maybe<Salary_By_Global_Bool_Exp>;
};


export type Query_RootSalary_By_LadArgs = {
  distinct_on?: Maybe<Array<Salary_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Lad_Order_By>>;
  where?: Maybe<Salary_By_Lad_Bool_Exp>;
};


export type Query_RootSalary_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Lad_Order_By>>;
  where?: Maybe<Salary_By_Lad_Bool_Exp>;
};


export type Query_RootSalary_By_NationArgs = {
  distinct_on?: Maybe<Array<Salary_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Nation_Order_By>>;
  where?: Maybe<Salary_By_Nation_Bool_Exp>;
};


export type Query_RootSalary_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Nation_Order_By>>;
  where?: Maybe<Salary_By_Nation_Bool_Exp>;
};


export type Query_RootSalary_By_RegionArgs = {
  distinct_on?: Maybe<Array<Salary_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Region_Order_By>>;
  where?: Maybe<Salary_By_Region_Bool_Exp>;
};


export type Query_RootSalary_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Region_Order_By>>;
  where?: Maybe<Salary_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Counts_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootSkill_Proportions_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Query_RootTermsArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


export type Query_RootTerms_AggregateArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


export type Query_RootTerms_By_PkArgs = {
  term: Scalars['String'];
};


export type Query_RootUserArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Query_RootUsersAggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** columns and relationships of "regions" */
export type Regions = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "regions" */
export type Regions_Aggregate = {
  aggregate?: Maybe<Regions_Aggregate_Fields>;
  nodes: Array<Regions>;
};

/** aggregate fields of "regions" */
export type Regions_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Regions_Max_Fields>;
  min?: Maybe<Regions_Min_Fields>;
};


/** aggregate fields of "regions" */
export type Regions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Regions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "regions". All fields are combined with a logical 'AND'. */
export type Regions_Bool_Exp = {
  _and?: Maybe<Array<Regions_Bool_Exp>>;
  _not?: Maybe<Regions_Bool_Exp>;
  _or?: Maybe<Array<Regions_Bool_Exp>>;
  id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "regions" */
export type Regions_Insert_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Regions_Max_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Regions_Min_Fields = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "regions" */
export type Regions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Regions>;
};

/** Ordering options when selecting data from "regions". */
export type Regions_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** select columns of table "regions" */
export enum Regions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "regions" */
export type Regions_Set_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "regions" */
export type Regions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Regions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Regions_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Regions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Regions_Set_Input>;
  where: Regions_Bool_Exp;
};

/** columns and relationships of "salary_by_canoncounty" */
export type Salary_By_Canoncounty = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Salary_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Salary_By_Canoncounty>;
};

/** aggregate fields of "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Salary_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salary_By_Canoncounty_Max_Fields>;
  min?: Maybe<Salary_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Salary_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Salary_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salary_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Salary_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Salary_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Salary_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Salary_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salary_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salary_By_Canoncounty_Avg_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salary_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Salary_By_Canoncounty_Bool_Exp = {
  AvgAnnualSalary?: Maybe<Float8_Comparison_Exp>;
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Salary_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Salary_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Inc_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Insert_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salary_By_Canoncounty_Max_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salary_By_Canoncounty_Min_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_By_Canoncounty>;
};

/** Ordering options when selecting data from "salary_by_canoncounty". */
export type Salary_By_Canoncounty_Order_By = {
  AvgAnnualSalary?: Maybe<Order_By>;
  CanonCounty?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "salary_by_canoncounty" */
export enum Salary_By_Canoncounty_Select_Column {
  /** column name */
  AvgAnnualSalary = 'AvgAnnualSalary',
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Set_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salary_By_Canoncounty_Stddev_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salary_By_Canoncounty_Stddev_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salary_By_Canoncounty_Stddev_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salary_by_canoncounty" */
export type Salary_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_By_Canoncounty_Stream_Cursor_Value_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CanonCounty?: Maybe<Scalars['String']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salary_By_Canoncounty_Sum_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

export type Salary_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Salary_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Salary_By_Canoncounty_Set_Input>;
  where: Salary_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_By_Canoncounty_Var_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salary_By_Canoncounty_Var_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salary_By_Canoncounty_Variance_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "salary_by_global" */
export type Salary_By_Global = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salary_by_global" */
export type Salary_By_Global_Aggregate = {
  aggregate?: Maybe<Salary_By_Global_Aggregate_Fields>;
  nodes: Array<Salary_By_Global>;
};

/** aggregate fields of "salary_by_global" */
export type Salary_By_Global_Aggregate_Fields = {
  avg?: Maybe<Salary_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salary_By_Global_Max_Fields>;
  min?: Maybe<Salary_By_Global_Min_Fields>;
  stddev?: Maybe<Salary_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Salary_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salary_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Salary_By_Global_Sum_Fields>;
  var_pop?: Maybe<Salary_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Salary_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Salary_By_Global_Variance_Fields>;
};


/** aggregate fields of "salary_by_global" */
export type Salary_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salary_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salary_By_Global_Avg_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salary_by_global". All fields are combined with a logical 'AND'. */
export type Salary_By_Global_Bool_Exp = {
  AvgAnnualSalary?: Maybe<Float8_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Salary_By_Global_Bool_Exp>>;
  _not?: Maybe<Salary_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Salary_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "salary_by_global" */
export type Salary_By_Global_Inc_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "salary_by_global" */
export type Salary_By_Global_Insert_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salary_By_Global_Max_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salary_By_Global_Min_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salary_by_global" */
export type Salary_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_By_Global>;
};

/** Ordering options when selecting data from "salary_by_global". */
export type Salary_By_Global_Order_By = {
  AvgAnnualSalary?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "salary_by_global" */
export enum Salary_By_Global_Select_Column {
  /** column name */
  AvgAnnualSalary = 'AvgAnnualSalary',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "salary_by_global" */
export type Salary_By_Global_Set_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salary_By_Global_Stddev_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salary_By_Global_Stddev_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salary_By_Global_Stddev_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salary_by_global" */
export type Salary_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_By_Global_Stream_Cursor_Value_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salary_By_Global_Sum_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

export type Salary_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Salary_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Salary_By_Global_Set_Input>;
  where: Salary_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_By_Global_Var_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salary_By_Global_Var_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salary_By_Global_Variance_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "salary_by_lad" */
export type Salary_By_Lad = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salary_by_lad" */
export type Salary_By_Lad_Aggregate = {
  aggregate?: Maybe<Salary_By_Lad_Aggregate_Fields>;
  nodes: Array<Salary_By_Lad>;
};

/** aggregate fields of "salary_by_lad" */
export type Salary_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Salary_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salary_By_Lad_Max_Fields>;
  min?: Maybe<Salary_By_Lad_Min_Fields>;
  stddev?: Maybe<Salary_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Salary_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salary_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Salary_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Salary_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Salary_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Salary_By_Lad_Variance_Fields>;
};


/** aggregate fields of "salary_by_lad" */
export type Salary_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salary_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salary_By_Lad_Avg_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salary_by_lad". All fields are combined with a logical 'AND'. */
export type Salary_By_Lad_Bool_Exp = {
  AvgAnnualSalary?: Maybe<Float8_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Salary_By_Lad_Bool_Exp>>;
  _not?: Maybe<Salary_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Salary_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "salary_by_lad" */
export type Salary_By_Lad_Inc_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "salary_by_lad" */
export type Salary_By_Lad_Insert_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salary_By_Lad_Max_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salary_By_Lad_Min_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salary_by_lad" */
export type Salary_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_By_Lad>;
};

/** Ordering options when selecting data from "salary_by_lad". */
export type Salary_By_Lad_Order_By = {
  AvgAnnualSalary?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "salary_by_lad" */
export enum Salary_By_Lad_Select_Column {
  /** column name */
  AvgAnnualSalary = 'AvgAnnualSalary',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "salary_by_lad" */
export type Salary_By_Lad_Set_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salary_By_Lad_Stddev_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salary_By_Lad_Stddev_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salary_By_Lad_Stddev_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salary_by_lad" */
export type Salary_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_By_Lad_Stream_Cursor_Value_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salary_By_Lad_Sum_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

export type Salary_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Salary_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Salary_By_Lad_Set_Input>;
  where: Salary_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_By_Lad_Var_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salary_By_Lad_Var_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salary_By_Lad_Variance_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "salary_by_nation" */
export type Salary_By_Nation = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salary_by_nation" */
export type Salary_By_Nation_Aggregate = {
  aggregate?: Maybe<Salary_By_Nation_Aggregate_Fields>;
  nodes: Array<Salary_By_Nation>;
};

/** aggregate fields of "salary_by_nation" */
export type Salary_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Salary_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salary_By_Nation_Max_Fields>;
  min?: Maybe<Salary_By_Nation_Min_Fields>;
  stddev?: Maybe<Salary_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Salary_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salary_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Salary_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Salary_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Salary_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Salary_By_Nation_Variance_Fields>;
};


/** aggregate fields of "salary_by_nation" */
export type Salary_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salary_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salary_By_Nation_Avg_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salary_by_nation". All fields are combined with a logical 'AND'. */
export type Salary_By_Nation_Bool_Exp = {
  AvgAnnualSalary?: Maybe<Float8_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Salary_By_Nation_Bool_Exp>>;
  _not?: Maybe<Salary_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Salary_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "salary_by_nation" */
export type Salary_By_Nation_Inc_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "salary_by_nation" */
export type Salary_By_Nation_Insert_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salary_By_Nation_Max_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salary_By_Nation_Min_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salary_by_nation" */
export type Salary_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_By_Nation>;
};

/** Ordering options when selecting data from "salary_by_nation". */
export type Salary_By_Nation_Order_By = {
  AvgAnnualSalary?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "salary_by_nation" */
export enum Salary_By_Nation_Select_Column {
  /** column name */
  AvgAnnualSalary = 'AvgAnnualSalary',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "salary_by_nation" */
export type Salary_By_Nation_Set_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salary_By_Nation_Stddev_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salary_By_Nation_Stddev_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salary_By_Nation_Stddev_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salary_by_nation" */
export type Salary_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_By_Nation_Stream_Cursor_Value_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salary_By_Nation_Sum_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

export type Salary_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Salary_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Salary_By_Nation_Set_Input>;
  where: Salary_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_By_Nation_Var_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salary_By_Nation_Var_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salary_By_Nation_Variance_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "salary_by_region" */
export type Salary_By_Region = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salary_by_region" */
export type Salary_By_Region_Aggregate = {
  aggregate?: Maybe<Salary_By_Region_Aggregate_Fields>;
  nodes: Array<Salary_By_Region>;
};

/** aggregate fields of "salary_by_region" */
export type Salary_By_Region_Aggregate_Fields = {
  avg?: Maybe<Salary_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salary_By_Region_Max_Fields>;
  min?: Maybe<Salary_By_Region_Min_Fields>;
  stddev?: Maybe<Salary_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Salary_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salary_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Salary_By_Region_Sum_Fields>;
  var_pop?: Maybe<Salary_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Salary_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Salary_By_Region_Variance_Fields>;
};


/** aggregate fields of "salary_by_region" */
export type Salary_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salary_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salary_By_Region_Avg_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salary_by_region". All fields are combined with a logical 'AND'. */
export type Salary_By_Region_Bool_Exp = {
  AvgAnnualSalary?: Maybe<Float8_Comparison_Exp>;
  CleanJobTitle?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Salary_By_Region_Bool_Exp>>;
  _not?: Maybe<Salary_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Salary_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "salary_by_region" */
export type Salary_By_Region_Inc_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "salary_by_region" */
export type Salary_By_Region_Insert_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salary_By_Region_Max_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salary_By_Region_Min_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salary_by_region" */
export type Salary_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_By_Region>;
};

/** Ordering options when selecting data from "salary_by_region". */
export type Salary_By_Region_Order_By = {
  AvgAnnualSalary?: Maybe<Order_By>;
  CleanJobTitle?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "salary_by_region" */
export enum Salary_By_Region_Select_Column {
  /** column name */
  AvgAnnualSalary = 'AvgAnnualSalary',
  /** column name */
  CleanJobTitle = 'CleanJobTitle',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "salary_by_region" */
export type Salary_By_Region_Set_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salary_By_Region_Stddev_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salary_By_Region_Stddev_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salary_By_Region_Stddev_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salary_by_region" */
export type Salary_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_By_Region_Stream_Cursor_Value_Input = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
  CleanJobTitle?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salary_By_Region_Sum_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['float8']>;
};

export type Salary_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Salary_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Salary_By_Region_Set_Input>;
  where: Salary_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_By_Region_Var_Pop_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salary_By_Region_Var_Samp_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salary_By_Region_Variance_Fields = {
  AvgAnnualSalary?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Month_By_Canoncounty>;
};

/** aggregate fields of "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_month_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Month_By_Canoncounty>;
};

/** Ordering options when selecting data from "skill_counts_per_month_by_canoncounty". */
export type Skill_Counts_Per_Month_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_month_by_canoncounty" */
export enum Skill_Counts_Per_Month_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_month_by_canoncounty" */
export type Skill_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Month_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Set_Input>;
  where: Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Month_By_Canoncounty_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Month_By_Global_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Month_By_Global>;
};

/** aggregate fields of "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Month_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Month_By_Global_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Month_By_Global_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Month_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Month_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Month_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Month_By_Global_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Month_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Month_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Month_By_Global_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Month_By_Global_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_month_by_global". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Month_By_Global_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Month_By_Global_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Month_By_Global_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Month_By_Global>;
};

/** Ordering options when selecting data from "skill_counts_per_month_by_global". */
export type Skill_Counts_Per_Month_By_Global_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_month_by_global" */
export enum Skill_Counts_Per_Month_By_Global_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Month_By_Global_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Month_By_Global_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Month_By_Global_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_month_by_global" */
export type Skill_Counts_Per_Month_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Month_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Month_By_Global_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Month_By_Global_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Month_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Month_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Month_By_Global_Set_Input>;
  where: Skill_Counts_Per_Month_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Month_By_Global_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Month_By_Global_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Month_By_Global_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Month_By_Lad_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Month_By_Lad>;
};

/** aggregate fields of "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Month_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Month_By_Lad_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Month_By_Lad_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Month_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Month_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Month_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Month_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Month_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Month_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Month_By_Lad_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Month_By_Lad_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_month_by_lad". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Month_By_Lad_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Month_By_Lad_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Month_By_Lad_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Month_By_Lad>;
};

/** Ordering options when selecting data from "skill_counts_per_month_by_lad". */
export type Skill_Counts_Per_Month_By_Lad_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_month_by_lad" */
export enum Skill_Counts_Per_Month_By_Lad_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Month_By_Lad_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Month_By_Lad_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Month_By_Lad_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_month_by_lad" */
export type Skill_Counts_Per_Month_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Month_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Month_By_Lad_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Month_By_Lad_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Month_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Month_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Month_By_Lad_Set_Input>;
  where: Skill_Counts_Per_Month_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Month_By_Lad_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Month_By_Lad_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Month_By_Lad_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Month_By_Nation_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Month_By_Nation>;
};

/** aggregate fields of "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Month_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Month_By_Nation_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Month_By_Nation_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Month_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Month_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Month_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Month_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Month_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Month_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Month_By_Nation_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Month_By_Nation_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_month_by_nation". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Month_By_Nation_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Month_By_Nation_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Month_By_Nation_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Month_By_Nation>;
};

/** Ordering options when selecting data from "skill_counts_per_month_by_nation". */
export type Skill_Counts_Per_Month_By_Nation_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_month_by_nation" */
export enum Skill_Counts_Per_Month_By_Nation_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Month_By_Nation_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Month_By_Nation_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Month_By_Nation_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_month_by_nation" */
export type Skill_Counts_Per_Month_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Month_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Month_By_Nation_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Month_By_Nation_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Month_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Month_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Month_By_Nation_Set_Input>;
  where: Skill_Counts_Per_Month_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Month_By_Nation_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Month_By_Nation_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Month_By_Nation_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Month_By_Region_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Month_By_Region>;
};

/** aggregate fields of "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Month_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Month_By_Region_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Month_By_Region_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Month_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Month_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Month_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Month_By_Region_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Month_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Month_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Month_By_Region_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Month_By_Region_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_month_by_region". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Month_By_Region_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Month_By_Region_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Month_By_Region_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Month_By_Region>;
};

/** Ordering options when selecting data from "skill_counts_per_month_by_region". */
export type Skill_Counts_Per_Month_By_Region_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_month_by_region" */
export enum Skill_Counts_Per_Month_By_Region_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Month_By_Region_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Month_By_Region_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Month_By_Region_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_month_by_region" */
export type Skill_Counts_Per_Month_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Month_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Month_By_Region_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Month_By_Region_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Month_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Month_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Month_By_Region_Set_Input>;
  where: Skill_Counts_Per_Month_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Month_By_Region_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Month_By_Region_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Month_By_Region_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Year_By_Canoncounty>;
};

/** aggregate fields of "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_year_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Year_By_Canoncounty>;
};

/** Ordering options when selecting data from "skill_counts_per_year_by_canoncounty". */
export type Skill_Counts_Per_Year_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_year_by_canoncounty" */
export enum Skill_Counts_Per_Year_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_year_by_canoncounty" */
export type Skill_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Year_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Set_Input>;
  where: Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Year_By_Canoncounty_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Year_By_Global_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Year_By_Global>;
};

/** aggregate fields of "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Year_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Year_By_Global_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Year_By_Global_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Year_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Year_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Year_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Year_By_Global_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Year_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Year_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Year_By_Global_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Year_By_Global_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_year_by_global". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Year_By_Global_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Year_By_Global_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Year_By_Global_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Year_By_Global>;
};

/** Ordering options when selecting data from "skill_counts_per_year_by_global". */
export type Skill_Counts_Per_Year_By_Global_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_year_by_global" */
export enum Skill_Counts_Per_Year_By_Global_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Year_By_Global_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Year_By_Global_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Year_By_Global_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_year_by_global" */
export type Skill_Counts_Per_Year_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Year_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Year_By_Global_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Year_By_Global_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Year_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Year_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Year_By_Global_Set_Input>;
  where: Skill_Counts_Per_Year_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Year_By_Global_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Year_By_Global_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Year_By_Global_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Year_By_Lad_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Year_By_Lad>;
};

/** aggregate fields of "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Year_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Year_By_Lad_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Year_By_Lad_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Year_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Year_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Year_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Year_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Year_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Year_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Year_By_Lad_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Year_By_Lad_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_year_by_lad". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Year_By_Lad_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Year_By_Lad_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Year_By_Lad_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Year_By_Lad>;
};

/** Ordering options when selecting data from "skill_counts_per_year_by_lad". */
export type Skill_Counts_Per_Year_By_Lad_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_year_by_lad" */
export enum Skill_Counts_Per_Year_By_Lad_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Year_By_Lad_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Year_By_Lad_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Year_By_Lad_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_year_by_lad" */
export type Skill_Counts_Per_Year_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Year_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Year_By_Lad_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Year_By_Lad_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Year_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Year_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Year_By_Lad_Set_Input>;
  where: Skill_Counts_Per_Year_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Year_By_Lad_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Year_By_Lad_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Year_By_Lad_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Year_By_Nation_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Year_By_Nation>;
};

/** aggregate fields of "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Year_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Year_By_Nation_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Year_By_Nation_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Year_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Year_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Year_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Year_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Year_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Year_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Year_By_Nation_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Year_By_Nation_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_year_by_nation". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Year_By_Nation_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Year_By_Nation_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Year_By_Nation_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Year_By_Nation>;
};

/** Ordering options when selecting data from "skill_counts_per_year_by_nation". */
export type Skill_Counts_Per_Year_By_Nation_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_year_by_nation" */
export enum Skill_Counts_Per_Year_By_Nation_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Year_By_Nation_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Year_By_Nation_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Year_By_Nation_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_year_by_nation" */
export type Skill_Counts_Per_Year_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Year_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Year_By_Nation_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Year_By_Nation_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Year_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Year_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Year_By_Nation_Set_Input>;
  where: Skill_Counts_Per_Year_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Year_By_Nation_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Year_By_Nation_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Year_By_Nation_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Aggregate = {
  aggregate?: Maybe<Skill_Counts_Per_Year_By_Region_Aggregate_Fields>;
  nodes: Array<Skill_Counts_Per_Year_By_Region>;
};

/** aggregate fields of "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Aggregate_Fields = {
  avg?: Maybe<Skill_Counts_Per_Year_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Counts_Per_Year_By_Region_Max_Fields>;
  min?: Maybe<Skill_Counts_Per_Year_By_Region_Min_Fields>;
  stddev?: Maybe<Skill_Counts_Per_Year_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Counts_Per_Year_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Counts_Per_Year_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Counts_Per_Year_By_Region_Sum_Fields>;
  var_pop?: Maybe<Skill_Counts_Per_Year_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Counts_Per_Year_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Skill_Counts_Per_Year_By_Region_Variance_Fields>;
};


/** aggregate fields of "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Counts_Per_Year_By_Region_Avg_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_counts_per_year_by_region". All fields are combined with a logical 'AND'. */
export type Skill_Counts_Per_Year_By_Region_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  Count?: Maybe<Bigint_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Bool_Exp>>;
  _not?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Inc_Input = {
  Count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Counts_Per_Year_By_Region_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Counts_Per_Year_By_Region_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Counts_Per_Year_By_Region>;
};

/** Ordering options when selecting data from "skill_counts_per_year_by_region". */
export type Skill_Counts_Per_Year_By_Region_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  Count?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_counts_per_year_by_region" */
export enum Skill_Counts_Per_Year_By_Region_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  Count = 'Count',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Counts_Per_Year_By_Region_Stddev_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Counts_Per_Year_By_Region_Stddev_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Counts_Per_Year_By_Region_Stddev_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_counts_per_year_by_region" */
export type Skill_Counts_Per_Year_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Counts_Per_Year_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Counts_Per_Year_By_Region_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  Count?: Maybe<Scalars['bigint']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Counts_Per_Year_By_Region_Sum_Fields = {
  Count?: Maybe<Scalars['bigint']>;
};

export type Skill_Counts_Per_Year_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Counts_Per_Year_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Counts_Per_Year_By_Region_Set_Input>;
  where: Skill_Counts_Per_Year_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Counts_Per_Year_By_Region_Var_Pop_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Counts_Per_Year_By_Region_Var_Samp_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Counts_Per_Year_By_Region_Variance_Fields = {
  Count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Month_By_Canoncounty>;
};

/** aggregate fields of "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_month_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CanonSkills?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Month_By_Canoncounty>;
};

/** Ordering options when selecting data from "skill_proportions_per_month_by_canoncounty". */
export type Skill_Proportions_Per_Month_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CanonSkills?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_month_by_canoncounty" */
export enum Skill_Proportions_Per_Month_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_month_by_canoncounty" */
export type Skill_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Month_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Month_By_Canoncounty_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Month_By_Global_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Month_By_Global>;
};

/** aggregate fields of "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Month_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Month_By_Global_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Month_By_Global_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Month_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Month_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Month_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Month_By_Global_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Month_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Month_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Month_By_Global_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Month_By_Global_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_month_by_global". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Month_By_Global_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Month_By_Global_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Month_By_Global_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Month_By_Global>;
};

/** Ordering options when selecting data from "skill_proportions_per_month_by_global". */
export type Skill_Proportions_Per_Month_By_Global_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_month_by_global" */
export enum Skill_Proportions_Per_Month_By_Global_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Month_By_Global_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Month_By_Global_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Month_By_Global_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_month_by_global" */
export type Skill_Proportions_Per_Month_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Month_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Month_By_Global_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Month_By_Global_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Month_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Month_By_Global_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Month_By_Global_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Month_By_Global_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Month_By_Global_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Month_By_Lad_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Month_By_Lad>;
};

/** aggregate fields of "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Month_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Month_By_Lad_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Month_By_Lad_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Month_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Month_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Month_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Month_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Month_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Month_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Month_By_Lad_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Month_By_Lad_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_month_by_lad". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Month_By_Lad_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Month_By_Lad_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Month_By_Lad_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Month_By_Lad>;
};

/** Ordering options when selecting data from "skill_proportions_per_month_by_lad". */
export type Skill_Proportions_Per_Month_By_Lad_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_month_by_lad" */
export enum Skill_Proportions_Per_Month_By_Lad_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Month_By_Lad_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Month_By_Lad_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Month_By_Lad_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_month_by_lad" */
export type Skill_Proportions_Per_Month_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Month_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Month_By_Lad_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Month_By_Lad_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Month_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Month_By_Lad_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Month_By_Lad_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Month_By_Lad_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Month_By_Lad_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Month_By_Nation_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Month_By_Nation>;
};

/** aggregate fields of "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Month_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Month_By_Nation_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Month_By_Nation_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Month_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Month_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Month_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Month_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Month_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Month_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Month_By_Nation_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Month_By_Nation_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_month_by_nation". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Month_By_Nation_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Month_By_Nation_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Month_By_Nation_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Month_By_Nation>;
};

/** Ordering options when selecting data from "skill_proportions_per_month_by_nation". */
export type Skill_Proportions_Per_Month_By_Nation_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_month_by_nation" */
export enum Skill_Proportions_Per_Month_By_Nation_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Month_By_Nation_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Month_By_Nation_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Month_By_Nation_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_month_by_nation" */
export type Skill_Proportions_Per_Month_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Month_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Month_By_Nation_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Month_By_Nation_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Month_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Month_By_Nation_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Month_By_Nation_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Month_By_Nation_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Month_By_Nation_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Month_By_Region_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Month_By_Region>;
};

/** aggregate fields of "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Month_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Month_By_Region_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Month_By_Region_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Month_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Month_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Month_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Month_By_Region_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Month_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Month_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Month_By_Region_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Month_By_Region_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_month_by_region". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Month_By_Region_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Month_By_Region_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Month_By_Region_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Month_By_Region>;
};

/** Ordering options when selecting data from "skill_proportions_per_month_by_region". */
export type Skill_Proportions_Per_Month_By_Region_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_month_by_region" */
export enum Skill_Proportions_Per_Month_By_Region_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Month_By_Region_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Month_By_Region_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Month_By_Region_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_month_by_region" */
export type Skill_Proportions_Per_Month_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Month_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Month_By_Region_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Month_By_Region_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Month_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Month_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Month_By_Region_Set_Input>;
  where: Skill_Proportions_Per_Month_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Month_By_Region_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Month_By_Region_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Month_By_Region_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Year_By_Canoncounty>;
};

/** aggregate fields of "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_year_by_canoncounty". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp = {
  CanonCounty?: Maybe<String_Comparison_Exp>;
  CanonSkills?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Insert_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Max_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Min_Fields = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Year_By_Canoncounty>;
};

/** Ordering options when selecting data from "skill_proportions_per_year_by_canoncounty". */
export type Skill_Proportions_Per_Year_By_Canoncounty_Order_By = {
  CanonCounty?: Maybe<Order_By>;
  CanonSkills?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_year_by_canoncounty" */
export enum Skill_Proportions_Per_Year_By_Canoncounty_Select_Column {
  /** column name */
  CanonCounty = 'CanonCounty',
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Set_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_year_by_canoncounty" */
export type Skill_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Value_Input = {
  CanonCounty?: Maybe<Scalars['String']>;
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Year_By_Canoncounty_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Year_By_Canoncounty_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Year_By_Global_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Year_By_Global>;
};

/** aggregate fields of "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Year_By_Global_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Year_By_Global_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Year_By_Global_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Year_By_Global_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Year_By_Global_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Year_By_Global_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Year_By_Global_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Year_By_Global_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Year_By_Global_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Year_By_Global_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Year_By_Global_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_year_by_global". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Year_By_Global_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Year_By_Global_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Year_By_Global_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Year_By_Global>;
};

/** Ordering options when selecting data from "skill_proportions_per_year_by_global". */
export type Skill_Proportions_Per_Year_By_Global_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_year_by_global" */
export enum Skill_Proportions_Per_Year_By_Global_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Year_By_Global_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Year_By_Global_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Year_By_Global_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_year_by_global" */
export type Skill_Proportions_Per_Year_By_Global_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Year_By_Global_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Year_By_Global_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Year_By_Global_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Year_By_Global_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Global_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Year_By_Global_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Global_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Year_By_Global_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Year_By_Global_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Year_By_Global_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Year_By_Lad_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Year_By_Lad>;
};

/** aggregate fields of "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Year_By_Lad_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Year_By_Lad_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Year_By_Lad_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Year_By_Lad_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Year_By_Lad_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Year_By_Lad_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Year_By_Lad_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Year_By_Lad_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Year_By_Lad_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Year_By_Lad_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Year_By_Lad_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_year_by_lad". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Year_By_Lad_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  CountyAreaCode?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  LadAreaCode?: Maybe<String_Comparison_Exp>;
  LocalAuthorityDistrict?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Year_By_Lad_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Year_By_Lad_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Year_By_Lad>;
};

/** Ordering options when selecting data from "skill_proportions_per_year_by_lad". */
export type Skill_Proportions_Per_Year_By_Lad_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  CountyAreaCode?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  LadAreaCode?: Maybe<Order_By>;
  LocalAuthorityDistrict?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_year_by_lad" */
export enum Skill_Proportions_Per_Year_By_Lad_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  CountyAreaCode = 'CountyAreaCode',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  LadAreaCode = 'LadAreaCode',
  /** column name */
  LocalAuthorityDistrict = 'LocalAuthorityDistrict',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Year_By_Lad_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Year_By_Lad_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Year_By_Lad_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_year_by_lad" */
export type Skill_Proportions_Per_Year_By_Lad_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Year_By_Lad_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Year_By_Lad_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  CountyAreaCode?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  LadAreaCode?: Maybe<Scalars['String']>;
  LocalAuthorityDistrict?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Year_By_Lad_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Year_By_Lad_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Lad_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Year_By_Lad_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Lad_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Year_By_Lad_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Year_By_Lad_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Year_By_Lad_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Year_By_Nation_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Year_By_Nation>;
};

/** aggregate fields of "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Year_By_Nation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Year_By_Nation_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Year_By_Nation_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Year_By_Nation_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Year_By_Nation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Year_By_Nation_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Year_By_Nation_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Year_By_Nation_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Year_By_Nation_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Year_By_Nation_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Year_By_Nation_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_year_by_nation". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Year_By_Nation_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  Nation?: Maybe<String_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Year_By_Nation_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Year_By_Nation_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Year_By_Nation>;
};

/** Ordering options when selecting data from "skill_proportions_per_year_by_nation". */
export type Skill_Proportions_Per_Year_By_Nation_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  Nation?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_year_by_nation" */
export enum Skill_Proportions_Per_Year_By_Nation_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  Nation = 'Nation',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Year_By_Nation_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Year_By_Nation_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Year_By_Nation_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_year_by_nation" */
export type Skill_Proportions_Per_Year_By_Nation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Year_By_Nation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Year_By_Nation_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  Nation?: Maybe<Scalars['String']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Year_By_Nation_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Year_By_Nation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Nation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Year_By_Nation_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Nation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Year_By_Nation_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Year_By_Nation_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Year_By_Nation_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Aggregate = {
  aggregate?: Maybe<Skill_Proportions_Per_Year_By_Region_Aggregate_Fields>;
  nodes: Array<Skill_Proportions_Per_Year_By_Region>;
};

/** aggregate fields of "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Aggregate_Fields = {
  avg?: Maybe<Skill_Proportions_Per_Year_By_Region_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Proportions_Per_Year_By_Region_Max_Fields>;
  min?: Maybe<Skill_Proportions_Per_Year_By_Region_Min_Fields>;
  stddev?: Maybe<Skill_Proportions_Per_Year_By_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Proportions_Per_Year_By_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Proportions_Per_Year_By_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Proportions_Per_Year_By_Region_Sum_Fields>;
  var_pop?: Maybe<Skill_Proportions_Per_Year_By_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Proportions_Per_Year_By_Region_Var_Samp_Fields>;
  variance?: Maybe<Skill_Proportions_Per_Year_By_Region_Variance_Fields>;
};


/** aggregate fields of "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skill_Proportions_Per_Year_By_Region_Avg_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skill_proportions_per_year_by_region". All fields are combined with a logical 'AND'. */
export type Skill_Proportions_Per_Year_By_Region_Bool_Exp = {
  CanonSkills?: Maybe<String_Comparison_Exp>;
  JobDate?: Maybe<Timestamp_Comparison_Exp>;
  NationAreaCode?: Maybe<String_Comparison_Exp>;
  Proportion?: Maybe<Float8_Comparison_Exp>;
  Region?: Maybe<String_Comparison_Exp>;
  RegionAreaCode?: Maybe<String_Comparison_Exp>;
  Source?: Maybe<String_Comparison_Exp>;
  _and?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Bool_Exp>>;
  _not?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
  _or?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Bool_Exp>>;
};

/** input type for incrementing numeric columns in table "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Inc_Input = {
  Proportion?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Insert_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Skill_Proportions_Per_Year_By_Region_Max_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Skill_Proportions_Per_Year_By_Region_Min_Fields = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill_Proportions_Per_Year_By_Region>;
};

/** Ordering options when selecting data from "skill_proportions_per_year_by_region". */
export type Skill_Proportions_Per_Year_By_Region_Order_By = {
  CanonSkills?: Maybe<Order_By>;
  JobDate?: Maybe<Order_By>;
  NationAreaCode?: Maybe<Order_By>;
  Proportion?: Maybe<Order_By>;
  Region?: Maybe<Order_By>;
  RegionAreaCode?: Maybe<Order_By>;
  Source?: Maybe<Order_By>;
};

/** select columns of table "skill_proportions_per_year_by_region" */
export enum Skill_Proportions_Per_Year_By_Region_Select_Column {
  /** column name */
  CanonSkills = 'CanonSkills',
  /** column name */
  JobDate = 'JobDate',
  /** column name */
  NationAreaCode = 'NationAreaCode',
  /** column name */
  Proportion = 'Proportion',
  /** column name */
  Region = 'Region',
  /** column name */
  RegionAreaCode = 'RegionAreaCode',
  /** column name */
  Source = 'Source'
}

/** input type for updating data in table "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Set_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Skill_Proportions_Per_Year_By_Region_Stddev_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skill_Proportions_Per_Year_By_Region_Stddev_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skill_Proportions_Per_Year_By_Region_Stddev_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skill_proportions_per_year_by_region" */
export type Skill_Proportions_Per_Year_By_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Proportions_Per_Year_By_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Proportions_Per_Year_By_Region_Stream_Cursor_Value_Input = {
  CanonSkills?: Maybe<Scalars['String']>;
  JobDate?: Maybe<Scalars['timestamp']>;
  NationAreaCode?: Maybe<Scalars['String']>;
  Proportion?: Maybe<Scalars['float8']>;
  Region?: Maybe<Scalars['String']>;
  RegionAreaCode?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Skill_Proportions_Per_Year_By_Region_Sum_Fields = {
  Proportion?: Maybe<Scalars['float8']>;
};

export type Skill_Proportions_Per_Year_By_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Proportions_Per_Year_By_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Proportions_Per_Year_By_Region_Set_Input>;
  where: Skill_Proportions_Per_Year_By_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Proportions_Per_Year_By_Region_Var_Pop_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skill_Proportions_Per_Year_By_Region_Var_Samp_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skill_Proportions_Per_Year_By_Region_Variance_Fields = {
  Proportion?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  /** fetch data from the table: "areas" */
  areas: Array<Areas>;
  /** fetch aggregated fields from the table: "areas" */
  areas_aggregate: Areas_Aggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table in a streaming manner: "areas" */
  areas_stream: Array<Areas>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets>;
  /** fetch data from the table: "careers" */
  careers: Array<Careers>;
  /** fetch aggregated fields from the table: "careers" */
  careers_aggregate: Careers_Aggregate;
  /** fetch data from the table in a streaming manner: "careers" */
  careers_stream: Array<Careers>;
  /** fetch data from the table: "counties" */
  counties: Array<Counties>;
  /** fetch aggregated fields from the table: "counties" */
  counties_aggregate: Counties_Aggregate;
  /** fetch data from the table in a streaming manner: "counties" */
  counties_stream: Array<Counties>;
  /** fetch data from the table: "employer_stats" */
  employer_stats: Array<Employer_Stats>;
  /** fetch aggregated fields from the table: "employer_stats" */
  employer_stats_aggregate: Employer_Stats_Aggregate;
  /** fetch data from the table in a streaming manner: "employer_stats" */
  employer_stats_stream: Array<Employer_Stats>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files>;
  /** An array relationship */
  files: Array<Files>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "geotree" */
  geotree: Array<Geotree>;
  /** fetch aggregated fields from the table: "geotree" */
  geotree_aggregate: Geotree_Aggregate;
  /** fetch data from the table: "geotree" using primary key columns */
  geotree_by_pk?: Maybe<Geotree>;
  /** fetch data from the table in a streaming manner: "geotree" */
  geotree_stream: Array<Geotree>;
  /** fetch data from the table: "global_emerging_jobs" */
  global_emerging_jobs: Array<Global_Emerging_Jobs>;
  /** fetch aggregated fields from the table: "global_emerging_jobs" */
  global_emerging_jobs_aggregate: Global_Emerging_Jobs_Aggregate;
  /** fetch data from the table in a streaming manner: "global_emerging_jobs" */
  global_emerging_jobs_stream: Array<Global_Emerging_Jobs>;
  /** fetch data from the table: "global_emerging_skills" */
  global_emerging_skills: Array<Global_Emerging_Skills>;
  /** fetch aggregated fields from the table: "global_emerging_skills" */
  global_emerging_skills_aggregate: Global_Emerging_Skills_Aggregate;
  /** fetch data from the table in a streaming manner: "global_emerging_skills" */
  global_emerging_skills_stream: Array<Global_Emerging_Skills>;
  /** fetch data from the table: "global_top_10_skill_clusters" */
  global_top_10_skill_clusters: Array<Global_Top_10_Skill_Clusters>;
  /** fetch aggregated fields from the table: "global_top_10_skill_clusters" */
  global_top_10_skill_clusters_aggregate: Global_Top_10_Skill_Clusters_Aggregate;
  /** fetch data from the table: "global_top_10_skill_clusters" using primary key columns */
  global_top_10_skill_clusters_by_pk?: Maybe<Global_Top_10_Skill_Clusters>;
  /** fetch data from the table in a streaming manner: "global_top_10_skill_clusters" */
  global_top_10_skill_clusters_stream: Array<Global_Top_10_Skill_Clusters>;
  /** fetch data from the table: "global_top_10_skills" */
  global_top_10_skills: Array<Global_Top_10_Skills>;
  /** fetch aggregated fields from the table: "global_top_10_skills" */
  global_top_10_skills_aggregate: Global_Top_10_Skills_Aggregate;
  /** fetch data from the table: "global_top_10_skills" using primary key columns */
  global_top_10_skills_by_pk?: Maybe<Global_Top_10_Skills>;
  /** fetch data from the table in a streaming manner: "global_top_10_skills" */
  global_top_10_skills_stream: Array<Global_Top_10_Skills>;
  /** fetch data from the table: "job_counts_per_month_by_canoncounty" */
  job_counts_per_month_by_canoncounty: Array<Job_Counts_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_canoncounty" */
  job_counts_per_month_by_canoncounty_aggregate: Job_Counts_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_month_by_canoncounty" */
  job_counts_per_month_by_canoncounty_stream: Array<Job_Counts_Per_Month_By_Canoncounty>;
  /** fetch data from the table: "job_counts_per_month_by_global" */
  job_counts_per_month_by_global: Array<Job_Counts_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_global" */
  job_counts_per_month_by_global_aggregate: Job_Counts_Per_Month_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_month_by_global" */
  job_counts_per_month_by_global_stream: Array<Job_Counts_Per_Month_By_Global>;
  /** fetch data from the table: "job_counts_per_month_by_lad" */
  job_counts_per_month_by_lad: Array<Job_Counts_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_lad" */
  job_counts_per_month_by_lad_aggregate: Job_Counts_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_month_by_lad" */
  job_counts_per_month_by_lad_stream: Array<Job_Counts_Per_Month_By_Lad>;
  /** fetch data from the table: "job_counts_per_month_by_nation" */
  job_counts_per_month_by_nation: Array<Job_Counts_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_nation" */
  job_counts_per_month_by_nation_aggregate: Job_Counts_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_month_by_nation" */
  job_counts_per_month_by_nation_stream: Array<Job_Counts_Per_Month_By_Nation>;
  /** fetch data from the table: "job_counts_per_month_by_region" */
  job_counts_per_month_by_region: Array<Job_Counts_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "job_counts_per_month_by_region" */
  job_counts_per_month_by_region_aggregate: Job_Counts_Per_Month_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_month_by_region" */
  job_counts_per_month_by_region_stream: Array<Job_Counts_Per_Month_By_Region>;
  /** fetch data from the table: "job_counts_per_year_by_canoncounty" */
  job_counts_per_year_by_canoncounty: Array<Job_Counts_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_canoncounty" */
  job_counts_per_year_by_canoncounty_aggregate: Job_Counts_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_year_by_canoncounty" */
  job_counts_per_year_by_canoncounty_stream: Array<Job_Counts_Per_Year_By_Canoncounty>;
  /** fetch data from the table: "job_counts_per_year_by_global" */
  job_counts_per_year_by_global: Array<Job_Counts_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_global" */
  job_counts_per_year_by_global_aggregate: Job_Counts_Per_Year_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_year_by_global" */
  job_counts_per_year_by_global_stream: Array<Job_Counts_Per_Year_By_Global>;
  /** fetch data from the table: "job_counts_per_year_by_lad" */
  job_counts_per_year_by_lad: Array<Job_Counts_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_lad" */
  job_counts_per_year_by_lad_aggregate: Job_Counts_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_year_by_lad" */
  job_counts_per_year_by_lad_stream: Array<Job_Counts_Per_Year_By_Lad>;
  /** fetch data from the table: "job_counts_per_year_by_nation" */
  job_counts_per_year_by_nation: Array<Job_Counts_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_nation" */
  job_counts_per_year_by_nation_aggregate: Job_Counts_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_year_by_nation" */
  job_counts_per_year_by_nation_stream: Array<Job_Counts_Per_Year_By_Nation>;
  /** fetch data from the table: "job_counts_per_year_by_region" */
  job_counts_per_year_by_region: Array<Job_Counts_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "job_counts_per_year_by_region" */
  job_counts_per_year_by_region_aggregate: Job_Counts_Per_Year_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "job_counts_per_year_by_region" */
  job_counts_per_year_by_region_stream: Array<Job_Counts_Per_Year_By_Region>;
  /** fetch data from the table: "job_proportions_per_month_by_canoncounty" */
  job_proportions_per_month_by_canoncounty: Array<Job_Proportions_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_canoncounty" */
  job_proportions_per_month_by_canoncounty_aggregate: Job_Proportions_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_month_by_canoncounty" */
  job_proportions_per_month_by_canoncounty_stream: Array<Job_Proportions_Per_Month_By_Canoncounty>;
  /** fetch data from the table: "job_proportions_per_month_by_global" */
  job_proportions_per_month_by_global: Array<Job_Proportions_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_global" */
  job_proportions_per_month_by_global_aggregate: Job_Proportions_Per_Month_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_month_by_global" */
  job_proportions_per_month_by_global_stream: Array<Job_Proportions_Per_Month_By_Global>;
  /** fetch data from the table: "job_proportions_per_month_by_lad" */
  job_proportions_per_month_by_lad: Array<Job_Proportions_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_lad" */
  job_proportions_per_month_by_lad_aggregate: Job_Proportions_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_month_by_lad" */
  job_proportions_per_month_by_lad_stream: Array<Job_Proportions_Per_Month_By_Lad>;
  /** fetch data from the table: "job_proportions_per_month_by_nation" */
  job_proportions_per_month_by_nation: Array<Job_Proportions_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_nation" */
  job_proportions_per_month_by_nation_aggregate: Job_Proportions_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_month_by_nation" */
  job_proportions_per_month_by_nation_stream: Array<Job_Proportions_Per_Month_By_Nation>;
  /** fetch data from the table: "job_proportions_per_month_by_region" */
  job_proportions_per_month_by_region: Array<Job_Proportions_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "job_proportions_per_month_by_region" */
  job_proportions_per_month_by_region_aggregate: Job_Proportions_Per_Month_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_month_by_region" */
  job_proportions_per_month_by_region_stream: Array<Job_Proportions_Per_Month_By_Region>;
  /** fetch data from the table: "job_proportions_per_year_by_canoncounty" */
  job_proportions_per_year_by_canoncounty: Array<Job_Proportions_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_canoncounty" */
  job_proportions_per_year_by_canoncounty_aggregate: Job_Proportions_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_year_by_canoncounty" */
  job_proportions_per_year_by_canoncounty_stream: Array<Job_Proportions_Per_Year_By_Canoncounty>;
  /** fetch data from the table: "job_proportions_per_year_by_global" */
  job_proportions_per_year_by_global: Array<Job_Proportions_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_global" */
  job_proportions_per_year_by_global_aggregate: Job_Proportions_Per_Year_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_year_by_global" */
  job_proportions_per_year_by_global_stream: Array<Job_Proportions_Per_Year_By_Global>;
  /** fetch data from the table: "job_proportions_per_year_by_lad" */
  job_proportions_per_year_by_lad: Array<Job_Proportions_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_lad" */
  job_proportions_per_year_by_lad_aggregate: Job_Proportions_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_year_by_lad" */
  job_proportions_per_year_by_lad_stream: Array<Job_Proportions_Per_Year_By_Lad>;
  /** fetch data from the table: "job_proportions_per_year_by_nation" */
  job_proportions_per_year_by_nation: Array<Job_Proportions_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_nation" */
  job_proportions_per_year_by_nation_aggregate: Job_Proportions_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_year_by_nation" */
  job_proportions_per_year_by_nation_stream: Array<Job_Proportions_Per_Year_By_Nation>;
  /** fetch data from the table: "job_proportions_per_year_by_region" */
  job_proportions_per_year_by_region: Array<Job_Proportions_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "job_proportions_per_year_by_region" */
  job_proportions_per_year_by_region_aggregate: Job_Proportions_Per_Year_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "job_proportions_per_year_by_region" */
  job_proportions_per_year_by_region_stream: Array<Job_Proportions_Per_Year_By_Region>;
  /** fetch data from the table: "lads" */
  lads: Array<Lads>;
  /** fetch aggregated fields from the table: "lads" */
  lads_aggregate: Lads_Aggregate;
  /** fetch data from the table in a streaming manner: "lads" */
  lads_stream: Array<Lads>;
  /** fetch data from the table: "nations" */
  nations: Array<Nations>;
  /** fetch aggregated fields from the table: "nations" */
  nations_aggregate: Nations_Aggregate;
  /** fetch data from the table in a streaming manner: "nations" */
  nations_stream: Array<Nations>;
  /** fetch data from the table: "profile_by_jobs" */
  profile_by_jobs: Array<Profile_By_Jobs>;
  /** fetch aggregated fields from the table: "profile_by_jobs" */
  profile_by_jobs_aggregate: Profile_By_Jobs_Aggregate;
  /** fetch data from the table in a streaming manner: "profile_by_jobs" */
  profile_by_jobs_stream: Array<Profile_By_Jobs>;
  /** fetch data from the table: "profile_by_skills" */
  profile_by_skills: Array<Profile_By_Skills>;
  /** fetch aggregated fields from the table: "profile_by_skills" */
  profile_by_skills_aggregate: Profile_By_Skills_Aggregate;
  /** fetch data from the table in a streaming manner: "profile_by_skills" */
  profile_by_skills_stream: Array<Profile_By_Skills>;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table in a streaming manner: "regions" */
  regions_stream: Array<Regions>;
  /** fetch data from the table: "salary_by_canoncounty" */
  salary_by_canoncounty: Array<Salary_By_Canoncounty>;
  /** fetch aggregated fields from the table: "salary_by_canoncounty" */
  salary_by_canoncounty_aggregate: Salary_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_by_canoncounty" */
  salary_by_canoncounty_stream: Array<Salary_By_Canoncounty>;
  /** fetch data from the table: "salary_by_global" */
  salary_by_global: Array<Salary_By_Global>;
  /** fetch aggregated fields from the table: "salary_by_global" */
  salary_by_global_aggregate: Salary_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_by_global" */
  salary_by_global_stream: Array<Salary_By_Global>;
  /** fetch data from the table: "salary_by_lad" */
  salary_by_lad: Array<Salary_By_Lad>;
  /** fetch aggregated fields from the table: "salary_by_lad" */
  salary_by_lad_aggregate: Salary_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_by_lad" */
  salary_by_lad_stream: Array<Salary_By_Lad>;
  /** fetch data from the table: "salary_by_nation" */
  salary_by_nation: Array<Salary_By_Nation>;
  /** fetch aggregated fields from the table: "salary_by_nation" */
  salary_by_nation_aggregate: Salary_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_by_nation" */
  salary_by_nation_stream: Array<Salary_By_Nation>;
  /** fetch data from the table: "salary_by_region" */
  salary_by_region: Array<Salary_By_Region>;
  /** fetch aggregated fields from the table: "salary_by_region" */
  salary_by_region_aggregate: Salary_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_by_region" */
  salary_by_region_stream: Array<Salary_By_Region>;
  /** fetch data from the table: "skill_counts_per_month_by_canoncounty" */
  skill_counts_per_month_by_canoncounty: Array<Skill_Counts_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_canoncounty" */
  skill_counts_per_month_by_canoncounty_aggregate: Skill_Counts_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_month_by_canoncounty" */
  skill_counts_per_month_by_canoncounty_stream: Array<Skill_Counts_Per_Month_By_Canoncounty>;
  /** fetch data from the table: "skill_counts_per_month_by_global" */
  skill_counts_per_month_by_global: Array<Skill_Counts_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_global" */
  skill_counts_per_month_by_global_aggregate: Skill_Counts_Per_Month_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_month_by_global" */
  skill_counts_per_month_by_global_stream: Array<Skill_Counts_Per_Month_By_Global>;
  /** fetch data from the table: "skill_counts_per_month_by_lad" */
  skill_counts_per_month_by_lad: Array<Skill_Counts_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_lad" */
  skill_counts_per_month_by_lad_aggregate: Skill_Counts_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_month_by_lad" */
  skill_counts_per_month_by_lad_stream: Array<Skill_Counts_Per_Month_By_Lad>;
  /** fetch data from the table: "skill_counts_per_month_by_nation" */
  skill_counts_per_month_by_nation: Array<Skill_Counts_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_nation" */
  skill_counts_per_month_by_nation_aggregate: Skill_Counts_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_month_by_nation" */
  skill_counts_per_month_by_nation_stream: Array<Skill_Counts_Per_Month_By_Nation>;
  /** fetch data from the table: "skill_counts_per_month_by_region" */
  skill_counts_per_month_by_region: Array<Skill_Counts_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "skill_counts_per_month_by_region" */
  skill_counts_per_month_by_region_aggregate: Skill_Counts_Per_Month_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_month_by_region" */
  skill_counts_per_month_by_region_stream: Array<Skill_Counts_Per_Month_By_Region>;
  /** fetch data from the table: "skill_counts_per_year_by_canoncounty" */
  skill_counts_per_year_by_canoncounty: Array<Skill_Counts_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_canoncounty" */
  skill_counts_per_year_by_canoncounty_aggregate: Skill_Counts_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_year_by_canoncounty" */
  skill_counts_per_year_by_canoncounty_stream: Array<Skill_Counts_Per_Year_By_Canoncounty>;
  /** fetch data from the table: "skill_counts_per_year_by_global" */
  skill_counts_per_year_by_global: Array<Skill_Counts_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_global" */
  skill_counts_per_year_by_global_aggregate: Skill_Counts_Per_Year_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_year_by_global" */
  skill_counts_per_year_by_global_stream: Array<Skill_Counts_Per_Year_By_Global>;
  /** fetch data from the table: "skill_counts_per_year_by_lad" */
  skill_counts_per_year_by_lad: Array<Skill_Counts_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_lad" */
  skill_counts_per_year_by_lad_aggregate: Skill_Counts_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_year_by_lad" */
  skill_counts_per_year_by_lad_stream: Array<Skill_Counts_Per_Year_By_Lad>;
  /** fetch data from the table: "skill_counts_per_year_by_nation" */
  skill_counts_per_year_by_nation: Array<Skill_Counts_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_nation" */
  skill_counts_per_year_by_nation_aggregate: Skill_Counts_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_year_by_nation" */
  skill_counts_per_year_by_nation_stream: Array<Skill_Counts_Per_Year_By_Nation>;
  /** fetch data from the table: "skill_counts_per_year_by_region" */
  skill_counts_per_year_by_region: Array<Skill_Counts_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "skill_counts_per_year_by_region" */
  skill_counts_per_year_by_region_aggregate: Skill_Counts_Per_Year_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_counts_per_year_by_region" */
  skill_counts_per_year_by_region_stream: Array<Skill_Counts_Per_Year_By_Region>;
  /** fetch data from the table: "skill_proportions_per_month_by_canoncounty" */
  skill_proportions_per_month_by_canoncounty: Array<Skill_Proportions_Per_Month_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_canoncounty" */
  skill_proportions_per_month_by_canoncounty_aggregate: Skill_Proportions_Per_Month_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_month_by_canoncounty" */
  skill_proportions_per_month_by_canoncounty_stream: Array<Skill_Proportions_Per_Month_By_Canoncounty>;
  /** fetch data from the table: "skill_proportions_per_month_by_global" */
  skill_proportions_per_month_by_global: Array<Skill_Proportions_Per_Month_By_Global>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_global" */
  skill_proportions_per_month_by_global_aggregate: Skill_Proportions_Per_Month_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_month_by_global" */
  skill_proportions_per_month_by_global_stream: Array<Skill_Proportions_Per_Month_By_Global>;
  /** fetch data from the table: "skill_proportions_per_month_by_lad" */
  skill_proportions_per_month_by_lad: Array<Skill_Proportions_Per_Month_By_Lad>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_lad" */
  skill_proportions_per_month_by_lad_aggregate: Skill_Proportions_Per_Month_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_month_by_lad" */
  skill_proportions_per_month_by_lad_stream: Array<Skill_Proportions_Per_Month_By_Lad>;
  /** fetch data from the table: "skill_proportions_per_month_by_nation" */
  skill_proportions_per_month_by_nation: Array<Skill_Proportions_Per_Month_By_Nation>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_nation" */
  skill_proportions_per_month_by_nation_aggregate: Skill_Proportions_Per_Month_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_month_by_nation" */
  skill_proportions_per_month_by_nation_stream: Array<Skill_Proportions_Per_Month_By_Nation>;
  /** fetch data from the table: "skill_proportions_per_month_by_region" */
  skill_proportions_per_month_by_region: Array<Skill_Proportions_Per_Month_By_Region>;
  /** fetch aggregated fields from the table: "skill_proportions_per_month_by_region" */
  skill_proportions_per_month_by_region_aggregate: Skill_Proportions_Per_Month_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_month_by_region" */
  skill_proportions_per_month_by_region_stream: Array<Skill_Proportions_Per_Month_By_Region>;
  /** fetch data from the table: "skill_proportions_per_year_by_canoncounty" */
  skill_proportions_per_year_by_canoncounty: Array<Skill_Proportions_Per_Year_By_Canoncounty>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_canoncounty" */
  skill_proportions_per_year_by_canoncounty_aggregate: Skill_Proportions_Per_Year_By_Canoncounty_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_year_by_canoncounty" */
  skill_proportions_per_year_by_canoncounty_stream: Array<Skill_Proportions_Per_Year_By_Canoncounty>;
  /** fetch data from the table: "skill_proportions_per_year_by_global" */
  skill_proportions_per_year_by_global: Array<Skill_Proportions_Per_Year_By_Global>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_global" */
  skill_proportions_per_year_by_global_aggregate: Skill_Proportions_Per_Year_By_Global_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_year_by_global" */
  skill_proportions_per_year_by_global_stream: Array<Skill_Proportions_Per_Year_By_Global>;
  /** fetch data from the table: "skill_proportions_per_year_by_lad" */
  skill_proportions_per_year_by_lad: Array<Skill_Proportions_Per_Year_By_Lad>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_lad" */
  skill_proportions_per_year_by_lad_aggregate: Skill_Proportions_Per_Year_By_Lad_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_year_by_lad" */
  skill_proportions_per_year_by_lad_stream: Array<Skill_Proportions_Per_Year_By_Lad>;
  /** fetch data from the table: "skill_proportions_per_year_by_nation" */
  skill_proportions_per_year_by_nation: Array<Skill_Proportions_Per_Year_By_Nation>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_nation" */
  skill_proportions_per_year_by_nation_aggregate: Skill_Proportions_Per_Year_By_Nation_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_year_by_nation" */
  skill_proportions_per_year_by_nation_stream: Array<Skill_Proportions_Per_Year_By_Nation>;
  /** fetch data from the table: "skill_proportions_per_year_by_region" */
  skill_proportions_per_year_by_region: Array<Skill_Proportions_Per_Year_By_Region>;
  /** fetch aggregated fields from the table: "skill_proportions_per_year_by_region" */
  skill_proportions_per_year_by_region_aggregate: Skill_Proportions_Per_Year_By_Region_Aggregate;
  /** fetch data from the table in a streaming manner: "skill_proportions_per_year_by_region" */
  skill_proportions_per_year_by_region_stream: Array<Skill_Proportions_Per_Year_By_Region>;
  /** fetch data from the table: "terms" */
  terms: Array<Terms>;
  /** fetch aggregated fields from the table: "terms" */
  terms_aggregate: Terms_Aggregate;
  /** fetch data from the table: "terms" using primary key columns */
  terms_by_pk?: Maybe<Terms>;
  /** fetch data from the table in a streaming manner: "terms" */
  terms_stream: Array<Terms>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAreasArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_AggregateArgs = {
  distinct_on?: Maybe<Array<Areas_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Areas_Order_By>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootAreas_By_PkArgs = {
  area_type: Scalars['String'];
  id: Scalars['String'];
};


export type Subscription_RootAreas_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Areas_Stream_Cursor_Input>>;
  where?: Maybe<Areas_Bool_Exp>;
};


export type Subscription_RootAuthProviderArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAuthProviderRequestArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthProviderRequestsArgs = {
  distinct_on?: Maybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviderRequests_Order_By>>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs = {
  distinct_on?: Maybe<Array<AuthProviderRequests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviderRequests_Order_By>>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthProviderRequests_Stream_Cursor_Input>>;
  where?: Maybe<AuthProviderRequests_Bool_Exp>;
};


export type Subscription_RootAuthProvidersArgs = {
  distinct_on?: Maybe<Array<AuthProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviders_Order_By>>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProvidersAggregateArgs = {
  distinct_on?: Maybe<Array<AuthProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProviders_Order_By>>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthProviders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthProviders_Stream_Cursor_Input>>;
  where?: Maybe<AuthProviders_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokenArgs = {
  refreshToken: Scalars['uuid'];
};


export type Subscription_RootAuthRefreshTokensArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthRefreshTokens_Stream_Cursor_Input>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


export type Subscription_RootAuthRoleArgs = {
  role: Scalars['String'];
};


export type Subscription_RootAuthRolesArgs = {
  distinct_on?: Maybe<Array<AuthRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRoles_Order_By>>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRolesAggregateArgs = {
  distinct_on?: Maybe<Array<AuthRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRoles_Order_By>>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthRoles_Stream_Cursor_Input>>;
  where?: Maybe<AuthRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserProviderArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserProvidersArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserProviders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthUserProviders_Stream_Cursor_Input>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


export type Subscription_RootAuthUserRoleArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserRolesArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRolesAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthUserRoles_Stream_Cursor_Input>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeyArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAuthUserSecurityKeysArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<AuthUserSecurityKeys_Stream_Cursor_Input>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


export type Subscription_RootBucketArgs = {
  id: Scalars['String'];
};


export type Subscription_RootBucketsArgs = {
  distinct_on?: Maybe<Array<Buckets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Buckets_Order_By>>;
  where?: Maybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBucketsAggregateArgs = {
  distinct_on?: Maybe<Array<Buckets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Buckets_Order_By>>;
  where?: Maybe<Buckets_Bool_Exp>;
};


export type Subscription_RootBuckets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Buckets_Stream_Cursor_Input>>;
  where?: Maybe<Buckets_Bool_Exp>;
};


export type Subscription_RootCareersArgs = {
  distinct_on?: Maybe<Array<Careers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Careers_Order_By>>;
  where?: Maybe<Careers_Bool_Exp>;
};


export type Subscription_RootCareers_AggregateArgs = {
  distinct_on?: Maybe<Array<Careers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Careers_Order_By>>;
  where?: Maybe<Careers_Bool_Exp>;
};


export type Subscription_RootCareers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Careers_Stream_Cursor_Input>>;
  where?: Maybe<Careers_Bool_Exp>;
};


export type Subscription_RootCountiesArgs = {
  distinct_on?: Maybe<Array<Counties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Counties_Order_By>>;
  where?: Maybe<Counties_Bool_Exp>;
};


export type Subscription_RootCounties_AggregateArgs = {
  distinct_on?: Maybe<Array<Counties_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Counties_Order_By>>;
  where?: Maybe<Counties_Bool_Exp>;
};


export type Subscription_RootCounties_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Counties_Stream_Cursor_Input>>;
  where?: Maybe<Counties_Bool_Exp>;
};


export type Subscription_RootEmployer_StatsArgs = {
  distinct_on?: Maybe<Array<Employer_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employer_Stats_Order_By>>;
  where?: Maybe<Employer_Stats_Bool_Exp>;
};


export type Subscription_RootEmployer_Stats_AggregateArgs = {
  distinct_on?: Maybe<Array<Employer_Stats_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Employer_Stats_Order_By>>;
  where?: Maybe<Employer_Stats_Bool_Exp>;
};


export type Subscription_RootEmployer_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Employer_Stats_Stream_Cursor_Input>>;
  where?: Maybe<Employer_Stats_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFilesArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};


export type Subscription_RootFilesAggregateArgs = {
  distinct_on?: Maybe<Array<Files_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Files_Order_By>>;
  where?: Maybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Files_Stream_Cursor_Input>>;
  where?: Maybe<Files_Bool_Exp>;
};


export type Subscription_RootGeotreeArgs = {
  distinct_on?: Maybe<Array<Geotree_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geotree_Order_By>>;
  where?: Maybe<Geotree_Bool_Exp>;
};


export type Subscription_RootGeotree_AggregateArgs = {
  distinct_on?: Maybe<Array<Geotree_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Geotree_Order_By>>;
  where?: Maybe<Geotree_Bool_Exp>;
};


export type Subscription_RootGeotree_By_PkArgs = {
  LadAreaCode: Scalars['bpchar'];
};


export type Subscription_RootGeotree_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Geotree_Stream_Cursor_Input>>;
  where?: Maybe<Geotree_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_JobsArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Jobs_Order_By>>;
  where?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_Jobs_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Jobs_Order_By>>;
  where?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Global_Emerging_Jobs_Stream_Cursor_Input>>;
  where?: Maybe<Global_Emerging_Jobs_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_SkillsArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Skills_Order_By>>;
  where?: Maybe<Global_Emerging_Skills_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Emerging_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Emerging_Skills_Order_By>>;
  where?: Maybe<Global_Emerging_Skills_Bool_Exp>;
};


export type Subscription_RootGlobal_Emerging_Skills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Global_Emerging_Skills_Stream_Cursor_Input>>;
  where?: Maybe<Global_Emerging_Skills_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_Skill_ClustersArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skill_Clusters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skill_Clusters_Order_By>>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_Skill_Clusters_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skill_Clusters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skill_Clusters_Order_By>>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_Skill_Clusters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGlobal_Top_10_Skill_Clusters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Global_Top_10_Skill_Clusters_Stream_Cursor_Input>>;
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_SkillsArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skills_Order_By>>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Global_Top_10_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Global_Top_10_Skills_Order_By>>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};


export type Subscription_RootGlobal_Top_10_Skills_By_PkArgs = {
  ParentSkill: Scalars['bpchar'];
};


export type Subscription_RootGlobal_Top_10_Skills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Global_Top_10_Skills_Stream_Cursor_Input>>;
  where?: Maybe<Global_Top_10_Skills_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Month_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Month_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Month_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Month_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Month_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Year_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Year_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Year_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Counts_Per_Year_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Counts_Per_Year_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Job_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Month_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Month_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Month_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Month_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Month_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Year_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Year_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Year_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Job_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootJob_Proportions_Per_Year_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Job_Proportions_Per_Year_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Job_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootLadsArgs = {
  distinct_on?: Maybe<Array<Lads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lads_Order_By>>;
  where?: Maybe<Lads_Bool_Exp>;
};


export type Subscription_RootLads_AggregateArgs = {
  distinct_on?: Maybe<Array<Lads_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Lads_Order_By>>;
  where?: Maybe<Lads_Bool_Exp>;
};


export type Subscription_RootLads_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Lads_Stream_Cursor_Input>>;
  where?: Maybe<Lads_Bool_Exp>;
};


export type Subscription_RootNationsArgs = {
  distinct_on?: Maybe<Array<Nations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nations_Order_By>>;
  where?: Maybe<Nations_Bool_Exp>;
};


export type Subscription_RootNations_AggregateArgs = {
  distinct_on?: Maybe<Array<Nations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Nations_Order_By>>;
  where?: Maybe<Nations_Bool_Exp>;
};


export type Subscription_RootNations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Nations_Stream_Cursor_Input>>;
  where?: Maybe<Nations_Bool_Exp>;
};


export type Subscription_RootProfile_By_JobsArgs = {
  distinct_on?: Maybe<Array<Profile_By_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Jobs_Order_By>>;
  where?: Maybe<Profile_By_Jobs_Bool_Exp>;
};


export type Subscription_RootProfile_By_Jobs_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_By_Jobs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Jobs_Order_By>>;
  where?: Maybe<Profile_By_Jobs_Bool_Exp>;
};


export type Subscription_RootProfile_By_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Profile_By_Jobs_Stream_Cursor_Input>>;
  where?: Maybe<Profile_By_Jobs_Bool_Exp>;
};


export type Subscription_RootProfile_By_SkillsArgs = {
  distinct_on?: Maybe<Array<Profile_By_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Skills_Order_By>>;
  where?: Maybe<Profile_By_Skills_Bool_Exp>;
};


export type Subscription_RootProfile_By_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Profile_By_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Profile_By_Skills_Order_By>>;
  where?: Maybe<Profile_By_Skills_Bool_Exp>;
};


export type Subscription_RootProfile_By_Skills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Profile_By_Skills_Stream_Cursor_Input>>;
  where?: Maybe<Profile_By_Skills_Bool_Exp>;
};


export type Subscription_RootRegionsArgs = {
  distinct_on?: Maybe<Array<Regions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regions_Order_By>>;
  where?: Maybe<Regions_Bool_Exp>;
};


export type Subscription_RootRegions_AggregateArgs = {
  distinct_on?: Maybe<Array<Regions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Regions_Order_By>>;
  where?: Maybe<Regions_Bool_Exp>;
};


export type Subscription_RootRegions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Regions_Stream_Cursor_Input>>;
  where?: Maybe<Regions_Bool_Exp>;
};


export type Subscription_RootSalary_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Salary_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Canoncounty_Order_By>>;
  where?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSalary_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Canoncounty_Order_By>>;
  where?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSalary_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Salary_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Salary_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSalary_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Salary_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Global_Order_By>>;
  where?: Maybe<Salary_By_Global_Bool_Exp>;
};


export type Subscription_RootSalary_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Global_Order_By>>;
  where?: Maybe<Salary_By_Global_Bool_Exp>;
};


export type Subscription_RootSalary_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Salary_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Salary_By_Global_Bool_Exp>;
};


export type Subscription_RootSalary_By_LadArgs = {
  distinct_on?: Maybe<Array<Salary_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Lad_Order_By>>;
  where?: Maybe<Salary_By_Lad_Bool_Exp>;
};


export type Subscription_RootSalary_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Lad_Order_By>>;
  where?: Maybe<Salary_By_Lad_Bool_Exp>;
};


export type Subscription_RootSalary_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Salary_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Salary_By_Lad_Bool_Exp>;
};


export type Subscription_RootSalary_By_NationArgs = {
  distinct_on?: Maybe<Array<Salary_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Nation_Order_By>>;
  where?: Maybe<Salary_By_Nation_Bool_Exp>;
};


export type Subscription_RootSalary_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Nation_Order_By>>;
  where?: Maybe<Salary_By_Nation_Bool_Exp>;
};


export type Subscription_RootSalary_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Salary_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Salary_By_Nation_Bool_Exp>;
};


export type Subscription_RootSalary_By_RegionArgs = {
  distinct_on?: Maybe<Array<Salary_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Region_Order_By>>;
  where?: Maybe<Salary_By_Region_Bool_Exp>;
};


export type Subscription_RootSalary_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Salary_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Salary_By_Region_Order_By>>;
  where?: Maybe<Salary_By_Region_Bool_Exp>;
};


export type Subscription_RootSalary_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Salary_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Salary_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Month_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Month_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Month_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Month_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Month_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Month_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Year_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Year_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Year_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Year_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Counts_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Counts_Per_Year_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Counts_Per_Year_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Counts_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Month_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Month_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Month_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Month_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Month_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Month_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Month_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_CanoncountyArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Canoncounty_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Canoncounty_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Canoncounty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Canoncounty_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_GlobalArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Global_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Global_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Global_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Year_By_Global_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Global_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_LadArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Lad_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Lad_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Lad_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Year_By_Lad_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Lad_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_NationArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Nation_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Nation_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Nation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Year_By_Nation_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Nation_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_RegionArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Region_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Proportions_Per_Year_By_Region_Order_By>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootSkill_Proportions_Per_Year_By_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Proportions_Per_Year_By_Region_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Proportions_Per_Year_By_Region_Bool_Exp>;
};


export type Subscription_RootTermsArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


export type Subscription_RootTerms_AggregateArgs = {
  distinct_on?: Maybe<Array<Terms_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Terms_Order_By>>;
  where?: Maybe<Terms_Bool_Exp>;
};


export type Subscription_RootTerms_By_PkArgs = {
  term: Scalars['String'];
};


export type Subscription_RootTerms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Terms_Stream_Cursor_Input>>;
  where?: Maybe<Terms_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Users_Stream_Cursor_Input>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** columns and relationships of "terms" */
export type Terms = {
  clusters?: Maybe<Scalars['Boolean']>;
  emergentjob?: Maybe<Scalars['Boolean']>;
  emergentskill?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['Boolean']>;
  skill?: Maybe<Scalars['Boolean']>;
  tech?: Maybe<Scalars['Boolean']>;
  term: Scalars['String'];
};

/** aggregated selection of "terms" */
export type Terms_Aggregate = {
  aggregate?: Maybe<Terms_Aggregate_Fields>;
  nodes: Array<Terms>;
};

/** aggregate fields of "terms" */
export type Terms_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Terms_Max_Fields>;
  min?: Maybe<Terms_Min_Fields>;
};


/** aggregate fields of "terms" */
export type Terms_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Terms_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "terms". All fields are combined with a logical 'AND'. */
export type Terms_Bool_Exp = {
  _and?: Maybe<Array<Terms_Bool_Exp>>;
  _not?: Maybe<Terms_Bool_Exp>;
  _or?: Maybe<Array<Terms_Bool_Exp>>;
  clusters?: Maybe<Boolean_Comparison_Exp>;
  emergentjob?: Maybe<Boolean_Comparison_Exp>;
  emergentskill?: Maybe<Boolean_Comparison_Exp>;
  job?: Maybe<Boolean_Comparison_Exp>;
  skill?: Maybe<Boolean_Comparison_Exp>;
  tech?: Maybe<Boolean_Comparison_Exp>;
  term?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "terms" */
export enum Terms_Constraint {
  /** unique or primary key constraint on columns "term" */
  TermsPkey = 'terms_pkey'
}

/** input type for inserting data into table "terms" */
export type Terms_Insert_Input = {
  clusters?: Maybe<Scalars['Boolean']>;
  emergentjob?: Maybe<Scalars['Boolean']>;
  emergentskill?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['Boolean']>;
  skill?: Maybe<Scalars['Boolean']>;
  tech?: Maybe<Scalars['Boolean']>;
  term?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Terms_Max_Fields = {
  term?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Terms_Min_Fields = {
  term?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "terms" */
export type Terms_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Terms>;
};

/** on_conflict condition type for table "terms" */
export type Terms_On_Conflict = {
  constraint: Terms_Constraint;
  update_columns?: Array<Terms_Update_Column>;
  where?: Maybe<Terms_Bool_Exp>;
};

/** Ordering options when selecting data from "terms". */
export type Terms_Order_By = {
  clusters?: Maybe<Order_By>;
  emergentjob?: Maybe<Order_By>;
  emergentskill?: Maybe<Order_By>;
  job?: Maybe<Order_By>;
  skill?: Maybe<Order_By>;
  tech?: Maybe<Order_By>;
  term?: Maybe<Order_By>;
};

/** primary key columns input for table: terms */
export type Terms_Pk_Columns_Input = {
  term: Scalars['String'];
};

/** select columns of table "terms" */
export enum Terms_Select_Column {
  /** column name */
  Clusters = 'clusters',
  /** column name */
  Emergentjob = 'emergentjob',
  /** column name */
  Emergentskill = 'emergentskill',
  /** column name */
  Job = 'job',
  /** column name */
  Skill = 'skill',
  /** column name */
  Tech = 'tech',
  /** column name */
  Term = 'term'
}

/** input type for updating data in table "terms" */
export type Terms_Set_Input = {
  clusters?: Maybe<Scalars['Boolean']>;
  emergentjob?: Maybe<Scalars['Boolean']>;
  emergentskill?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['Boolean']>;
  skill?: Maybe<Scalars['Boolean']>;
  tech?: Maybe<Scalars['Boolean']>;
  term?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "terms" */
export type Terms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Terms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Terms_Stream_Cursor_Value_Input = {
  clusters?: Maybe<Scalars['Boolean']>;
  emergentjob?: Maybe<Scalars['Boolean']>;
  emergentskill?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Scalars['Boolean']>;
  skill?: Maybe<Scalars['Boolean']>;
  tech?: Maybe<Scalars['Boolean']>;
  term?: Maybe<Scalars['String']>;
};

/** update columns of table "terms" */
export enum Terms_Update_Column {
  /** column name */
  Clusters = 'clusters',
  /** column name */
  Emergentjob = 'emergentjob',
  /** column name */
  Emergentskill = 'emergentskill',
  /** column name */
  Job = 'job',
  /** column name */
  Skill = 'skill',
  /** column name */
  Tech = 'tech',
  /** column name */
  Term = 'term'
}

export type Terms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Terms_Set_Input>;
  where: Terms_Bool_Exp;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users = {
  activated: Scalars['Boolean'];
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole: Scalars['String'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles;
  disabled: Scalars['Boolean'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['citext']>;
  emailVerified: Scalars['Boolean'];
  id: Scalars['uuid'];
  isAnonymous: Scalars['Boolean'];
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt: Scalars['timestamptz'];
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified: Scalars['Boolean'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate;
  /** An array relationship */
  roles: Array<AuthUserRoles>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt: Scalars['timestamptz'];
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs = {
  path?: Maybe<Scalars['String']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthRefreshTokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokens_Order_By>>;
  where?: Maybe<AuthRefreshTokens_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserRoles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserRoles_Order_By>>;
  where?: Maybe<AuthUserRoles_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserSecurityKeys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserSecurityKeys_Order_By>>;
  where?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs = {
  distinct_on?: Maybe<Array<AuthUserProviders_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthUserProviders_Order_By>>;
  where?: Maybe<AuthUserProviders_Bool_Exp>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate = {
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields = {
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Users_Bool_Exp>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Users_Bool_Exp>>;
  activated?: Maybe<Boolean_Comparison_Exp>;
  activeMfaType?: Maybe<String_Comparison_Exp>;
  avatarUrl?: Maybe<String_Comparison_Exp>;
  createdAt?: Maybe<Timestamptz_Comparison_Exp>;
  currentChallenge?: Maybe<String_Comparison_Exp>;
  defaultRole?: Maybe<String_Comparison_Exp>;
  defaultRoleByRole?: Maybe<AuthRoles_Bool_Exp>;
  disabled?: Maybe<Boolean_Comparison_Exp>;
  displayName?: Maybe<String_Comparison_Exp>;
  email?: Maybe<Citext_Comparison_Exp>;
  emailVerified?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  isAnonymous?: Maybe<Boolean_Comparison_Exp>;
  lastSeen?: Maybe<Timestamptz_Comparison_Exp>;
  locale?: Maybe<String_Comparison_Exp>;
  metadata?: Maybe<Jsonb_Comparison_Exp>;
  newEmail?: Maybe<Citext_Comparison_Exp>;
  otpHash?: Maybe<String_Comparison_Exp>;
  otpHashExpiresAt?: Maybe<Timestamptz_Comparison_Exp>;
  otpMethodLastUsed?: Maybe<String_Comparison_Exp>;
  passwordHash?: Maybe<String_Comparison_Exp>;
  phoneNumber?: Maybe<String_Comparison_Exp>;
  phoneNumberVerified?: Maybe<Boolean_Comparison_Exp>;
  refreshTokens?: Maybe<AuthRefreshTokens_Bool_Exp>;
  refreshTokens_aggregate?: Maybe<AuthRefreshTokens_Aggregate_Bool_Exp>;
  roles?: Maybe<AuthUserRoles_Bool_Exp>;
  roles_aggregate?: Maybe<AuthUserRoles_Aggregate_Bool_Exp>;
  securityKeys?: Maybe<AuthUserSecurityKeys_Bool_Exp>;
  securityKeys_aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Bool_Exp>;
  ticket?: Maybe<String_Comparison_Exp>;
  ticketExpiresAt?: Maybe<Timestamptz_Comparison_Exp>;
  totpSecret?: Maybe<String_Comparison_Exp>;
  updatedAt?: Maybe<Timestamptz_Comparison_Exp>;
  userProviders?: Maybe<AuthUserProviders_Bool_Exp>;
  userProviders_aggregate?: Maybe<AuthUserProviders_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  metadata?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  metadata?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  metadata?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  defaultRoleByRole?: Maybe<AuthRoles_Obj_Rel_Insert_Input>;
  disabled?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  refreshTokens?: Maybe<AuthRefreshTokens_Arr_Rel_Insert_Input>;
  roles?: Maybe<AuthUserRoles_Arr_Rel_Insert_Input>;
  securityKeys?: Maybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userProviders?: Maybe<AuthUserProviders_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By = {
  activeMfaType?: Maybe<Order_By>;
  avatarUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  currentChallenge?: Maybe<Order_By>;
  defaultRole?: Maybe<Order_By>;
  displayName?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastSeen?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  newEmail?: Maybe<Order_By>;
  otpHash?: Maybe<Order_By>;
  otpHashExpiresAt?: Maybe<Order_By>;
  otpMethodLastUsed?: Maybe<Order_By>;
  passwordHash?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  ticket?: Maybe<Order_By>;
  ticketExpiresAt?: Maybe<Order_By>;
  totpSecret?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By = {
  activeMfaType?: Maybe<Order_By>;
  avatarUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  currentChallenge?: Maybe<Order_By>;
  defaultRole?: Maybe<Order_By>;
  displayName?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lastSeen?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  newEmail?: Maybe<Order_By>;
  otpHash?: Maybe<Order_By>;
  otpHashExpiresAt?: Maybe<Order_By>;
  otpMethodLastUsed?: Maybe<Order_By>;
  passwordHash?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  ticket?: Maybe<Order_By>;
  ticketExpiresAt?: Maybe<Order_By>;
  totpSecret?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By = {
  activated?: Maybe<Order_By>;
  activeMfaType?: Maybe<Order_By>;
  avatarUrl?: Maybe<Order_By>;
  createdAt?: Maybe<Order_By>;
  currentChallenge?: Maybe<Order_By>;
  defaultRole?: Maybe<Order_By>;
  defaultRoleByRole?: Maybe<AuthRoles_Order_By>;
  disabled?: Maybe<Order_By>;
  displayName?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  emailVerified?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  isAnonymous?: Maybe<Order_By>;
  lastSeen?: Maybe<Order_By>;
  locale?: Maybe<Order_By>;
  metadata?: Maybe<Order_By>;
  newEmail?: Maybe<Order_By>;
  otpHash?: Maybe<Order_By>;
  otpHashExpiresAt?: Maybe<Order_By>;
  otpMethodLastUsed?: Maybe<Order_By>;
  passwordHash?: Maybe<Order_By>;
  phoneNumber?: Maybe<Order_By>;
  phoneNumberVerified?: Maybe<Order_By>;
  refreshTokens_aggregate?: Maybe<AuthRefreshTokens_Aggregate_Order_By>;
  roles_aggregate?: Maybe<AuthUserRoles_Aggregate_Order_By>;
  securityKeys_aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Order_By>;
  ticket?: Maybe<Order_By>;
  ticketExpiresAt?: Maybe<Order_By>;
  totpSecret?: Maybe<Order_By>;
  updatedAt?: Maybe<Order_By>;
  userProviders_aggregate?: Maybe<AuthUserProviders_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  metadata?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Activated = 'activated',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Activated = 'activated',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  activeMfaType?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currentChallenge?: Maybe<Scalars['String']>;
  defaultRole?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  locale?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  newEmail?: Maybe<Scalars['citext']>;
  otpHash?: Maybe<Scalars['String']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']>;
  otpMethodLastUsed?: Maybe<Scalars['String']>;
  passwordHash?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  ticket?: Maybe<Scalars['String']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']>;
  totpSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  ActiveMfaType = 'activeMfaType',
  /** column name */
  AvatarUrl = 'avatarUrl',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CurrentChallenge = 'currentChallenge',
  /** column name */
  DefaultRole = 'defaultRole',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'isAnonymous',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Locale = 'locale',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NewEmail = 'newEmail',
  /** column name */
  OtpHash = 'otpHash',
  /** column name */
  OtpHashExpiresAt = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed = 'otpMethodLastUsed',
  /** column name */
  PasswordHash = 'passwordHash',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PhoneNumberVerified = 'phoneNumberVerified',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticketExpiresAt',
  /** column name */
  TotpSecret = 'totpSecret',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type GetTermsQueryVariables = Exact<{
  like?: Scalars['String'];
  except?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTermsQuery = { skills: Array<Pick<Terms, 'term'>>, jobs: Array<Pick<Terms, 'term'>>, emergentskills: Array<Pick<Terms, 'term'>>, emergentjobs: Array<Pick<Terms, 'term'>>, tech: Array<Pick<Terms, 'term'>>, clusters: Array<Pick<Terms, 'term'>> };

export type GetAreasLikeQueryVariables = Exact<{
  like: Scalars['String'];
}>;


export type GetAreasLikeQuery = { areas: Array<Pick<Areas, 'id' | 'name' | 'area_type'>> };

export type AreaFragment = Pick<Areas, 'id' | 'name' | 'area_type'>;

export type GetAreasAndChildrenQueryVariables = Exact<{
  parent_id?: Scalars['String'];
  parent_area_type?: Scalars['String'];
  child_area_type?: Scalars['String'];
}>;


export type GetAreasAndChildrenQuery = { parent: Array<AreaFragment>, children: Array<AreaFragment>, grandchildren: Array<AreaFragment>, ggrandchildren: Array<AreaFragment> };

export type GetAllAreasByTypeQueryVariables = Exact<{
  area_type: Scalars['String'];
}>;


export type GetAllAreasByTypeQuery = { areas: Array<AreaFragment> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserQuery = { user?: Maybe<Pick<Users, 'id' | 'email' | 'displayName' | 'metadata' | 'avatarUrl' | 'activated'>> };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid'];
  displayName: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
}>;


export type UpdateUserMutation = { updateUser?: Maybe<Pick<Users, 'id' | 'displayName' | 'metadata'>> };

export type GetSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesQuery = { sites: Array<{ CanonEmployer: Employer_Stats['employer'], Latitude: Employer_Stats['latitude'], Longitude: Employer_Stats['longitude'] }> };

export type GetJobsAndSkillsOnEmployersQueryVariables = Exact<{
  employers?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetJobsAndSkillsOnEmployersQuery = { jobs: Array<{ Employer: Employer_Stats['employer'], Label: Employer_Stats['label'], Count: Employer_Stats['Count'] }>, skills: Array<{ Employer: Employer_Stats['employer'], Label: Employer_Stats['label'], Count: Employer_Stats['Count'] }> };

export type GetCareerQueryVariables = Exact<{
  terms?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  measure?: Maybe<Scalars['String']>;
  years?: Maybe<Array<Scalars['float8']> | Scalars['float8']>;
  area_restriction?: Maybe<Scalars['String']>;
  area_restriction_unit?: Maybe<Scalars['String']>;
  area_restriction_children?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  area_unit?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
}>;


export type GetCareerQuery = { global_uk: Array<Pick<Careers, 'year' | 'label' | 'amount'>>, global_restricted: Array<Pick<Careers, 'year' | 'label' | 'amount'>>, geocompared: Array<(
    Pick<Careers, 'year' | 'label' | 'amount'>
    & { careers_area?: Maybe<Pick<Areas, 'id' | 'name'>> }
  )>, geocompared_restricted: Array<(
    Pick<Careers, 'year' | 'label' | 'amount'>
    & { careers_area?: Maybe<Pick<Areas, 'id' | 'name'>> }
  )> };

export type GetGlobalCountsAndPropsQueryVariables = Exact<{
  category?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
}>;


export type GetGlobalCountsAndPropsQuery = { all_counts: Array<Pick<Careers, 'label' | 'amount'>>, all_props: Array<Pick<Careers, 'label' | 'amount'>> };

export type GetMaxYearQueryVariables = Exact<{
  source?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
}>;


export type GetMaxYearQuery = { max_year: { aggregate?: Maybe<{ max?: Maybe<Pick<Careers_Max_Fields, 'year'>> }> } };

export type GetSkillClustersQueryVariables = Exact<{
  where?: Maybe<Global_Top_10_Skill_Clusters_Bool_Exp>;
}>;


export type GetSkillClustersQuery = { global_top_10_skill_clusters: Array<Pick<Global_Top_10_Skill_Clusters, 'id' | 'ParentSkill' | 'ChildSkill' | 'Similarity'>> };

export type GetAllSkillClustersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSkillClustersQuery = { global_top_10_skill_clusters: Array<Pick<Global_Top_10_Skill_Clusters, 'id' | 'ParentSkill' | 'ChildSkill' | 'Similarity'>> };

export const AreaFragmentDoc = gql`
    fragment Area on areas {
  id
  name
  area_type
}
    `;
export const GetTermsDocument = gql`
    query GetTerms($like: String! = "%", $except: [String!] = [""]) {
  skills: terms(
    distinct_on: term
    where: {term: {_ilike: $like, _nin: $except}, skill: {_eq: true}}
    limit: 200
  ) {
    term
  }
  jobs: terms(
    distinct_on: term
    where: {term: {_ilike: $like, _nin: $except}, job: {_eq: true}}
    limit: 200
  ) {
    term
  }
  emergentskills: terms(
    where: {term: {_ilike: $like, _nin: $except}, emergentskill: {_eq: true}}
    limit: 200
  ) {
    term
  }
  emergentjobs: terms(
    where: {term: {_ilike: $like, _nin: $except}, emergentjob: {_eq: true}}
    limit: 200
  ) {
    term
  }
  tech: terms(
    distinct_on: term
    where: {term: {_ilike: $like, _nin: $except}, tech: {_eq: true}}
    limit: 200
  ) {
    term
  }
  clusters: terms(
    distinct_on: term
    where: {term: {_ilike: $like, _nin: $except}, clusters: {_eq: true}}
    limit: 200
  ) {
    term
  }
}
    `;

/**
 * __useGetTermsQuery__
 *
 * To run a query within a React component, call `useGetTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsQuery({
 *   variables: {
 *      like: // value for 'like'
 *      except: // value for 'except'
 *   },
 * });
 */
export function useGetTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
      }
export function useGetTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
        }
export type GetTermsQueryHookResult = ReturnType<typeof useGetTermsQuery>;
export type GetTermsLazyQueryHookResult = ReturnType<typeof useGetTermsLazyQuery>;
export type GetTermsQueryResult = Apollo.QueryResult<GetTermsQuery, GetTermsQueryVariables>;
export const GetAreasLikeDocument = gql`
    query GetAreasLike($like: String!) {
  areas(where: {name: {_ilike: $like}}, limit: 50) {
    id
    name
    area_type
  }
}
    `;

/**
 * __useGetAreasLikeQuery__
 *
 * To run a query within a React component, call `useGetAreasLikeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasLikeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasLikeQuery({
 *   variables: {
 *      like: // value for 'like'
 *   },
 * });
 */
export function useGetAreasLikeQuery(baseOptions: Apollo.QueryHookOptions<GetAreasLikeQuery, GetAreasLikeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreasLikeQuery, GetAreasLikeQueryVariables>(GetAreasLikeDocument, options);
      }
export function useGetAreasLikeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreasLikeQuery, GetAreasLikeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreasLikeQuery, GetAreasLikeQueryVariables>(GetAreasLikeDocument, options);
        }
export type GetAreasLikeQueryHookResult = ReturnType<typeof useGetAreasLikeQuery>;
export type GetAreasLikeLazyQueryHookResult = ReturnType<typeof useGetAreasLikeLazyQuery>;
export type GetAreasLikeQueryResult = Apollo.QueryResult<GetAreasLikeQuery, GetAreasLikeQueryVariables>;
export const GetAreasAndChildrenDocument = gql`
    query GetAreasAndChildren($parent_id: String! = "E12000004", $parent_area_type: String! = "region", $child_area_type: String! = "lad") {
  parent: areas(
    where: {area_type: {_eq: $parent_area_type}, id: {_eq: $parent_id}}
  ) {
    ...Area
  }
  children: areas(
    where: {parent_area: {id: {_eq: $parent_id}}, area_type: {_eq: $child_area_type}}
  ) {
    ...Area
  }
  grandchildren: areas(
    where: {parent_area: {parent_area: {id: {_eq: $parent_id}}}, area_type: {_eq: $child_area_type}}
  ) {
    ...Area
  }
  ggrandchildren: areas(
    where: {parent_area: {parent_area: {parent_area: {id: {_eq: $parent_id}}}}, area_type: {_eq: $child_area_type}}
  ) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

/**
 * __useGetAreasAndChildrenQuery__
 *
 * To run a query within a React component, call `useGetAreasAndChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasAndChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasAndChildrenQuery({
 *   variables: {
 *      parent_id: // value for 'parent_id'
 *      parent_area_type: // value for 'parent_area_type'
 *      child_area_type: // value for 'child_area_type'
 *   },
 * });
 */
export function useGetAreasAndChildrenQuery(baseOptions?: Apollo.QueryHookOptions<GetAreasAndChildrenQuery, GetAreasAndChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreasAndChildrenQuery, GetAreasAndChildrenQueryVariables>(GetAreasAndChildrenDocument, options);
      }
export function useGetAreasAndChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreasAndChildrenQuery, GetAreasAndChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreasAndChildrenQuery, GetAreasAndChildrenQueryVariables>(GetAreasAndChildrenDocument, options);
        }
export type GetAreasAndChildrenQueryHookResult = ReturnType<typeof useGetAreasAndChildrenQuery>;
export type GetAreasAndChildrenLazyQueryHookResult = ReturnType<typeof useGetAreasAndChildrenLazyQuery>;
export type GetAreasAndChildrenQueryResult = Apollo.QueryResult<GetAreasAndChildrenQuery, GetAreasAndChildrenQueryVariables>;
export const GetAllAreasByTypeDocument = gql`
    query GetAllAreasByType($area_type: String!) {
  areas(where: {area_type: {_eq: $area_type}}) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

/**
 * __useGetAllAreasByTypeQuery__
 *
 * To run a query within a React component, call `useGetAllAreasByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAreasByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAreasByTypeQuery({
 *   variables: {
 *      area_type: // value for 'area_type'
 *   },
 * });
 */
export function useGetAllAreasByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAllAreasByTypeQuery, GetAllAreasByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAreasByTypeQuery, GetAllAreasByTypeQueryVariables>(GetAllAreasByTypeDocument, options);
      }
export function useGetAllAreasByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAreasByTypeQuery, GetAllAreasByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAreasByTypeQuery, GetAllAreasByTypeQueryVariables>(GetAllAreasByTypeDocument, options);
        }
export type GetAllAreasByTypeQueryHookResult = ReturnType<typeof useGetAllAreasByTypeQuery>;
export type GetAllAreasByTypeLazyQueryHookResult = ReturnType<typeof useGetAllAreasByTypeLazyQuery>;
export type GetAllAreasByTypeQueryResult = Apollo.QueryResult<GetAllAreasByTypeQuery, GetAllAreasByTypeQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: uuid!) {
  user(id: $id) {
    id
    email
    displayName
    metadata
    avatarUrl
    activated
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: uuid!, $displayName: String!, $metadata: jsonb) {
  updateUser(
    pk_columns: {id: $id}
    _set: {displayName: $displayName, metadata: $metadata}
  ) {
    id
    displayName
    metadata
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetSitesDocument = gql`
    query GetSites {
  sites: employer_stats(distinct_on: employer) {
    CanonEmployer: employer
    Latitude: latitude
    Longitude: longitude
  }
}
    `;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export const GetJobsAndSkillsOnEmployersDocument = gql`
    query GetJobsAndSkillsOnEmployers($employers: [String!]) {
  jobs: employer_stats(
    where: {employer: {_in: $employers}, category: {_eq: "job"}}
    order_by: [{Count: asc}]
  ) {
    Employer: employer
    Label: label
    Count: Count
  }
  skills: employer_stats(
    where: {employer: {_in: $employers}, category: {_eq: "skill"}}
    order_by: [{Count: asc}]
  ) {
    Employer: employer
    Label: label
    Count: Count
  }
}
    `;

/**
 * __useGetJobsAndSkillsOnEmployersQuery__
 *
 * To run a query within a React component, call `useGetJobsAndSkillsOnEmployersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsAndSkillsOnEmployersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsAndSkillsOnEmployersQuery({
 *   variables: {
 *      employers: // value for 'employers'
 *   },
 * });
 */
export function useGetJobsAndSkillsOnEmployersQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsAndSkillsOnEmployersQuery, GetJobsAndSkillsOnEmployersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsAndSkillsOnEmployersQuery, GetJobsAndSkillsOnEmployersQueryVariables>(GetJobsAndSkillsOnEmployersDocument, options);
      }
export function useGetJobsAndSkillsOnEmployersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsAndSkillsOnEmployersQuery, GetJobsAndSkillsOnEmployersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsAndSkillsOnEmployersQuery, GetJobsAndSkillsOnEmployersQueryVariables>(GetJobsAndSkillsOnEmployersDocument, options);
        }
export type GetJobsAndSkillsOnEmployersQueryHookResult = ReturnType<typeof useGetJobsAndSkillsOnEmployersQuery>;
export type GetJobsAndSkillsOnEmployersLazyQueryHookResult = ReturnType<typeof useGetJobsAndSkillsOnEmployersLazyQuery>;
export type GetJobsAndSkillsOnEmployersQueryResult = Apollo.QueryResult<GetJobsAndSkillsOnEmployersQuery, GetJobsAndSkillsOnEmployersQueryVariables>;
export const GetCareerDocument = gql`
    query GetCareer($terms: [String!] = ["Welding"], $category: String = "skill", $measure: String = "counts", $years: [float8!] = [2010, 2011], $area_restriction: String = "E12000007", $area_restriction_unit: String = "nation", $area_restriction_children: [String!] = ["E09000001"], $area_unit: String = "nation", $source: String = "ecitb") {
  global_uk: careers(
    where: {label: {_in: $terms}, category: {_eq: $category}, measure: {_eq: $measure}, year: {_in: $years}, area_id: {_is_null: true}, area_type: {_eq: "global"}, source: {_eq: $source}}
  ) {
    year
    label
    amount
  }
  global_restricted: careers(
    where: {label: {_in: $terms}, category: {_eq: $category}, measure: {_eq: $measure}, year: {_in: $years}, area_id: {_eq: $area_restriction}, area_type: {_eq: $area_restriction_unit}, source: {_eq: $source}}
  ) {
    year
    label
    amount
  }
  geocompared: careers(
    where: {label: {_in: $terms}, category: {_eq: $category}, measure: {_eq: $measure}, year: {_in: $years}, area_type: {_eq: $area_unit}, source: {_eq: $source}}
  ) {
    year
    label
    amount
    careers_area {
      id
      name
    }
  }
  geocompared_restricted: careers(
    where: {label: {_in: $terms}, category: {_eq: $category}, measure: {_eq: $measure}, year: {_in: $years}, area_id: {_in: $area_restriction_children}, area_type: {_eq: $area_unit}, source: {_eq: $source}}
  ) {
    year
    label
    amount
    careers_area {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCareerQuery__
 *
 * To run a query within a React component, call `useGetCareerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerQuery({
 *   variables: {
 *      terms: // value for 'terms'
 *      category: // value for 'category'
 *      measure: // value for 'measure'
 *      years: // value for 'years'
 *      area_restriction: // value for 'area_restriction'
 *      area_restriction_unit: // value for 'area_restriction_unit'
 *      area_restriction_children: // value for 'area_restriction_children'
 *      area_unit: // value for 'area_unit'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetCareerQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerQuery, GetCareerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerQuery, GetCareerQueryVariables>(GetCareerDocument, options);
      }
export function useGetCareerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerQuery, GetCareerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerQuery, GetCareerQueryVariables>(GetCareerDocument, options);
        }
export type GetCareerQueryHookResult = ReturnType<typeof useGetCareerQuery>;
export type GetCareerLazyQueryHookResult = ReturnType<typeof useGetCareerLazyQuery>;
export type GetCareerQueryResult = Apollo.QueryResult<GetCareerQuery, GetCareerQueryVariables>;
export const GetGlobalCountsAndPropsDocument = gql`
    query GetGlobalCountsAndProps($category: String, $year: float8, $source: String) {
  all_counts: careers(
    limit: 100
    where: {area_type: {_eq: "global"}, measure: {_eq: "counts"}, category: {_eq: $category}, year: {_eq: $year}, source: {_eq: $source}}
    order_by: [{amount: desc}]
  ) {
    label
    amount
  }
  all_props: careers(
    limit: 100
    where: {area_type: {_eq: "global"}, measure: {_eq: "proportions"}, category: {_eq: $category}, year: {_eq: $year}, source: {_eq: $source}}
    order_by: [{amount: desc}]
  ) {
    label
    amount
  }
}
    `;

/**
 * __useGetGlobalCountsAndPropsQuery__
 *
 * To run a query within a React component, call `useGetGlobalCountsAndPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalCountsAndPropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalCountsAndPropsQuery({
 *   variables: {
 *      category: // value for 'category'
 *      year: // value for 'year'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetGlobalCountsAndPropsQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalCountsAndPropsQuery, GetGlobalCountsAndPropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalCountsAndPropsQuery, GetGlobalCountsAndPropsQueryVariables>(GetGlobalCountsAndPropsDocument, options);
      }
export function useGetGlobalCountsAndPropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalCountsAndPropsQuery, GetGlobalCountsAndPropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalCountsAndPropsQuery, GetGlobalCountsAndPropsQueryVariables>(GetGlobalCountsAndPropsDocument, options);
        }
export type GetGlobalCountsAndPropsQueryHookResult = ReturnType<typeof useGetGlobalCountsAndPropsQuery>;
export type GetGlobalCountsAndPropsLazyQueryHookResult = ReturnType<typeof useGetGlobalCountsAndPropsLazyQuery>;
export type GetGlobalCountsAndPropsQueryResult = Apollo.QueryResult<GetGlobalCountsAndPropsQuery, GetGlobalCountsAndPropsQueryVariables>;
export const GetMaxYearDocument = gql`
    query GetMaxYear($source: String = "ecitb", $category: String = "skill") {
  max_year: careers_aggregate(
    where: {source: {_eq: $source}, category: {_eq: $category}}
  ) {
    aggregate {
      max {
        year
      }
    }
  }
}
    `;

/**
 * __useGetMaxYearQuery__
 *
 * To run a query within a React component, call `useGetMaxYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaxYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaxYearQuery({
 *   variables: {
 *      source: // value for 'source'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetMaxYearQuery(baseOptions?: Apollo.QueryHookOptions<GetMaxYearQuery, GetMaxYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaxYearQuery, GetMaxYearQueryVariables>(GetMaxYearDocument, options);
      }
export function useGetMaxYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaxYearQuery, GetMaxYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaxYearQuery, GetMaxYearQueryVariables>(GetMaxYearDocument, options);
        }
export type GetMaxYearQueryHookResult = ReturnType<typeof useGetMaxYearQuery>;
export type GetMaxYearLazyQueryHookResult = ReturnType<typeof useGetMaxYearLazyQuery>;
export type GetMaxYearQueryResult = Apollo.QueryResult<GetMaxYearQuery, GetMaxYearQueryVariables>;
export const GetSkillClustersDocument = gql`
    query GetSkillClusters($where: global_top_10_skill_clusters_bool_exp) {
  global_top_10_skill_clusters(where: $where) {
    id
    ParentSkill
    ChildSkill
    Similarity
  }
}
    `;

/**
 * __useGetSkillClustersQuery__
 *
 * To run a query within a React component, call `useGetSkillClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillClustersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSkillClustersQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillClustersQuery, GetSkillClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillClustersQuery, GetSkillClustersQueryVariables>(GetSkillClustersDocument, options);
      }
export function useGetSkillClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillClustersQuery, GetSkillClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillClustersQuery, GetSkillClustersQueryVariables>(GetSkillClustersDocument, options);
        }
export type GetSkillClustersQueryHookResult = ReturnType<typeof useGetSkillClustersQuery>;
export type GetSkillClustersLazyQueryHookResult = ReturnType<typeof useGetSkillClustersLazyQuery>;
export type GetSkillClustersQueryResult = Apollo.QueryResult<GetSkillClustersQuery, GetSkillClustersQueryVariables>;
export const GetAllSkillClustersDocument = gql`
    query GetAllSkillClusters {
  global_top_10_skill_clusters(limit: 100) {
    id
    ParentSkill
    ChildSkill
    Similarity
  }
}
    `;

/**
 * __useGetAllSkillClustersQuery__
 *
 * To run a query within a React component, call `useGetAllSkillClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSkillClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSkillClustersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSkillClustersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSkillClustersQuery, GetAllSkillClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSkillClustersQuery, GetAllSkillClustersQueryVariables>(GetAllSkillClustersDocument, options);
      }
export function useGetAllSkillClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSkillClustersQuery, GetAllSkillClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSkillClustersQuery, GetAllSkillClustersQueryVariables>(GetAllSkillClustersDocument, options);
        }
export type GetAllSkillClustersQueryHookResult = ReturnType<typeof useGetAllSkillClustersQuery>;
export type GetAllSkillClustersLazyQueryHookResult = ReturnType<typeof useGetAllSkillClustersLazyQuery>;
export type GetAllSkillClustersQueryResult = Apollo.QueryResult<GetAllSkillClustersQuery, GetAllSkillClustersQueryVariables>;
export type areasKeySpecifier = ('area_type' | 'id' | 'name' | 'parent_area' | 'parent_area_type' | 'parent_id' | areasKeySpecifier)[];
export type areasFieldPolicy = {
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_area?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type areas_aggregateKeySpecifier = ('aggregate' | 'nodes' | areas_aggregateKeySpecifier)[];
export type areas_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type areas_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | areas_aggregate_fieldsKeySpecifier)[];
export type areas_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type areas_max_fieldsKeySpecifier = ('area_type' | 'id' | 'name' | 'parent_area_type' | 'parent_id' | areas_max_fieldsKeySpecifier)[];
export type areas_max_fieldsFieldPolicy = {
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type areas_min_fieldsKeySpecifier = ('area_type' | 'id' | 'name' | 'parent_area_type' | 'parent_id' | areas_min_fieldsKeySpecifier)[];
export type areas_min_fieldsFieldPolicy = {
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type areas_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | areas_mutation_responseKeySpecifier)[];
export type areas_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequestsKeySpecifier = ('id' | 'options' | authProviderRequestsKeySpecifier)[];
export type authProviderRequestsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequests_aggregateKeySpecifier = ('aggregate' | 'nodes' | authProviderRequests_aggregateKeySpecifier)[];
export type authProviderRequests_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequests_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authProviderRequests_aggregate_fieldsKeySpecifier)[];
export type authProviderRequests_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequests_max_fieldsKeySpecifier = ('id' | authProviderRequests_max_fieldsKeySpecifier)[];
export type authProviderRequests_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequests_min_fieldsKeySpecifier = ('id' | authProviderRequests_min_fieldsKeySpecifier)[];
export type authProviderRequests_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviderRequests_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authProviderRequests_mutation_responseKeySpecifier)[];
export type authProviderRequests_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProvidersKeySpecifier = ('id' | 'userProviders' | 'userProviders_aggregate' | authProvidersKeySpecifier)[];
export type authProvidersFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	userProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	userProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviders_aggregateKeySpecifier = ('aggregate' | 'nodes' | authProviders_aggregateKeySpecifier)[];
export type authProviders_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviders_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authProviders_aggregate_fieldsKeySpecifier)[];
export type authProviders_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviders_max_fieldsKeySpecifier = ('id' | authProviders_max_fieldsKeySpecifier)[];
export type authProviders_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviders_min_fieldsKeySpecifier = ('id' | authProviders_min_fieldsKeySpecifier)[];
export type authProviders_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authProviders_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authProviders_mutation_responseKeySpecifier)[];
export type authProviders_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokensKeySpecifier = ('createdAt' | 'expiresAt' | 'refreshToken' | 'refreshTokenHash' | 'user' | 'userId' | authRefreshTokensKeySpecifier)[];
export type authRefreshTokensFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokenHash?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokens_aggregateKeySpecifier = ('aggregate' | 'nodes' | authRefreshTokens_aggregateKeySpecifier)[];
export type authRefreshTokens_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokens_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authRefreshTokens_aggregate_fieldsKeySpecifier)[];
export type authRefreshTokens_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokens_max_fieldsKeySpecifier = ('createdAt' | 'expiresAt' | 'refreshToken' | 'refreshTokenHash' | 'userId' | authRefreshTokens_max_fieldsKeySpecifier)[];
export type authRefreshTokens_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokenHash?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokens_min_fieldsKeySpecifier = ('createdAt' | 'expiresAt' | 'refreshToken' | 'refreshTokenHash' | 'userId' | authRefreshTokens_min_fieldsKeySpecifier)[];
export type authRefreshTokens_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokenHash?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRefreshTokens_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authRefreshTokens_mutation_responseKeySpecifier)[];
export type authRefreshTokens_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRolesKeySpecifier = ('role' | 'userRoles' | 'userRoles_aggregate' | 'usersByDefaultRole' | 'usersByDefaultRole_aggregate' | authRolesKeySpecifier)[];
export type authRolesFieldPolicy = {
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	usersByDefaultRole?: FieldPolicy<any> | FieldReadFunction<any>,
	usersByDefaultRole_aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRoles_aggregateKeySpecifier = ('aggregate' | 'nodes' | authRoles_aggregateKeySpecifier)[];
export type authRoles_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRoles_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authRoles_aggregate_fieldsKeySpecifier)[];
export type authRoles_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRoles_max_fieldsKeySpecifier = ('role' | authRoles_max_fieldsKeySpecifier)[];
export type authRoles_max_fieldsFieldPolicy = {
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRoles_min_fieldsKeySpecifier = ('role' | authRoles_min_fieldsKeySpecifier)[];
export type authRoles_min_fieldsFieldPolicy = {
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authRoles_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authRoles_mutation_responseKeySpecifier)[];
export type authRoles_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProvidersKeySpecifier = ('accessToken' | 'createdAt' | 'id' | 'provider' | 'providerId' | 'providerUserId' | 'refreshToken' | 'updatedAt' | 'user' | 'userId' | authUserProvidersKeySpecifier)[];
export type authUserProvidersFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProviders_aggregateKeySpecifier = ('aggregate' | 'nodes' | authUserProviders_aggregateKeySpecifier)[];
export type authUserProviders_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProviders_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authUserProviders_aggregate_fieldsKeySpecifier)[];
export type authUserProviders_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProviders_max_fieldsKeySpecifier = ('accessToken' | 'createdAt' | 'id' | 'providerId' | 'providerUserId' | 'refreshToken' | 'updatedAt' | 'userId' | authUserProviders_max_fieldsKeySpecifier)[];
export type authUserProviders_max_fieldsFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProviders_min_fieldsKeySpecifier = ('accessToken' | 'createdAt' | 'id' | 'providerId' | 'providerUserId' | 'refreshToken' | 'updatedAt' | 'userId' | authUserProviders_min_fieldsKeySpecifier)[];
export type authUserProviders_min_fieldsFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerUserId?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserProviders_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authUserProviders_mutation_responseKeySpecifier)[];
export type authUserProviders_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRolesKeySpecifier = ('createdAt' | 'id' | 'role' | 'roleByRole' | 'user' | 'userId' | authUserRolesKeySpecifier)[];
export type authUserRolesFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roleByRole?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRoles_aggregateKeySpecifier = ('aggregate' | 'nodes' | authUserRoles_aggregateKeySpecifier)[];
export type authUserRoles_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRoles_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | authUserRoles_aggregate_fieldsKeySpecifier)[];
export type authUserRoles_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRoles_max_fieldsKeySpecifier = ('createdAt' | 'id' | 'role' | 'userId' | authUserRoles_max_fieldsKeySpecifier)[];
export type authUserRoles_max_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRoles_min_fieldsKeySpecifier = ('createdAt' | 'id' | 'role' | 'userId' | authUserRoles_min_fieldsKeySpecifier)[];
export type authUserRoles_min_fieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserRoles_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authUserRoles_mutation_responseKeySpecifier)[];
export type authUserRoles_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeysKeySpecifier = ('counter' | 'credentialId' | 'credentialPublicKey' | 'id' | 'nickname' | 'transports' | 'user' | 'userId' | authUserSecurityKeysKeySpecifier)[];
export type authUserSecurityKeysFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialId?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialPublicKey?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	transports?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_aggregateKeySpecifier = ('aggregate' | 'nodes' | authUserSecurityKeys_aggregateKeySpecifier)[];
export type authUserSecurityKeys_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | authUserSecurityKeys_aggregate_fieldsKeySpecifier)[];
export type authUserSecurityKeys_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_avg_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_avg_fieldsKeySpecifier)[];
export type authUserSecurityKeys_avg_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_max_fieldsKeySpecifier = ('counter' | 'credentialId' | 'id' | 'nickname' | 'transports' | 'userId' | authUserSecurityKeys_max_fieldsKeySpecifier)[];
export type authUserSecurityKeys_max_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	transports?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_min_fieldsKeySpecifier = ('counter' | 'credentialId' | 'id' | 'nickname' | 'transports' | 'userId' | authUserSecurityKeys_min_fieldsKeySpecifier)[];
export type authUserSecurityKeys_min_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>,
	credentialId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	transports?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | authUserSecurityKeys_mutation_responseKeySpecifier)[];
export type authUserSecurityKeys_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_stddev_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_stddev_fieldsKeySpecifier)[];
export type authUserSecurityKeys_stddev_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_stddev_pop_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_stddev_pop_fieldsKeySpecifier)[];
export type authUserSecurityKeys_stddev_pop_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_stddev_samp_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_stddev_samp_fieldsKeySpecifier)[];
export type authUserSecurityKeys_stddev_samp_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_sum_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_sum_fieldsKeySpecifier)[];
export type authUserSecurityKeys_sum_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_var_pop_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_var_pop_fieldsKeySpecifier)[];
export type authUserSecurityKeys_var_pop_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_var_samp_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_var_samp_fieldsKeySpecifier)[];
export type authUserSecurityKeys_var_samp_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type authUserSecurityKeys_variance_fieldsKeySpecifier = ('counter' | authUserSecurityKeys_variance_fieldsKeySpecifier)[];
export type authUserSecurityKeys_variance_fieldsFieldPolicy = {
	counter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bucketsKeySpecifier = ('cacheControl' | 'createdAt' | 'downloadExpiration' | 'files' | 'files_aggregate' | 'id' | 'maxUploadFileSize' | 'minUploadFileSize' | 'presignedUrlsEnabled' | 'updatedAt' | bucketsKeySpecifier)[];
export type bucketsFieldPolicy = {
	cacheControl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	files_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	presignedUrlsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_aggregateKeySpecifier = ('aggregate' | 'nodes' | buckets_aggregateKeySpecifier)[];
export type buckets_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | buckets_aggregate_fieldsKeySpecifier)[];
export type buckets_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_avg_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_avg_fieldsKeySpecifier)[];
export type buckets_avg_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_max_fieldsKeySpecifier = ('cacheControl' | 'createdAt' | 'downloadExpiration' | 'id' | 'maxUploadFileSize' | 'minUploadFileSize' | 'updatedAt' | buckets_max_fieldsKeySpecifier)[];
export type buckets_max_fieldsFieldPolicy = {
	cacheControl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_min_fieldsKeySpecifier = ('cacheControl' | 'createdAt' | 'downloadExpiration' | 'id' | 'maxUploadFileSize' | 'minUploadFileSize' | 'updatedAt' | buckets_min_fieldsKeySpecifier)[];
export type buckets_min_fieldsFieldPolicy = {
	cacheControl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | buckets_mutation_responseKeySpecifier)[];
export type buckets_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_stddev_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_stddev_fieldsKeySpecifier)[];
export type buckets_stddev_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_stddev_pop_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_stddev_pop_fieldsKeySpecifier)[];
export type buckets_stddev_pop_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_stddev_samp_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_stddev_samp_fieldsKeySpecifier)[];
export type buckets_stddev_samp_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_sum_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_sum_fieldsKeySpecifier)[];
export type buckets_sum_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_var_pop_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_var_pop_fieldsKeySpecifier)[];
export type buckets_var_pop_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_var_samp_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_var_samp_fieldsKeySpecifier)[];
export type buckets_var_samp_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buckets_variance_fieldsKeySpecifier = ('downloadExpiration' | 'maxUploadFileSize' | 'minUploadFileSize' | buckets_variance_fieldsKeySpecifier)[];
export type buckets_variance_fieldsFieldPolicy = {
	downloadExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	maxUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>,
	minUploadFileSize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careersKeySpecifier = ('amount' | 'area_id' | 'area_type' | 'careers_area' | 'category' | 'label' | 'measure' | 'source' | 'year' | careersKeySpecifier)[];
export type careersFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	area_id?: FieldPolicy<any> | FieldReadFunction<any>,
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	careers_area?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	measure?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_aggregateKeySpecifier = ('aggregate' | 'nodes' | careers_aggregateKeySpecifier)[];
export type careers_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | careers_aggregate_fieldsKeySpecifier)[];
export type careers_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_avg_fieldsKeySpecifier = ('amount' | 'year' | careers_avg_fieldsKeySpecifier)[];
export type careers_avg_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_max_fieldsKeySpecifier = ('amount' | 'area_id' | 'area_type' | 'category' | 'label' | 'measure' | 'source' | 'year' | careers_max_fieldsKeySpecifier)[];
export type careers_max_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	area_id?: FieldPolicy<any> | FieldReadFunction<any>,
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	measure?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_min_fieldsKeySpecifier = ('amount' | 'area_id' | 'area_type' | 'category' | 'label' | 'measure' | 'source' | 'year' | careers_min_fieldsKeySpecifier)[];
export type careers_min_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	area_id?: FieldPolicy<any> | FieldReadFunction<any>,
	area_type?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	measure?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | careers_mutation_responseKeySpecifier)[];
export type careers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_stddev_fieldsKeySpecifier = ('amount' | 'year' | careers_stddev_fieldsKeySpecifier)[];
export type careers_stddev_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_stddev_pop_fieldsKeySpecifier = ('amount' | 'year' | careers_stddev_pop_fieldsKeySpecifier)[];
export type careers_stddev_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_stddev_samp_fieldsKeySpecifier = ('amount' | 'year' | careers_stddev_samp_fieldsKeySpecifier)[];
export type careers_stddev_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_sum_fieldsKeySpecifier = ('amount' | 'year' | careers_sum_fieldsKeySpecifier)[];
export type careers_sum_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_var_pop_fieldsKeySpecifier = ('amount' | 'year' | careers_var_pop_fieldsKeySpecifier)[];
export type careers_var_pop_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_var_samp_fieldsKeySpecifier = ('amount' | 'year' | careers_var_samp_fieldsKeySpecifier)[];
export type careers_var_samp_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type careers_variance_fieldsKeySpecifier = ('amount' | 'year' | careers_variance_fieldsKeySpecifier)[];
export type careers_variance_fieldsFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	year?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countiesKeySpecifier = ('id' | 'name' | countiesKeySpecifier)[];
export type countiesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type counties_aggregateKeySpecifier = ('aggregate' | 'nodes' | counties_aggregateKeySpecifier)[];
export type counties_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type counties_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | counties_aggregate_fieldsKeySpecifier)[];
export type counties_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type counties_max_fieldsKeySpecifier = ('id' | 'name' | counties_max_fieldsKeySpecifier)[];
export type counties_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type counties_min_fieldsKeySpecifier = ('id' | 'name' | counties_min_fieldsKeySpecifier)[];
export type counties_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type counties_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | counties_mutation_responseKeySpecifier)[];
export type counties_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_statsKeySpecifier = ('Count' | 'category' | 'employer' | 'label' | 'latitude' | 'longitude' | 'source' | employer_statsKeySpecifier)[];
export type employer_statsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_aggregateKeySpecifier = ('aggregate' | 'nodes' | employer_stats_aggregateKeySpecifier)[];
export type employer_stats_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | employer_stats_aggregate_fieldsKeySpecifier)[];
export type employer_stats_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_avg_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_avg_fieldsKeySpecifier)[];
export type employer_stats_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_max_fieldsKeySpecifier = ('Count' | 'category' | 'employer' | 'label' | 'latitude' | 'longitude' | 'source' | employer_stats_max_fieldsKeySpecifier)[];
export type employer_stats_max_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_min_fieldsKeySpecifier = ('Count' | 'category' | 'employer' | 'label' | 'latitude' | 'longitude' | 'source' | employer_stats_min_fieldsKeySpecifier)[];
export type employer_stats_min_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	employer?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | employer_stats_mutation_responseKeySpecifier)[];
export type employer_stats_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_stddev_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_stddev_fieldsKeySpecifier)[];
export type employer_stats_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_stddev_pop_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_stddev_pop_fieldsKeySpecifier)[];
export type employer_stats_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_stddev_samp_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_stddev_samp_fieldsKeySpecifier)[];
export type employer_stats_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_sum_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_sum_fieldsKeySpecifier)[];
export type employer_stats_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_var_pop_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_var_pop_fieldsKeySpecifier)[];
export type employer_stats_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_var_samp_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_var_samp_fieldsKeySpecifier)[];
export type employer_stats_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type employer_stats_variance_fieldsKeySpecifier = ('Count' | 'latitude' | 'longitude' | employer_stats_variance_fieldsKeySpecifier)[];
export type employer_stats_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type filesKeySpecifier = ('bucket' | 'bucketId' | 'createdAt' | 'etag' | 'id' | 'isUploaded' | 'mimeType' | 'name' | 'size' | 'updatedAt' | 'uploadedByUserId' | filesKeySpecifier)[];
export type filesFieldPolicy = {
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	bucketId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	etag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isUploaded?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_aggregateKeySpecifier = ('aggregate' | 'nodes' | files_aggregateKeySpecifier)[];
export type files_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | files_aggregate_fieldsKeySpecifier)[];
export type files_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_avg_fieldsKeySpecifier = ('size' | files_avg_fieldsKeySpecifier)[];
export type files_avg_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_max_fieldsKeySpecifier = ('bucketId' | 'createdAt' | 'etag' | 'id' | 'mimeType' | 'name' | 'size' | 'updatedAt' | 'uploadedByUserId' | files_max_fieldsKeySpecifier)[];
export type files_max_fieldsFieldPolicy = {
	bucketId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	etag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_min_fieldsKeySpecifier = ('bucketId' | 'createdAt' | 'etag' | 'id' | 'mimeType' | 'name' | 'size' | 'updatedAt' | 'uploadedByUserId' | files_min_fieldsKeySpecifier)[];
export type files_min_fieldsFieldPolicy = {
	bucketId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	etag?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedByUserId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | files_mutation_responseKeySpecifier)[];
export type files_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_stddev_fieldsKeySpecifier = ('size' | files_stddev_fieldsKeySpecifier)[];
export type files_stddev_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_stddev_pop_fieldsKeySpecifier = ('size' | files_stddev_pop_fieldsKeySpecifier)[];
export type files_stddev_pop_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_stddev_samp_fieldsKeySpecifier = ('size' | files_stddev_samp_fieldsKeySpecifier)[];
export type files_stddev_samp_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_sum_fieldsKeySpecifier = ('size' | files_sum_fieldsKeySpecifier)[];
export type files_sum_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_var_pop_fieldsKeySpecifier = ('size' | files_var_pop_fieldsKeySpecifier)[];
export type files_var_pop_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_var_samp_fieldsKeySpecifier = ('size' | files_var_samp_fieldsKeySpecifier)[];
export type files_var_samp_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type files_variance_fieldsKeySpecifier = ('size' | files_variance_fieldsKeySpecifier)[];
export type files_variance_fieldsFieldPolicy = {
	size?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotreeKeySpecifier = ('CountyAreaCode' | 'LadAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | geotreeKeySpecifier)[];
export type geotreeFieldPolicy = {
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotree_aggregateKeySpecifier = ('aggregate' | 'nodes' | geotree_aggregateKeySpecifier)[];
export type geotree_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotree_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | geotree_aggregate_fieldsKeySpecifier)[];
export type geotree_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotree_max_fieldsKeySpecifier = ('CountyAreaCode' | 'LadAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | geotree_max_fieldsKeySpecifier)[];
export type geotree_max_fieldsFieldPolicy = {
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotree_min_fieldsKeySpecifier = ('CountyAreaCode' | 'LadAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | geotree_min_fieldsKeySpecifier)[];
export type geotree_min_fieldsFieldPolicy = {
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type geotree_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | geotree_mutation_responseKeySpecifier)[];
export type geotree_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobsKeySpecifier = ('CleanJobTitle' | 'Proportion' | 'Source' | global_emerging_jobsKeySpecifier)[];
export type global_emerging_jobsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_aggregateKeySpecifier = ('aggregate' | 'nodes' | global_emerging_jobs_aggregateKeySpecifier)[];
export type global_emerging_jobs_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | global_emerging_jobs_aggregate_fieldsKeySpecifier)[];
export type global_emerging_jobs_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_avg_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_avg_fieldsKeySpecifier)[];
export type global_emerging_jobs_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Proportion' | 'Source' | global_emerging_jobs_max_fieldsKeySpecifier)[];
export type global_emerging_jobs_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Proportion' | 'Source' | global_emerging_jobs_min_fieldsKeySpecifier)[];
export type global_emerging_jobs_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | global_emerging_jobs_mutation_responseKeySpecifier)[];
export type global_emerging_jobs_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_stddev_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_stddev_fieldsKeySpecifier)[];
export type global_emerging_jobs_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_stddev_pop_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_stddev_pop_fieldsKeySpecifier)[];
export type global_emerging_jobs_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_stddev_samp_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_stddev_samp_fieldsKeySpecifier)[];
export type global_emerging_jobs_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_sum_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_sum_fieldsKeySpecifier)[];
export type global_emerging_jobs_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_var_pop_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_var_pop_fieldsKeySpecifier)[];
export type global_emerging_jobs_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_var_samp_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_var_samp_fieldsKeySpecifier)[];
export type global_emerging_jobs_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_jobs_variance_fieldsKeySpecifier = ('Proportion' | global_emerging_jobs_variance_fieldsKeySpecifier)[];
export type global_emerging_jobs_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skillsKeySpecifier = ('CanonSkills' | 'Proportion' | 'Source' | global_emerging_skillsKeySpecifier)[];
export type global_emerging_skillsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_aggregateKeySpecifier = ('aggregate' | 'nodes' | global_emerging_skills_aggregateKeySpecifier)[];
export type global_emerging_skills_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | global_emerging_skills_aggregate_fieldsKeySpecifier)[];
export type global_emerging_skills_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_avg_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_avg_fieldsKeySpecifier)[];
export type global_emerging_skills_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_max_fieldsKeySpecifier = ('CanonSkills' | 'Proportion' | 'Source' | global_emerging_skills_max_fieldsKeySpecifier)[];
export type global_emerging_skills_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_min_fieldsKeySpecifier = ('CanonSkills' | 'Proportion' | 'Source' | global_emerging_skills_min_fieldsKeySpecifier)[];
export type global_emerging_skills_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | global_emerging_skills_mutation_responseKeySpecifier)[];
export type global_emerging_skills_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_stddev_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_stddev_fieldsKeySpecifier)[];
export type global_emerging_skills_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_stddev_pop_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_stddev_pop_fieldsKeySpecifier)[];
export type global_emerging_skills_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_stddev_samp_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_stddev_samp_fieldsKeySpecifier)[];
export type global_emerging_skills_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_sum_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_sum_fieldsKeySpecifier)[];
export type global_emerging_skills_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_var_pop_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_var_pop_fieldsKeySpecifier)[];
export type global_emerging_skills_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_var_samp_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_var_samp_fieldsKeySpecifier)[];
export type global_emerging_skills_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_emerging_skills_variance_fieldsKeySpecifier = ('Proportion' | global_emerging_skills_variance_fieldsKeySpecifier)[];
export type global_emerging_skills_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clustersKeySpecifier = ('ChildSkill' | 'ParentSkill' | 'Similarity' | 'id' | global_top_10_skill_clustersKeySpecifier)[];
export type global_top_10_skill_clustersFieldPolicy = {
	ChildSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_aggregateKeySpecifier = ('aggregate' | 'nodes' | global_top_10_skill_clusters_aggregateKeySpecifier)[];
export type global_top_10_skill_clusters_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | global_top_10_skill_clusters_aggregate_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_avg_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_avg_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_avg_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_max_fieldsKeySpecifier = ('ChildSkill' | 'ParentSkill' | 'Similarity' | 'id' | global_top_10_skill_clusters_max_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_max_fieldsFieldPolicy = {
	ChildSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_min_fieldsKeySpecifier = ('ChildSkill' | 'ParentSkill' | 'Similarity' | 'id' | global_top_10_skill_clusters_min_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_min_fieldsFieldPolicy = {
	ChildSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | global_top_10_skill_clusters_mutation_responseKeySpecifier)[];
export type global_top_10_skill_clusters_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_stddev_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_stddev_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_stddev_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_stddev_pop_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_stddev_pop_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_stddev_pop_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_stddev_samp_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_stddev_samp_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_stddev_samp_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_sum_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_sum_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_sum_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_var_pop_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_var_pop_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_var_pop_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_var_samp_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_var_samp_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_var_samp_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skill_clusters_variance_fieldsKeySpecifier = ('Similarity' | 'id' | global_top_10_skill_clusters_variance_fieldsKeySpecifier)[];
export type global_top_10_skill_clusters_variance_fieldsFieldPolicy = {
	Similarity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skillsKeySpecifier = ('ParentSkill' | 'id' | global_top_10_skillsKeySpecifier)[];
export type global_top_10_skillsFieldPolicy = {
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_aggregateKeySpecifier = ('aggregate' | 'nodes' | global_top_10_skills_aggregateKeySpecifier)[];
export type global_top_10_skills_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | global_top_10_skills_aggregate_fieldsKeySpecifier)[];
export type global_top_10_skills_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_avg_fieldsKeySpecifier = ('id' | global_top_10_skills_avg_fieldsKeySpecifier)[];
export type global_top_10_skills_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_max_fieldsKeySpecifier = ('ParentSkill' | 'id' | global_top_10_skills_max_fieldsKeySpecifier)[];
export type global_top_10_skills_max_fieldsFieldPolicy = {
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_min_fieldsKeySpecifier = ('ParentSkill' | 'id' | global_top_10_skills_min_fieldsKeySpecifier)[];
export type global_top_10_skills_min_fieldsFieldPolicy = {
	ParentSkill?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | global_top_10_skills_mutation_responseKeySpecifier)[];
export type global_top_10_skills_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_stddev_fieldsKeySpecifier = ('id' | global_top_10_skills_stddev_fieldsKeySpecifier)[];
export type global_top_10_skills_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_stddev_pop_fieldsKeySpecifier = ('id' | global_top_10_skills_stddev_pop_fieldsKeySpecifier)[];
export type global_top_10_skills_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_stddev_samp_fieldsKeySpecifier = ('id' | global_top_10_skills_stddev_samp_fieldsKeySpecifier)[];
export type global_top_10_skills_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_sum_fieldsKeySpecifier = ('id' | global_top_10_skills_sum_fieldsKeySpecifier)[];
export type global_top_10_skills_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_var_pop_fieldsKeySpecifier = ('id' | global_top_10_skills_var_pop_fieldsKeySpecifier)[];
export type global_top_10_skills_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_var_samp_fieldsKeySpecifier = ('id' | global_top_10_skills_var_samp_fieldsKeySpecifier)[];
export type global_top_10_skills_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type global_top_10_skills_variance_fieldsKeySpecifier = ('id' | global_top_10_skills_variance_fieldsKeySpecifier)[];
export type global_top_10_skills_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncountyKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_canoncountyKeySpecifier)[];
export type job_counts_per_month_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_month_by_canoncounty_aggregateKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_canoncounty_max_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_canoncounty_min_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_month_by_canoncounty_mutation_responseKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier)[];
export type job_counts_per_month_by_canoncounty_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_globalKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_month_by_globalKeySpecifier)[];
export type job_counts_per_month_by_globalFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_month_by_global_aggregateKeySpecifier)[];
export type job_counts_per_month_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_month_by_global_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_avg_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_avg_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_month_by_global_max_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_month_by_global_min_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_month_by_global_mutation_responseKeySpecifier)[];
export type job_counts_per_month_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_stddev_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_sum_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_sum_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_global_variance_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_global_variance_fieldsKeySpecifier)[];
export type job_counts_per_month_by_global_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_ladKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_ladKeySpecifier)[];
export type job_counts_per_month_by_ladFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_month_by_lad_aggregateKeySpecifier)[];
export type job_counts_per_month_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_month_by_lad_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_avg_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_avg_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_lad_max_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_lad_min_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_month_by_lad_mutation_responseKeySpecifier)[];
export type job_counts_per_month_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_stddev_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_sum_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_sum_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_lad_variance_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_lad_variance_fieldsKeySpecifier)[];
export type job_counts_per_month_by_lad_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nationKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_month_by_nationKeySpecifier)[];
export type job_counts_per_month_by_nationFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_month_by_nation_aggregateKeySpecifier)[];
export type job_counts_per_month_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_month_by_nation_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_avg_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_avg_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_month_by_nation_max_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_month_by_nation_min_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_month_by_nation_mutation_responseKeySpecifier)[];
export type job_counts_per_month_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_stddev_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_sum_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_sum_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_nation_variance_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_nation_variance_fieldsKeySpecifier)[];
export type job_counts_per_month_by_nation_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_regionKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_regionKeySpecifier)[];
export type job_counts_per_month_by_regionFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_month_by_region_aggregateKeySpecifier)[];
export type job_counts_per_month_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_month_by_region_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_avg_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_avg_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_region_max_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_month_by_region_min_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_month_by_region_mutation_responseKeySpecifier)[];
export type job_counts_per_month_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_stddev_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_sum_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_sum_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_month_by_region_variance_fieldsKeySpecifier = ('Count' | job_counts_per_month_by_region_variance_fieldsKeySpecifier)[];
export type job_counts_per_month_by_region_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncountyKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_canoncountyKeySpecifier)[];
export type job_counts_per_year_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_year_by_canoncounty_aggregateKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_canoncounty_max_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_canoncounty_min_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_year_by_canoncounty_mutation_responseKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier)[];
export type job_counts_per_year_by_canoncounty_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_globalKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_year_by_globalKeySpecifier)[];
export type job_counts_per_year_by_globalFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_year_by_global_aggregateKeySpecifier)[];
export type job_counts_per_year_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_year_by_global_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_avg_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_avg_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_year_by_global_max_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Source' | job_counts_per_year_by_global_min_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_year_by_global_mutation_responseKeySpecifier)[];
export type job_counts_per_year_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_stddev_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_sum_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_sum_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_global_variance_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_global_variance_fieldsKeySpecifier)[];
export type job_counts_per_year_by_global_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_ladKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_ladKeySpecifier)[];
export type job_counts_per_year_by_ladFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_year_by_lad_aggregateKeySpecifier)[];
export type job_counts_per_year_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_year_by_lad_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_avg_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_avg_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_lad_max_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_lad_min_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_year_by_lad_mutation_responseKeySpecifier)[];
export type job_counts_per_year_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_stddev_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_sum_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_sum_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_lad_variance_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_lad_variance_fieldsKeySpecifier)[];
export type job_counts_per_year_by_lad_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nationKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_year_by_nationKeySpecifier)[];
export type job_counts_per_year_by_nationFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_year_by_nation_aggregateKeySpecifier)[];
export type job_counts_per_year_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_year_by_nation_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_avg_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_avg_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_year_by_nation_max_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | job_counts_per_year_by_nation_min_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_year_by_nation_mutation_responseKeySpecifier)[];
export type job_counts_per_year_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_stddev_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_sum_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_sum_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_nation_variance_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_nation_variance_fieldsKeySpecifier)[];
export type job_counts_per_year_by_nation_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_regionKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_regionKeySpecifier)[];
export type job_counts_per_year_by_regionFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_counts_per_year_by_region_aggregateKeySpecifier)[];
export type job_counts_per_year_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_counts_per_year_by_region_aggregate_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_avg_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_avg_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_max_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_region_max_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_min_fieldsKeySpecifier = ('CleanJobTitle' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | job_counts_per_year_by_region_min_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_counts_per_year_by_region_mutation_responseKeySpecifier)[];
export type job_counts_per_year_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_stddev_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_stddev_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_sum_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_sum_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_var_pop_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_var_pop_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_var_samp_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_var_samp_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_counts_per_year_by_region_variance_fieldsKeySpecifier = ('Count' | job_counts_per_year_by_region_variance_fieldsKeySpecifier)[];
export type job_counts_per_year_by_region_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncountyKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_canoncountyKeySpecifier)[];
export type job_proportions_per_month_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_month_by_canoncounty_aggregateKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_canoncounty_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_globalKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_month_by_globalKeySpecifier)[];
export type job_proportions_per_month_by_globalFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_month_by_global_aggregateKeySpecifier)[];
export type job_proportions_per_month_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_month_by_global_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_avg_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_month_by_global_max_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_month_by_global_min_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_month_by_global_mutation_responseKeySpecifier)[];
export type job_proportions_per_month_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_sum_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_global_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_global_variance_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_global_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_ladKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_ladKeySpecifier)[];
export type job_proportions_per_month_by_ladFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_month_by_lad_aggregateKeySpecifier)[];
export type job_proportions_per_month_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_avg_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_max_fieldsKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_lad_max_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_min_fieldsKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_lad_min_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_month_by_lad_mutation_responseKeySpecifier)[];
export type job_proportions_per_month_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_sum_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_lad_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_lad_variance_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_lad_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nationKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_month_by_nationKeySpecifier)[];
export type job_proportions_per_month_by_nationFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_month_by_nation_aggregateKeySpecifier)[];
export type job_proportions_per_month_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_avg_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_month_by_nation_max_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_month_by_nation_min_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_month_by_nation_mutation_responseKeySpecifier)[];
export type job_proportions_per_month_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_sum_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_nation_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_nation_variance_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_nation_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_regionKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_regionKeySpecifier)[];
export type job_proportions_per_month_by_regionFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_month_by_region_aggregateKeySpecifier)[];
export type job_proportions_per_month_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_month_by_region_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_avg_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_region_max_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_month_by_region_min_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_month_by_region_mutation_responseKeySpecifier)[];
export type job_proportions_per_month_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_sum_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_month_by_region_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_month_by_region_variance_fieldsKeySpecifier)[];
export type job_proportions_per_month_by_region_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncountyKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_canoncountyKeySpecifier)[];
export type job_proportions_per_year_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_year_by_canoncounty_aggregateKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_canoncounty_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_globalKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_year_by_globalKeySpecifier)[];
export type job_proportions_per_year_by_globalFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_year_by_global_aggregateKeySpecifier)[];
export type job_proportions_per_year_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_year_by_global_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_avg_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_year_by_global_max_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Proportion' | 'Source' | job_proportions_per_year_by_global_min_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_year_by_global_mutation_responseKeySpecifier)[];
export type job_proportions_per_year_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_sum_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_global_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_global_variance_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_global_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_ladKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_ladKeySpecifier)[];
export type job_proportions_per_year_by_ladFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_year_by_lad_aggregateKeySpecifier)[];
export type job_proportions_per_year_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_avg_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_max_fieldsKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_lad_max_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_min_fieldsKeySpecifier = ('CleanJobTitle' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_lad_min_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_year_by_lad_mutation_responseKeySpecifier)[];
export type job_proportions_per_year_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_sum_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_lad_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_lad_variance_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_lad_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nationKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_year_by_nationKeySpecifier)[];
export type job_proportions_per_year_by_nationFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_year_by_nation_aggregateKeySpecifier)[];
export type job_proportions_per_year_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_avg_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_year_by_nation_max_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | job_proportions_per_year_by_nation_min_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_year_by_nation_mutation_responseKeySpecifier)[];
export type job_proportions_per_year_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_sum_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_nation_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_nation_variance_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_nation_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_regionKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_regionKeySpecifier)[];
export type job_proportions_per_year_by_regionFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | job_proportions_per_year_by_region_aggregateKeySpecifier)[];
export type job_proportions_per_year_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | job_proportions_per_year_by_region_aggregate_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_avg_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_avg_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_max_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_region_max_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_max_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_min_fieldsKeySpecifier = ('CleanJobTitle' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | job_proportions_per_year_by_region_min_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_min_fieldsFieldPolicy = {
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | job_proportions_per_year_by_region_mutation_responseKeySpecifier)[];
export type job_proportions_per_year_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_stddev_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_stddev_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_sum_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_sum_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_var_pop_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_var_pop_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_var_samp_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_var_samp_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type job_proportions_per_year_by_region_variance_fieldsKeySpecifier = ('Proportion' | job_proportions_per_year_by_region_variance_fieldsKeySpecifier)[];
export type job_proportions_per_year_by_region_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ladsKeySpecifier = ('id' | 'name' | ladsKeySpecifier)[];
export type ladsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type lads_aggregateKeySpecifier = ('aggregate' | 'nodes' | lads_aggregateKeySpecifier)[];
export type lads_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type lads_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | lads_aggregate_fieldsKeySpecifier)[];
export type lads_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type lads_max_fieldsKeySpecifier = ('id' | 'name' | lads_max_fieldsKeySpecifier)[];
export type lads_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type lads_min_fieldsKeySpecifier = ('id' | 'name' | lads_min_fieldsKeySpecifier)[];
export type lads_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type lads_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | lads_mutation_responseKeySpecifier)[];
export type lads_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type mutation_rootKeySpecifier = ('deleteAuthProvider' | 'deleteAuthProviderRequest' | 'deleteAuthProviderRequests' | 'deleteAuthProviders' | 'deleteAuthRefreshToken' | 'deleteAuthRefreshTokens' | 'deleteAuthRole' | 'deleteAuthRoles' | 'deleteAuthUserProvider' | 'deleteAuthUserProviders' | 'deleteAuthUserRole' | 'deleteAuthUserRoles' | 'deleteAuthUserSecurityKey' | 'deleteAuthUserSecurityKeys' | 'deleteBucket' | 'deleteBuckets' | 'deleteFile' | 'deleteFiles' | 'deleteUser' | 'deleteUsers' | 'delete_areas' | 'delete_areas_by_pk' | 'delete_careers' | 'delete_counties' | 'delete_employer_stats' | 'delete_geotree' | 'delete_geotree_by_pk' | 'delete_global_emerging_jobs' | 'delete_global_emerging_skills' | 'delete_global_top_10_skill_clusters' | 'delete_global_top_10_skill_clusters_by_pk' | 'delete_global_top_10_skills' | 'delete_global_top_10_skills_by_pk' | 'delete_job_counts_per_month_by_canoncounty' | 'delete_job_counts_per_month_by_global' | 'delete_job_counts_per_month_by_lad' | 'delete_job_counts_per_month_by_nation' | 'delete_job_counts_per_month_by_region' | 'delete_job_counts_per_year_by_canoncounty' | 'delete_job_counts_per_year_by_global' | 'delete_job_counts_per_year_by_lad' | 'delete_job_counts_per_year_by_nation' | 'delete_job_counts_per_year_by_region' | 'delete_job_proportions_per_month_by_canoncounty' | 'delete_job_proportions_per_month_by_global' | 'delete_job_proportions_per_month_by_lad' | 'delete_job_proportions_per_month_by_nation' | 'delete_job_proportions_per_month_by_region' | 'delete_job_proportions_per_year_by_canoncounty' | 'delete_job_proportions_per_year_by_global' | 'delete_job_proportions_per_year_by_lad' | 'delete_job_proportions_per_year_by_nation' | 'delete_job_proportions_per_year_by_region' | 'delete_lads' | 'delete_nations' | 'delete_profile_by_jobs' | 'delete_profile_by_skills' | 'delete_regions' | 'delete_salary_by_canoncounty' | 'delete_salary_by_global' | 'delete_salary_by_lad' | 'delete_salary_by_nation' | 'delete_salary_by_region' | 'delete_skill_counts_per_month_by_canoncounty' | 'delete_skill_counts_per_month_by_global' | 'delete_skill_counts_per_month_by_lad' | 'delete_skill_counts_per_month_by_nation' | 'delete_skill_counts_per_month_by_region' | 'delete_skill_counts_per_year_by_canoncounty' | 'delete_skill_counts_per_year_by_global' | 'delete_skill_counts_per_year_by_lad' | 'delete_skill_counts_per_year_by_nation' | 'delete_skill_counts_per_year_by_region' | 'delete_skill_proportions_per_month_by_canoncounty' | 'delete_skill_proportions_per_month_by_global' | 'delete_skill_proportions_per_month_by_lad' | 'delete_skill_proportions_per_month_by_nation' | 'delete_skill_proportions_per_month_by_region' | 'delete_skill_proportions_per_year_by_canoncounty' | 'delete_skill_proportions_per_year_by_global' | 'delete_skill_proportions_per_year_by_lad' | 'delete_skill_proportions_per_year_by_nation' | 'delete_skill_proportions_per_year_by_region' | 'delete_terms' | 'delete_terms_by_pk' | 'insertAuthProvider' | 'insertAuthProviderRequest' | 'insertAuthProviderRequests' | 'insertAuthProviders' | 'insertAuthRefreshToken' | 'insertAuthRefreshTokens' | 'insertAuthRole' | 'insertAuthRoles' | 'insertAuthUserProvider' | 'insertAuthUserProviders' | 'insertAuthUserRole' | 'insertAuthUserRoles' | 'insertAuthUserSecurityKey' | 'insertAuthUserSecurityKeys' | 'insertBucket' | 'insertBuckets' | 'insertFile' | 'insertFiles' | 'insertUser' | 'insertUsers' | 'insert_areas' | 'insert_areas_one' | 'insert_careers' | 'insert_careers_one' | 'insert_counties' | 'insert_counties_one' | 'insert_employer_stats' | 'insert_employer_stats_one' | 'insert_geotree' | 'insert_geotree_one' | 'insert_global_emerging_jobs' | 'insert_global_emerging_jobs_one' | 'insert_global_emerging_skills' | 'insert_global_emerging_skills_one' | 'insert_global_top_10_skill_clusters' | 'insert_global_top_10_skill_clusters_one' | 'insert_global_top_10_skills' | 'insert_global_top_10_skills_one' | 'insert_job_counts_per_month_by_canoncounty' | 'insert_job_counts_per_month_by_canoncounty_one' | 'insert_job_counts_per_month_by_global' | 'insert_job_counts_per_month_by_global_one' | 'insert_job_counts_per_month_by_lad' | 'insert_job_counts_per_month_by_lad_one' | 'insert_job_counts_per_month_by_nation' | 'insert_job_counts_per_month_by_nation_one' | 'insert_job_counts_per_month_by_region' | 'insert_job_counts_per_month_by_region_one' | 'insert_job_counts_per_year_by_canoncounty' | 'insert_job_counts_per_year_by_canoncounty_one' | 'insert_job_counts_per_year_by_global' | 'insert_job_counts_per_year_by_global_one' | 'insert_job_counts_per_year_by_lad' | 'insert_job_counts_per_year_by_lad_one' | 'insert_job_counts_per_year_by_nation' | 'insert_job_counts_per_year_by_nation_one' | 'insert_job_counts_per_year_by_region' | 'insert_job_counts_per_year_by_region_one' | 'insert_job_proportions_per_month_by_canoncounty' | 'insert_job_proportions_per_month_by_canoncounty_one' | 'insert_job_proportions_per_month_by_global' | 'insert_job_proportions_per_month_by_global_one' | 'insert_job_proportions_per_month_by_lad' | 'insert_job_proportions_per_month_by_lad_one' | 'insert_job_proportions_per_month_by_nation' | 'insert_job_proportions_per_month_by_nation_one' | 'insert_job_proportions_per_month_by_region' | 'insert_job_proportions_per_month_by_region_one' | 'insert_job_proportions_per_year_by_canoncounty' | 'insert_job_proportions_per_year_by_canoncounty_one' | 'insert_job_proportions_per_year_by_global' | 'insert_job_proportions_per_year_by_global_one' | 'insert_job_proportions_per_year_by_lad' | 'insert_job_proportions_per_year_by_lad_one' | 'insert_job_proportions_per_year_by_nation' | 'insert_job_proportions_per_year_by_nation_one' | 'insert_job_proportions_per_year_by_region' | 'insert_job_proportions_per_year_by_region_one' | 'insert_lads' | 'insert_lads_one' | 'insert_nations' | 'insert_nations_one' | 'insert_profile_by_jobs' | 'insert_profile_by_jobs_one' | 'insert_profile_by_skills' | 'insert_profile_by_skills_one' | 'insert_regions' | 'insert_regions_one' | 'insert_salary_by_canoncounty' | 'insert_salary_by_canoncounty_one' | 'insert_salary_by_global' | 'insert_salary_by_global_one' | 'insert_salary_by_lad' | 'insert_salary_by_lad_one' | 'insert_salary_by_nation' | 'insert_salary_by_nation_one' | 'insert_salary_by_region' | 'insert_salary_by_region_one' | 'insert_skill_counts_per_month_by_canoncounty' | 'insert_skill_counts_per_month_by_canoncounty_one' | 'insert_skill_counts_per_month_by_global' | 'insert_skill_counts_per_month_by_global_one' | 'insert_skill_counts_per_month_by_lad' | 'insert_skill_counts_per_month_by_lad_one' | 'insert_skill_counts_per_month_by_nation' | 'insert_skill_counts_per_month_by_nation_one' | 'insert_skill_counts_per_month_by_region' | 'insert_skill_counts_per_month_by_region_one' | 'insert_skill_counts_per_year_by_canoncounty' | 'insert_skill_counts_per_year_by_canoncounty_one' | 'insert_skill_counts_per_year_by_global' | 'insert_skill_counts_per_year_by_global_one' | 'insert_skill_counts_per_year_by_lad' | 'insert_skill_counts_per_year_by_lad_one' | 'insert_skill_counts_per_year_by_nation' | 'insert_skill_counts_per_year_by_nation_one' | 'insert_skill_counts_per_year_by_region' | 'insert_skill_counts_per_year_by_region_one' | 'insert_skill_proportions_per_month_by_canoncounty' | 'insert_skill_proportions_per_month_by_canoncounty_one' | 'insert_skill_proportions_per_month_by_global' | 'insert_skill_proportions_per_month_by_global_one' | 'insert_skill_proportions_per_month_by_lad' | 'insert_skill_proportions_per_month_by_lad_one' | 'insert_skill_proportions_per_month_by_nation' | 'insert_skill_proportions_per_month_by_nation_one' | 'insert_skill_proportions_per_month_by_region' | 'insert_skill_proportions_per_month_by_region_one' | 'insert_skill_proportions_per_year_by_canoncounty' | 'insert_skill_proportions_per_year_by_canoncounty_one' | 'insert_skill_proportions_per_year_by_global' | 'insert_skill_proportions_per_year_by_global_one' | 'insert_skill_proportions_per_year_by_lad' | 'insert_skill_proportions_per_year_by_lad_one' | 'insert_skill_proportions_per_year_by_nation' | 'insert_skill_proportions_per_year_by_nation_one' | 'insert_skill_proportions_per_year_by_region' | 'insert_skill_proportions_per_year_by_region_one' | 'insert_terms' | 'insert_terms_one' | 'updateAuthProvider' | 'updateAuthProviderRequest' | 'updateAuthProviderRequests' | 'updateAuthProviders' | 'updateAuthRefreshToken' | 'updateAuthRefreshTokens' | 'updateAuthRole' | 'updateAuthRoles' | 'updateAuthUserProvider' | 'updateAuthUserProviders' | 'updateAuthUserRole' | 'updateAuthUserRoles' | 'updateAuthUserSecurityKey' | 'updateAuthUserSecurityKeys' | 'updateBucket' | 'updateBuckets' | 'updateFile' | 'updateFiles' | 'updateUser' | 'updateUsers' | 'update_areas' | 'update_areas_by_pk' | 'update_areas_many' | 'update_authProviderRequests_many' | 'update_authProviders_many' | 'update_authRefreshTokens_many' | 'update_authRoles_many' | 'update_authUserProviders_many' | 'update_authUserRoles_many' | 'update_authUserSecurityKeys_many' | 'update_buckets_many' | 'update_careers' | 'update_careers_many' | 'update_counties' | 'update_counties_many' | 'update_employer_stats' | 'update_employer_stats_many' | 'update_files_many' | 'update_geotree' | 'update_geotree_by_pk' | 'update_geotree_many' | 'update_global_emerging_jobs' | 'update_global_emerging_jobs_many' | 'update_global_emerging_skills' | 'update_global_emerging_skills_many' | 'update_global_top_10_skill_clusters' | 'update_global_top_10_skill_clusters_by_pk' | 'update_global_top_10_skill_clusters_many' | 'update_global_top_10_skills' | 'update_global_top_10_skills_by_pk' | 'update_global_top_10_skills_many' | 'update_job_counts_per_month_by_canoncounty' | 'update_job_counts_per_month_by_canoncounty_many' | 'update_job_counts_per_month_by_global' | 'update_job_counts_per_month_by_global_many' | 'update_job_counts_per_month_by_lad' | 'update_job_counts_per_month_by_lad_many' | 'update_job_counts_per_month_by_nation' | 'update_job_counts_per_month_by_nation_many' | 'update_job_counts_per_month_by_region' | 'update_job_counts_per_month_by_region_many' | 'update_job_counts_per_year_by_canoncounty' | 'update_job_counts_per_year_by_canoncounty_many' | 'update_job_counts_per_year_by_global' | 'update_job_counts_per_year_by_global_many' | 'update_job_counts_per_year_by_lad' | 'update_job_counts_per_year_by_lad_many' | 'update_job_counts_per_year_by_nation' | 'update_job_counts_per_year_by_nation_many' | 'update_job_counts_per_year_by_region' | 'update_job_counts_per_year_by_region_many' | 'update_job_proportions_per_month_by_canoncounty' | 'update_job_proportions_per_month_by_canoncounty_many' | 'update_job_proportions_per_month_by_global' | 'update_job_proportions_per_month_by_global_many' | 'update_job_proportions_per_month_by_lad' | 'update_job_proportions_per_month_by_lad_many' | 'update_job_proportions_per_month_by_nation' | 'update_job_proportions_per_month_by_nation_many' | 'update_job_proportions_per_month_by_region' | 'update_job_proportions_per_month_by_region_many' | 'update_job_proportions_per_year_by_canoncounty' | 'update_job_proportions_per_year_by_canoncounty_many' | 'update_job_proportions_per_year_by_global' | 'update_job_proportions_per_year_by_global_many' | 'update_job_proportions_per_year_by_lad' | 'update_job_proportions_per_year_by_lad_many' | 'update_job_proportions_per_year_by_nation' | 'update_job_proportions_per_year_by_nation_many' | 'update_job_proportions_per_year_by_region' | 'update_job_proportions_per_year_by_region_many' | 'update_lads' | 'update_lads_many' | 'update_nations' | 'update_nations_many' | 'update_profile_by_jobs' | 'update_profile_by_jobs_many' | 'update_profile_by_skills' | 'update_profile_by_skills_many' | 'update_regions' | 'update_regions_many' | 'update_salary_by_canoncounty' | 'update_salary_by_canoncounty_many' | 'update_salary_by_global' | 'update_salary_by_global_many' | 'update_salary_by_lad' | 'update_salary_by_lad_many' | 'update_salary_by_nation' | 'update_salary_by_nation_many' | 'update_salary_by_region' | 'update_salary_by_region_many' | 'update_skill_counts_per_month_by_canoncounty' | 'update_skill_counts_per_month_by_canoncounty_many' | 'update_skill_counts_per_month_by_global' | 'update_skill_counts_per_month_by_global_many' | 'update_skill_counts_per_month_by_lad' | 'update_skill_counts_per_month_by_lad_many' | 'update_skill_counts_per_month_by_nation' | 'update_skill_counts_per_month_by_nation_many' | 'update_skill_counts_per_month_by_region' | 'update_skill_counts_per_month_by_region_many' | 'update_skill_counts_per_year_by_canoncounty' | 'update_skill_counts_per_year_by_canoncounty_many' | 'update_skill_counts_per_year_by_global' | 'update_skill_counts_per_year_by_global_many' | 'update_skill_counts_per_year_by_lad' | 'update_skill_counts_per_year_by_lad_many' | 'update_skill_counts_per_year_by_nation' | 'update_skill_counts_per_year_by_nation_many' | 'update_skill_counts_per_year_by_region' | 'update_skill_counts_per_year_by_region_many' | 'update_skill_proportions_per_month_by_canoncounty' | 'update_skill_proportions_per_month_by_canoncounty_many' | 'update_skill_proportions_per_month_by_global' | 'update_skill_proportions_per_month_by_global_many' | 'update_skill_proportions_per_month_by_lad' | 'update_skill_proportions_per_month_by_lad_many' | 'update_skill_proportions_per_month_by_nation' | 'update_skill_proportions_per_month_by_nation_many' | 'update_skill_proportions_per_month_by_region' | 'update_skill_proportions_per_month_by_region_many' | 'update_skill_proportions_per_year_by_canoncounty' | 'update_skill_proportions_per_year_by_canoncounty_many' | 'update_skill_proportions_per_year_by_global' | 'update_skill_proportions_per_year_by_global_many' | 'update_skill_proportions_per_year_by_lad' | 'update_skill_proportions_per_year_by_lad_many' | 'update_skill_proportions_per_year_by_nation' | 'update_skill_proportions_per_year_by_nation_many' | 'update_skill_proportions_per_year_by_region' | 'update_skill_proportions_per_year_by_region_many' | 'update_terms' | 'update_terms_by_pk' | 'update_terms_many' | 'update_users_many' | mutation_rootKeySpecifier)[];
export type mutation_rootFieldPolicy = {
	deleteAuthProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthProviderRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthProviderRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthRefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthRefreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthRole?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserSecurityKey?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteAuthUserSecurityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFile?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_areas?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_areas_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_careers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_counties?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_employer_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_geotree?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_geotree_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_emerging_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_emerging_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_top_10_skill_clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_top_10_skill_clusters_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_top_10_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_global_top_10_skills_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_job_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_lads?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_nations?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_profile_by_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_profile_by_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_regions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_salary_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_salary_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_salary_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_salary_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_salary_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_skill_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_terms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthProviderRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthProviderRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthRefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthRefreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthRole?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserSecurityKey?: FieldPolicy<any> | FieldReadFunction<any>,
	insertAuthUserSecurityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	insertBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	insertBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	insertFile?: FieldPolicy<any> | FieldReadFunction<any>,
	insertFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	insertUser?: FieldPolicy<any> | FieldReadFunction<any>,
	insertUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_areas?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_areas_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_careers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_careers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_counties?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_counties_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_employer_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_employer_stats_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_geotree?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_geotree_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_emerging_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_emerging_jobs_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_emerging_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_emerging_skills_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_top_10_skill_clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_top_10_skill_clusters_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_top_10_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_global_top_10_skills_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_month_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_counts_per_year_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_month_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_job_proportions_per_year_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_lads?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_lads_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_nations?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_nations_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_profile_by_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_profile_by_jobs_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_profile_by_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_profile_by_skills_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_regions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_regions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_salary_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_month_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_counts_per_year_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_month_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_canoncounty_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_global_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_lad_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_nation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_skill_proportions_per_year_by_region_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_terms_one?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthProviderRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthProviderRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthRefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthRefreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthRole?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserSecurityKey?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAuthUserSecurityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBuckets?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFile?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_areas?: FieldPolicy<any> | FieldReadFunction<any>,
	update_areas_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_areas_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authProviderRequests_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authProviders_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authRefreshTokens_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authRoles_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authUserProviders_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authUserRoles_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_authUserSecurityKeys_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_buckets_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_careers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_careers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_counties?: FieldPolicy<any> | FieldReadFunction<any>,
	update_counties_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_employer_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	update_employer_stats_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_files_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_geotree?: FieldPolicy<any> | FieldReadFunction<any>,
	update_geotree_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_geotree_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_emerging_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_emerging_jobs_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_emerging_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_emerging_skills_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skill_clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skill_clusters_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skill_clusters_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skills_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_global_top_10_skills_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_month_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_counts_per_year_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_month_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_job_proportions_per_year_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_lads?: FieldPolicy<any> | FieldReadFunction<any>,
	update_lads_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_nations?: FieldPolicy<any> | FieldReadFunction<any>,
	update_nations_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_profile_by_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	update_profile_by_jobs_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_profile_by_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	update_profile_by_skills_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_regions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_regions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_salary_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_month_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_counts_per_year_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_month_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_canoncounty_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_global_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_lad_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_nation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	update_skill_proportions_per_year_by_region_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	update_terms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_terms_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_users_many?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nationsKeySpecifier = ('id' | 'name' | nationsKeySpecifier)[];
export type nationsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nations_aggregateKeySpecifier = ('aggregate' | 'nodes' | nations_aggregateKeySpecifier)[];
export type nations_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nations_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | nations_aggregate_fieldsKeySpecifier)[];
export type nations_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nations_max_fieldsKeySpecifier = ('id' | 'name' | nations_max_fieldsKeySpecifier)[];
export type nations_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nations_min_fieldsKeySpecifier = ('id' | 'name' | nations_min_fieldsKeySpecifier)[];
export type nations_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type nations_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | nations_mutation_responseKeySpecifier)[];
export type nations_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobsKeySpecifier = ('CanonEmployer' | 'CleanJobTitle' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_jobsKeySpecifier)[];
export type profile_by_jobsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_aggregateKeySpecifier = ('aggregate' | 'nodes' | profile_by_jobs_aggregateKeySpecifier)[];
export type profile_by_jobs_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | profile_by_jobs_aggregate_fieldsKeySpecifier)[];
export type profile_by_jobs_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_avg_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_avg_fieldsKeySpecifier)[];
export type profile_by_jobs_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_max_fieldsKeySpecifier = ('CanonEmployer' | 'CleanJobTitle' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_jobs_max_fieldsKeySpecifier)[];
export type profile_by_jobs_max_fieldsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_min_fieldsKeySpecifier = ('CanonEmployer' | 'CleanJobTitle' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_jobs_min_fieldsKeySpecifier)[];
export type profile_by_jobs_min_fieldsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | profile_by_jobs_mutation_responseKeySpecifier)[];
export type profile_by_jobs_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_stddev_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_stddev_fieldsKeySpecifier)[];
export type profile_by_jobs_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_stddev_pop_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_stddev_pop_fieldsKeySpecifier)[];
export type profile_by_jobs_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_stddev_samp_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_stddev_samp_fieldsKeySpecifier)[];
export type profile_by_jobs_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_sum_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_sum_fieldsKeySpecifier)[];
export type profile_by_jobs_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_var_pop_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_var_pop_fieldsKeySpecifier)[];
export type profile_by_jobs_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_var_samp_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_var_samp_fieldsKeySpecifier)[];
export type profile_by_jobs_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_jobs_variance_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_jobs_variance_fieldsKeySpecifier)[];
export type profile_by_jobs_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skillsKeySpecifier = ('CanonEmployer' | 'CanonSkills' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_skillsKeySpecifier)[];
export type profile_by_skillsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_aggregateKeySpecifier = ('aggregate' | 'nodes' | profile_by_skills_aggregateKeySpecifier)[];
export type profile_by_skills_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | profile_by_skills_aggregate_fieldsKeySpecifier)[];
export type profile_by_skills_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_avg_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_avg_fieldsKeySpecifier)[];
export type profile_by_skills_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_max_fieldsKeySpecifier = ('CanonEmployer' | 'CanonSkills' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_skills_max_fieldsKeySpecifier)[];
export type profile_by_skills_max_fieldsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_min_fieldsKeySpecifier = ('CanonEmployer' | 'CanonSkills' | 'Count' | 'Latitude' | 'Longitude' | 'Source' | profile_by_skills_min_fieldsKeySpecifier)[];
export type profile_by_skills_min_fieldsFieldPolicy = {
	CanonEmployer?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | profile_by_skills_mutation_responseKeySpecifier)[];
export type profile_by_skills_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_stddev_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_stddev_fieldsKeySpecifier)[];
export type profile_by_skills_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_stddev_pop_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_stddev_pop_fieldsKeySpecifier)[];
export type profile_by_skills_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_stddev_samp_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_stddev_samp_fieldsKeySpecifier)[];
export type profile_by_skills_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_sum_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_sum_fieldsKeySpecifier)[];
export type profile_by_skills_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_var_pop_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_var_pop_fieldsKeySpecifier)[];
export type profile_by_skills_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_var_samp_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_var_samp_fieldsKeySpecifier)[];
export type profile_by_skills_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type profile_by_skills_variance_fieldsKeySpecifier = ('Count' | 'Latitude' | 'Longitude' | profile_by_skills_variance_fieldsKeySpecifier)[];
export type profile_by_skills_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	Latitude?: FieldPolicy<any> | FieldReadFunction<any>,
	Longitude?: FieldPolicy<any> | FieldReadFunction<any>
};
export type query_rootKeySpecifier = ('areas' | 'areas_aggregate' | 'areas_by_pk' | 'authProvider' | 'authProviderRequest' | 'authProviderRequests' | 'authProviderRequestsAggregate' | 'authProviders' | 'authProvidersAggregate' | 'authRefreshToken' | 'authRefreshTokens' | 'authRefreshTokensAggregate' | 'authRole' | 'authRoles' | 'authRolesAggregate' | 'authUserProvider' | 'authUserProviders' | 'authUserProvidersAggregate' | 'authUserRole' | 'authUserRoles' | 'authUserRolesAggregate' | 'authUserSecurityKey' | 'authUserSecurityKeys' | 'authUserSecurityKeysAggregate' | 'bucket' | 'buckets' | 'bucketsAggregate' | 'careers' | 'careers_aggregate' | 'counties' | 'counties_aggregate' | 'employer_stats' | 'employer_stats_aggregate' | 'file' | 'files' | 'filesAggregate' | 'geotree' | 'geotree_aggregate' | 'geotree_by_pk' | 'global_emerging_jobs' | 'global_emerging_jobs_aggregate' | 'global_emerging_skills' | 'global_emerging_skills_aggregate' | 'global_top_10_skill_clusters' | 'global_top_10_skill_clusters_aggregate' | 'global_top_10_skill_clusters_by_pk' | 'global_top_10_skills' | 'global_top_10_skills_aggregate' | 'global_top_10_skills_by_pk' | 'job_counts_per_month_by_canoncounty' | 'job_counts_per_month_by_canoncounty_aggregate' | 'job_counts_per_month_by_global' | 'job_counts_per_month_by_global_aggregate' | 'job_counts_per_month_by_lad' | 'job_counts_per_month_by_lad_aggregate' | 'job_counts_per_month_by_nation' | 'job_counts_per_month_by_nation_aggregate' | 'job_counts_per_month_by_region' | 'job_counts_per_month_by_region_aggregate' | 'job_counts_per_year_by_canoncounty' | 'job_counts_per_year_by_canoncounty_aggregate' | 'job_counts_per_year_by_global' | 'job_counts_per_year_by_global_aggregate' | 'job_counts_per_year_by_lad' | 'job_counts_per_year_by_lad_aggregate' | 'job_counts_per_year_by_nation' | 'job_counts_per_year_by_nation_aggregate' | 'job_counts_per_year_by_region' | 'job_counts_per_year_by_region_aggregate' | 'job_proportions_per_month_by_canoncounty' | 'job_proportions_per_month_by_canoncounty_aggregate' | 'job_proportions_per_month_by_global' | 'job_proportions_per_month_by_global_aggregate' | 'job_proportions_per_month_by_lad' | 'job_proportions_per_month_by_lad_aggregate' | 'job_proportions_per_month_by_nation' | 'job_proportions_per_month_by_nation_aggregate' | 'job_proportions_per_month_by_region' | 'job_proportions_per_month_by_region_aggregate' | 'job_proportions_per_year_by_canoncounty' | 'job_proportions_per_year_by_canoncounty_aggregate' | 'job_proportions_per_year_by_global' | 'job_proportions_per_year_by_global_aggregate' | 'job_proportions_per_year_by_lad' | 'job_proportions_per_year_by_lad_aggregate' | 'job_proportions_per_year_by_nation' | 'job_proportions_per_year_by_nation_aggregate' | 'job_proportions_per_year_by_region' | 'job_proportions_per_year_by_region_aggregate' | 'lads' | 'lads_aggregate' | 'nations' | 'nations_aggregate' | 'profile_by_jobs' | 'profile_by_jobs_aggregate' | 'profile_by_skills' | 'profile_by_skills_aggregate' | 'regions' | 'regions_aggregate' | 'salary_by_canoncounty' | 'salary_by_canoncounty_aggregate' | 'salary_by_global' | 'salary_by_global_aggregate' | 'salary_by_lad' | 'salary_by_lad_aggregate' | 'salary_by_nation' | 'salary_by_nation_aggregate' | 'salary_by_region' | 'salary_by_region_aggregate' | 'skill_counts_per_month_by_canoncounty' | 'skill_counts_per_month_by_canoncounty_aggregate' | 'skill_counts_per_month_by_global' | 'skill_counts_per_month_by_global_aggregate' | 'skill_counts_per_month_by_lad' | 'skill_counts_per_month_by_lad_aggregate' | 'skill_counts_per_month_by_nation' | 'skill_counts_per_month_by_nation_aggregate' | 'skill_counts_per_month_by_region' | 'skill_counts_per_month_by_region_aggregate' | 'skill_counts_per_year_by_canoncounty' | 'skill_counts_per_year_by_canoncounty_aggregate' | 'skill_counts_per_year_by_global' | 'skill_counts_per_year_by_global_aggregate' | 'skill_counts_per_year_by_lad' | 'skill_counts_per_year_by_lad_aggregate' | 'skill_counts_per_year_by_nation' | 'skill_counts_per_year_by_nation_aggregate' | 'skill_counts_per_year_by_region' | 'skill_counts_per_year_by_region_aggregate' | 'skill_proportions_per_month_by_canoncounty' | 'skill_proportions_per_month_by_canoncounty_aggregate' | 'skill_proportions_per_month_by_global' | 'skill_proportions_per_month_by_global_aggregate' | 'skill_proportions_per_month_by_lad' | 'skill_proportions_per_month_by_lad_aggregate' | 'skill_proportions_per_month_by_nation' | 'skill_proportions_per_month_by_nation_aggregate' | 'skill_proportions_per_month_by_region' | 'skill_proportions_per_month_by_region_aggregate' | 'skill_proportions_per_year_by_canoncounty' | 'skill_proportions_per_year_by_canoncounty_aggregate' | 'skill_proportions_per_year_by_global' | 'skill_proportions_per_year_by_global_aggregate' | 'skill_proportions_per_year_by_lad' | 'skill_proportions_per_year_by_lad_aggregate' | 'skill_proportions_per_year_by_nation' | 'skill_proportions_per_year_by_nation_aggregate' | 'skill_proportions_per_year_by_region' | 'skill_proportions_per_year_by_region_aggregate' | 'terms' | 'terms_aggregate' | 'terms_by_pk' | 'user' | 'users' | 'usersAggregate' | query_rootKeySpecifier)[];
export type query_rootFieldPolicy = {
	areas?: FieldPolicy<any> | FieldReadFunction<any>,
	areas_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	areas_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	authProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequestsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	authProvidersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshTokensAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authRole?: FieldPolicy<any> | FieldReadFunction<any>,
	authRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	authRolesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProvidersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRolesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKey?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKeysAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	buckets?: FieldPolicy<any> | FieldReadFunction<any>,
	bucketsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	careers?: FieldPolicy<any> | FieldReadFunction<any>,
	careers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	counties?: FieldPolicy<any> | FieldReadFunction<any>,
	counties_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	employer_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	employer_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	filesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_jobs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	lads?: FieldPolicy<any> | FieldReadFunction<any>,
	lads_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nations?: FieldPolicy<any> | FieldReadFunction<any>,
	nations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_jobs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	regions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	terms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	terms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	usersAggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regionsKeySpecifier = ('id' | 'name' | regionsKeySpecifier)[];
export type regionsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regions_aggregateKeySpecifier = ('aggregate' | 'nodes' | regions_aggregateKeySpecifier)[];
export type regions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regions_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | regions_aggregate_fieldsKeySpecifier)[];
export type regions_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regions_max_fieldsKeySpecifier = ('id' | 'name' | regions_max_fieldsKeySpecifier)[];
export type regions_max_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regions_min_fieldsKeySpecifier = ('id' | 'name' | regions_min_fieldsKeySpecifier)[];
export type regions_min_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type regions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | regions_mutation_responseKeySpecifier)[];
export type regions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncountyKeySpecifier = ('AvgAnnualSalary' | 'CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_canoncountyKeySpecifier)[];
export type salary_by_canoncountyFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | salary_by_canoncounty_aggregateKeySpecifier)[];
export type salary_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | salary_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type salary_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_avg_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_avg_fieldsKeySpecifier)[];
export type salary_by_canoncounty_avg_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_max_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_canoncounty_max_fieldsKeySpecifier)[];
export type salary_by_canoncounty_max_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_min_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CanonCounty' | 'CleanJobTitle' | 'CountyAreaCode' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_canoncounty_min_fieldsKeySpecifier)[];
export type salary_by_canoncounty_min_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | salary_by_canoncounty_mutation_responseKeySpecifier)[];
export type salary_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_stddev_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type salary_by_canoncounty_stddev_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type salary_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type salary_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_sum_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_sum_fieldsKeySpecifier)[];
export type salary_by_canoncounty_sum_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_var_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type salary_by_canoncounty_var_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_var_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type salary_by_canoncounty_var_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_canoncounty_variance_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_canoncounty_variance_fieldsKeySpecifier)[];
export type salary_by_canoncounty_variance_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_globalKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Source' | salary_by_globalKeySpecifier)[];
export type salary_by_globalFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | salary_by_global_aggregateKeySpecifier)[];
export type salary_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | salary_by_global_aggregate_fieldsKeySpecifier)[];
export type salary_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_avg_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_avg_fieldsKeySpecifier)[];
export type salary_by_global_avg_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_max_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Source' | salary_by_global_max_fieldsKeySpecifier)[];
export type salary_by_global_max_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_min_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Source' | salary_by_global_min_fieldsKeySpecifier)[];
export type salary_by_global_min_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | salary_by_global_mutation_responseKeySpecifier)[];
export type salary_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_stddev_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_stddev_fieldsKeySpecifier)[];
export type salary_by_global_stddev_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_stddev_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_stddev_pop_fieldsKeySpecifier)[];
export type salary_by_global_stddev_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_stddev_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_stddev_samp_fieldsKeySpecifier)[];
export type salary_by_global_stddev_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_sum_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_sum_fieldsKeySpecifier)[];
export type salary_by_global_sum_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_var_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_var_pop_fieldsKeySpecifier)[];
export type salary_by_global_var_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_var_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_var_samp_fieldsKeySpecifier)[];
export type salary_by_global_var_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_global_variance_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_global_variance_fieldsKeySpecifier)[];
export type salary_by_global_variance_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_ladKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'CountyAreaCode' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_ladKeySpecifier)[];
export type salary_by_ladFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | salary_by_lad_aggregateKeySpecifier)[];
export type salary_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | salary_by_lad_aggregate_fieldsKeySpecifier)[];
export type salary_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_avg_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_avg_fieldsKeySpecifier)[];
export type salary_by_lad_avg_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_max_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'CountyAreaCode' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_lad_max_fieldsKeySpecifier)[];
export type salary_by_lad_max_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_min_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'CountyAreaCode' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | salary_by_lad_min_fieldsKeySpecifier)[];
export type salary_by_lad_min_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | salary_by_lad_mutation_responseKeySpecifier)[];
export type salary_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_stddev_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_stddev_fieldsKeySpecifier)[];
export type salary_by_lad_stddev_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_stddev_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type salary_by_lad_stddev_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_stddev_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type salary_by_lad_stddev_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_sum_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_sum_fieldsKeySpecifier)[];
export type salary_by_lad_sum_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_var_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_var_pop_fieldsKeySpecifier)[];
export type salary_by_lad_var_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_var_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_var_samp_fieldsKeySpecifier)[];
export type salary_by_lad_var_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_lad_variance_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_lad_variance_fieldsKeySpecifier)[];
export type salary_by_lad_variance_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nationKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Nation' | 'NationAreaCode' | 'Source' | salary_by_nationKeySpecifier)[];
export type salary_by_nationFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | salary_by_nation_aggregateKeySpecifier)[];
export type salary_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | salary_by_nation_aggregate_fieldsKeySpecifier)[];
export type salary_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_avg_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_avg_fieldsKeySpecifier)[];
export type salary_by_nation_avg_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_max_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Nation' | 'NationAreaCode' | 'Source' | salary_by_nation_max_fieldsKeySpecifier)[];
export type salary_by_nation_max_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_min_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'Nation' | 'NationAreaCode' | 'Source' | salary_by_nation_min_fieldsKeySpecifier)[];
export type salary_by_nation_min_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | salary_by_nation_mutation_responseKeySpecifier)[];
export type salary_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_stddev_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_stddev_fieldsKeySpecifier)[];
export type salary_by_nation_stddev_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_stddev_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type salary_by_nation_stddev_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_stddev_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type salary_by_nation_stddev_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_sum_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_sum_fieldsKeySpecifier)[];
export type salary_by_nation_sum_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_var_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_var_pop_fieldsKeySpecifier)[];
export type salary_by_nation_var_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_var_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_var_samp_fieldsKeySpecifier)[];
export type salary_by_nation_var_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_nation_variance_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_nation_variance_fieldsKeySpecifier)[];
export type salary_by_nation_variance_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_regionKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | salary_by_regionKeySpecifier)[];
export type salary_by_regionFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | salary_by_region_aggregateKeySpecifier)[];
export type salary_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | salary_by_region_aggregate_fieldsKeySpecifier)[];
export type salary_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_avg_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_avg_fieldsKeySpecifier)[];
export type salary_by_region_avg_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_max_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | salary_by_region_max_fieldsKeySpecifier)[];
export type salary_by_region_max_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_min_fieldsKeySpecifier = ('AvgAnnualSalary' | 'CleanJobTitle' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | salary_by_region_min_fieldsKeySpecifier)[];
export type salary_by_region_min_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>,
	CleanJobTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | salary_by_region_mutation_responseKeySpecifier)[];
export type salary_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_stddev_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_stddev_fieldsKeySpecifier)[];
export type salary_by_region_stddev_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_stddev_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_stddev_pop_fieldsKeySpecifier)[];
export type salary_by_region_stddev_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_stddev_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_stddev_samp_fieldsKeySpecifier)[];
export type salary_by_region_stddev_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_sum_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_sum_fieldsKeySpecifier)[];
export type salary_by_region_sum_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_var_pop_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_var_pop_fieldsKeySpecifier)[];
export type salary_by_region_var_pop_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_var_samp_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_var_samp_fieldsKeySpecifier)[];
export type salary_by_region_var_samp_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type salary_by_region_variance_fieldsKeySpecifier = ('AvgAnnualSalary' | salary_by_region_variance_fieldsKeySpecifier)[];
export type salary_by_region_variance_fieldsFieldPolicy = {
	AvgAnnualSalary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncountyKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_canoncountyKeySpecifier)[];
export type skill_counts_per_month_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_month_by_canoncounty_aggregateKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_canoncounty_max_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_canoncounty_min_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_month_by_canoncounty_mutation_responseKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_canoncounty_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_globalKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_month_by_globalKeySpecifier)[];
export type skill_counts_per_month_by_globalFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_month_by_global_aggregateKeySpecifier)[];
export type skill_counts_per_month_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_month_by_global_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_avg_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_month_by_global_max_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_month_by_global_min_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_month_by_global_mutation_responseKeySpecifier)[];
export type skill_counts_per_month_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_sum_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_global_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_global_variance_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_global_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_ladKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_ladKeySpecifier)[];
export type skill_counts_per_month_by_ladFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_month_by_lad_aggregateKeySpecifier)[];
export type skill_counts_per_month_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_month_by_lad_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_avg_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_lad_max_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_lad_min_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_month_by_lad_mutation_responseKeySpecifier)[];
export type skill_counts_per_month_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_sum_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_lad_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_lad_variance_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_lad_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nationKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_month_by_nationKeySpecifier)[];
export type skill_counts_per_month_by_nationFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_month_by_nation_aggregateKeySpecifier)[];
export type skill_counts_per_month_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_month_by_nation_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_avg_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_month_by_nation_max_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_month_by_nation_min_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_month_by_nation_mutation_responseKeySpecifier)[];
export type skill_counts_per_month_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_sum_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_nation_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_nation_variance_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_nation_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_regionKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_regionKeySpecifier)[];
export type skill_counts_per_month_by_regionFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_month_by_region_aggregateKeySpecifier)[];
export type skill_counts_per_month_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_month_by_region_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_avg_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_region_max_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_month_by_region_min_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_month_by_region_mutation_responseKeySpecifier)[];
export type skill_counts_per_month_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_sum_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_month_by_region_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_month_by_region_variance_fieldsKeySpecifier)[];
export type skill_counts_per_month_by_region_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncountyKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_canoncountyKeySpecifier)[];
export type skill_counts_per_year_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_year_by_canoncounty_aggregateKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_canoncounty_max_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_canoncounty_min_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_year_by_canoncounty_mutation_responseKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_canoncounty_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_globalKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_year_by_globalKeySpecifier)[];
export type skill_counts_per_year_by_globalFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_year_by_global_aggregateKeySpecifier)[];
export type skill_counts_per_year_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_year_by_global_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_avg_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_year_by_global_max_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Source' | skill_counts_per_year_by_global_min_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_year_by_global_mutation_responseKeySpecifier)[];
export type skill_counts_per_year_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_sum_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_global_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_global_variance_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_global_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_ladKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_ladKeySpecifier)[];
export type skill_counts_per_year_by_ladFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_year_by_lad_aggregateKeySpecifier)[];
export type skill_counts_per_year_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_year_by_lad_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_avg_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_lad_max_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_lad_min_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_year_by_lad_mutation_responseKeySpecifier)[];
export type skill_counts_per_year_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_sum_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_lad_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_lad_variance_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_lad_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nationKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_year_by_nationKeySpecifier)[];
export type skill_counts_per_year_by_nationFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_year_by_nation_aggregateKeySpecifier)[];
export type skill_counts_per_year_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_year_by_nation_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_avg_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_year_by_nation_max_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Source' | skill_counts_per_year_by_nation_min_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_year_by_nation_mutation_responseKeySpecifier)[];
export type skill_counts_per_year_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_sum_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_nation_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_nation_variance_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_nation_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_regionKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_regionKeySpecifier)[];
export type skill_counts_per_year_by_regionFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_counts_per_year_by_region_aggregateKeySpecifier)[];
export type skill_counts_per_year_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_counts_per_year_by_region_aggregate_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_avg_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_avg_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_avg_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_max_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_region_max_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_min_fieldsKeySpecifier = ('CanonSkills' | 'Count' | 'JobDate' | 'NationAreaCode' | 'Region' | 'RegionAreaCode' | 'Source' | skill_counts_per_year_by_region_min_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	Count?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_counts_per_year_by_region_mutation_responseKeySpecifier)[];
export type skill_counts_per_year_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_stddev_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_stddev_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_stddev_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_stddev_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_stddev_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_sum_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_sum_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_sum_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_var_pop_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_var_pop_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_var_pop_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_var_samp_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_var_samp_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_var_samp_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_counts_per_year_by_region_variance_fieldsKeySpecifier = ('Count' | skill_counts_per_year_by_region_variance_fieldsKeySpecifier)[];
export type skill_counts_per_year_by_region_variance_fieldsFieldPolicy = {
	Count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncountyKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_canoncountyKeySpecifier)[];
export type skill_proportions_per_month_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_month_by_canoncounty_aggregateKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_canoncounty_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_globalKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_month_by_globalKeySpecifier)[];
export type skill_proportions_per_month_by_globalFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_month_by_global_aggregateKeySpecifier)[];
export type skill_proportions_per_month_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_month_by_global_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_month_by_global_max_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_month_by_global_min_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_month_by_global_mutation_responseKeySpecifier)[];
export type skill_proportions_per_month_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_global_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_global_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_global_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_ladKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_ladKeySpecifier)[];
export type skill_proportions_per_month_by_ladFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_month_by_lad_aggregateKeySpecifier)[];
export type skill_proportions_per_month_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_max_fieldsKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_lad_max_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_min_fieldsKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_lad_min_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_month_by_lad_mutation_responseKeySpecifier)[];
export type skill_proportions_per_month_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_lad_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_lad_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_lad_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nationKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_month_by_nationKeySpecifier)[];
export type skill_proportions_per_month_by_nationFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_month_by_nation_aggregateKeySpecifier)[];
export type skill_proportions_per_month_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_month_by_nation_max_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_month_by_nation_min_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_month_by_nation_mutation_responseKeySpecifier)[];
export type skill_proportions_per_month_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_nation_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_nation_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_nation_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_regionKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_regionKeySpecifier)[];
export type skill_proportions_per_month_by_regionFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_month_by_region_aggregateKeySpecifier)[];
export type skill_proportions_per_month_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_month_by_region_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_region_max_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_month_by_region_min_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_month_by_region_mutation_responseKeySpecifier)[];
export type skill_proportions_per_month_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_month_by_region_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_month_by_region_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_month_by_region_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncountyKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_canoncountyKeySpecifier)[];
export type skill_proportions_per_year_by_canoncountyFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_year_by_canoncounty_aggregateKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_max_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier = ('CanonCounty' | 'CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_min_fieldsFieldPolicy = {
	CanonCounty?: FieldPolicy<any> | FieldReadFunction<any>,
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_canoncounty_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_globalKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_year_by_globalKeySpecifier)[];
export type skill_proportions_per_year_by_globalFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_year_by_global_aggregateKeySpecifier)[];
export type skill_proportions_per_year_by_global_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_year_by_global_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_year_by_global_max_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Proportion' | 'Source' | skill_proportions_per_year_by_global_min_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_year_by_global_mutation_responseKeySpecifier)[];
export type skill_proportions_per_year_by_global_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_global_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_global_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_global_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_ladKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_ladKeySpecifier)[];
export type skill_proportions_per_year_by_ladFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_year_by_lad_aggregateKeySpecifier)[];
export type skill_proportions_per_year_by_lad_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_max_fieldsKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_lad_max_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_min_fieldsKeySpecifier = ('CanonSkills' | 'CountyAreaCode' | 'JobDate' | 'LadAreaCode' | 'LocalAuthorityDistrict' | 'NationAreaCode' | 'Proportion' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_lad_min_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	CountyAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	LadAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	LocalAuthorityDistrict?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_year_by_lad_mutation_responseKeySpecifier)[];
export type skill_proportions_per_year_by_lad_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_lad_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_lad_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_lad_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nationKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_year_by_nationKeySpecifier)[];
export type skill_proportions_per_year_by_nationFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_year_by_nation_aggregateKeySpecifier)[];
export type skill_proportions_per_year_by_nation_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_year_by_nation_max_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'Nation' | 'NationAreaCode' | 'Proportion' | 'Source' | skill_proportions_per_year_by_nation_min_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	Nation?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_year_by_nation_mutation_responseKeySpecifier)[];
export type skill_proportions_per_year_by_nation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_nation_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_nation_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_nation_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_regionKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_regionKeySpecifier)[];
export type skill_proportions_per_year_by_regionFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_aggregateKeySpecifier = ('aggregate' | 'nodes' | skill_proportions_per_year_by_region_aggregateKeySpecifier)[];
export type skill_proportions_per_year_by_region_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | skill_proportions_per_year_by_region_aggregate_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_avg_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_avg_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_avg_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_max_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_region_max_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_max_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_min_fieldsKeySpecifier = ('CanonSkills' | 'JobDate' | 'NationAreaCode' | 'Proportion' | 'Region' | 'RegionAreaCode' | 'Source' | skill_proportions_per_year_by_region_min_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_min_fieldsFieldPolicy = {
	CanonSkills?: FieldPolicy<any> | FieldReadFunction<any>,
	JobDate?: FieldPolicy<any> | FieldReadFunction<any>,
	NationAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>,
	Region?: FieldPolicy<any> | FieldReadFunction<any>,
	RegionAreaCode?: FieldPolicy<any> | FieldReadFunction<any>,
	Source?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | skill_proportions_per_year_by_region_mutation_responseKeySpecifier)[];
export type skill_proportions_per_year_by_region_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_stddev_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_stddev_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_stddev_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_stddev_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_stddev_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_sum_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_sum_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_sum_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_var_pop_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_var_pop_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_var_pop_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_var_samp_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_var_samp_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_var_samp_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type skill_proportions_per_year_by_region_variance_fieldsKeySpecifier = ('Proportion' | skill_proportions_per_year_by_region_variance_fieldsKeySpecifier)[];
export type skill_proportions_per_year_by_region_variance_fieldsFieldPolicy = {
	Proportion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type subscription_rootKeySpecifier = ('areas' | 'areas_aggregate' | 'areas_by_pk' | 'areas_stream' | 'authProvider' | 'authProviderRequest' | 'authProviderRequests' | 'authProviderRequestsAggregate' | 'authProviderRequests_stream' | 'authProviders' | 'authProvidersAggregate' | 'authProviders_stream' | 'authRefreshToken' | 'authRefreshTokens' | 'authRefreshTokensAggregate' | 'authRefreshTokens_stream' | 'authRole' | 'authRoles' | 'authRolesAggregate' | 'authRoles_stream' | 'authUserProvider' | 'authUserProviders' | 'authUserProvidersAggregate' | 'authUserProviders_stream' | 'authUserRole' | 'authUserRoles' | 'authUserRolesAggregate' | 'authUserRoles_stream' | 'authUserSecurityKey' | 'authUserSecurityKeys' | 'authUserSecurityKeysAggregate' | 'authUserSecurityKeys_stream' | 'bucket' | 'buckets' | 'bucketsAggregate' | 'buckets_stream' | 'careers' | 'careers_aggregate' | 'careers_stream' | 'counties' | 'counties_aggregate' | 'counties_stream' | 'employer_stats' | 'employer_stats_aggregate' | 'employer_stats_stream' | 'file' | 'files' | 'filesAggregate' | 'files_stream' | 'geotree' | 'geotree_aggregate' | 'geotree_by_pk' | 'geotree_stream' | 'global_emerging_jobs' | 'global_emerging_jobs_aggregate' | 'global_emerging_jobs_stream' | 'global_emerging_skills' | 'global_emerging_skills_aggregate' | 'global_emerging_skills_stream' | 'global_top_10_skill_clusters' | 'global_top_10_skill_clusters_aggregate' | 'global_top_10_skill_clusters_by_pk' | 'global_top_10_skill_clusters_stream' | 'global_top_10_skills' | 'global_top_10_skills_aggregate' | 'global_top_10_skills_by_pk' | 'global_top_10_skills_stream' | 'job_counts_per_month_by_canoncounty' | 'job_counts_per_month_by_canoncounty_aggregate' | 'job_counts_per_month_by_canoncounty_stream' | 'job_counts_per_month_by_global' | 'job_counts_per_month_by_global_aggregate' | 'job_counts_per_month_by_global_stream' | 'job_counts_per_month_by_lad' | 'job_counts_per_month_by_lad_aggregate' | 'job_counts_per_month_by_lad_stream' | 'job_counts_per_month_by_nation' | 'job_counts_per_month_by_nation_aggregate' | 'job_counts_per_month_by_nation_stream' | 'job_counts_per_month_by_region' | 'job_counts_per_month_by_region_aggregate' | 'job_counts_per_month_by_region_stream' | 'job_counts_per_year_by_canoncounty' | 'job_counts_per_year_by_canoncounty_aggregate' | 'job_counts_per_year_by_canoncounty_stream' | 'job_counts_per_year_by_global' | 'job_counts_per_year_by_global_aggregate' | 'job_counts_per_year_by_global_stream' | 'job_counts_per_year_by_lad' | 'job_counts_per_year_by_lad_aggregate' | 'job_counts_per_year_by_lad_stream' | 'job_counts_per_year_by_nation' | 'job_counts_per_year_by_nation_aggregate' | 'job_counts_per_year_by_nation_stream' | 'job_counts_per_year_by_region' | 'job_counts_per_year_by_region_aggregate' | 'job_counts_per_year_by_region_stream' | 'job_proportions_per_month_by_canoncounty' | 'job_proportions_per_month_by_canoncounty_aggregate' | 'job_proportions_per_month_by_canoncounty_stream' | 'job_proportions_per_month_by_global' | 'job_proportions_per_month_by_global_aggregate' | 'job_proportions_per_month_by_global_stream' | 'job_proportions_per_month_by_lad' | 'job_proportions_per_month_by_lad_aggregate' | 'job_proportions_per_month_by_lad_stream' | 'job_proportions_per_month_by_nation' | 'job_proportions_per_month_by_nation_aggregate' | 'job_proportions_per_month_by_nation_stream' | 'job_proportions_per_month_by_region' | 'job_proportions_per_month_by_region_aggregate' | 'job_proportions_per_month_by_region_stream' | 'job_proportions_per_year_by_canoncounty' | 'job_proportions_per_year_by_canoncounty_aggregate' | 'job_proportions_per_year_by_canoncounty_stream' | 'job_proportions_per_year_by_global' | 'job_proportions_per_year_by_global_aggregate' | 'job_proportions_per_year_by_global_stream' | 'job_proportions_per_year_by_lad' | 'job_proportions_per_year_by_lad_aggregate' | 'job_proportions_per_year_by_lad_stream' | 'job_proportions_per_year_by_nation' | 'job_proportions_per_year_by_nation_aggregate' | 'job_proportions_per_year_by_nation_stream' | 'job_proportions_per_year_by_region' | 'job_proportions_per_year_by_region_aggregate' | 'job_proportions_per_year_by_region_stream' | 'lads' | 'lads_aggregate' | 'lads_stream' | 'nations' | 'nations_aggregate' | 'nations_stream' | 'profile_by_jobs' | 'profile_by_jobs_aggregate' | 'profile_by_jobs_stream' | 'profile_by_skills' | 'profile_by_skills_aggregate' | 'profile_by_skills_stream' | 'regions' | 'regions_aggregate' | 'regions_stream' | 'salary_by_canoncounty' | 'salary_by_canoncounty_aggregate' | 'salary_by_canoncounty_stream' | 'salary_by_global' | 'salary_by_global_aggregate' | 'salary_by_global_stream' | 'salary_by_lad' | 'salary_by_lad_aggregate' | 'salary_by_lad_stream' | 'salary_by_nation' | 'salary_by_nation_aggregate' | 'salary_by_nation_stream' | 'salary_by_region' | 'salary_by_region_aggregate' | 'salary_by_region_stream' | 'skill_counts_per_month_by_canoncounty' | 'skill_counts_per_month_by_canoncounty_aggregate' | 'skill_counts_per_month_by_canoncounty_stream' | 'skill_counts_per_month_by_global' | 'skill_counts_per_month_by_global_aggregate' | 'skill_counts_per_month_by_global_stream' | 'skill_counts_per_month_by_lad' | 'skill_counts_per_month_by_lad_aggregate' | 'skill_counts_per_month_by_lad_stream' | 'skill_counts_per_month_by_nation' | 'skill_counts_per_month_by_nation_aggregate' | 'skill_counts_per_month_by_nation_stream' | 'skill_counts_per_month_by_region' | 'skill_counts_per_month_by_region_aggregate' | 'skill_counts_per_month_by_region_stream' | 'skill_counts_per_year_by_canoncounty' | 'skill_counts_per_year_by_canoncounty_aggregate' | 'skill_counts_per_year_by_canoncounty_stream' | 'skill_counts_per_year_by_global' | 'skill_counts_per_year_by_global_aggregate' | 'skill_counts_per_year_by_global_stream' | 'skill_counts_per_year_by_lad' | 'skill_counts_per_year_by_lad_aggregate' | 'skill_counts_per_year_by_lad_stream' | 'skill_counts_per_year_by_nation' | 'skill_counts_per_year_by_nation_aggregate' | 'skill_counts_per_year_by_nation_stream' | 'skill_counts_per_year_by_region' | 'skill_counts_per_year_by_region_aggregate' | 'skill_counts_per_year_by_region_stream' | 'skill_proportions_per_month_by_canoncounty' | 'skill_proportions_per_month_by_canoncounty_aggregate' | 'skill_proportions_per_month_by_canoncounty_stream' | 'skill_proportions_per_month_by_global' | 'skill_proportions_per_month_by_global_aggregate' | 'skill_proportions_per_month_by_global_stream' | 'skill_proportions_per_month_by_lad' | 'skill_proportions_per_month_by_lad_aggregate' | 'skill_proportions_per_month_by_lad_stream' | 'skill_proportions_per_month_by_nation' | 'skill_proportions_per_month_by_nation_aggregate' | 'skill_proportions_per_month_by_nation_stream' | 'skill_proportions_per_month_by_region' | 'skill_proportions_per_month_by_region_aggregate' | 'skill_proportions_per_month_by_region_stream' | 'skill_proportions_per_year_by_canoncounty' | 'skill_proportions_per_year_by_canoncounty_aggregate' | 'skill_proportions_per_year_by_canoncounty_stream' | 'skill_proportions_per_year_by_global' | 'skill_proportions_per_year_by_global_aggregate' | 'skill_proportions_per_year_by_global_stream' | 'skill_proportions_per_year_by_lad' | 'skill_proportions_per_year_by_lad_aggregate' | 'skill_proportions_per_year_by_lad_stream' | 'skill_proportions_per_year_by_nation' | 'skill_proportions_per_year_by_nation_aggregate' | 'skill_proportions_per_year_by_nation_stream' | 'skill_proportions_per_year_by_region' | 'skill_proportions_per_year_by_region_aggregate' | 'skill_proportions_per_year_by_region_stream' | 'terms' | 'terms_aggregate' | 'terms_by_pk' | 'terms_stream' | 'user' | 'users' | 'usersAggregate' | 'users_stream' | subscription_rootKeySpecifier)[];
export type subscription_rootFieldPolicy = {
	areas?: FieldPolicy<any> | FieldReadFunction<any>,
	areas_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	areas_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	areas_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequests?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequestsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviderRequests_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	authProvidersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authProviders_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshTokensAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authRefreshTokens_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authRole?: FieldPolicy<any> | FieldReadFunction<any>,
	authRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	authRolesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authRoles_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProvidersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserProviders_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRole?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRolesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserRoles_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKey?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKeysAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	authUserSecurityKeys_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bucket?: FieldPolicy<any> | FieldReadFunction<any>,
	buckets?: FieldPolicy<any> | FieldReadFunction<any>,
	bucketsAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	buckets_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	careers?: FieldPolicy<any> | FieldReadFunction<any>,
	careers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	careers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	counties?: FieldPolicy<any> | FieldReadFunction<any>,
	counties_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	counties_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	employer_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	employer_stats_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	employer_stats_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	filesAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	files_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	geotree_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_jobs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_jobs_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_emerging_skills_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skill_clusters_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	global_top_10_skills_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_month_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_counts_per_year_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_month_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	job_proportions_per_year_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	lads?: FieldPolicy<any> | FieldReadFunction<any>,
	lads_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	lads_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	nations?: FieldPolicy<any> | FieldReadFunction<any>,
	nations_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nations_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_jobs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_jobs_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_skills?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_skills_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	profile_by_skills_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	regions?: FieldPolicy<any> | FieldReadFunction<any>,
	regions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	regions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	salary_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_month_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_counts_per_year_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_month_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_canoncounty?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_canoncounty_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_canoncounty_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_global?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_global_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_global_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_lad?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_lad_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_lad_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_nation?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_nation_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_nation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_region?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_region_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	skill_proportions_per_year_by_region_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	terms?: FieldPolicy<any> | FieldReadFunction<any>,
	terms_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	terms_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	terms_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	usersAggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	users_stream?: FieldPolicy<any> | FieldReadFunction<any>
};
export type termsKeySpecifier = ('clusters' | 'emergentjob' | 'emergentskill' | 'job' | 'skill' | 'tech' | 'term' | termsKeySpecifier)[];
export type termsFieldPolicy = {
	clusters?: FieldPolicy<any> | FieldReadFunction<any>,
	emergentjob?: FieldPolicy<any> | FieldReadFunction<any>,
	emergentskill?: FieldPolicy<any> | FieldReadFunction<any>,
	job?: FieldPolicy<any> | FieldReadFunction<any>,
	skill?: FieldPolicy<any> | FieldReadFunction<any>,
	tech?: FieldPolicy<any> | FieldReadFunction<any>,
	term?: FieldPolicy<any> | FieldReadFunction<any>
};
export type terms_aggregateKeySpecifier = ('aggregate' | 'nodes' | terms_aggregateKeySpecifier)[];
export type terms_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type terms_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | terms_aggregate_fieldsKeySpecifier)[];
export type terms_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type terms_max_fieldsKeySpecifier = ('term' | terms_max_fieldsKeySpecifier)[];
export type terms_max_fieldsFieldPolicy = {
	term?: FieldPolicy<any> | FieldReadFunction<any>
};
export type terms_min_fieldsKeySpecifier = ('term' | terms_min_fieldsKeySpecifier)[];
export type terms_min_fieldsFieldPolicy = {
	term?: FieldPolicy<any> | FieldReadFunction<any>
};
export type terms_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | terms_mutation_responseKeySpecifier)[];
export type terms_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type usersKeySpecifier = ('activated' | 'activeMfaType' | 'avatarUrl' | 'createdAt' | 'currentChallenge' | 'defaultRole' | 'defaultRoleByRole' | 'disabled' | 'displayName' | 'email' | 'emailVerified' | 'id' | 'isAnonymous' | 'lastSeen' | 'locale' | 'metadata' | 'newEmail' | 'otpHash' | 'otpHashExpiresAt' | 'otpMethodLastUsed' | 'passwordHash' | 'phoneNumber' | 'phoneNumberVerified' | 'refreshTokens' | 'refreshTokens_aggregate' | 'roles' | 'roles_aggregate' | 'securityKeys' | 'securityKeys_aggregate' | 'ticket' | 'ticketExpiresAt' | 'totpSecret' | 'updatedAt' | 'userProviders' | 'userProviders_aggregate' | usersKeySpecifier)[];
export type usersFieldPolicy = {
	activated?: FieldPolicy<any> | FieldReadFunction<any>,
	activeMfaType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentChallenge?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultRole?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultRoleByRole?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAnonymous?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSeen?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	newEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHash?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHashExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	otpMethodLastUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordHash?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumberVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokens_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	roles_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	securityKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	securityKeys_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	ticket?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	totpSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	userProviders_aggregate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_aggregateKeySpecifier = ('aggregate' | 'nodes' | users_aggregateKeySpecifier)[];
export type users_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | users_aggregate_fieldsKeySpecifier)[];
export type users_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_max_fieldsKeySpecifier = ('activeMfaType' | 'avatarUrl' | 'createdAt' | 'currentChallenge' | 'defaultRole' | 'displayName' | 'email' | 'id' | 'lastSeen' | 'locale' | 'newEmail' | 'otpHash' | 'otpHashExpiresAt' | 'otpMethodLastUsed' | 'passwordHash' | 'phoneNumber' | 'ticket' | 'ticketExpiresAt' | 'totpSecret' | 'updatedAt' | users_max_fieldsKeySpecifier)[];
export type users_max_fieldsFieldPolicy = {
	activeMfaType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentChallenge?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultRole?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSeen?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	newEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHash?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHashExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	otpMethodLastUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordHash?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ticket?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	totpSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_min_fieldsKeySpecifier = ('activeMfaType' | 'avatarUrl' | 'createdAt' | 'currentChallenge' | 'defaultRole' | 'displayName' | 'email' | 'id' | 'lastSeen' | 'locale' | 'newEmail' | 'otpHash' | 'otpHashExpiresAt' | 'otpMethodLastUsed' | 'passwordHash' | 'phoneNumber' | 'ticket' | 'ticketExpiresAt' | 'totpSecret' | 'updatedAt' | users_min_fieldsKeySpecifier)[];
export type users_min_fieldsFieldPolicy = {
	activeMfaType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	currentChallenge?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultRole?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastSeen?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	newEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHash?: FieldPolicy<any> | FieldReadFunction<any>,
	otpHashExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	otpMethodLastUsed?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordHash?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	ticket?: FieldPolicy<any> | FieldReadFunction<any>,
	ticketExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	totpSecret?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type users_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | users_mutation_responseKeySpecifier)[];
export type users_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TypedTypePolicies = TypePolicies & {
	areas?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areasKeySpecifier | (() => undefined | areasKeySpecifier),
		fields?: areasFieldPolicy,
	},
	areas_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areas_aggregateKeySpecifier | (() => undefined | areas_aggregateKeySpecifier),
		fields?: areas_aggregateFieldPolicy,
	},
	areas_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areas_aggregate_fieldsKeySpecifier | (() => undefined | areas_aggregate_fieldsKeySpecifier),
		fields?: areas_aggregate_fieldsFieldPolicy,
	},
	areas_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areas_max_fieldsKeySpecifier | (() => undefined | areas_max_fieldsKeySpecifier),
		fields?: areas_max_fieldsFieldPolicy,
	},
	areas_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areas_min_fieldsKeySpecifier | (() => undefined | areas_min_fieldsKeySpecifier),
		fields?: areas_min_fieldsFieldPolicy,
	},
	areas_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | areas_mutation_responseKeySpecifier | (() => undefined | areas_mutation_responseKeySpecifier),
		fields?: areas_mutation_responseFieldPolicy,
	},
	authProviderRequests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequestsKeySpecifier | (() => undefined | authProviderRequestsKeySpecifier),
		fields?: authProviderRequestsFieldPolicy,
	},
	authProviderRequests_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequests_aggregateKeySpecifier | (() => undefined | authProviderRequests_aggregateKeySpecifier),
		fields?: authProviderRequests_aggregateFieldPolicy,
	},
	authProviderRequests_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequests_aggregate_fieldsKeySpecifier | (() => undefined | authProviderRequests_aggregate_fieldsKeySpecifier),
		fields?: authProviderRequests_aggregate_fieldsFieldPolicy,
	},
	authProviderRequests_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequests_max_fieldsKeySpecifier | (() => undefined | authProviderRequests_max_fieldsKeySpecifier),
		fields?: authProviderRequests_max_fieldsFieldPolicy,
	},
	authProviderRequests_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequests_min_fieldsKeySpecifier | (() => undefined | authProviderRequests_min_fieldsKeySpecifier),
		fields?: authProviderRequests_min_fieldsFieldPolicy,
	},
	authProviderRequests_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviderRequests_mutation_responseKeySpecifier | (() => undefined | authProviderRequests_mutation_responseKeySpecifier),
		fields?: authProviderRequests_mutation_responseFieldPolicy,
	},
	authProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProvidersKeySpecifier | (() => undefined | authProvidersKeySpecifier),
		fields?: authProvidersFieldPolicy,
	},
	authProviders_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviders_aggregateKeySpecifier | (() => undefined | authProviders_aggregateKeySpecifier),
		fields?: authProviders_aggregateFieldPolicy,
	},
	authProviders_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviders_aggregate_fieldsKeySpecifier | (() => undefined | authProviders_aggregate_fieldsKeySpecifier),
		fields?: authProviders_aggregate_fieldsFieldPolicy,
	},
	authProviders_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviders_max_fieldsKeySpecifier | (() => undefined | authProviders_max_fieldsKeySpecifier),
		fields?: authProviders_max_fieldsFieldPolicy,
	},
	authProviders_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviders_min_fieldsKeySpecifier | (() => undefined | authProviders_min_fieldsKeySpecifier),
		fields?: authProviders_min_fieldsFieldPolicy,
	},
	authProviders_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authProviders_mutation_responseKeySpecifier | (() => undefined | authProviders_mutation_responseKeySpecifier),
		fields?: authProviders_mutation_responseFieldPolicy,
	},
	authRefreshTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokensKeySpecifier | (() => undefined | authRefreshTokensKeySpecifier),
		fields?: authRefreshTokensFieldPolicy,
	},
	authRefreshTokens_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokens_aggregateKeySpecifier | (() => undefined | authRefreshTokens_aggregateKeySpecifier),
		fields?: authRefreshTokens_aggregateFieldPolicy,
	},
	authRefreshTokens_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokens_aggregate_fieldsKeySpecifier | (() => undefined | authRefreshTokens_aggregate_fieldsKeySpecifier),
		fields?: authRefreshTokens_aggregate_fieldsFieldPolicy,
	},
	authRefreshTokens_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokens_max_fieldsKeySpecifier | (() => undefined | authRefreshTokens_max_fieldsKeySpecifier),
		fields?: authRefreshTokens_max_fieldsFieldPolicy,
	},
	authRefreshTokens_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokens_min_fieldsKeySpecifier | (() => undefined | authRefreshTokens_min_fieldsKeySpecifier),
		fields?: authRefreshTokens_min_fieldsFieldPolicy,
	},
	authRefreshTokens_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRefreshTokens_mutation_responseKeySpecifier | (() => undefined | authRefreshTokens_mutation_responseKeySpecifier),
		fields?: authRefreshTokens_mutation_responseFieldPolicy,
	},
	authRoles?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRolesKeySpecifier | (() => undefined | authRolesKeySpecifier),
		fields?: authRolesFieldPolicy,
	},
	authRoles_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRoles_aggregateKeySpecifier | (() => undefined | authRoles_aggregateKeySpecifier),
		fields?: authRoles_aggregateFieldPolicy,
	},
	authRoles_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRoles_aggregate_fieldsKeySpecifier | (() => undefined | authRoles_aggregate_fieldsKeySpecifier),
		fields?: authRoles_aggregate_fieldsFieldPolicy,
	},
	authRoles_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRoles_max_fieldsKeySpecifier | (() => undefined | authRoles_max_fieldsKeySpecifier),
		fields?: authRoles_max_fieldsFieldPolicy,
	},
	authRoles_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRoles_min_fieldsKeySpecifier | (() => undefined | authRoles_min_fieldsKeySpecifier),
		fields?: authRoles_min_fieldsFieldPolicy,
	},
	authRoles_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authRoles_mutation_responseKeySpecifier | (() => undefined | authRoles_mutation_responseKeySpecifier),
		fields?: authRoles_mutation_responseFieldPolicy,
	},
	authUserProviders?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProvidersKeySpecifier | (() => undefined | authUserProvidersKeySpecifier),
		fields?: authUserProvidersFieldPolicy,
	},
	authUserProviders_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProviders_aggregateKeySpecifier | (() => undefined | authUserProviders_aggregateKeySpecifier),
		fields?: authUserProviders_aggregateFieldPolicy,
	},
	authUserProviders_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProviders_aggregate_fieldsKeySpecifier | (() => undefined | authUserProviders_aggregate_fieldsKeySpecifier),
		fields?: authUserProviders_aggregate_fieldsFieldPolicy,
	},
	authUserProviders_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProviders_max_fieldsKeySpecifier | (() => undefined | authUserProviders_max_fieldsKeySpecifier),
		fields?: authUserProviders_max_fieldsFieldPolicy,
	},
	authUserProviders_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProviders_min_fieldsKeySpecifier | (() => undefined | authUserProviders_min_fieldsKeySpecifier),
		fields?: authUserProviders_min_fieldsFieldPolicy,
	},
	authUserProviders_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserProviders_mutation_responseKeySpecifier | (() => undefined | authUserProviders_mutation_responseKeySpecifier),
		fields?: authUserProviders_mutation_responseFieldPolicy,
	},
	authUserRoles?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRolesKeySpecifier | (() => undefined | authUserRolesKeySpecifier),
		fields?: authUserRolesFieldPolicy,
	},
	authUserRoles_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRoles_aggregateKeySpecifier | (() => undefined | authUserRoles_aggregateKeySpecifier),
		fields?: authUserRoles_aggregateFieldPolicy,
	},
	authUserRoles_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRoles_aggregate_fieldsKeySpecifier | (() => undefined | authUserRoles_aggregate_fieldsKeySpecifier),
		fields?: authUserRoles_aggregate_fieldsFieldPolicy,
	},
	authUserRoles_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRoles_max_fieldsKeySpecifier | (() => undefined | authUserRoles_max_fieldsKeySpecifier),
		fields?: authUserRoles_max_fieldsFieldPolicy,
	},
	authUserRoles_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRoles_min_fieldsKeySpecifier | (() => undefined | authUserRoles_min_fieldsKeySpecifier),
		fields?: authUserRoles_min_fieldsFieldPolicy,
	},
	authUserRoles_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserRoles_mutation_responseKeySpecifier | (() => undefined | authUserRoles_mutation_responseKeySpecifier),
		fields?: authUserRoles_mutation_responseFieldPolicy,
	},
	authUserSecurityKeys?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeysKeySpecifier | (() => undefined | authUserSecurityKeysKeySpecifier),
		fields?: authUserSecurityKeysFieldPolicy,
	},
	authUserSecurityKeys_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_aggregateKeySpecifier | (() => undefined | authUserSecurityKeys_aggregateKeySpecifier),
		fields?: authUserSecurityKeys_aggregateFieldPolicy,
	},
	authUserSecurityKeys_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_aggregate_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_aggregate_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_aggregate_fieldsFieldPolicy,
	},
	authUserSecurityKeys_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_avg_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_avg_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_avg_fieldsFieldPolicy,
	},
	authUserSecurityKeys_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_max_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_max_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_max_fieldsFieldPolicy,
	},
	authUserSecurityKeys_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_min_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_min_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_min_fieldsFieldPolicy,
	},
	authUserSecurityKeys_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_mutation_responseKeySpecifier | (() => undefined | authUserSecurityKeys_mutation_responseKeySpecifier),
		fields?: authUserSecurityKeys_mutation_responseFieldPolicy,
	},
	authUserSecurityKeys_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_stddev_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_stddev_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_stddev_fieldsFieldPolicy,
	},
	authUserSecurityKeys_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_stddev_pop_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_stddev_pop_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_stddev_pop_fieldsFieldPolicy,
	},
	authUserSecurityKeys_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_stddev_samp_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_stddev_samp_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_stddev_samp_fieldsFieldPolicy,
	},
	authUserSecurityKeys_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_sum_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_sum_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_sum_fieldsFieldPolicy,
	},
	authUserSecurityKeys_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_var_pop_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_var_pop_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_var_pop_fieldsFieldPolicy,
	},
	authUserSecurityKeys_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_var_samp_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_var_samp_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_var_samp_fieldsFieldPolicy,
	},
	authUserSecurityKeys_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | authUserSecurityKeys_variance_fieldsKeySpecifier | (() => undefined | authUserSecurityKeys_variance_fieldsKeySpecifier),
		fields?: authUserSecurityKeys_variance_fieldsFieldPolicy,
	},
	buckets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bucketsKeySpecifier | (() => undefined | bucketsKeySpecifier),
		fields?: bucketsFieldPolicy,
	},
	buckets_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_aggregateKeySpecifier | (() => undefined | buckets_aggregateKeySpecifier),
		fields?: buckets_aggregateFieldPolicy,
	},
	buckets_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_aggregate_fieldsKeySpecifier | (() => undefined | buckets_aggregate_fieldsKeySpecifier),
		fields?: buckets_aggregate_fieldsFieldPolicy,
	},
	buckets_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_avg_fieldsKeySpecifier | (() => undefined | buckets_avg_fieldsKeySpecifier),
		fields?: buckets_avg_fieldsFieldPolicy,
	},
	buckets_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_max_fieldsKeySpecifier | (() => undefined | buckets_max_fieldsKeySpecifier),
		fields?: buckets_max_fieldsFieldPolicy,
	},
	buckets_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_min_fieldsKeySpecifier | (() => undefined | buckets_min_fieldsKeySpecifier),
		fields?: buckets_min_fieldsFieldPolicy,
	},
	buckets_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_mutation_responseKeySpecifier | (() => undefined | buckets_mutation_responseKeySpecifier),
		fields?: buckets_mutation_responseFieldPolicy,
	},
	buckets_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_stddev_fieldsKeySpecifier | (() => undefined | buckets_stddev_fieldsKeySpecifier),
		fields?: buckets_stddev_fieldsFieldPolicy,
	},
	buckets_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_stddev_pop_fieldsKeySpecifier | (() => undefined | buckets_stddev_pop_fieldsKeySpecifier),
		fields?: buckets_stddev_pop_fieldsFieldPolicy,
	},
	buckets_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_stddev_samp_fieldsKeySpecifier | (() => undefined | buckets_stddev_samp_fieldsKeySpecifier),
		fields?: buckets_stddev_samp_fieldsFieldPolicy,
	},
	buckets_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_sum_fieldsKeySpecifier | (() => undefined | buckets_sum_fieldsKeySpecifier),
		fields?: buckets_sum_fieldsFieldPolicy,
	},
	buckets_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_var_pop_fieldsKeySpecifier | (() => undefined | buckets_var_pop_fieldsKeySpecifier),
		fields?: buckets_var_pop_fieldsFieldPolicy,
	},
	buckets_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_var_samp_fieldsKeySpecifier | (() => undefined | buckets_var_samp_fieldsKeySpecifier),
		fields?: buckets_var_samp_fieldsFieldPolicy,
	},
	buckets_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buckets_variance_fieldsKeySpecifier | (() => undefined | buckets_variance_fieldsKeySpecifier),
		fields?: buckets_variance_fieldsFieldPolicy,
	},
	careers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careersKeySpecifier | (() => undefined | careersKeySpecifier),
		fields?: careersFieldPolicy,
	},
	careers_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_aggregateKeySpecifier | (() => undefined | careers_aggregateKeySpecifier),
		fields?: careers_aggregateFieldPolicy,
	},
	careers_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_aggregate_fieldsKeySpecifier | (() => undefined | careers_aggregate_fieldsKeySpecifier),
		fields?: careers_aggregate_fieldsFieldPolicy,
	},
	careers_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_avg_fieldsKeySpecifier | (() => undefined | careers_avg_fieldsKeySpecifier),
		fields?: careers_avg_fieldsFieldPolicy,
	},
	careers_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_max_fieldsKeySpecifier | (() => undefined | careers_max_fieldsKeySpecifier),
		fields?: careers_max_fieldsFieldPolicy,
	},
	careers_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_min_fieldsKeySpecifier | (() => undefined | careers_min_fieldsKeySpecifier),
		fields?: careers_min_fieldsFieldPolicy,
	},
	careers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_mutation_responseKeySpecifier | (() => undefined | careers_mutation_responseKeySpecifier),
		fields?: careers_mutation_responseFieldPolicy,
	},
	careers_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_stddev_fieldsKeySpecifier | (() => undefined | careers_stddev_fieldsKeySpecifier),
		fields?: careers_stddev_fieldsFieldPolicy,
	},
	careers_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_stddev_pop_fieldsKeySpecifier | (() => undefined | careers_stddev_pop_fieldsKeySpecifier),
		fields?: careers_stddev_pop_fieldsFieldPolicy,
	},
	careers_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_stddev_samp_fieldsKeySpecifier | (() => undefined | careers_stddev_samp_fieldsKeySpecifier),
		fields?: careers_stddev_samp_fieldsFieldPolicy,
	},
	careers_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_sum_fieldsKeySpecifier | (() => undefined | careers_sum_fieldsKeySpecifier),
		fields?: careers_sum_fieldsFieldPolicy,
	},
	careers_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_var_pop_fieldsKeySpecifier | (() => undefined | careers_var_pop_fieldsKeySpecifier),
		fields?: careers_var_pop_fieldsFieldPolicy,
	},
	careers_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_var_samp_fieldsKeySpecifier | (() => undefined | careers_var_samp_fieldsKeySpecifier),
		fields?: careers_var_samp_fieldsFieldPolicy,
	},
	careers_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | careers_variance_fieldsKeySpecifier | (() => undefined | careers_variance_fieldsKeySpecifier),
		fields?: careers_variance_fieldsFieldPolicy,
	},
	counties?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countiesKeySpecifier | (() => undefined | countiesKeySpecifier),
		fields?: countiesFieldPolicy,
	},
	counties_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | counties_aggregateKeySpecifier | (() => undefined | counties_aggregateKeySpecifier),
		fields?: counties_aggregateFieldPolicy,
	},
	counties_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | counties_aggregate_fieldsKeySpecifier | (() => undefined | counties_aggregate_fieldsKeySpecifier),
		fields?: counties_aggregate_fieldsFieldPolicy,
	},
	counties_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | counties_max_fieldsKeySpecifier | (() => undefined | counties_max_fieldsKeySpecifier),
		fields?: counties_max_fieldsFieldPolicy,
	},
	counties_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | counties_min_fieldsKeySpecifier | (() => undefined | counties_min_fieldsKeySpecifier),
		fields?: counties_min_fieldsFieldPolicy,
	},
	counties_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | counties_mutation_responseKeySpecifier | (() => undefined | counties_mutation_responseKeySpecifier),
		fields?: counties_mutation_responseFieldPolicy,
	},
	employer_stats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_statsKeySpecifier | (() => undefined | employer_statsKeySpecifier),
		fields?: employer_statsFieldPolicy,
	},
	employer_stats_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_aggregateKeySpecifier | (() => undefined | employer_stats_aggregateKeySpecifier),
		fields?: employer_stats_aggregateFieldPolicy,
	},
	employer_stats_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_aggregate_fieldsKeySpecifier | (() => undefined | employer_stats_aggregate_fieldsKeySpecifier),
		fields?: employer_stats_aggregate_fieldsFieldPolicy,
	},
	employer_stats_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_avg_fieldsKeySpecifier | (() => undefined | employer_stats_avg_fieldsKeySpecifier),
		fields?: employer_stats_avg_fieldsFieldPolicy,
	},
	employer_stats_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_max_fieldsKeySpecifier | (() => undefined | employer_stats_max_fieldsKeySpecifier),
		fields?: employer_stats_max_fieldsFieldPolicy,
	},
	employer_stats_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_min_fieldsKeySpecifier | (() => undefined | employer_stats_min_fieldsKeySpecifier),
		fields?: employer_stats_min_fieldsFieldPolicy,
	},
	employer_stats_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_mutation_responseKeySpecifier | (() => undefined | employer_stats_mutation_responseKeySpecifier),
		fields?: employer_stats_mutation_responseFieldPolicy,
	},
	employer_stats_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_stddev_fieldsKeySpecifier | (() => undefined | employer_stats_stddev_fieldsKeySpecifier),
		fields?: employer_stats_stddev_fieldsFieldPolicy,
	},
	employer_stats_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_stddev_pop_fieldsKeySpecifier | (() => undefined | employer_stats_stddev_pop_fieldsKeySpecifier),
		fields?: employer_stats_stddev_pop_fieldsFieldPolicy,
	},
	employer_stats_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_stddev_samp_fieldsKeySpecifier | (() => undefined | employer_stats_stddev_samp_fieldsKeySpecifier),
		fields?: employer_stats_stddev_samp_fieldsFieldPolicy,
	},
	employer_stats_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_sum_fieldsKeySpecifier | (() => undefined | employer_stats_sum_fieldsKeySpecifier),
		fields?: employer_stats_sum_fieldsFieldPolicy,
	},
	employer_stats_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_var_pop_fieldsKeySpecifier | (() => undefined | employer_stats_var_pop_fieldsKeySpecifier),
		fields?: employer_stats_var_pop_fieldsFieldPolicy,
	},
	employer_stats_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_var_samp_fieldsKeySpecifier | (() => undefined | employer_stats_var_samp_fieldsKeySpecifier),
		fields?: employer_stats_var_samp_fieldsFieldPolicy,
	},
	employer_stats_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | employer_stats_variance_fieldsKeySpecifier | (() => undefined | employer_stats_variance_fieldsKeySpecifier),
		fields?: employer_stats_variance_fieldsFieldPolicy,
	},
	files?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | filesKeySpecifier | (() => undefined | filesKeySpecifier),
		fields?: filesFieldPolicy,
	},
	files_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_aggregateKeySpecifier | (() => undefined | files_aggregateKeySpecifier),
		fields?: files_aggregateFieldPolicy,
	},
	files_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_aggregate_fieldsKeySpecifier | (() => undefined | files_aggregate_fieldsKeySpecifier),
		fields?: files_aggregate_fieldsFieldPolicy,
	},
	files_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_avg_fieldsKeySpecifier | (() => undefined | files_avg_fieldsKeySpecifier),
		fields?: files_avg_fieldsFieldPolicy,
	},
	files_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_max_fieldsKeySpecifier | (() => undefined | files_max_fieldsKeySpecifier),
		fields?: files_max_fieldsFieldPolicy,
	},
	files_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_min_fieldsKeySpecifier | (() => undefined | files_min_fieldsKeySpecifier),
		fields?: files_min_fieldsFieldPolicy,
	},
	files_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_mutation_responseKeySpecifier | (() => undefined | files_mutation_responseKeySpecifier),
		fields?: files_mutation_responseFieldPolicy,
	},
	files_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_stddev_fieldsKeySpecifier | (() => undefined | files_stddev_fieldsKeySpecifier),
		fields?: files_stddev_fieldsFieldPolicy,
	},
	files_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_stddev_pop_fieldsKeySpecifier | (() => undefined | files_stddev_pop_fieldsKeySpecifier),
		fields?: files_stddev_pop_fieldsFieldPolicy,
	},
	files_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_stddev_samp_fieldsKeySpecifier | (() => undefined | files_stddev_samp_fieldsKeySpecifier),
		fields?: files_stddev_samp_fieldsFieldPolicy,
	},
	files_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_sum_fieldsKeySpecifier | (() => undefined | files_sum_fieldsKeySpecifier),
		fields?: files_sum_fieldsFieldPolicy,
	},
	files_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_var_pop_fieldsKeySpecifier | (() => undefined | files_var_pop_fieldsKeySpecifier),
		fields?: files_var_pop_fieldsFieldPolicy,
	},
	files_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_var_samp_fieldsKeySpecifier | (() => undefined | files_var_samp_fieldsKeySpecifier),
		fields?: files_var_samp_fieldsFieldPolicy,
	},
	files_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | files_variance_fieldsKeySpecifier | (() => undefined | files_variance_fieldsKeySpecifier),
		fields?: files_variance_fieldsFieldPolicy,
	},
	geotree?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotreeKeySpecifier | (() => undefined | geotreeKeySpecifier),
		fields?: geotreeFieldPolicy,
	},
	geotree_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotree_aggregateKeySpecifier | (() => undefined | geotree_aggregateKeySpecifier),
		fields?: geotree_aggregateFieldPolicy,
	},
	geotree_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotree_aggregate_fieldsKeySpecifier | (() => undefined | geotree_aggregate_fieldsKeySpecifier),
		fields?: geotree_aggregate_fieldsFieldPolicy,
	},
	geotree_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotree_max_fieldsKeySpecifier | (() => undefined | geotree_max_fieldsKeySpecifier),
		fields?: geotree_max_fieldsFieldPolicy,
	},
	geotree_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotree_min_fieldsKeySpecifier | (() => undefined | geotree_min_fieldsKeySpecifier),
		fields?: geotree_min_fieldsFieldPolicy,
	},
	geotree_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | geotree_mutation_responseKeySpecifier | (() => undefined | geotree_mutation_responseKeySpecifier),
		fields?: geotree_mutation_responseFieldPolicy,
	},
	global_emerging_jobs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobsKeySpecifier | (() => undefined | global_emerging_jobsKeySpecifier),
		fields?: global_emerging_jobsFieldPolicy,
	},
	global_emerging_jobs_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_aggregateKeySpecifier | (() => undefined | global_emerging_jobs_aggregateKeySpecifier),
		fields?: global_emerging_jobs_aggregateFieldPolicy,
	},
	global_emerging_jobs_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_aggregate_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_aggregate_fieldsKeySpecifier),
		fields?: global_emerging_jobs_aggregate_fieldsFieldPolicy,
	},
	global_emerging_jobs_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_avg_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_avg_fieldsKeySpecifier),
		fields?: global_emerging_jobs_avg_fieldsFieldPolicy,
	},
	global_emerging_jobs_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_max_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_max_fieldsKeySpecifier),
		fields?: global_emerging_jobs_max_fieldsFieldPolicy,
	},
	global_emerging_jobs_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_min_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_min_fieldsKeySpecifier),
		fields?: global_emerging_jobs_min_fieldsFieldPolicy,
	},
	global_emerging_jobs_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_mutation_responseKeySpecifier | (() => undefined | global_emerging_jobs_mutation_responseKeySpecifier),
		fields?: global_emerging_jobs_mutation_responseFieldPolicy,
	},
	global_emerging_jobs_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_stddev_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_stddev_fieldsKeySpecifier),
		fields?: global_emerging_jobs_stddev_fieldsFieldPolicy,
	},
	global_emerging_jobs_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_stddev_pop_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_stddev_pop_fieldsKeySpecifier),
		fields?: global_emerging_jobs_stddev_pop_fieldsFieldPolicy,
	},
	global_emerging_jobs_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_stddev_samp_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_stddev_samp_fieldsKeySpecifier),
		fields?: global_emerging_jobs_stddev_samp_fieldsFieldPolicy,
	},
	global_emerging_jobs_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_sum_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_sum_fieldsKeySpecifier),
		fields?: global_emerging_jobs_sum_fieldsFieldPolicy,
	},
	global_emerging_jobs_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_var_pop_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_var_pop_fieldsKeySpecifier),
		fields?: global_emerging_jobs_var_pop_fieldsFieldPolicy,
	},
	global_emerging_jobs_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_var_samp_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_var_samp_fieldsKeySpecifier),
		fields?: global_emerging_jobs_var_samp_fieldsFieldPolicy,
	},
	global_emerging_jobs_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_jobs_variance_fieldsKeySpecifier | (() => undefined | global_emerging_jobs_variance_fieldsKeySpecifier),
		fields?: global_emerging_jobs_variance_fieldsFieldPolicy,
	},
	global_emerging_skills?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skillsKeySpecifier | (() => undefined | global_emerging_skillsKeySpecifier),
		fields?: global_emerging_skillsFieldPolicy,
	},
	global_emerging_skills_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_aggregateKeySpecifier | (() => undefined | global_emerging_skills_aggregateKeySpecifier),
		fields?: global_emerging_skills_aggregateFieldPolicy,
	},
	global_emerging_skills_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_aggregate_fieldsKeySpecifier | (() => undefined | global_emerging_skills_aggregate_fieldsKeySpecifier),
		fields?: global_emerging_skills_aggregate_fieldsFieldPolicy,
	},
	global_emerging_skills_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_avg_fieldsKeySpecifier | (() => undefined | global_emerging_skills_avg_fieldsKeySpecifier),
		fields?: global_emerging_skills_avg_fieldsFieldPolicy,
	},
	global_emerging_skills_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_max_fieldsKeySpecifier | (() => undefined | global_emerging_skills_max_fieldsKeySpecifier),
		fields?: global_emerging_skills_max_fieldsFieldPolicy,
	},
	global_emerging_skills_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_min_fieldsKeySpecifier | (() => undefined | global_emerging_skills_min_fieldsKeySpecifier),
		fields?: global_emerging_skills_min_fieldsFieldPolicy,
	},
	global_emerging_skills_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_mutation_responseKeySpecifier | (() => undefined | global_emerging_skills_mutation_responseKeySpecifier),
		fields?: global_emerging_skills_mutation_responseFieldPolicy,
	},
	global_emerging_skills_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_stddev_fieldsKeySpecifier | (() => undefined | global_emerging_skills_stddev_fieldsKeySpecifier),
		fields?: global_emerging_skills_stddev_fieldsFieldPolicy,
	},
	global_emerging_skills_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_stddev_pop_fieldsKeySpecifier | (() => undefined | global_emerging_skills_stddev_pop_fieldsKeySpecifier),
		fields?: global_emerging_skills_stddev_pop_fieldsFieldPolicy,
	},
	global_emerging_skills_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_stddev_samp_fieldsKeySpecifier | (() => undefined | global_emerging_skills_stddev_samp_fieldsKeySpecifier),
		fields?: global_emerging_skills_stddev_samp_fieldsFieldPolicy,
	},
	global_emerging_skills_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_sum_fieldsKeySpecifier | (() => undefined | global_emerging_skills_sum_fieldsKeySpecifier),
		fields?: global_emerging_skills_sum_fieldsFieldPolicy,
	},
	global_emerging_skills_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_var_pop_fieldsKeySpecifier | (() => undefined | global_emerging_skills_var_pop_fieldsKeySpecifier),
		fields?: global_emerging_skills_var_pop_fieldsFieldPolicy,
	},
	global_emerging_skills_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_var_samp_fieldsKeySpecifier | (() => undefined | global_emerging_skills_var_samp_fieldsKeySpecifier),
		fields?: global_emerging_skills_var_samp_fieldsFieldPolicy,
	},
	global_emerging_skills_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_emerging_skills_variance_fieldsKeySpecifier | (() => undefined | global_emerging_skills_variance_fieldsKeySpecifier),
		fields?: global_emerging_skills_variance_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clustersKeySpecifier | (() => undefined | global_top_10_skill_clustersKeySpecifier),
		fields?: global_top_10_skill_clustersFieldPolicy,
	},
	global_top_10_skill_clusters_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_aggregateKeySpecifier | (() => undefined | global_top_10_skill_clusters_aggregateKeySpecifier),
		fields?: global_top_10_skill_clusters_aggregateFieldPolicy,
	},
	global_top_10_skill_clusters_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_aggregate_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_aggregate_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_aggregate_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_avg_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_avg_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_avg_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_max_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_max_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_max_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_min_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_min_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_min_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_mutation_responseKeySpecifier | (() => undefined | global_top_10_skill_clusters_mutation_responseKeySpecifier),
		fields?: global_top_10_skill_clusters_mutation_responseFieldPolicy,
	},
	global_top_10_skill_clusters_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_stddev_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_stddev_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_stddev_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_stddev_pop_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_stddev_pop_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_stddev_pop_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_stddev_samp_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_stddev_samp_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_stddev_samp_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_sum_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_sum_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_sum_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_var_pop_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_var_pop_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_var_pop_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_var_samp_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_var_samp_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_var_samp_fieldsFieldPolicy,
	},
	global_top_10_skill_clusters_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skill_clusters_variance_fieldsKeySpecifier | (() => undefined | global_top_10_skill_clusters_variance_fieldsKeySpecifier),
		fields?: global_top_10_skill_clusters_variance_fieldsFieldPolicy,
	},
	global_top_10_skills?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skillsKeySpecifier | (() => undefined | global_top_10_skillsKeySpecifier),
		fields?: global_top_10_skillsFieldPolicy,
	},
	global_top_10_skills_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_aggregateKeySpecifier | (() => undefined | global_top_10_skills_aggregateKeySpecifier),
		fields?: global_top_10_skills_aggregateFieldPolicy,
	},
	global_top_10_skills_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_aggregate_fieldsKeySpecifier | (() => undefined | global_top_10_skills_aggregate_fieldsKeySpecifier),
		fields?: global_top_10_skills_aggregate_fieldsFieldPolicy,
	},
	global_top_10_skills_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_avg_fieldsKeySpecifier | (() => undefined | global_top_10_skills_avg_fieldsKeySpecifier),
		fields?: global_top_10_skills_avg_fieldsFieldPolicy,
	},
	global_top_10_skills_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_max_fieldsKeySpecifier | (() => undefined | global_top_10_skills_max_fieldsKeySpecifier),
		fields?: global_top_10_skills_max_fieldsFieldPolicy,
	},
	global_top_10_skills_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_min_fieldsKeySpecifier | (() => undefined | global_top_10_skills_min_fieldsKeySpecifier),
		fields?: global_top_10_skills_min_fieldsFieldPolicy,
	},
	global_top_10_skills_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_mutation_responseKeySpecifier | (() => undefined | global_top_10_skills_mutation_responseKeySpecifier),
		fields?: global_top_10_skills_mutation_responseFieldPolicy,
	},
	global_top_10_skills_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_stddev_fieldsKeySpecifier | (() => undefined | global_top_10_skills_stddev_fieldsKeySpecifier),
		fields?: global_top_10_skills_stddev_fieldsFieldPolicy,
	},
	global_top_10_skills_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_stddev_pop_fieldsKeySpecifier | (() => undefined | global_top_10_skills_stddev_pop_fieldsKeySpecifier),
		fields?: global_top_10_skills_stddev_pop_fieldsFieldPolicy,
	},
	global_top_10_skills_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_stddev_samp_fieldsKeySpecifier | (() => undefined | global_top_10_skills_stddev_samp_fieldsKeySpecifier),
		fields?: global_top_10_skills_stddev_samp_fieldsFieldPolicy,
	},
	global_top_10_skills_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_sum_fieldsKeySpecifier | (() => undefined | global_top_10_skills_sum_fieldsKeySpecifier),
		fields?: global_top_10_skills_sum_fieldsFieldPolicy,
	},
	global_top_10_skills_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_var_pop_fieldsKeySpecifier | (() => undefined | global_top_10_skills_var_pop_fieldsKeySpecifier),
		fields?: global_top_10_skills_var_pop_fieldsFieldPolicy,
	},
	global_top_10_skills_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_var_samp_fieldsKeySpecifier | (() => undefined | global_top_10_skills_var_samp_fieldsKeySpecifier),
		fields?: global_top_10_skills_var_samp_fieldsFieldPolicy,
	},
	global_top_10_skills_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | global_top_10_skills_variance_fieldsKeySpecifier | (() => undefined | global_top_10_skills_variance_fieldsKeySpecifier),
		fields?: global_top_10_skills_variance_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncountyKeySpecifier | (() => undefined | job_counts_per_month_by_canoncountyKeySpecifier),
		fields?: job_counts_per_month_by_canoncountyFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_aggregateKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_aggregateKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_aggregateFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_avg_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_max_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_max_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_min_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_min_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_mutation_responseKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_mutation_responseFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_sum_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_canoncounty_variance_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_globalKeySpecifier | (() => undefined | job_counts_per_month_by_globalKeySpecifier),
		fields?: job_counts_per_month_by_globalFieldPolicy,
	},
	job_counts_per_month_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_aggregateKeySpecifier | (() => undefined | job_counts_per_month_by_global_aggregateKeySpecifier),
		fields?: job_counts_per_month_by_global_aggregateFieldPolicy,
	},
	job_counts_per_month_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_avg_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_avg_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_max_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_max_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_max_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_min_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_min_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_min_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_mutation_responseKeySpecifier | (() => undefined | job_counts_per_month_by_global_mutation_responseKeySpecifier),
		fields?: job_counts_per_month_by_global_mutation_responseFieldPolicy,
	},
	job_counts_per_month_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_stddev_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_sum_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_sum_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_global_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_global_variance_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_global_variance_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_ladKeySpecifier | (() => undefined | job_counts_per_month_by_ladKeySpecifier),
		fields?: job_counts_per_month_by_ladFieldPolicy,
	},
	job_counts_per_month_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_aggregateKeySpecifier | (() => undefined | job_counts_per_month_by_lad_aggregateKeySpecifier),
		fields?: job_counts_per_month_by_lad_aggregateFieldPolicy,
	},
	job_counts_per_month_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_avg_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_avg_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_max_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_max_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_max_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_min_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_min_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_min_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_mutation_responseKeySpecifier | (() => undefined | job_counts_per_month_by_lad_mutation_responseKeySpecifier),
		fields?: job_counts_per_month_by_lad_mutation_responseFieldPolicy,
	},
	job_counts_per_month_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_stddev_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_sum_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_sum_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_lad_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_lad_variance_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_lad_variance_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nationKeySpecifier | (() => undefined | job_counts_per_month_by_nationKeySpecifier),
		fields?: job_counts_per_month_by_nationFieldPolicy,
	},
	job_counts_per_month_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_aggregateKeySpecifier | (() => undefined | job_counts_per_month_by_nation_aggregateKeySpecifier),
		fields?: job_counts_per_month_by_nation_aggregateFieldPolicy,
	},
	job_counts_per_month_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_avg_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_avg_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_max_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_max_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_max_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_min_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_min_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_min_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_mutation_responseKeySpecifier | (() => undefined | job_counts_per_month_by_nation_mutation_responseKeySpecifier),
		fields?: job_counts_per_month_by_nation_mutation_responseFieldPolicy,
	},
	job_counts_per_month_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_stddev_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_sum_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_sum_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_nation_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_nation_variance_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_nation_variance_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_regionKeySpecifier | (() => undefined | job_counts_per_month_by_regionKeySpecifier),
		fields?: job_counts_per_month_by_regionFieldPolicy,
	},
	job_counts_per_month_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_aggregateKeySpecifier | (() => undefined | job_counts_per_month_by_region_aggregateKeySpecifier),
		fields?: job_counts_per_month_by_region_aggregateFieldPolicy,
	},
	job_counts_per_month_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_avg_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_avg_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_max_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_max_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_max_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_min_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_min_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_min_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_mutation_responseKeySpecifier | (() => undefined | job_counts_per_month_by_region_mutation_responseKeySpecifier),
		fields?: job_counts_per_month_by_region_mutation_responseFieldPolicy,
	},
	job_counts_per_month_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_stddev_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_sum_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_sum_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_month_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_month_by_region_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_month_by_region_variance_fieldsKeySpecifier),
		fields?: job_counts_per_month_by_region_variance_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncountyKeySpecifier | (() => undefined | job_counts_per_year_by_canoncountyKeySpecifier),
		fields?: job_counts_per_year_by_canoncountyFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_aggregateKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_aggregateKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_aggregateFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_avg_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_max_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_max_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_min_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_min_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_mutation_responseKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_mutation_responseFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_sum_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_canoncounty_variance_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_globalKeySpecifier | (() => undefined | job_counts_per_year_by_globalKeySpecifier),
		fields?: job_counts_per_year_by_globalFieldPolicy,
	},
	job_counts_per_year_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_aggregateKeySpecifier | (() => undefined | job_counts_per_year_by_global_aggregateKeySpecifier),
		fields?: job_counts_per_year_by_global_aggregateFieldPolicy,
	},
	job_counts_per_year_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_avg_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_avg_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_max_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_max_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_max_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_min_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_min_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_min_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_mutation_responseKeySpecifier | (() => undefined | job_counts_per_year_by_global_mutation_responseKeySpecifier),
		fields?: job_counts_per_year_by_global_mutation_responseFieldPolicy,
	},
	job_counts_per_year_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_stddev_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_sum_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_sum_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_global_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_global_variance_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_global_variance_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_ladKeySpecifier | (() => undefined | job_counts_per_year_by_ladKeySpecifier),
		fields?: job_counts_per_year_by_ladFieldPolicy,
	},
	job_counts_per_year_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_aggregateKeySpecifier | (() => undefined | job_counts_per_year_by_lad_aggregateKeySpecifier),
		fields?: job_counts_per_year_by_lad_aggregateFieldPolicy,
	},
	job_counts_per_year_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_avg_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_avg_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_max_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_max_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_max_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_min_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_min_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_min_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_mutation_responseKeySpecifier | (() => undefined | job_counts_per_year_by_lad_mutation_responseKeySpecifier),
		fields?: job_counts_per_year_by_lad_mutation_responseFieldPolicy,
	},
	job_counts_per_year_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_stddev_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_sum_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_sum_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_lad_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_lad_variance_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_lad_variance_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nationKeySpecifier | (() => undefined | job_counts_per_year_by_nationKeySpecifier),
		fields?: job_counts_per_year_by_nationFieldPolicy,
	},
	job_counts_per_year_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_aggregateKeySpecifier | (() => undefined | job_counts_per_year_by_nation_aggregateKeySpecifier),
		fields?: job_counts_per_year_by_nation_aggregateFieldPolicy,
	},
	job_counts_per_year_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_avg_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_avg_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_max_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_max_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_max_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_min_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_min_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_min_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_mutation_responseKeySpecifier | (() => undefined | job_counts_per_year_by_nation_mutation_responseKeySpecifier),
		fields?: job_counts_per_year_by_nation_mutation_responseFieldPolicy,
	},
	job_counts_per_year_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_stddev_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_sum_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_sum_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_nation_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_nation_variance_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_nation_variance_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_regionKeySpecifier | (() => undefined | job_counts_per_year_by_regionKeySpecifier),
		fields?: job_counts_per_year_by_regionFieldPolicy,
	},
	job_counts_per_year_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_aggregateKeySpecifier | (() => undefined | job_counts_per_year_by_region_aggregateKeySpecifier),
		fields?: job_counts_per_year_by_region_aggregateFieldPolicy,
	},
	job_counts_per_year_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_aggregate_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_aggregate_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_aggregate_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_avg_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_avg_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_avg_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_max_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_max_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_max_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_min_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_min_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_min_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_mutation_responseKeySpecifier | (() => undefined | job_counts_per_year_by_region_mutation_responseKeySpecifier),
		fields?: job_counts_per_year_by_region_mutation_responseFieldPolicy,
	},
	job_counts_per_year_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_stddev_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_stddev_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_stddev_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_stddev_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_stddev_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_sum_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_sum_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_sum_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_var_pop_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_var_pop_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_var_pop_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_var_samp_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_var_samp_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_var_samp_fieldsFieldPolicy,
	},
	job_counts_per_year_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_counts_per_year_by_region_variance_fieldsKeySpecifier | (() => undefined | job_counts_per_year_by_region_variance_fieldsKeySpecifier),
		fields?: job_counts_per_year_by_region_variance_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncountyKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncountyKeySpecifier),
		fields?: job_proportions_per_month_by_canoncountyFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_aggregateKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_aggregateKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_aggregateFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_avg_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_max_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_min_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_mutation_responseFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_sum_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_canoncounty_variance_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_globalKeySpecifier | (() => undefined | job_proportions_per_month_by_globalKeySpecifier),
		fields?: job_proportions_per_month_by_globalFieldPolicy,
	},
	job_proportions_per_month_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_aggregateKeySpecifier | (() => undefined | job_proportions_per_month_by_global_aggregateKeySpecifier),
		fields?: job_proportions_per_month_by_global_aggregateFieldPolicy,
	},
	job_proportions_per_month_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_avg_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_max_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_max_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_min_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_min_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_month_by_global_mutation_responseKeySpecifier),
		fields?: job_proportions_per_month_by_global_mutation_responseFieldPolicy,
	},
	job_proportions_per_month_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_sum_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_global_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_global_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_global_variance_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_ladKeySpecifier | (() => undefined | job_proportions_per_month_by_ladKeySpecifier),
		fields?: job_proportions_per_month_by_ladFieldPolicy,
	},
	job_proportions_per_month_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_aggregateKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_aggregateKeySpecifier),
		fields?: job_proportions_per_month_by_lad_aggregateFieldPolicy,
	},
	job_proportions_per_month_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_avg_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_max_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_max_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_min_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_min_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_mutation_responseKeySpecifier),
		fields?: job_proportions_per_month_by_lad_mutation_responseFieldPolicy,
	},
	job_proportions_per_month_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_sum_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_lad_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_lad_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_lad_variance_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nationKeySpecifier | (() => undefined | job_proportions_per_month_by_nationKeySpecifier),
		fields?: job_proportions_per_month_by_nationFieldPolicy,
	},
	job_proportions_per_month_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_aggregateKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_aggregateKeySpecifier),
		fields?: job_proportions_per_month_by_nation_aggregateFieldPolicy,
	},
	job_proportions_per_month_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_avg_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_max_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_max_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_min_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_min_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_mutation_responseKeySpecifier),
		fields?: job_proportions_per_month_by_nation_mutation_responseFieldPolicy,
	},
	job_proportions_per_month_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_sum_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_nation_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_nation_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_nation_variance_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_regionKeySpecifier | (() => undefined | job_proportions_per_month_by_regionKeySpecifier),
		fields?: job_proportions_per_month_by_regionFieldPolicy,
	},
	job_proportions_per_month_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_aggregateKeySpecifier | (() => undefined | job_proportions_per_month_by_region_aggregateKeySpecifier),
		fields?: job_proportions_per_month_by_region_aggregateFieldPolicy,
	},
	job_proportions_per_month_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_avg_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_max_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_max_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_min_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_min_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_month_by_region_mutation_responseKeySpecifier),
		fields?: job_proportions_per_month_by_region_mutation_responseFieldPolicy,
	},
	job_proportions_per_month_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_sum_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_month_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_month_by_region_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_month_by_region_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_month_by_region_variance_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncountyKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncountyKeySpecifier),
		fields?: job_proportions_per_year_by_canoncountyFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_aggregateKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_aggregateKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_aggregateFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_avg_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_max_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_min_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_mutation_responseFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_sum_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_canoncounty_variance_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_globalKeySpecifier | (() => undefined | job_proportions_per_year_by_globalKeySpecifier),
		fields?: job_proportions_per_year_by_globalFieldPolicy,
	},
	job_proportions_per_year_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_aggregateKeySpecifier | (() => undefined | job_proportions_per_year_by_global_aggregateKeySpecifier),
		fields?: job_proportions_per_year_by_global_aggregateFieldPolicy,
	},
	job_proportions_per_year_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_avg_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_max_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_max_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_min_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_min_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_year_by_global_mutation_responseKeySpecifier),
		fields?: job_proportions_per_year_by_global_mutation_responseFieldPolicy,
	},
	job_proportions_per_year_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_sum_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_global_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_global_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_global_variance_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_ladKeySpecifier | (() => undefined | job_proportions_per_year_by_ladKeySpecifier),
		fields?: job_proportions_per_year_by_ladFieldPolicy,
	},
	job_proportions_per_year_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_aggregateKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_aggregateKeySpecifier),
		fields?: job_proportions_per_year_by_lad_aggregateFieldPolicy,
	},
	job_proportions_per_year_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_avg_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_max_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_max_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_min_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_min_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_mutation_responseKeySpecifier),
		fields?: job_proportions_per_year_by_lad_mutation_responseFieldPolicy,
	},
	job_proportions_per_year_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_sum_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_lad_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_lad_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_lad_variance_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nationKeySpecifier | (() => undefined | job_proportions_per_year_by_nationKeySpecifier),
		fields?: job_proportions_per_year_by_nationFieldPolicy,
	},
	job_proportions_per_year_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_aggregateKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_aggregateKeySpecifier),
		fields?: job_proportions_per_year_by_nation_aggregateFieldPolicy,
	},
	job_proportions_per_year_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_avg_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_max_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_max_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_min_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_min_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_mutation_responseKeySpecifier),
		fields?: job_proportions_per_year_by_nation_mutation_responseFieldPolicy,
	},
	job_proportions_per_year_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_sum_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_nation_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_nation_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_nation_variance_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_regionKeySpecifier | (() => undefined | job_proportions_per_year_by_regionKeySpecifier),
		fields?: job_proportions_per_year_by_regionFieldPolicy,
	},
	job_proportions_per_year_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_aggregateKeySpecifier | (() => undefined | job_proportions_per_year_by_region_aggregateKeySpecifier),
		fields?: job_proportions_per_year_by_region_aggregateFieldPolicy,
	},
	job_proportions_per_year_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_aggregate_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_aggregate_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_aggregate_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_avg_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_avg_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_avg_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_max_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_max_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_max_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_min_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_min_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_min_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_mutation_responseKeySpecifier | (() => undefined | job_proportions_per_year_by_region_mutation_responseKeySpecifier),
		fields?: job_proportions_per_year_by_region_mutation_responseFieldPolicy,
	},
	job_proportions_per_year_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_stddev_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_stddev_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_stddev_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_stddev_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_stddev_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_sum_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_sum_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_sum_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_var_pop_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_var_pop_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_var_pop_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_var_samp_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_var_samp_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_var_samp_fieldsFieldPolicy,
	},
	job_proportions_per_year_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | job_proportions_per_year_by_region_variance_fieldsKeySpecifier | (() => undefined | job_proportions_per_year_by_region_variance_fieldsKeySpecifier),
		fields?: job_proportions_per_year_by_region_variance_fieldsFieldPolicy,
	},
	lads?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ladsKeySpecifier | (() => undefined | ladsKeySpecifier),
		fields?: ladsFieldPolicy,
	},
	lads_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | lads_aggregateKeySpecifier | (() => undefined | lads_aggregateKeySpecifier),
		fields?: lads_aggregateFieldPolicy,
	},
	lads_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | lads_aggregate_fieldsKeySpecifier | (() => undefined | lads_aggregate_fieldsKeySpecifier),
		fields?: lads_aggregate_fieldsFieldPolicy,
	},
	lads_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | lads_max_fieldsKeySpecifier | (() => undefined | lads_max_fieldsKeySpecifier),
		fields?: lads_max_fieldsFieldPolicy,
	},
	lads_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | lads_min_fieldsKeySpecifier | (() => undefined | lads_min_fieldsKeySpecifier),
		fields?: lads_min_fieldsFieldPolicy,
	},
	lads_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | lads_mutation_responseKeySpecifier | (() => undefined | lads_mutation_responseKeySpecifier),
		fields?: lads_mutation_responseFieldPolicy,
	},
	mutation_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | mutation_rootKeySpecifier | (() => undefined | mutation_rootKeySpecifier),
		fields?: mutation_rootFieldPolicy,
	},
	nations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nationsKeySpecifier | (() => undefined | nationsKeySpecifier),
		fields?: nationsFieldPolicy,
	},
	nations_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nations_aggregateKeySpecifier | (() => undefined | nations_aggregateKeySpecifier),
		fields?: nations_aggregateFieldPolicy,
	},
	nations_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nations_aggregate_fieldsKeySpecifier | (() => undefined | nations_aggregate_fieldsKeySpecifier),
		fields?: nations_aggregate_fieldsFieldPolicy,
	},
	nations_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nations_max_fieldsKeySpecifier | (() => undefined | nations_max_fieldsKeySpecifier),
		fields?: nations_max_fieldsFieldPolicy,
	},
	nations_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nations_min_fieldsKeySpecifier | (() => undefined | nations_min_fieldsKeySpecifier),
		fields?: nations_min_fieldsFieldPolicy,
	},
	nations_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | nations_mutation_responseKeySpecifier | (() => undefined | nations_mutation_responseKeySpecifier),
		fields?: nations_mutation_responseFieldPolicy,
	},
	profile_by_jobs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobsKeySpecifier | (() => undefined | profile_by_jobsKeySpecifier),
		fields?: profile_by_jobsFieldPolicy,
	},
	profile_by_jobs_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_aggregateKeySpecifier | (() => undefined | profile_by_jobs_aggregateKeySpecifier),
		fields?: profile_by_jobs_aggregateFieldPolicy,
	},
	profile_by_jobs_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_aggregate_fieldsKeySpecifier | (() => undefined | profile_by_jobs_aggregate_fieldsKeySpecifier),
		fields?: profile_by_jobs_aggregate_fieldsFieldPolicy,
	},
	profile_by_jobs_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_avg_fieldsKeySpecifier | (() => undefined | profile_by_jobs_avg_fieldsKeySpecifier),
		fields?: profile_by_jobs_avg_fieldsFieldPolicy,
	},
	profile_by_jobs_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_max_fieldsKeySpecifier | (() => undefined | profile_by_jobs_max_fieldsKeySpecifier),
		fields?: profile_by_jobs_max_fieldsFieldPolicy,
	},
	profile_by_jobs_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_min_fieldsKeySpecifier | (() => undefined | profile_by_jobs_min_fieldsKeySpecifier),
		fields?: profile_by_jobs_min_fieldsFieldPolicy,
	},
	profile_by_jobs_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_mutation_responseKeySpecifier | (() => undefined | profile_by_jobs_mutation_responseKeySpecifier),
		fields?: profile_by_jobs_mutation_responseFieldPolicy,
	},
	profile_by_jobs_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_stddev_fieldsKeySpecifier | (() => undefined | profile_by_jobs_stddev_fieldsKeySpecifier),
		fields?: profile_by_jobs_stddev_fieldsFieldPolicy,
	},
	profile_by_jobs_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_stddev_pop_fieldsKeySpecifier | (() => undefined | profile_by_jobs_stddev_pop_fieldsKeySpecifier),
		fields?: profile_by_jobs_stddev_pop_fieldsFieldPolicy,
	},
	profile_by_jobs_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_stddev_samp_fieldsKeySpecifier | (() => undefined | profile_by_jobs_stddev_samp_fieldsKeySpecifier),
		fields?: profile_by_jobs_stddev_samp_fieldsFieldPolicy,
	},
	profile_by_jobs_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_sum_fieldsKeySpecifier | (() => undefined | profile_by_jobs_sum_fieldsKeySpecifier),
		fields?: profile_by_jobs_sum_fieldsFieldPolicy,
	},
	profile_by_jobs_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_var_pop_fieldsKeySpecifier | (() => undefined | profile_by_jobs_var_pop_fieldsKeySpecifier),
		fields?: profile_by_jobs_var_pop_fieldsFieldPolicy,
	},
	profile_by_jobs_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_var_samp_fieldsKeySpecifier | (() => undefined | profile_by_jobs_var_samp_fieldsKeySpecifier),
		fields?: profile_by_jobs_var_samp_fieldsFieldPolicy,
	},
	profile_by_jobs_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_jobs_variance_fieldsKeySpecifier | (() => undefined | profile_by_jobs_variance_fieldsKeySpecifier),
		fields?: profile_by_jobs_variance_fieldsFieldPolicy,
	},
	profile_by_skills?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skillsKeySpecifier | (() => undefined | profile_by_skillsKeySpecifier),
		fields?: profile_by_skillsFieldPolicy,
	},
	profile_by_skills_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_aggregateKeySpecifier | (() => undefined | profile_by_skills_aggregateKeySpecifier),
		fields?: profile_by_skills_aggregateFieldPolicy,
	},
	profile_by_skills_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_aggregate_fieldsKeySpecifier | (() => undefined | profile_by_skills_aggregate_fieldsKeySpecifier),
		fields?: profile_by_skills_aggregate_fieldsFieldPolicy,
	},
	profile_by_skills_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_avg_fieldsKeySpecifier | (() => undefined | profile_by_skills_avg_fieldsKeySpecifier),
		fields?: profile_by_skills_avg_fieldsFieldPolicy,
	},
	profile_by_skills_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_max_fieldsKeySpecifier | (() => undefined | profile_by_skills_max_fieldsKeySpecifier),
		fields?: profile_by_skills_max_fieldsFieldPolicy,
	},
	profile_by_skills_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_min_fieldsKeySpecifier | (() => undefined | profile_by_skills_min_fieldsKeySpecifier),
		fields?: profile_by_skills_min_fieldsFieldPolicy,
	},
	profile_by_skills_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_mutation_responseKeySpecifier | (() => undefined | profile_by_skills_mutation_responseKeySpecifier),
		fields?: profile_by_skills_mutation_responseFieldPolicy,
	},
	profile_by_skills_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_stddev_fieldsKeySpecifier | (() => undefined | profile_by_skills_stddev_fieldsKeySpecifier),
		fields?: profile_by_skills_stddev_fieldsFieldPolicy,
	},
	profile_by_skills_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_stddev_pop_fieldsKeySpecifier | (() => undefined | profile_by_skills_stddev_pop_fieldsKeySpecifier),
		fields?: profile_by_skills_stddev_pop_fieldsFieldPolicy,
	},
	profile_by_skills_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_stddev_samp_fieldsKeySpecifier | (() => undefined | profile_by_skills_stddev_samp_fieldsKeySpecifier),
		fields?: profile_by_skills_stddev_samp_fieldsFieldPolicy,
	},
	profile_by_skills_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_sum_fieldsKeySpecifier | (() => undefined | profile_by_skills_sum_fieldsKeySpecifier),
		fields?: profile_by_skills_sum_fieldsFieldPolicy,
	},
	profile_by_skills_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_var_pop_fieldsKeySpecifier | (() => undefined | profile_by_skills_var_pop_fieldsKeySpecifier),
		fields?: profile_by_skills_var_pop_fieldsFieldPolicy,
	},
	profile_by_skills_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_var_samp_fieldsKeySpecifier | (() => undefined | profile_by_skills_var_samp_fieldsKeySpecifier),
		fields?: profile_by_skills_var_samp_fieldsFieldPolicy,
	},
	profile_by_skills_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | profile_by_skills_variance_fieldsKeySpecifier | (() => undefined | profile_by_skills_variance_fieldsKeySpecifier),
		fields?: profile_by_skills_variance_fieldsFieldPolicy,
	},
	query_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | query_rootKeySpecifier | (() => undefined | query_rootKeySpecifier),
		fields?: query_rootFieldPolicy,
	},
	regions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regionsKeySpecifier | (() => undefined | regionsKeySpecifier),
		fields?: regionsFieldPolicy,
	},
	regions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regions_aggregateKeySpecifier | (() => undefined | regions_aggregateKeySpecifier),
		fields?: regions_aggregateFieldPolicy,
	},
	regions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regions_aggregate_fieldsKeySpecifier | (() => undefined | regions_aggregate_fieldsKeySpecifier),
		fields?: regions_aggregate_fieldsFieldPolicy,
	},
	regions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regions_max_fieldsKeySpecifier | (() => undefined | regions_max_fieldsKeySpecifier),
		fields?: regions_max_fieldsFieldPolicy,
	},
	regions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regions_min_fieldsKeySpecifier | (() => undefined | regions_min_fieldsKeySpecifier),
		fields?: regions_min_fieldsFieldPolicy,
	},
	regions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | regions_mutation_responseKeySpecifier | (() => undefined | regions_mutation_responseKeySpecifier),
		fields?: regions_mutation_responseFieldPolicy,
	},
	salary_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncountyKeySpecifier | (() => undefined | salary_by_canoncountyKeySpecifier),
		fields?: salary_by_canoncountyFieldPolicy,
	},
	salary_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_aggregateKeySpecifier | (() => undefined | salary_by_canoncounty_aggregateKeySpecifier),
		fields?: salary_by_canoncounty_aggregateFieldPolicy,
	},
	salary_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	salary_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_avg_fieldsFieldPolicy,
	},
	salary_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_max_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_max_fieldsFieldPolicy,
	},
	salary_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_min_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_min_fieldsFieldPolicy,
	},
	salary_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | salary_by_canoncounty_mutation_responseKeySpecifier),
		fields?: salary_by_canoncounty_mutation_responseFieldPolicy,
	},
	salary_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	salary_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	salary_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	salary_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_sum_fieldsFieldPolicy,
	},
	salary_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	salary_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	salary_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | salary_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: salary_by_canoncounty_variance_fieldsFieldPolicy,
	},
	salary_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_globalKeySpecifier | (() => undefined | salary_by_globalKeySpecifier),
		fields?: salary_by_globalFieldPolicy,
	},
	salary_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_aggregateKeySpecifier | (() => undefined | salary_by_global_aggregateKeySpecifier),
		fields?: salary_by_global_aggregateFieldPolicy,
	},
	salary_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_aggregate_fieldsKeySpecifier | (() => undefined | salary_by_global_aggregate_fieldsKeySpecifier),
		fields?: salary_by_global_aggregate_fieldsFieldPolicy,
	},
	salary_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_avg_fieldsKeySpecifier | (() => undefined | salary_by_global_avg_fieldsKeySpecifier),
		fields?: salary_by_global_avg_fieldsFieldPolicy,
	},
	salary_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_max_fieldsKeySpecifier | (() => undefined | salary_by_global_max_fieldsKeySpecifier),
		fields?: salary_by_global_max_fieldsFieldPolicy,
	},
	salary_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_min_fieldsKeySpecifier | (() => undefined | salary_by_global_min_fieldsKeySpecifier),
		fields?: salary_by_global_min_fieldsFieldPolicy,
	},
	salary_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_mutation_responseKeySpecifier | (() => undefined | salary_by_global_mutation_responseKeySpecifier),
		fields?: salary_by_global_mutation_responseFieldPolicy,
	},
	salary_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_stddev_fieldsKeySpecifier | (() => undefined | salary_by_global_stddev_fieldsKeySpecifier),
		fields?: salary_by_global_stddev_fieldsFieldPolicy,
	},
	salary_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | salary_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: salary_by_global_stddev_pop_fieldsFieldPolicy,
	},
	salary_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | salary_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: salary_by_global_stddev_samp_fieldsFieldPolicy,
	},
	salary_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_sum_fieldsKeySpecifier | (() => undefined | salary_by_global_sum_fieldsKeySpecifier),
		fields?: salary_by_global_sum_fieldsFieldPolicy,
	},
	salary_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_var_pop_fieldsKeySpecifier | (() => undefined | salary_by_global_var_pop_fieldsKeySpecifier),
		fields?: salary_by_global_var_pop_fieldsFieldPolicy,
	},
	salary_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_var_samp_fieldsKeySpecifier | (() => undefined | salary_by_global_var_samp_fieldsKeySpecifier),
		fields?: salary_by_global_var_samp_fieldsFieldPolicy,
	},
	salary_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_global_variance_fieldsKeySpecifier | (() => undefined | salary_by_global_variance_fieldsKeySpecifier),
		fields?: salary_by_global_variance_fieldsFieldPolicy,
	},
	salary_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_ladKeySpecifier | (() => undefined | salary_by_ladKeySpecifier),
		fields?: salary_by_ladFieldPolicy,
	},
	salary_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_aggregateKeySpecifier | (() => undefined | salary_by_lad_aggregateKeySpecifier),
		fields?: salary_by_lad_aggregateFieldPolicy,
	},
	salary_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | salary_by_lad_aggregate_fieldsKeySpecifier),
		fields?: salary_by_lad_aggregate_fieldsFieldPolicy,
	},
	salary_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_avg_fieldsKeySpecifier | (() => undefined | salary_by_lad_avg_fieldsKeySpecifier),
		fields?: salary_by_lad_avg_fieldsFieldPolicy,
	},
	salary_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_max_fieldsKeySpecifier | (() => undefined | salary_by_lad_max_fieldsKeySpecifier),
		fields?: salary_by_lad_max_fieldsFieldPolicy,
	},
	salary_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_min_fieldsKeySpecifier | (() => undefined | salary_by_lad_min_fieldsKeySpecifier),
		fields?: salary_by_lad_min_fieldsFieldPolicy,
	},
	salary_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_mutation_responseKeySpecifier | (() => undefined | salary_by_lad_mutation_responseKeySpecifier),
		fields?: salary_by_lad_mutation_responseFieldPolicy,
	},
	salary_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_stddev_fieldsKeySpecifier | (() => undefined | salary_by_lad_stddev_fieldsKeySpecifier),
		fields?: salary_by_lad_stddev_fieldsFieldPolicy,
	},
	salary_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | salary_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: salary_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	salary_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | salary_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: salary_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	salary_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_sum_fieldsKeySpecifier | (() => undefined | salary_by_lad_sum_fieldsKeySpecifier),
		fields?: salary_by_lad_sum_fieldsFieldPolicy,
	},
	salary_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | salary_by_lad_var_pop_fieldsKeySpecifier),
		fields?: salary_by_lad_var_pop_fieldsFieldPolicy,
	},
	salary_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | salary_by_lad_var_samp_fieldsKeySpecifier),
		fields?: salary_by_lad_var_samp_fieldsFieldPolicy,
	},
	salary_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_lad_variance_fieldsKeySpecifier | (() => undefined | salary_by_lad_variance_fieldsKeySpecifier),
		fields?: salary_by_lad_variance_fieldsFieldPolicy,
	},
	salary_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nationKeySpecifier | (() => undefined | salary_by_nationKeySpecifier),
		fields?: salary_by_nationFieldPolicy,
	},
	salary_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_aggregateKeySpecifier | (() => undefined | salary_by_nation_aggregateKeySpecifier),
		fields?: salary_by_nation_aggregateFieldPolicy,
	},
	salary_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | salary_by_nation_aggregate_fieldsKeySpecifier),
		fields?: salary_by_nation_aggregate_fieldsFieldPolicy,
	},
	salary_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_avg_fieldsKeySpecifier | (() => undefined | salary_by_nation_avg_fieldsKeySpecifier),
		fields?: salary_by_nation_avg_fieldsFieldPolicy,
	},
	salary_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_max_fieldsKeySpecifier | (() => undefined | salary_by_nation_max_fieldsKeySpecifier),
		fields?: salary_by_nation_max_fieldsFieldPolicy,
	},
	salary_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_min_fieldsKeySpecifier | (() => undefined | salary_by_nation_min_fieldsKeySpecifier),
		fields?: salary_by_nation_min_fieldsFieldPolicy,
	},
	salary_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_mutation_responseKeySpecifier | (() => undefined | salary_by_nation_mutation_responseKeySpecifier),
		fields?: salary_by_nation_mutation_responseFieldPolicy,
	},
	salary_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_stddev_fieldsKeySpecifier | (() => undefined | salary_by_nation_stddev_fieldsKeySpecifier),
		fields?: salary_by_nation_stddev_fieldsFieldPolicy,
	},
	salary_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | salary_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: salary_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	salary_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | salary_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: salary_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	salary_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_sum_fieldsKeySpecifier | (() => undefined | salary_by_nation_sum_fieldsKeySpecifier),
		fields?: salary_by_nation_sum_fieldsFieldPolicy,
	},
	salary_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | salary_by_nation_var_pop_fieldsKeySpecifier),
		fields?: salary_by_nation_var_pop_fieldsFieldPolicy,
	},
	salary_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | salary_by_nation_var_samp_fieldsKeySpecifier),
		fields?: salary_by_nation_var_samp_fieldsFieldPolicy,
	},
	salary_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_nation_variance_fieldsKeySpecifier | (() => undefined | salary_by_nation_variance_fieldsKeySpecifier),
		fields?: salary_by_nation_variance_fieldsFieldPolicy,
	},
	salary_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_regionKeySpecifier | (() => undefined | salary_by_regionKeySpecifier),
		fields?: salary_by_regionFieldPolicy,
	},
	salary_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_aggregateKeySpecifier | (() => undefined | salary_by_region_aggregateKeySpecifier),
		fields?: salary_by_region_aggregateFieldPolicy,
	},
	salary_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_aggregate_fieldsKeySpecifier | (() => undefined | salary_by_region_aggregate_fieldsKeySpecifier),
		fields?: salary_by_region_aggregate_fieldsFieldPolicy,
	},
	salary_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_avg_fieldsKeySpecifier | (() => undefined | salary_by_region_avg_fieldsKeySpecifier),
		fields?: salary_by_region_avg_fieldsFieldPolicy,
	},
	salary_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_max_fieldsKeySpecifier | (() => undefined | salary_by_region_max_fieldsKeySpecifier),
		fields?: salary_by_region_max_fieldsFieldPolicy,
	},
	salary_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_min_fieldsKeySpecifier | (() => undefined | salary_by_region_min_fieldsKeySpecifier),
		fields?: salary_by_region_min_fieldsFieldPolicy,
	},
	salary_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_mutation_responseKeySpecifier | (() => undefined | salary_by_region_mutation_responseKeySpecifier),
		fields?: salary_by_region_mutation_responseFieldPolicy,
	},
	salary_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_stddev_fieldsKeySpecifier | (() => undefined | salary_by_region_stddev_fieldsKeySpecifier),
		fields?: salary_by_region_stddev_fieldsFieldPolicy,
	},
	salary_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | salary_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: salary_by_region_stddev_pop_fieldsFieldPolicy,
	},
	salary_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | salary_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: salary_by_region_stddev_samp_fieldsFieldPolicy,
	},
	salary_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_sum_fieldsKeySpecifier | (() => undefined | salary_by_region_sum_fieldsKeySpecifier),
		fields?: salary_by_region_sum_fieldsFieldPolicy,
	},
	salary_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_var_pop_fieldsKeySpecifier | (() => undefined | salary_by_region_var_pop_fieldsKeySpecifier),
		fields?: salary_by_region_var_pop_fieldsFieldPolicy,
	},
	salary_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_var_samp_fieldsKeySpecifier | (() => undefined | salary_by_region_var_samp_fieldsKeySpecifier),
		fields?: salary_by_region_var_samp_fieldsFieldPolicy,
	},
	salary_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | salary_by_region_variance_fieldsKeySpecifier | (() => undefined | salary_by_region_variance_fieldsKeySpecifier),
		fields?: salary_by_region_variance_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncountyKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncountyKeySpecifier),
		fields?: skill_counts_per_month_by_canoncountyFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_aggregateKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_aggregateKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_aggregateFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_avg_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_max_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_max_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_min_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_min_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_mutation_responseKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_mutation_responseFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_sum_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_canoncounty_variance_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_globalKeySpecifier | (() => undefined | skill_counts_per_month_by_globalKeySpecifier),
		fields?: skill_counts_per_month_by_globalFieldPolicy,
	},
	skill_counts_per_month_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_aggregateKeySpecifier | (() => undefined | skill_counts_per_month_by_global_aggregateKeySpecifier),
		fields?: skill_counts_per_month_by_global_aggregateFieldPolicy,
	},
	skill_counts_per_month_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_avg_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_max_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_max_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_min_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_min_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_month_by_global_mutation_responseKeySpecifier),
		fields?: skill_counts_per_month_by_global_mutation_responseFieldPolicy,
	},
	skill_counts_per_month_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_sum_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_global_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_global_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_global_variance_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_ladKeySpecifier | (() => undefined | skill_counts_per_month_by_ladKeySpecifier),
		fields?: skill_counts_per_month_by_ladFieldPolicy,
	},
	skill_counts_per_month_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_aggregateKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_aggregateKeySpecifier),
		fields?: skill_counts_per_month_by_lad_aggregateFieldPolicy,
	},
	skill_counts_per_month_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_avg_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_max_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_max_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_min_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_min_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_mutation_responseKeySpecifier),
		fields?: skill_counts_per_month_by_lad_mutation_responseFieldPolicy,
	},
	skill_counts_per_month_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_sum_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_lad_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_lad_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_lad_variance_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nationKeySpecifier | (() => undefined | skill_counts_per_month_by_nationKeySpecifier),
		fields?: skill_counts_per_month_by_nationFieldPolicy,
	},
	skill_counts_per_month_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_aggregateKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_aggregateKeySpecifier),
		fields?: skill_counts_per_month_by_nation_aggregateFieldPolicy,
	},
	skill_counts_per_month_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_avg_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_max_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_max_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_min_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_min_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_mutation_responseKeySpecifier),
		fields?: skill_counts_per_month_by_nation_mutation_responseFieldPolicy,
	},
	skill_counts_per_month_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_sum_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_nation_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_nation_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_nation_variance_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_regionKeySpecifier | (() => undefined | skill_counts_per_month_by_regionKeySpecifier),
		fields?: skill_counts_per_month_by_regionFieldPolicy,
	},
	skill_counts_per_month_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_aggregateKeySpecifier | (() => undefined | skill_counts_per_month_by_region_aggregateKeySpecifier),
		fields?: skill_counts_per_month_by_region_aggregateFieldPolicy,
	},
	skill_counts_per_month_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_avg_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_max_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_max_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_min_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_min_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_month_by_region_mutation_responseKeySpecifier),
		fields?: skill_counts_per_month_by_region_mutation_responseFieldPolicy,
	},
	skill_counts_per_month_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_sum_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_month_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_month_by_region_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_month_by_region_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_month_by_region_variance_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncountyKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncountyKeySpecifier),
		fields?: skill_counts_per_year_by_canoncountyFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_aggregateKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_aggregateKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_aggregateFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_avg_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_max_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_max_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_min_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_min_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_mutation_responseKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_mutation_responseFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_sum_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_canoncounty_variance_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_globalKeySpecifier | (() => undefined | skill_counts_per_year_by_globalKeySpecifier),
		fields?: skill_counts_per_year_by_globalFieldPolicy,
	},
	skill_counts_per_year_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_aggregateKeySpecifier | (() => undefined | skill_counts_per_year_by_global_aggregateKeySpecifier),
		fields?: skill_counts_per_year_by_global_aggregateFieldPolicy,
	},
	skill_counts_per_year_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_avg_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_max_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_max_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_min_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_min_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_year_by_global_mutation_responseKeySpecifier),
		fields?: skill_counts_per_year_by_global_mutation_responseFieldPolicy,
	},
	skill_counts_per_year_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_sum_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_global_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_global_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_global_variance_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_ladKeySpecifier | (() => undefined | skill_counts_per_year_by_ladKeySpecifier),
		fields?: skill_counts_per_year_by_ladFieldPolicy,
	},
	skill_counts_per_year_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_aggregateKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_aggregateKeySpecifier),
		fields?: skill_counts_per_year_by_lad_aggregateFieldPolicy,
	},
	skill_counts_per_year_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_avg_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_max_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_max_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_min_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_min_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_mutation_responseKeySpecifier),
		fields?: skill_counts_per_year_by_lad_mutation_responseFieldPolicy,
	},
	skill_counts_per_year_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_sum_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_lad_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_lad_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_lad_variance_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nationKeySpecifier | (() => undefined | skill_counts_per_year_by_nationKeySpecifier),
		fields?: skill_counts_per_year_by_nationFieldPolicy,
	},
	skill_counts_per_year_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_aggregateKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_aggregateKeySpecifier),
		fields?: skill_counts_per_year_by_nation_aggregateFieldPolicy,
	},
	skill_counts_per_year_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_avg_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_max_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_max_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_min_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_min_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_mutation_responseKeySpecifier),
		fields?: skill_counts_per_year_by_nation_mutation_responseFieldPolicy,
	},
	skill_counts_per_year_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_sum_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_nation_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_nation_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_nation_variance_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_regionKeySpecifier | (() => undefined | skill_counts_per_year_by_regionKeySpecifier),
		fields?: skill_counts_per_year_by_regionFieldPolicy,
	},
	skill_counts_per_year_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_aggregateKeySpecifier | (() => undefined | skill_counts_per_year_by_region_aggregateKeySpecifier),
		fields?: skill_counts_per_year_by_region_aggregateFieldPolicy,
	},
	skill_counts_per_year_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_aggregate_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_aggregate_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_aggregate_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_avg_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_avg_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_avg_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_max_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_max_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_max_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_min_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_min_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_min_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_mutation_responseKeySpecifier | (() => undefined | skill_counts_per_year_by_region_mutation_responseKeySpecifier),
		fields?: skill_counts_per_year_by_region_mutation_responseFieldPolicy,
	},
	skill_counts_per_year_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_stddev_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_stddev_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_stddev_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_stddev_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_stddev_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_sum_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_sum_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_sum_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_var_pop_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_var_pop_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_var_pop_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_var_samp_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_var_samp_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_var_samp_fieldsFieldPolicy,
	},
	skill_counts_per_year_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_counts_per_year_by_region_variance_fieldsKeySpecifier | (() => undefined | skill_counts_per_year_by_region_variance_fieldsKeySpecifier),
		fields?: skill_counts_per_year_by_region_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncountyKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncountyKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncountyFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_aggregateKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_aggregateKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_aggregateFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_max_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_min_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_mutation_responseFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_canoncounty_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_globalKeySpecifier | (() => undefined | skill_proportions_per_month_by_globalKeySpecifier),
		fields?: skill_proportions_per_month_by_globalFieldPolicy,
	},
	skill_proportions_per_month_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_aggregateKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_aggregateKeySpecifier),
		fields?: skill_proportions_per_month_by_global_aggregateFieldPolicy,
	},
	skill_proportions_per_month_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_max_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_min_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_month_by_global_mutation_responseFieldPolicy,
	},
	skill_proportions_per_month_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_global_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_global_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_global_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_ladKeySpecifier | (() => undefined | skill_proportions_per_month_by_ladKeySpecifier),
		fields?: skill_proportions_per_month_by_ladFieldPolicy,
	},
	skill_proportions_per_month_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_aggregateKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_aggregateKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_aggregateFieldPolicy,
	},
	skill_proportions_per_month_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_max_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_min_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_mutation_responseFieldPolicy,
	},
	skill_proportions_per_month_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_lad_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_lad_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_lad_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nationKeySpecifier | (() => undefined | skill_proportions_per_month_by_nationKeySpecifier),
		fields?: skill_proportions_per_month_by_nationFieldPolicy,
	},
	skill_proportions_per_month_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_aggregateKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_aggregateKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_aggregateFieldPolicy,
	},
	skill_proportions_per_month_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_max_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_min_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_mutation_responseFieldPolicy,
	},
	skill_proportions_per_month_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_nation_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_nation_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_nation_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_regionKeySpecifier | (() => undefined | skill_proportions_per_month_by_regionKeySpecifier),
		fields?: skill_proportions_per_month_by_regionFieldPolicy,
	},
	skill_proportions_per_month_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_aggregateKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_aggregateKeySpecifier),
		fields?: skill_proportions_per_month_by_region_aggregateFieldPolicy,
	},
	skill_proportions_per_month_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_max_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_min_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_month_by_region_mutation_responseFieldPolicy,
	},
	skill_proportions_per_month_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_month_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_month_by_region_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_month_by_region_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_month_by_region_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncountyKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncountyKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncountyFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_aggregateKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_aggregateKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_aggregateFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_max_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_min_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_mutation_responseFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_canoncounty_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_canoncounty_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_canoncounty_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_globalKeySpecifier | (() => undefined | skill_proportions_per_year_by_globalKeySpecifier),
		fields?: skill_proportions_per_year_by_globalFieldPolicy,
	},
	skill_proportions_per_year_by_global_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_aggregateKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_aggregateKeySpecifier),
		fields?: skill_proportions_per_year_by_global_aggregateFieldPolicy,
	},
	skill_proportions_per_year_by_global_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_max_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_min_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_year_by_global_mutation_responseFieldPolicy,
	},
	skill_proportions_per_year_by_global_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_global_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_global_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_global_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_global_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_ladKeySpecifier | (() => undefined | skill_proportions_per_year_by_ladKeySpecifier),
		fields?: skill_proportions_per_year_by_ladFieldPolicy,
	},
	skill_proportions_per_year_by_lad_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_aggregateKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_aggregateKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_aggregateFieldPolicy,
	},
	skill_proportions_per_year_by_lad_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_max_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_min_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_mutation_responseFieldPolicy,
	},
	skill_proportions_per_year_by_lad_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_lad_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_lad_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_lad_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_lad_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nationKeySpecifier | (() => undefined | skill_proportions_per_year_by_nationKeySpecifier),
		fields?: skill_proportions_per_year_by_nationFieldPolicy,
	},
	skill_proportions_per_year_by_nation_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_aggregateKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_aggregateKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_aggregateFieldPolicy,
	},
	skill_proportions_per_year_by_nation_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_max_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_min_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_mutation_responseFieldPolicy,
	},
	skill_proportions_per_year_by_nation_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_nation_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_nation_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_nation_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_nation_variance_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_regionKeySpecifier | (() => undefined | skill_proportions_per_year_by_regionKeySpecifier),
		fields?: skill_proportions_per_year_by_regionFieldPolicy,
	},
	skill_proportions_per_year_by_region_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_aggregateKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_aggregateKeySpecifier),
		fields?: skill_proportions_per_year_by_region_aggregateFieldPolicy,
	},
	skill_proportions_per_year_by_region_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_aggregate_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_aggregate_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_aggregate_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_avg_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_avg_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_avg_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_max_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_max_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_max_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_min_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_min_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_min_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_mutation_responseKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_mutation_responseKeySpecifier),
		fields?: skill_proportions_per_year_by_region_mutation_responseFieldPolicy,
	},
	skill_proportions_per_year_by_region_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_stddev_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_stddev_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_stddev_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_stddev_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_stddev_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_stddev_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_stddev_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_sum_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_sum_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_sum_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_var_pop_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_var_pop_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_var_pop_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_var_samp_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_var_samp_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_var_samp_fieldsFieldPolicy,
	},
	skill_proportions_per_year_by_region_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | skill_proportions_per_year_by_region_variance_fieldsKeySpecifier | (() => undefined | skill_proportions_per_year_by_region_variance_fieldsKeySpecifier),
		fields?: skill_proportions_per_year_by_region_variance_fieldsFieldPolicy,
	},
	subscription_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | subscription_rootKeySpecifier | (() => undefined | subscription_rootKeySpecifier),
		fields?: subscription_rootFieldPolicy,
	},
	terms?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | termsKeySpecifier | (() => undefined | termsKeySpecifier),
		fields?: termsFieldPolicy,
	},
	terms_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | terms_aggregateKeySpecifier | (() => undefined | terms_aggregateKeySpecifier),
		fields?: terms_aggregateFieldPolicy,
	},
	terms_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | terms_aggregate_fieldsKeySpecifier | (() => undefined | terms_aggregate_fieldsKeySpecifier),
		fields?: terms_aggregate_fieldsFieldPolicy,
	},
	terms_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | terms_max_fieldsKeySpecifier | (() => undefined | terms_max_fieldsKeySpecifier),
		fields?: terms_max_fieldsFieldPolicy,
	},
	terms_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | terms_min_fieldsKeySpecifier | (() => undefined | terms_min_fieldsKeySpecifier),
		fields?: terms_min_fieldsFieldPolicy,
	},
	terms_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | terms_mutation_responseKeySpecifier | (() => undefined | terms_mutation_responseKeySpecifier),
		fields?: terms_mutation_responseFieldPolicy,
	},
	users?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | usersKeySpecifier | (() => undefined | usersKeySpecifier),
		fields?: usersFieldPolicy,
	},
	users_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_aggregateKeySpecifier | (() => undefined | users_aggregateKeySpecifier),
		fields?: users_aggregateFieldPolicy,
	},
	users_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_aggregate_fieldsKeySpecifier | (() => undefined | users_aggregate_fieldsKeySpecifier),
		fields?: users_aggregate_fieldsFieldPolicy,
	},
	users_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_max_fieldsKeySpecifier | (() => undefined | users_max_fieldsKeySpecifier),
		fields?: users_max_fieldsFieldPolicy,
	},
	users_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_min_fieldsKeySpecifier | (() => undefined | users_min_fieldsKeySpecifier),
		fields?: users_min_fieldsFieldPolicy,
	},
	users_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | users_mutation_responseKeySpecifier | (() => undefined | users_mutation_responseKeySpecifier),
		fields?: users_mutation_responseFieldPolicy,
	}
};

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    